(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react-animate-height'), require('styled-components'), require('numeral'), require('@bonlineza/b-lib/EllipsisLoader'), require('@bonlineza/b-lib/PageReady'), require('stylis-rule-sheet'), require('react-dom'), require('prop-types'), require('raf'), require('react-input-autosize'), require('react-transition-group'), require('@bonlineza/b-lib/functions'), require('rc-slider'), require('react-notify-toast'), require('axios')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-animate-height', 'styled-components', 'numeral', '@bonlineza/b-lib/EllipsisLoader', '@bonlineza/b-lib/PageReady', 'stylis-rule-sheet', 'react-dom', 'prop-types', 'raf', 'react-input-autosize', 'react-transition-group', '@bonlineza/b-lib/functions', 'rc-slider', 'react-notify-toast', 'axios'], factory) :
  (global = global || self, factory(global.blib = {}, global.React, global.AnimateHeight, global.styled, global.numeral, global.EllipsisLoader, global.PageReady, global['stylis-rule-sheet'], global.reactDom, global.PropTypes, global.raf, global['react-input-autosize'], global['react-transition-group'], global.function, global.rcSlider, global['react-notify-toast'], global.axios));
}(this, (function (exports, React, AnimateHeight, styled, numeral, EllipsisLoader, PageReady, stylisRuleSheet, reactDom, PropTypes, raf, AutosizeInput, reactTransitionGroup, functions, rcSlider, Notifications, axios) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  AnimateHeight = AnimateHeight && Object.prototype.hasOwnProperty.call(AnimateHeight, 'default') ? AnimateHeight['default'] : AnimateHeight;
  var styled__default = 'default' in styled ? styled['default'] : styled;
  numeral = numeral && Object.prototype.hasOwnProperty.call(numeral, 'default') ? numeral['default'] : numeral;
  EllipsisLoader = EllipsisLoader && Object.prototype.hasOwnProperty.call(EllipsisLoader, 'default') ? EllipsisLoader['default'] : EllipsisLoader;
  PageReady = PageReady && Object.prototype.hasOwnProperty.call(PageReady, 'default') ? PageReady['default'] : PageReady;
  stylisRuleSheet = stylisRuleSheet && Object.prototype.hasOwnProperty.call(stylisRuleSheet, 'default') ? stylisRuleSheet['default'] : stylisRuleSheet;
  var PropTypes__default = 'default' in PropTypes ? PropTypes['default'] : PropTypes;
  raf = raf && Object.prototype.hasOwnProperty.call(raf, 'default') ? raf['default'] : raf;
  AutosizeInput = AutosizeInput && Object.prototype.hasOwnProperty.call(AutosizeInput, 'default') ? AutosizeInput['default'] : AutosizeInput;
  var Notifications__default = 'default' in Notifications ? Notifications['default'] : Notifications;
  axios = axios && Object.prototype.hasOwnProperty.call(axios, 'default') ? axios['default'] : axios;

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var _templateObject;
  var OuterContainer = styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n"])), function (props) {
    return props.theme.colors.borderColor;
  });

  var _templateObject$1;
  var ToggleButton = styled__default.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  padding-left: 3rem;\n  padding-right: 3rem;\n  display: flex;\n  align-items: center;\n  min-height: 70px;\n  height: 70px;\n  cursor: pointer;\n  outline: none;\n"])));

  var _templateObject$2;
  var Title = styled__default.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: bold;\n  flex-grow: 1;\n  color: ", ";\n"])), function (props) {
    return props.theme.fontSizes[2];
  }, function (props) {
    return props.theme.colors.primary || '';
  });

  var _templateObject$3;
  var BodyContent = styled__default.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[5];
  });

  var _templateObject$4;
  var BodyDivider = styled__default.hr(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  margin-top: 0;\n  border-style: none;\n  border-bottom: 1px solid ", ";\n"])), function (props) {
    return props.theme.marginPaddings[4];
  }, function (props) {
    return props.theme.colors.borderColor;
  });

  var _templateObject$5;
  var Body = styled__default.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  padding-left: ", ";\n  padding-right: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[6];
  }, function (props) {
    return props.theme.marginPaddings[6];
  });

  var theme = {
    breakpoints: ['40em', '52em', '64em'],
    space: ['0px', '4px', '8px', '16px', '32px', '64px', '128px', '256px', '512px'],
    fontSizes: ['12px', '14px', '16px', '20px', '24px', '32px', '48px', '64px', '72px'],
    marginPaddings: ['0.5rem', '1rem', '1.5rem', '2rem', '2.5rem', '3rem', '3.5rem', '4rem', '4.5rem', '5rem', '5.5rem', '6rem'],
    letterSpacings: ['-0.5px', '0px', '+0.5px'],
    radii: ['0px', '2px', '4px', '8px'],
    borderRadius: '6px',
    colors: {
      primary: '#000',
      base: '#4e4949',
      baseLt: '#817c7c',
      borderColor: '#d8d8d8',
      ntrlMin: '#fff',
      ntrlMinTen: '#e6e6e6',
      gray: '#efefef',
      darkerGray: '#454141'
    },
    rareStepColors: {
      primary: '#202b58',
      secondary: '#ef5c2d',
      ntrlMin: '#ffffff',
      ntrl40: '#f4f4f4',
      ntrl50: '#808080',
      ntrl60: '#e8e8e8',
      ntrl70: '#252525',
      ntrlMax: '#000000'
    },
    rareStepFontWeights: {
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    },
    rareStepFontSize: {
      h1: '36px',
      h2: '30px',
      h3: '24px',
      h4: '20px',
      h5: '16px',
      h6: '14px',
      footerTitle: '16px'
    },
    rareStepPageSizes: {
      mobile: '500px',
      tablet: '768px',
      desktop: '992px',
      screenl: '1280px',
      screenxl: '1680px',
      screenxxl: '1920px',
      container: '1600px'
    }
  };

  var themed = (function (Component) {
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
        ref: ref
      })));
    });
  });

  var runAfter = function runAfter(fn, duration) {
    setTimeout(fn, duration);
  };

  var getInitHeight = function getInitHeight(defaultHeight) {
    if (defaultHeight === 'auto') return 'auto';
    return 0;
  };
  /**
   * An Expand and Collapsible container which show a Title by default
   * and then expands to show the content/children when it is triggered
   */


  var Accordion = function Accordion(_ref) {
    var wrapperClass = _ref.wrapperClass,
        containerClass = _ref.containerClass,
        title = _ref.title,
        closeIndicator = _ref.closeIndicator,
        openIndicator = _ref.openIndicator,
        itemKey = _ref.itemKey,
        childRenderer = _ref.children,
        duration = _ref.duration,
        onAnimationStart = _ref.onAnimationStart,
        onAnimationEnd = _ref.onAnimationEnd,
        onClose = _ref.onClose,
        onOpen = _ref.onOpen,
        onToggle = _ref.onToggle,
        identifier = _ref.identifier,
        defaultHeight = _ref.defaultHeight;

    var _useState = React.useState(getInitHeight(defaultHeight)),
        _useState2 = _slicedToArray(_useState, 2),
        height = _useState2[0],
        setHeight = _useState2[1];

    var isClosed = height === 0 || false;

    var toggle = function toggle() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return null;
      };
      setHeight(isClosed ? 'auto' : 0); // triggers animation with duration

      runAfter(callback, duration);

      if (isClosed) {
        runAfter(onOpen, duration);
      } else {
        runAfter(onClose, duration);
      }

      runAfter(onToggle, duration);
    };

    var close = function close() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return null;
      };
      setHeight(0); // triggers animation with duration

      runAfter(callback, duration);
      runAfter(onClose, duration);
    };

    var open = function open() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return null;
      };
      setHeight('auto'); // triggers animation with duration

      runAfter(callback, duration);
      runAfter(onOpen, duration);
    };

    var CloseIndicator = closeIndicator;
    var OpenIndicator = openIndicator;
    return /*#__PURE__*/React__default.createElement("div", {
      className: wrapperClass
    }, /*#__PURE__*/React__default.createElement(OuterContainer, {
      "data-qe-id": identifier,
      className: containerClass
    }, /*#__PURE__*/React__default.createElement(ToggleButton, {
      className: "".concat(containerClass, "__toggle-button"),
      "data-qe-id": "".concat(identifier, "-toggle-button"),
      onKeyPress: function onKeyPress() {
        return null;
      },
      onClick: function onClick(e) {
        e.preventDefault();
        toggle();
      },
      role: "button",
      tabIndex: itemKey + 1
    }, /*#__PURE__*/React__default.createElement(Title, {
      className: "".concat(containerClass, "__toggle-button__title")
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(containerClass, "__toggle-button__indicator")
    }, isClosed ? /*#__PURE__*/React__default.createElement(OpenIndicator, null) : /*#__PURE__*/React__default.createElement(CloseIndicator, null))), /*#__PURE__*/React__default.createElement(AnimateHeight, {
      height: height,
      duration: duration,
      onAnimationStart: onAnimationStart,
      onAnimationEnd: onAnimationEnd
    }, /*#__PURE__*/React__default.createElement(Body, {
      className: "".concat(containerClass, "__body")
    }, title ? /*#__PURE__*/React__default.createElement(BodyDivider, null) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), /*#__PURE__*/React__default.createElement(BodyContent, {
      className: "".concat(containerClass, "__body__content")
    }, typeof childRenderer === 'function' ? childRenderer(close, open, toggle) : childRenderer)))));
  };

  Accordion.defaultProps = {
    identifier: '',
    wrapperClass: '',
    containerClass: 'luxity-accordion',
    title: '',
    itemKey: 0,
    children: null,
    duration: 500,
    defaultHeight: '0',
    onAnimationStart: function onAnimationStart() {
      return null;
    },
    onAnimationEnd: function onAnimationEnd() {
      return null;
    },
    onClose: function onClose() {
      return null;
    },
    onOpen: function onOpen() {
      return null;
    },
    onToggle: function onToggle() {
      return null;
    },
    closeIndicator: function closeIndicator() {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Close");
    },
    openIndicator: function openIndicator() {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Open");
    }
  };
  var index = themed(Accordion);

  var _templateObject$6;
  var inputMarginRight = '0.2em';
  var CheckboxLabel = styled__default.label(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  span {\n    :before {\n      content: '\\2713';\n      position: absolute;\n      display: none;\n      color: white;\n      left: 0.4em;\n      top: 0.1em;\n      font-size: ", ";\n      text-align: center;\n    }\n  }\n\n  input {\n    font-size: ", ";\n    background-color: ", ";\n    appearance: none;\n    outline: none;\n    height: 1em;\n    width: 1em;\n    margin-right: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    transition-duration: 0.3s;\n    cursor: pointer;\n\n    &:checked {\n      background-color: ", ";\n    }\n\n    &:checked + span:before {\n      display: block;\n    }\n  }\n"], ["\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  span {\n    :before {\n      content: '\\\\2713';\n      position: absolute;\n      display: none;\n      color: white;\n      left: 0.4em;\n      top: 0.1em;\n      font-size: ", ";\n      text-align: center;\n    }\n  }\n\n  input {\n    font-size: ", ";\n    background-color: ", ";\n    appearance: none;\n    outline: none;\n    height: 1em;\n    width: 1em;\n    margin-right: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    transition-duration: 0.3s;\n    cursor: pointer;\n\n    &:checked {\n      background-color: ", ";\n    }\n\n    &:checked + span:before {\n      display: block;\n    }\n  }\n"])), function (props) {
    var _props$theme;

    return (_props$theme = props.theme) !== null && _props$theme !== void 0 && _props$theme.fontSizes.length ? props.theme.fontSizes[4] : '1em';
  }, function (props) {
    return props.theme.fontSizes[4];
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, inputMarginRight, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.colors.primary;
  });
  var ErrorMessage = styled__default.div({
    color: function color(props) {
      return props.theme.colors.primary;
    }
  });

  var LuxityCheckboxFormWrapper = function LuxityCheckboxFormWrapper(_ref) {
    var name = _ref.name,
        innerText = _ref.innerText,
        checkboxValues = _ref.checkboxValues,
        controlRef = _ref.controlRef,
        errors = _ref.errors;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        checked = _useState2[0],
        setCheckedState = _useState2[1];

    React.useEffect(function () {
      var checkedValue = checkboxValues.checkedValue,
          uncheckedValue = checkboxValues.uncheckedValue;
      controlRef(name, checked ? checkedValue : uncheckedValue);
    }, [checkboxValues, checked, controlRef, name]);

    var handleCheckChange = function handleCheckChange() {
      setCheckedState(!checked);
    };

    return /*#__PURE__*/React__default.createElement(LuxityCheckbox, {
      handleChange: handleCheckChange,
      name: name,
      innerText: innerText,
      errors: errors
    });
  };

  LuxityCheckboxFormWrapper.defaultProps = {
    innerText: '',
    errors: {}
  };

  var FormWrapper = LuxityCheckboxFormWrapper;

  /**
   * Checkbox input component which includes a label and error message elements
   * works well for forms
   */
  var Checkbox = function Checkbox(_ref) {
    var handleChange = _ref.handleChange,
        name = _ref.name,
        innerText = _ref.innerText,
        errors = _ref.errors,
        baseClass = _ref.baseClass;

    var _useState = React.useState(errors[name] || null),
        _useState2 = _slicedToArray(_useState, 2),
        errMsg = _useState2[0],
        setErrMsg = _useState2[1];

    React.useEffect(function () {
      setErrMsg(errors[name] || null);
    }, [errors, name]);
    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(CheckboxLabel, {
      htmlFor: name,
      className: baseClass
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "checkbox",
      id: name,
      name: name,
      onChange: handleChange,
      className: "".concat(baseClass, "__input")
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(baseClass, "__inner-text")
    }, innerText)), errMsg && /*#__PURE__*/React__default.createElement(ErrorMessage, {
      className: "".concat(baseClass, "-error")
    }, errMsg));
  };

  Checkbox.defaultProps = {
    handleChange: function handleChange() {
      return null;
    },
    baseClass: 'checkbox',
    innerText: '',
    errors: {}
  };
  var LuxityCheckbox = themed(Checkbox);

  /** @format */

  numeral.register('locale', 'en-ZA', {
    delimiters: {
      thousands: ',',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function ordinal() {
      return '.';
    },
    currency: {
      symbol: 'R'
    }
  });
  numeral.locale('en-ZA');
  String.locale = numeral.locale;
  /**
   * Curreny Formatter
   * @param {number} number - the number to be formatted
   * @param {boolean} round - flag to indicate if the number needs to be rounded off
   */

  function fC(number) {
    var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var parsedNumber = parseFloat(number);
    return !Number.isNaN(parsedNumber) ? numeral(round ? Math.round(parsedNumber) : parsedNumber).format('$ 0,0.00') : 'R -';
  }

  /** @format */
  var request = {
    fetching: false,
    failed: false,
    success: false,
    payload: null
  };
  var method = {
    DELETE: 'DELETE',
    POST: 'POST',
    GET: 'GET'
  };

  var simpleRequest = (function (axiosInstance, url) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
    var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
      return null;
    };
    var onFailed = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {
      return null;
    };
    var requestConfigParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    return axiosInstance[method.toLowerCase()](url, payload, requestConfigParams).then(function (res) {
      onSuccess(res);
      return res;
    }).catch(function (err) {
      onFailed(err);
      return err;
    });
  });

  var interestCategories = {
    SHOES: 'SHOES',
    BAGS: 'BAGS',
    ACCESSORIES: 'ACCESSORIES',
    WATCHES: 'WATCHES',
    APPAREL: 'APPAREL'
  };
  var catArray = [{
    categoryTitle: 'Bags',
    value: interestCategories.BAGS
  }, {
    categoryTitle: 'Shoes',
    value: interestCategories.SHOES
  }, {
    categoryTitle: 'Accessories',
    value: interestCategories.ACCESSORIES
  }, {
    categoryTitle: 'Clothing',
    value: interestCategories.APPAREL
  }, {
    categoryTitle: 'Watches',
    value: interestCategories.WATCHES
  }];
  var interestCategoryMaxPrices = {
    SHOES: 50000,
    BAGS: 500000,
    ACCESSORIES: 100000,
    WATCHES: 500000,
    APPAREL: 100000
  };

  var genders = {
    FEMALE: 0,
    MALE: 1,
    UNISEX: 2
  };

  var Trash = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      version: "1.1",
      id: "svg-trash",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 15.1 17.5",
      xmlSpace: "preserve"
    }, props), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
      d: "M2.4,17.5c-0.4-0.1-0.5-0.4-0.5-0.8c0-4,0-7.9,0-11.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0-0.7,0-1,0 C0.3,4.6,0,4.3,0,4C0,3.3,0,2.7,0,2c0.1-0.8,0.8-1.5,1.7-1.6c1.3,0,2.6,0,3.9,0c0.1,0,0.2,0,0.3-0.1C6,0.1,6.2,0,6.5,0 c0.7,0,1.4,0,2.1,0c0.3,0,0.5,0.1,0.6,0.3c0.1,0.1,0.1,0.1,0.2,0.1c1.3,0,2.5,0,3.8,0c0.8,0,1.4,0.4,1.7,1.1C15,1.7,15,2,15,2.3 c0,0.5,0,1,0,1.6c0,0.5-0.3,0.7-0.7,0.7c-0.4,0-0.7,0-1.1,0c0,0,0,0-0.1,0c0,0.1,0,0.1,0,0.2c0,4,0,7.9,0,11.9 c0,0.4-0.1,0.7-0.5,0.8C9.2,17.5,5.8,17.5,2.4,17.5z M11.8,16.2c0-3.9,0-7.7,0-11.6c-2.9,0-5.7,0-8.6,0c0,3.9,0,7.7,0,11.6 C6.1,16.2,9,16.2,11.8,16.2z M1.3,3.2c4.1,0,8.3,0,12.4,0c0-0.3,0-0.6,0-0.9c0-0.5-0.2-0.6-0.6-0.6c-3.7,0-7.4,0-11.1,0 c-0.1,0-0.2,0-0.3,0C1.5,1.8,1.3,2,1.3,2.2C1.3,2.5,1.3,2.9,1.3,3.2z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M5.1,9.8c0-1.1,0-2.3,0-3.4c0-0.4,0.2-0.7,0.5-0.7C6,5.6,6.3,5.8,6.4,6.1c0,0.1,0,0.2,0,0.3c0,2.2,0,4.5,0,6.7 c0,0.1,0,0.3-0.1,0.4C6.2,13.8,6,14,5.7,13.9c-0.3,0-0.5-0.2-0.6-0.5c0-0.1,0-0.2,0-0.3C5.1,12,5.1,10.9,5.1,9.8z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M9.9,9.8c0,1.1,0,2.3,0,3.4c0,0.3-0.2,0.6-0.5,0.7c-0.4,0.1-0.8-0.1-0.9-0.5c0-0.1,0-0.2,0-0.2c0-2.3,0-4.5,0-6.8 c0-0.4,0.2-0.7,0.5-0.7c0.3-0.1,0.7,0.1,0.7,0.5c0,0.1,0,0.2,0,0.3C9.9,7.6,9.9,8.7,9.9,9.8z"
    })));
  });

  var _templateObject$7;
  var SvgWrapper = styled__default.span(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  padding: 1rem;\n  display: flex;\n  svg {\n    width: 23px;\n    height: auto;\n  }\n"])));

  var _templateObject$8;
  var IconWrapper = styled__default.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  height: auto;\n  margin-bottom: 1rem;\n  margin-left: 1rem;\n  display: flex;\n  align-items: center;\n  height: auto;\n\n  :hover {\n    background-color: ", ";\n    cursor: pointer;\n  }\n\n  #svg-trash {\n    width: 15px;\n    height: 100%;\n  }\n"])), function (props) {
    return props.theme.colors.borderColor;
  }, function (props) {
    return props.theme.colors.borderColor;
  });

  var media = {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px'
  };

  var _templateObject$9, _templateObject2, _templateObject3, _templateObject4;
  var MALE = genders.MALE,
      FEMALE = genders.FEMALE,
      UNISEX = genders.UNISEX;

  var TrashIcon = function TrashIcon(_ref) {
    var onClick = _ref.onClick,
        id = _ref.id;
    return /*#__PURE__*/React__default.createElement(IconWrapper, {
      onClick: onClick,
      id: id
    }, /*#__PURE__*/React__default.createElement(SvgWrapper, null, /*#__PURE__*/React__default.createElement(Trash, null)));
  };

  var InterestItem = /*#__PURE__*/function (_React$Component) {
    _inherits(InterestItem, _React$Component);

    var _super = _createSuper(InterestItem);

    function InterestItem(props) {
      var _this;

      _classCallCheck(this, InterestItem);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "deleteInterestItem", function () {
        var id = _this.props.data.id;

        _this.setState({
          delete: _objectSpread2(_objectSpread2({}, request), {}, {
            fetching: true
          })
        });

        var url = _this.props.deleteInterestApi(id);

        simpleRequest(_this.props.requestInstance, url, method.DELETE, null, function () {
          _this.setState({
            delete: _objectSpread2(_objectSpread2({}, request), {}, {
              success: true
            })
          });

          _this.props.onDeleted(_this.props.data);
        }, function () {
          return _this.setState({
            delete: _objectSpread2({}, request)
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getGender", function (gender) {
        switch (gender) {
          case MALE:
            return 'Male';

          case FEMALE:
            return 'Female';

          case UNISEX:
          default:
            return 'Unisex';
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getCategory", function (category) {
        if (category === interestCategories.APPAREL) {
          return 'CLOTHING';
        }

        return category;
      });

      _defineProperty(_assertThisInitialized(_this), "render", function () {
        var _data$min_shoe_size, _data$max_shoe_size;

        var data = _this.props.data;
        var success = _this.state.delete.success;
        return /*#__PURE__*/React__default.createElement(InterestItemContainer, {
          id: "interests__item--".concat(data.id),
          className: "".concat(success && 'interests__item--hiding')
        }, /*#__PURE__*/React__default.createElement(InterestItemContent, {
          className: "interest-item__container ".concat(_this.props.className || '')
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "interest-item__container_heading"
        }, /*#__PURE__*/React__default.createElement(InterestItemTitle, null, "Category:"), /*#__PURE__*/React__default.createElement("div", {
          id: "interest-item-".concat(data.id, "__category"),
          className: "list-items"
        }, _this.getCategory(data.category_type))), /*#__PURE__*/React__default.createElement("div", {
          className: "interest-item__container_heading"
        }, /*#__PURE__*/React__default.createElement(InterestItemTitle, null, "Brands:"), /*#__PURE__*/React__default.createElement("div", {
          className: "list-items"
        }, data.luxity_brands.length > 0 ? data.luxity_brands.map(function (brand) {
          return /*#__PURE__*/React__default.createElement("span", {
            key: "".concat(brand.name, "-").concat(data.id)
          }, brand.name);
        }) : 'All')), /*#__PURE__*/React__default.createElement("div", {
          className: "interest-item__container_heading"
        }, /*#__PURE__*/React__default.createElement(InterestItemTitle, null, "Department:"), /*#__PURE__*/React__default.createElement("div", {
          className: "list-items"
        }, _this.getGender(data.gender))), /*#__PURE__*/React__default.createElement("div", {
          className: "interest-item__container_heading"
        }, /*#__PURE__*/React__default.createElement(InterestItemTitle, null, "Price:"), /*#__PURE__*/React__default.createElement("div", {
          className: "list-items"
        }, fC(data.min_price), "\xA0-\xA0", fC(data.max_price))), /*#__PURE__*/React__default.createElement("div", {
          className: "interest-item__container_heading"
        }, /*#__PURE__*/React__default.createElement(InterestItemTitle, null, "Style:"), /*#__PURE__*/React__default.createElement("div", {
          className: "list-items"
        }, data.luxity_styles.length > 0 ? data.luxity_styles.map(function (style) {
          return /*#__PURE__*/React__default.createElement("span", {
            key: "".concat(style.name, "-").concat(data.id)
          }, style.name);
        }) : 'All')), /*#__PURE__*/React__default.createElement("div", {
          className: "interest-item__container_heading ".concat(data.category_type === interestCategories.SHOES ? '' : 'no-shoe-size-section')
        }, data.category_type === interestCategories.SHOES ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(InterestItemTitle, null, "Shoe Size:"), /*#__PURE__*/React__default.createElement("div", {
          className: "list-items"
        }, "".concat((data === null || data === void 0 ? void 0 : (_data$min_shoe_size = data.min_shoe_size) === null || _data$min_shoe_size === void 0 ? void 0 : _data$min_shoe_size.size) || '', " - "), "".concat((data === null || data === void 0 ? void 0 : (_data$max_shoe_size = data.max_shoe_size) === null || _data$max_shoe_size === void 0 ? void 0 : _data$max_shoe_size.size) || '', " "))) : /*#__PURE__*/React__default.createElement(SheoSizeContentDiv, null, "-"))), /*#__PURE__*/React__default.createElement(TrashIcon, {
          id: "interest-".concat(data.id, "-delete-button"),
          onClick: function onClick() {
            if (!_this.state.delete.fetching) {
              _this.deleteInterestItem();
            }
          }
        }));
      });

      _this.state = {
        delete: _objectSpread2({}, request)
      };
      return _this;
    }

    return _createClass(InterestItem);
  }(React__default.Component);

  var SheoSizeContentDiv = styled__default.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), media.xs);
  var InterestItemTitle = styled__default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  display: none;\n\n  @media (max-width: ", ") {\n    display: inline;\n  }\n"])), media.xs);
  var InterestItemContainer = styled__default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n\n  .no-shoe-size-section {\n    @media (max-width: ", ") {\n      display: none;\n    }\n  }\n"])), media.xs);
  var InterestItemContent = styled__default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 95%;\n  height: 100%;\n  border: 1px solid ", ";\n  padding: 0.5em;\n  margin-bottom: ", ";\n\n  .interest-item__container_heading {\n    color: ", ";\n    flex-basis: calc(100% / 8);\n    margin-left: ", ";\n    margin-top: 0.3rem;\n\n    @media (max-width: ", ") {\n      display: inline;\n    }\n  }\n\n  .list-items {\n    display: inline-flex;\n    flex-direction: column;\n\n    @media (max-width: ", ") {\n      margin-left: ", ";\n    }\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n  }\n"])), function (props) {
    return props.theme.colors.borderColor;
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.colors.darkerGray;
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, media.xs, media.xs, function (props) {
    return props.theme.marginPaddings[0];
  }, media.xs);
  var ThemedInterestItem = themed(InterestItem);
  /**
   * The Interest Item view shows the selected interest configuration,
   * and gives user control to delete it.
   */

  var InterestItem$1 = (function (props) {
    return /*#__PURE__*/React__default.createElement(ThemedInterestItem, props);
  });

  var interpretErrorMessage = function interpretErrorMessage(error) {
    var customMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Failed: :error_code';
    var message = customMessage || 'Network Error';
    return message.replace(':error_code', error.status || 'Network Down');
  };

  var LuxityPageReadyContext = /*#__PURE__*/React__default.createContext({
    data: null
  });
  /**
   * A flavour of PageReady with Luxity customisations
   * 1. the onIsLoading callback is useful to parent components that have more complex data interactions
   * 2. an error message interpreter is supplied from the local helper library
   */

  var LuxityPageReady = /*#__PURE__*/function (_React$Component) {
    _inherits(LuxityPageReady, _React$Component);

    var _super = _createSuper(LuxityPageReady);

    function LuxityPageReady() {
      var _this;

      _classCallCheck(this, LuxityPageReady);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        data: null
      });

      _defineProperty(_assertThisInitialized(_this), "refreshPage", function () {
        return _this.pageReadyInstance.initRequest();
      });

      return _this;
    }

    _createClass(LuxityPageReady, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            customErrorMessage = _this$props.customErrorMessage,
            customErrorHandler = _this$props.customErrorHandler,
            getRequestPromise = _this$props.getRequestPromise,
            _onData = _this$props.onData,
            children = _this$props.children;
        var data = this.state.data;
        return /*#__PURE__*/React__default.createElement(PageReady, {
          ref: function ref(inst) {
            _this2.pageReadyInstance = inst;
          },
          onData: function onData(res) {
            _this2.setState({
              data: res.data
            });

            _onData(res);
          },
          getRequestInstance: function getRequestInstance() {
            _this2.props.onIsLoading(true);

            return getRequestPromise().then(function (out) {
              _this2.props.onIsLoading(false);

              return out;
            }).catch(function (oops) {
              _this2.props.onIsLoading(false);

              return oops;
            });
          },
          customErrorMessage: customErrorMessage,
          customErrorHandler: customErrorHandler,
          renderCustomLoader: function renderCustomLoader() {
            return /*#__PURE__*/React__default.createElement(EllipsisLoader, null);
          },
          errorMessageInterpreter: interpretErrorMessage
        }, /*#__PURE__*/React__default.createElement(LuxityPageReadyContext.Provider, {
          value: {
            data: data
          }
        }, children));
      }
    }]);

    return LuxityPageReady;
  }(React__default.Component);

  LuxityPageReady.defaultProps = {
    onIsLoading: function onIsLoading() {
      return null;
    },
    customErrorMessage: '',
    customErrorHandler: function customErrorHandler() {
      return null;
    },
    onData: function onData() {
      return null;
    }
  };

  var _templateObject$a;
  var RadioButtonsContainer = styled__default.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

  var _templateObject$b;
  var ButtonListWrapper = styled__default.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: ", ";\n"])), function (_ref) {
    var noWrap = _ref.noWrap;
    return noWrap ? 'nowrap' : 'wrap';
  });

  var _templateObject$c;
  var Title$1 = styled__default.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n  flex-basis: 40%;\n"])), function (props) {
    return props.theme.colors.base;
  });

  var _templateObject$d;
  var RadioButtonLabel = styled__default.label(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: ", ";\n  margin-right: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.marginPaddings[0];
  });

  var _templateObject$e;
  var RadioButtonCircle = styled__default.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  margin-right: 5px;\n  border: 1px solid ", ";\n  display: flex;\n"])), function (props) {
    return props.theme.colors.base;
  });

  var _templateObject$f;
  var RadioButtonCircleInner = styled__default.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  height: 8px;\n  width: 8px;\n  border-radius: 50%;\n  margin: auto;\n"])));

  var _templateObject$g;
  var RadioButtonInput = styled__default.input(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  display: none;\n  :checked ~ ", " {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"])), RadioButtonCircle, RadioButtonCircleInner, function (props) {
    return props.theme.colors.base;
  });

  var _templateObject$h;
  var RadioButtonText = styled__default.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

  var RadioButtonsFormWrapper = function RadioButtonsFormWrapper(_ref) {
    var name = _ref.name,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        controlRef = _ref.controlRef,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? [] : _ref$options,
        _ref$errors = _ref.errors,
        errors = _ref$errors === void 0 ? {} : _ref$errors;
    var optsWithControlRef = options.map(function (option) {
      return _objectSpread2(_objectSpread2({}, option), {}, {
        actionCallback: function actionCallback() {
          return controlRef(name, option.value);
        }
      });
    });
    return /*#__PURE__*/React__default.createElement(RadioButtons$1, {
      name: name,
      title: title,
      options: optsWithControlRef,
      errors: errors,
      noWrap: true
    });
  };

  var FormWrapper$1 = RadioButtonsFormWrapper;

  /**
   * RadioButtons component can show multiple radios, a title and an error message
   */
  var RadioButtons = function RadioButtons(_ref) {
    var options = _ref.options,
        name = _ref.name,
        noWrap = _ref.noWrap,
        title = _ref.title,
        errors = _ref.errors;

    var _useState = React.useState(errors[name]),
        _useState2 = _slicedToArray(_useState, 2),
        errMsg = _useState2[0],
        setErrMsg = _useState2[1];

    React.useEffect(function () {
      setErrMsg(errors[name]);
    }, [errors, name]);
    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(RadioButtonsContainer, null, /*#__PURE__*/React__default.createElement(Title$1, null, title), /*#__PURE__*/React__default.createElement(ButtonListWrapper, {
      noWrap: noWrap
    }, options.map(function (_ref2, index) {
      var _ref2$actionCallback = _ref2.actionCallback,
          actionCallback = _ref2$actionCallback === void 0 ? function () {
        return null;
      } : _ref2$actionCallback,
          _ref2$value = _ref2.value,
          value = _ref2$value === void 0 ? '' : _ref2$value,
          _ref2$innerText = _ref2.innerText,
          innerText = _ref2$innerText === void 0 ? '' : _ref2$innerText,
          _ref2$checked = _ref2.checked,
          checked = _ref2$checked === void 0 ? false : _ref2$checked;
      return /*#__PURE__*/React__default.createElement(RadioButtonLabel, {
        key: "".concat(name, "-").concat(index),
        htmlFor: "".concat(name, "_").concat(index)
      }, /*#__PURE__*/React__default.createElement(RadioButtonInput, {
        id: "".concat(name, "_").concat(index),
        type: "radio",
        name: name,
        defaultChecked: checked,
        onChange: function onChange() {
          setErrMsg('');
          actionCallback(name, value);
        },
        value: value
      }), /*#__PURE__*/React__default.createElement(RadioButtonCircle, null, /*#__PURE__*/React__default.createElement(RadioButtonCircleInner, null)), /*#__PURE__*/React__default.createElement(RadioButtonText, null, innerText));
    }))), errMsg && /*#__PURE__*/React__default.createElement(ErrorMessage, null, errMsg));
  };

  RadioButtons.defaultProps = {
    noWrap: false,
    title: '',
    errors: {}
  };
  var RadioButtons$1 = themed(RadioButtons);

  var _templateObject$i, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5;
  /* position relative is required for the Body element to be positioned correctly */

  var relativeInlineStyle = styled.css(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  position: relative;\n"])));
  var topMiddleBodyStyle = styled.css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  bottom: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
  var getTopMiddleArrowAfterStyle = function getTopMiddleArrowAfterStyle(props) {
    return styled.css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  /*Bottom Arrow*/\n  top: 100%; /* At the bottom of the tooltip */\n  left: calc(50% - ", ");\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", " transparent transparent transparent;\n"])), props.apexWidth, props.apexWidth, props.theme.colors.base);
  };
  var getBottomMiddleBodyStyle = function getBottomMiddleBodyStyle(props) {
    return styled.css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: calc(50% - ", " / 2);\n"])), props.bodyWidth);
  };
  var getBottomMiddleArrowAfterStyle = function getBottomMiddleArrowAfterStyle(props) {
    return styled.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  /*Top Arrow*/\n  bottom: 100%; /* At the top of the tooltip */\n  top: initial;\n  left: 50%;\n  border-style: solid;\n  border-color: transparent transparent ", " transparent;\n"])), props.theme.colors.base);
  };

  var _templateObject$j;

  var getBodyStyle = function getBodyStyle() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$toolTipPositio = props.toolTipPosition,
        toolTipPosition = _props$toolTipPositio === void 0 ? '' : _props$toolTipPositio;

    switch (toolTipPosition) {
      case 'top':
        return topMiddleBodyStyle;

      case 'bottom':
        return getBottomMiddleBodyStyle(props);

      default:
        return null;
    }
  };

  var getAfterStyling = function getAfterStyling() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var toolTipPosition = props.toolTipPosition;

    switch (toolTipPosition) {
      case 'top':
        return getTopMiddleArrowAfterStyle(props);

      case 'bottom':
        return getBottomMiddleArrowAfterStyle(props);

      default:
        return '';
    }
  };

  var Body$1 = styled__default.span(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  ", ";\n  visibility: hidden;\n  opacity: 0;\n  width: ", ";\n  transition: visibility 0.3s linear, opacity 0.3s linear;\n  background-color: ", ";\n  color: white;\n  text-align: center;\n  border-radius: 5px;\n  ", "\n  &::after {\n    content: ' ';\n    position: absolute;\n    ", "\n  }\n"])), relativeInlineStyle, function (props) {
    return props.bodyWidth;
  }, function (props) {
    return props.theme.colors.base || 'black';
  }, function (props) {
    return getBodyStyle(props);
  }, function (props) {
    return getAfterStyling(props);
  });

  var _templateObject$k;
  var Container = styled__default.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  ", ";\n  cursor: pointer;\n  &:hover ", " {\n    opacity: 1;\n    visibility: visible;\n  }\n"])), relativeInlineStyle, Body$1);

  var Tooltip = function Tooltip(_ref) {
    var children = _ref.children,
        toolTipText = _ref.toolTipText,
        toolTipPosition = _ref.toolTipPosition,
        bodyWidth = _ref.bodyWidth,
        apexWidth = _ref.apexWidth,
        containerClassName = _ref.containerClassName,
        bodyClassName = _ref.bodyClassName;
    return /*#__PURE__*/React__default.createElement(Container, {
      className: containerClassName
    }, children, /*#__PURE__*/React__default.createElement(Body$1, {
      toolTipPosition: toolTipPosition,
      bodyWidth: bodyWidth,
      apexWidth: apexWidth,
      className: bodyClassName
    }, toolTipText));
  };

  Tooltip.defaultProps = {
    children: null,
    toolTipText: '',
    toolTipPosition: 'top',
    bodyWidth: '8em',
    apexWidth: '5px',
    containerClassName: '',
    bodyClassName: ''
  };
  var index$1 = themed(Tooltip);

  var _templateObject$l, _templateObject2$2;
  var disabledButtonStyle = styled.css(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n  opacity: 0.4;\n"])));
  var baseButtonStyle = styled.css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  padding: 1rem 3.5rem;\n  cursor: pointer;\n  letter-spacing: 1.3px;\n  border-style: none;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: #fff;\n  transition: 0.2s ease-in-out;\n  outline: none;\n  min-width: 150px;\n"])));

  var _excluded = ["children"];

  var _templateObject$m;
  var Button = styled__default.button(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  color: ", ";\n  &:active,\n  &:hover {\n    background-color: #fff;\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n\n    &:hover {\n      background-color: ", ";\n      color: #ffff;\n    }\n  }\n"])), baseButtonStyle, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, disabledButtonStyle, function (props) {
    return props.theme.colors.primary;
  });

  var PrimaryButton = function PrimaryButton(_ref) {
    var children = _ref.children,
        restProps = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React__default.createElement(Button, restProps, children);
  };

  var PrimaryButton$1 = themed(PrimaryButton);

  var _excluded$1 = ["children"];

  var _templateObject$n;
  var Button$1 = styled__default.button(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:disabled {\n    ", "\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), baseButtonStyle, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, disabledButtonStyle, function (props) {
    return props.theme.colors.base;
  });

  var SecondaryButton = function SecondaryButton(_ref) {
    var children = _ref.children,
        restProps = _objectWithoutProperties(_ref, _excluded$1);

    return /*#__PURE__*/React__default.createElement(Button$1, restProps, children);
  };

  var SecondaryButton$1 = themed(SecondaryButton);

  var _excluded$2 = ["children"];

  var _templateObject$o;
  var Button$2 = styled__default.button(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  ", ";\n  background-color: transparent;\n  color: ", ";\n  &:hover {\n    color: ", ";\n  }\n  &:disabled {\n    ", ";\n    color: ", ";\n  }\n"])), baseButtonStyle, function (props) {
    return props.theme.colors.base;
  }, function (props) {
    return props.theme.colors.primary;
  }, disabledButtonStyle, function (props) {
    return props.theme.colors.base;
  });

  var TextButton = function TextButton(_ref) {
    var children = _ref.children,
        restProps = _objectWithoutProperties(_ref, _excluded$2);

    return /*#__PURE__*/React__default.createElement(Button$2, restProps, children);
  };

  TextButton.defaultProps = {
    type: 'button'
  };
  var TextButton$1 = themed(TextButton);

  var _excluded$3 = ["children"];

  var _templateObject$p;
  var Button$3 = styled__default(TextButton$1)(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.base;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  });

  var InvertedTextButton = function InvertedTextButton(_ref) {
    var children = _ref.children,
        restProps = _objectWithoutProperties(_ref, _excluded$3);

    return /*#__PURE__*/React__default.createElement(Button$3, restProps, children);
  };

  var InvertedTextButton$1 = themed(InvertedTextButton);

  var _excluded$4 = ["children"];

  var _templateObject$q;
  var Button$4 = styled__default.button(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  outline: none;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  &:disabled {\n    ", ";\n  }\n"])), disabledButtonStyle);

  var WrapperButton = function WrapperButton(_ref) {
    var children = _ref.children,
        restProps = _objectWithoutProperties(_ref, _excluded$4);

    return /*#__PURE__*/React__default.createElement(Button$4, restProps, children);
  };

  var _excluded$5 = ["value", "onChange", "prefix", "allowNegativeValue", "groupSeparator", "decimalSeparator"];
  var unMask = function unMask() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.replace(/\D/g, '');
  };
  /**
   * Currency Input which formats the value to a specific format
   */

  var CurrencyInputFormatter = function CurrencyInputFormatter(_ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        prefix = _ref.prefix,
        allowNegativeValue = _ref.allowNegativeValue,
        groupSeparator = _ref.groupSeparator,
        decimalSeparator = _ref.decimalSeparator,
        rest = _objectWithoutProperties(_ref, _excluded$5);

    var handleValueChange = function handleValueChange(event) {
      var inputValue = event.target.value;
      var unmaskedValue = unMask(inputValue);
      onChange(unmaskedValue);
    };

    var formatCurrency = function formatCurrency(originalValue) {
      var numericValue = Number(originalValue);
      var formattedValue = numericValue.toLocaleString('en-US');
      return prefix + formattedValue;
    };

    var formattedValue = formatCurrency(value);
    return /*#__PURE__*/React__default.createElement("input", _extends({}, rest, {
      type: "text",
      value: formattedValue,
      onChange: handleValueChange
    }));
  };

  CurrencyInputFormatter.defaultProps = {
    value: '',
    prefix: 'R',
    groupSeparator: ',',
    decimalSeparator: '.',
    allowNegativeValue: false,
    onChange: function onChange() {}
  };

  var safeIsNaN = Number.isNaN ||
      function ponyfill(value) {
          return typeof value === 'number' && value !== value;
      };
  function isEqual(first, second) {
      if (first === second) {
          return true;
      }
      if (safeIsNaN(first) && safeIsNaN(second)) {
          return true;
      }
      return false;
  }
  function areInputsEqual(newInputs, lastInputs) {
      if (newInputs.length !== lastInputs.length) {
          return false;
      }
      for (var i = 0; i < newInputs.length; i++) {
          if (!isEqual(newInputs[i], lastInputs[i])) {
              return false;
          }
      }
      return true;
  }

  function memoizeOne(resultFn, isEqual) {
      if (isEqual === void 0) { isEqual = areInputsEqual; }
      var lastThis;
      var lastArgs = [];
      var lastResult;
      var calledOnce = false;
      function memoized() {
          var newArgs = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              newArgs[_i] = arguments[_i];
          }
          if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
              return lastResult;
          }
          lastResult = resultFn.apply(this, newArgs);
          calledOnce = true;
          lastThis = this;
          lastArgs = newArgs;
          return lastResult;
      }
      return memoized;
  }

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  /* eslint-disable */
  // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
  function murmurhash2_32_gc(str) {
    var l = str.length,
        h = l ^ l,
        i = 0,
        k;

    while (l >= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
      k ^= k >>> 24;
      k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
      l -= 4;
      ++i;
    }

    switch (l) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }

    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
  }

  function stylis_min (W) {
    function M(d, c, e, h, a) {
      for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
        g = e.charCodeAt(l);
        l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

        if (0 === b + n + v + m) {
          if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
            switch (g) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                f += e.charAt(l);
            }

            g = 59;
          }

          switch (g) {
            case 123:
              f = f.trim();
              q = f.charCodeAt(0);
              k = 1;

              for (t = ++l; l < B;) {
                switch (g = e.charCodeAt(l)) {
                  case 123:
                    k++;
                    break;

                  case 125:
                    k--;
                    break;

                  case 47:
                    switch (g = e.charCodeAt(l + 1)) {
                      case 42:
                      case 47:
                        a: {
                          for (u = l + 1; u < J; ++u) {
                            switch (e.charCodeAt(u)) {
                              case 47:
                                if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                  l = u + 1;
                                  break a;
                                }

                                break;

                              case 10:
                                if (47 === g) {
                                  l = u + 1;
                                  break a;
                                }

                            }
                          }

                          l = u;
                        }

                    }

                    break;

                  case 91:
                    g++;

                  case 40:
                    g++;

                  case 34:
                  case 39:
                    for (; l++ < J && e.charCodeAt(l) !== g;) {
                    }

                }

                if (0 === k) break;
                l++;
              }

              k = e.substring(t, l);
              0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

              switch (q) {
                case 64:
                  0 < r && (f = f.replace(N, ''));
                  g = f.charCodeAt(1);

                  switch (g) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      r = c;
                      break;

                    default:
                      r = O;
                  }

                  k = M(c, r, k, g, a + 1);
                  t = k.length;
                  0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                  if (0 < t) switch (g) {
                    case 115:
                      f = f.replace(da, ea);

                    case 100:
                    case 109:
                    case 45:
                      k = f + '{' + k + '}';
                      break;

                    case 107:
                      f = f.replace(fa, '$1 $2');
                      k = f + '{' + k + '}';
                      k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                      break;

                    default:
                      k = f + k, 112 === h && (k = (p += k, ''));
                  } else k = '';
                  break;

                default:
                  k = M(c, X(c, f, I), k, h, a + 1);
              }

              F += k;
              k = I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
              break;

            case 125:
            case 59:
              f = (0 < r ? f.replace(N, '') : f).trim();
              if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
                case 0:
                  break;

                case 64:
                  if (105 === g || 99 === g) {
                    G += f + e.charAt(l);
                    break;
                  }

                default:
                  58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
              }
              I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
          }
        }

        switch (g) {
          case 13:
          case 10:
            47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
            0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
            z = 1;
            D++;
            break;

          case 59:
          case 125:
            if (0 === b + n + v + m) {
              z++;
              break;
            }

          default:
            z++;
            y = e.charAt(l);

            switch (g) {
              case 9:
              case 32:
                if (0 === n + m + b) switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = '';
                    break;

                  default:
                    32 !== g && (y = ' ');
                }
                break;

              case 0:
                y = '\\0';
                break;

              case 12:
                y = '\\f';
                break;

              case 11:
                y = '\\v';
                break;

              case 38:
                0 === n + b + m && (r = I = 1, y = '\f' + y);
                break;

              case 108:
                if (0 === n + b + m + E && 0 < u) switch (l - u) {
                  case 2:
                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                  case 8:
                    111 === K && (E = K);
                }
                break;

              case 58:
                0 === n + b + m && (u = l);
                break;

              case 44:
                0 === b + v + n + m && (r = 1, y += '\r');
                break;

              case 34:
              case 39:
                0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                break;

              case 91:
                0 === n + b + v && m++;
                break;

              case 93:
                0 === n + b + v && m--;
                break;

              case 41:
                0 === n + b + m && v--;
                break;

              case 40:
                if (0 === n + b + m) {
                  if (0 === q) switch (2 * x + 3 * K) {
                    case 533:
                      break;

                    default:
                      q = 1;
                  }
                  v++;
                }

                break;

              case 64:
                0 === b + v + n + m + u + k && (k = 1);
                break;

              case 42:
              case 47:
                if (!(0 < n + m + v)) switch (b) {
                  case 0:
                    switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;

                      case 220:
                        t = l, b = 42;
                    }

                    break;

                  case 42:
                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                }
            }

            0 === b && (f += y);
        }

        K = x;
        x = g;
        l++;
      }

      t = p.length;

      if (0 < t) {
        r = c;
        if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
        p = r.join(',') + '{' + p + '}';

        if (0 !== w * E) {
          2 !== w || L(p, 2) || (E = 0);

          switch (E) {
            case 111:
              p = p.replace(ha, ':-moz-$1') + p;
              break;

            case 112:
              p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
          }

          E = 0;
        }
      }

      return G + p + F;
    }

    function X(d, c, e) {
      var h = c.trim().split(ia);
      c = h;
      var a = h.length,
          m = d.length;

      switch (m) {
        case 0:
        case 1:
          var b = 0;

          for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
            c[b] = Z(d, c[b], e).trim();
          }

          break;

        default:
          var v = b = 0;

          for (c = []; b < a; ++b) {
            for (var n = 0; n < m; ++n) {
              c[v++] = Z(d[n] + ' ', h[b], e).trim();
            }
          }

      }

      return c;
    }

    function Z(d, c, e) {
      var h = c.charCodeAt(0);
      33 > h && (h = (c = c.trim()).charCodeAt(0));

      switch (h) {
        case 38:
          return c.replace(F, '$1' + d.trim());

        case 58:
          return d.trim() + c.replace(F, '$1' + d.trim());

        default:
          if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
      }

      return d + c;
    }

    function P(d, c, e, h) {
      var a = d + ';',
          m = 2 * c + 3 * e + 4 * h;

      if (944 === m) {
        d = a.indexOf(':', 9) + 1;
        var b = a.substring(d, a.length - 1).trim();
        b = a.substring(0, d).trim() + b + ';';
        return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
      }

      if (0 === w || 2 === w && !L(a, 1)) return a;

      switch (m) {
        case 1015:
          return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

        case 951:
          return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

        case 963:
          return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

        case 1009:
          if (100 !== a.charCodeAt(4)) break;

        case 969:
        case 942:
          return '-webkit-' + a + a;

        case 978:
          return '-webkit-' + a + '-moz-' + a + a;

        case 1019:
        case 983:
          return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

        case 883:
          if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
          if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
          break;

        case 932:
          if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
            case 103:
              return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

            case 115:
              return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

            case 98:
              return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
          }
          return '-webkit-' + a + '-ms-' + a + a;

        case 964:
          return '-webkit-' + a + '-ms-flex-' + a + a;

        case 1023:
          if (99 !== a.charCodeAt(8)) break;
          b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
          return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

        case 1005:
          return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

        case 1e3:
          b = a.substring(13).trim();
          c = b.indexOf('-') + 1;

          switch (b.charCodeAt(0) + b.charCodeAt(c)) {
            case 226:
              b = a.replace(G, 'tb');
              break;

            case 232:
              b = a.replace(G, 'tb-rl');
              break;

            case 220:
              b = a.replace(G, 'lr');
              break;

            default:
              return a;
          }

          return '-webkit-' + a + '-ms-' + b + a;

        case 1017:
          if (-1 === a.indexOf('sticky', 9)) break;

        case 975:
          c = (a = d).length - 10;
          b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

          switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
            case 203:
              if (111 > b.charCodeAt(8)) break;

            case 115:
              a = a.replace(b, '-webkit-' + b) + ';' + a;
              break;

            case 207:
            case 102:
              a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
          }

          return a + ';';

        case 938:
          if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
            case 105:
              return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

            case 115:
              return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

            default:
              return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
          }
          break;

        case 973:
        case 989:
          if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

        case 931:
        case 953:
          if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
          break;

        case 962:
          if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
      }

      return a;
    }

    function L(d, c) {
      var e = d.indexOf(1 === c ? ':' : '{'),
          h = d.substring(0, 3 !== c ? e : 10);
      e = d.substring(e + 1, d.length - 1);
      return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }

    function ea(d, c) {
      var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
      return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }

    function H(d, c, e, h, a, m, b, v, n, q) {
      for (var g = 0, x = c, w; g < A; ++g) {
        switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;

          default:
            x = w;
        }
      }

      if (x !== c) return x;
    }

    function T(d) {
      switch (d) {
        case void 0:
        case null:
          A = S.length = 0;
          break;

        default:
          switch (d.constructor) {
            case Array:
              for (var c = 0, e = d.length; c < e; ++c) {
                T(d[c]);
              }

              break;

            case Function:
              S[A++] = d;
              break;

            case Boolean:
              Y = !!d | 0;
          }

      }

      return T;
    }

    function U(d) {
      d = d.prefix;
      void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
      return U;
    }

    function B(d, c) {
      var e = d;
      33 > e.charCodeAt(0) && (e = e.trim());
      V = e;
      e = [V];

      if (0 < A) {
        var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
        void 0 !== h && 'string' === typeof h && (c = h);
      }

      var a = M(O, e, c, 0, 0);
      0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
      V = '';
      E = 0;
      z = D = 1;
      return a;
    }

    var ca = /^\0+/g,
        N = /[\0\r\f]/g,
        aa = /: */g,
        ka = /zoo|gra/,
        ma = /([,: ])(transform)/g,
        ia = /,\r+?/g,
        F = /([\t\r\n ])*\f?&/g,
        fa = /@(k\w+)\s*(\S*)\s*/,
        Q = /::(place)/g,
        ha = /:(read-only)/g,
        G = /[svh]\w+-[tblr]{2}/,
        da = /\(\s*(.*)\s*\)/g,
        oa = /([\s\S]*?);/g,
        ba = /-self|flex-/g,
        na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
        la = /stretch|:\s*\w+\-(?:conte|avail)/,
        ja = /([^-])(image-set\()/,
        z = 1,
        D = 1,
        E = 0,
        w = 1,
        O = [],
        S = [],
        A = 0,
        R = null,
        Y = 0,
        V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
  }

  var hyphenateRegex = /[A-Z]|^ms/g;
  var processStyleName = memoize(function (styleName) {
    return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });
  var processStyleValue = function processStyleValue(key, value) {
    if (value == null || typeof value === 'boolean') {
      return '';
    }

    if (unitlessKeys[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
    !isNaN(value) && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  if (process.env.NODE_ENV !== 'production') {
    var contentValuePattern = /(attr|calc|counters?|url)\(/;
    var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
    var oldProcessStyleValue = processStyleValue;

    processStyleValue = function processStyleValue(key, value) {
      if (key === 'content') {
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
          console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
        }
      }

      return oldProcessStyleValue(key, value);
    };
  }

  var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';

    for (; i < len; i++) {
      var arg = args[i];
      if (arg == null) continue;
      var toAdd = void 0;

      switch (typeof arg) {
        case 'boolean':
          break;

        case 'function':
          if (process.env.NODE_ENV !== 'production') {
            console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
          }

          toAdd = classnames([arg()]);
          break;

        case 'object':
          {
            if (Array.isArray(arg)) {
              toAdd = classnames(arg);
            } else {
              toAdd = '';

              for (var k in arg) {
                if (arg[k] && k) {
                  toAdd && (toAdd += ' ');
                  toAdd += k;
                }
              }
            }

            break;
          }

        default:
          {
            toAdd = arg;
          }
      }

      if (toAdd) {
        cls && (cls += ' ');
        cls += toAdd;
      }
    }

    return cls;
  };
  var isBrowser = typeof document !== 'undefined';

  /*

  high performance StyleSheet for css-in-js systems

  - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance
  - 'polyfills' on server side

  // usage

  import StyleSheet from 'glamor/lib/sheet'
  let styleSheet = new StyleSheet()

  styleSheet.inject()
  - 'injects' the stylesheet into the page (or into memory if on server)

  styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet

  styleSheet.flush()
  - empties the stylesheet of all its contents

  */
  // $FlowFixMe
  function sheetForTag(tag) {
    if (tag.sheet) {
      // $FlowFixMe
      return tag.sheet;
    } // this weirdness brought to you by firefox


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        // $FlowFixMe
        return document.styleSheets[i];
      }
    }
  }

  function makeStyleTag(opts) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', opts.key || '');

    if (opts.nonce !== undefined) {
      tag.setAttribute('nonce', opts.nonce);
    }

    tag.appendChild(document.createTextNode('')) // $FlowFixMe
    ;
    (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
    return tag;
  }

  var StyleSheet =
  /*#__PURE__*/
  function () {
    function StyleSheet(options) {
      this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

      this.tags = [];
      this.ctr = 0;
      this.opts = options;
    }

    var _proto = StyleSheet.prototype;

    _proto.inject = function inject() {
      if (this.injected) {
        throw new Error('already injected!');
      }

      this.tags[0] = makeStyleTag(this.opts);
      this.injected = true;
    };

    _proto.speedy = function speedy(bool) {
      if (this.ctr !== 0) {
        // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
        throw new Error("cannot change speedy now");
      }

      this.isSpeedy = !!bool;
    };

    _proto.insert = function insert(rule, sourceMap) {
      // this is the ultrafast version, works across browsers
      if (this.isSpeedy) {
        var tag = this.tags[this.tags.length - 1];
        var sheet = sheetForTag(tag);

        try {
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn('illegal rule', rule); // eslint-disable-line no-console
          }
        }
      } else {
        var _tag = makeStyleTag(this.opts);

        this.tags.push(_tag);

        _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
      }

      this.ctr++;

      if (this.ctr % 65000 === 0) {
        this.tags.push(makeStyleTag(this.opts));
      }
    };

    _proto.flush = function flush() {
      // $FlowFixMe
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0; // todo - look for remnants in document.styleSheets

      this.injected = false;
    };

    return StyleSheet;
  }();

  function createEmotion(context, options) {
    if (context.__SECRET_EMOTION__ !== undefined) {
      return context.__SECRET_EMOTION__;
    }

    if (options === undefined) options = {};
    var key = options.key || 'css';

    if (process.env.NODE_ENV !== 'production') {
      if (/[^a-z-]/.test(key)) {
        throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
      }
    }

    var current;

    function insertRule(rule) {
      current += rule;

      if (isBrowser) {
        sheet.insert(rule, currentSourceMap);
      }
    }

    var insertionPlugin = stylisRuleSheet(insertRule);
    var stylisOptions;

    if (options.prefix !== undefined) {
      stylisOptions = {
        prefix: options.prefix
      };
    }

    var caches = {
      registered: {},
      inserted: {},
      nonce: options.nonce,
      key: key
    };
    var sheet = new StyleSheet(options);

    if (isBrowser) {
      // 🚀
      sheet.inject();
    }

    var stylis = new stylis_min(stylisOptions);
    stylis.use(options.stylisPlugins)(insertionPlugin);
    var currentSourceMap = '';

    function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
      if (interpolation == null) {
        return '';
      }

      switch (typeof interpolation) {
        case 'boolean':
          return '';

        case 'function':
          if (interpolation.__emotion_styles !== undefined) {
            var selector = interpolation.toString();

            if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
              throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
            }

            return selector;
          }

          if (this === undefined && process.env.NODE_ENV !== 'production') {
            console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
          }

          return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
          interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

        case 'object':
          return createStringFromObject.call(this, interpolation);

        default:
          var cached = caches.registered[interpolation];
          return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
      }
    }

    var objectToStringCache = new WeakMap();

    function createStringFromObject(obj) {
      if (objectToStringCache.has(obj)) {
        // $FlowFixMe
        return objectToStringCache.get(obj);
      }

      var string = '';

      if (Array.isArray(obj)) {
        obj.forEach(function (interpolation) {
          string += handleInterpolation.call(this, interpolation, false);
        }, this);
      } else {
        Object.keys(obj).forEach(function (key) {
          if (typeof obj[key] !== 'object') {
            if (caches.registered[obj[key]] !== undefined) {
              string += key + "{" + caches.registered[obj[key]] + "}";
            } else {
              string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
            }
          } else {
            if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
              throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
            }

            if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
              obj[key].forEach(function (value) {
                string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
              });
            } else {
              string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
            }
          }
        }, this);
      }

      objectToStringCache.set(obj, string);
      return string;
    }

    var name;
    var stylesWithLabel;
    var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

    var createClassName = function createClassName(styles, identifierName) {
      return murmurhash2_32_gc(styles + identifierName) + identifierName;
    };

    if (process.env.NODE_ENV !== 'production') {
      var oldCreateClassName = createClassName;
      var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

      createClassName = function createClassName(styles, identifierName) {
        return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
          currentSourceMap = sourceMap;
          return '';
        }), identifierName);
      };
    }

    var createStyles = function createStyles(strings) {
      var stringMode = true;
      var styles = '';
      var identifierName = '';

      if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation.call(this, strings, false);
      } else {
        styles += strings[0];
      }

      for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      interpolations.forEach(function (interpolation, i) {
        styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
        );

        if (stringMode === true && strings[i + 1] !== undefined) {
          styles += strings[i + 1];
        }
      }, this);
      stylesWithLabel = styles;
      styles = styles.replace(labelPattern, function (match, p1) {
        identifierName += "-" + p1;
        return '';
      });
      name = createClassName(styles, identifierName);
      return styles;
    };

    if (process.env.NODE_ENV !== 'production') {
      var oldStylis = stylis;

      stylis = function stylis(selector, styles) {
        oldStylis(selector, styles);
        currentSourceMap = '';
      };
    }

    function insert(scope, styles) {
      if (caches.inserted[name] === undefined) {
        current = '';
        stylis(scope, styles);
        caches.inserted[name] = current;
      }
    }

    var css = function css() {
      var styles = createStyles.apply(this, arguments);
      var selector = key + "-" + name;

      if (caches.registered[selector] === undefined) {
        caches.registered[selector] = stylesWithLabel;
      }

      insert("." + selector, styles);
      return selector;
    };

    var keyframes = function keyframes() {
      var styles = createStyles.apply(this, arguments);
      var animation = "animation-" + name;
      insert('', "@keyframes " + animation + "{" + styles + "}");
      return animation;
    };

    var injectGlobal = function injectGlobal() {
      var styles = createStyles.apply(this, arguments);
      insert('', styles);
    };

    function getRegisteredStyles(registeredStyles, classNames) {
      var rawClassName = '';
      classNames.split(' ').forEach(function (className) {
        if (caches.registered[className] !== undefined) {
          registeredStyles.push(className);
        } else {
          rawClassName += className + " ";
        }
      });
      return rawClassName;
    }

    function merge(className, sourceMap) {
      var registeredStyles = [];
      var rawClassName = getRegisteredStyles(registeredStyles, className);

      if (registeredStyles.length < 2) {
        return className;
      }

      return rawClassName + css(registeredStyles, sourceMap);
    }

    function cx() {
      for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classNames[_key2] = arguments[_key2];
      }

      return merge(classnames(classNames));
    }

    function hydrateSingleId(id) {
      caches.inserted[id] = true;
    }

    function hydrate(ids) {
      ids.forEach(hydrateSingleId);
    }

    function flush() {
      if (isBrowser) {
        sheet.flush();
        sheet.inject();
      }

      caches.inserted = {};
      caches.registered = {};
    }

    if (isBrowser) {
      var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
      Array.prototype.forEach.call(chunks, function (node) {
        // $FlowFixMe
        sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

        node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
      });
    }

    var emotion = {
      flush: flush,
      hydrate: hydrate,
      cx: cx,
      merge: merge,
      getRegisteredStyles: getRegisteredStyles,
      injectGlobal: injectGlobal,
      keyframes: keyframes,
      css: css,
      sheet: sheet,
      caches: caches
    };
    context.__SECRET_EMOTION__ = emotion;
    return emotion;
  }

  var context = typeof global !== 'undefined' ? global : {};

  var _createEmotion = createEmotion(context),
      flush = _createEmotion.flush,
      hydrate = _createEmotion.hydrate,
      cx = _createEmotion.cx,
      merge = _createEmotion.merge,
      getRegisteredStyles = _createEmotion.getRegisteredStyles,
      injectGlobal = _createEmotion.injectGlobal,
      keyframes = _createEmotion.keyframes,
      css = _createEmotion.css,
      sheet = _createEmotion.sheet,
      caches = _createEmotion.caches;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
  }

  function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
  }

  function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$1(o, p);
  }

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose$1(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized$1(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn$1(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized$1(self);
  }

  function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
  }

  function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray$1(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  // ==============================
  // NO OP
  // ==============================
  var noop = function noop() {};
  // Class Name Prefixer
  // ==============================

  /**
   String representation of component state for styling with class names.

   Expects an array of strings OR a string/object pair:
   - className(['comp', 'comp-arg', 'comp-arg-2'])
     @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
   - className('comp', { some: true, state: false })
     @returns 'react-select__comp react-select__comp--some'
  */

  function applyPrefixToName(prefix, name) {
    if (!name) {
      return prefix;
    } else if (name[0] === '-') {
      return prefix + name;
    } else {
      return prefix + '__' + name;
    }
  }

  function classNames(prefix, cssKey, state, className) {
    var arr = [cssKey, className];

    if (state && prefix) {
      for (var key in state) {
        if (state.hasOwnProperty(key) && state[key]) {
          arr.push("".concat(applyPrefixToName(prefix, key)));
        }
      }
    }

    return arr.filter(function (i) {
      return i;
    }).map(function (i) {
      return String(i).trim();
    }).join(' ');
  } // ==============================
  // Clean Value
  // ==============================

  var cleanValue = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (_typeof(value) === 'object' && value !== null) return [value];
    return [];
  }; // ==============================
  // Handle Input Change
  // ==============================

  function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
      var newValue = onInputChange(inputValue, actionMeta);
      if (typeof newValue === 'string') return newValue;
    }

    return inputValue;
  } // ==============================
  // Scroll Helpers
  // ==============================

  function isDocumentElement(el) {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
  } // Normalized Scroll Top
  // ------------------------------

  function getScrollTop(el) {
    if (isDocumentElement(el)) {
      return window.pageYOffset;
    }

    return el.scrollTop;
  }
  function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
      window.scrollTo(0, top);
      return;
    }

    el.scrollTop = top;
  } // Get Scroll Parent
  // ------------------------------

  function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...

    if (style.position === 'fixed') return docEl;

    for (var parent = element; parent = parent.parentElement;) {
      style = getComputedStyle(parent);

      if (excludeStaticParent && style.position === 'static') {
        continue;
      }

      if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
        return parent;
      }
    }

    return docEl;
  } // Animated Scroll To
  // ------------------------------

  /**
    @param t: time (elapsed)
    @param b: initial value
    @param c: amount of change
    @param d: duration
  */

  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;

    function animateScroll() {
      currentTime += increment;
      var val = easeOutCubic(currentTime, start, change, duration);
      scrollTo(element, val);

      if (currentTime < duration) {
        raf(animateScroll);
      } else {
        callback(element);
      }
    }

    animateScroll();
  } // Scroll Into View
  // ------------------------------

  function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;

    if (focusedRect.bottom + overScroll > menuRect.bottom) {
      scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    } else if (focusedRect.top - overScroll < menuRect.top) {
      scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
  } // ==============================
  // Get bounding client object
  // ==============================
  // cannot get keys using array notation with DOMRect

  function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
      bottom: rect.bottom,
      height: rect.height,
      left: rect.left,
      right: rect.right,
      top: rect.top,
      width: rect.width
    };
  }
  // Touch Capability Detector
  // ==============================

  function isTouchCapable() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  } // ==============================
  // Mobile Device Detector
  // ==============================

  function isMobileDevice() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return false;
    }
  }

  function getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight,
        menuEl = _ref.menuEl,
        minHeight = _ref.minHeight,
        placement = _ref.placement,
        shouldScroll = _ref.shouldScroll,
        isFixedPosition = _ref.isFixedPosition,
        theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
      placement: 'bottom',
      maxHeight: maxHeight
    }; // something went wrong, return default state

    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered

    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
        scrollHeight = _scrollParent$getBoun.height;

    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
        menuBottom = _menuEl$getBoundingCl.bottom,
        menuHeight = _menuEl$getBoundingCl.height,
        menuTop = _menuEl$getBoundingCl.top;

    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
        containerTop = _menuEl$offsetParent$.top;

    var viewHeight = window.innerHeight;
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;

    switch (placement) {
      case 'auto':
      case 'bottom':
        // 1: the menu will fit, do nothing
        if (viewSpaceBelow >= menuHeight) {
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled


        if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          }

          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained


        if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          } // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.


          var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
          return {
            placement: 'bottom',
            maxHeight: constrainedHeight
          };
        } // 4. Forked beviour when there isn't enough space below
        // AUTO: flip the menu, render above


        if (placement === 'auto' || isFixedPosition) {
          // may need to be constrained after flipping
          var _constrainedHeight = maxHeight;
          var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

          if (spaceAbove >= minHeight) {
            _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
          }

          return {
            placement: 'top',
            maxHeight: _constrainedHeight
          };
        } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


        if (placement === 'bottom') {
          scrollTo(scrollParent, scrollDown);
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        }

        break;

      case 'top':
        // 1: the menu will fit, do nothing
        if (viewSpaceAbove >= menuHeight) {
          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled


        if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }

          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained


        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.

          if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
            _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
          }

          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }

          return {
            placement: 'top',
            maxHeight: _constrainedHeight2
          };
        } // 4. not enough space, the browser WILL NOT increase scrollable area when
        // absolutely positioned element rendered above the viewport (only below).
        // Flip the menu, render below


        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };

      default:
        throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    } // fulfil contract with flow: implicit return value of undefined


    return defaultState;
  } // Menu Component
  // ------------------------------

  function alignToControl(placement) {
    var placementToCSSProp = {
      bottom: 'top',
      top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
  }

  var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
  };

  var menuCSS = function menuCSS(_ref2) {
    var _ref3;

    var placement = _ref2.placement,
        _ref2$theme = _ref2.theme,
        borderRadius = _ref2$theme.borderRadius,
        spacing = _ref2$theme.spacing,
        colors = _ref2$theme.colors;
    return _ref3 = {
      label: 'menu'
    }, _defineProperty$1(_ref3, alignToControl(placement), '100%'), _defineProperty$1(_ref3, "backgroundColor", colors.neutral0), _defineProperty$1(_ref3, "borderRadius", borderRadius), _defineProperty$1(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty$1(_ref3, "marginBottom", spacing.menuGutter), _defineProperty$1(_ref3, "marginTop", spacing.menuGutter), _defineProperty$1(_ref3, "position", 'absolute'), _defineProperty$1(_ref3, "width", '100%'), _defineProperty$1(_ref3, "zIndex", 1), _ref3;
  }; // NOTE: internal only

  var MenuPlacer =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(MenuPlacer, _Component);

    function MenuPlacer() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$1(this, MenuPlacer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
        maxHeight: _this.props.maxMenuHeight,
        placement: null
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getPlacement", function (ref) {
        var _this$props = _this.props,
            minMenuHeight = _this$props.minMenuHeight,
            maxMenuHeight = _this$props.maxMenuHeight,
            menuPlacement = _this$props.menuPlacement,
            menuPosition = _this$props.menuPosition,
            menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
            theme = _this$props.theme;
        var getPortalPlacement = _this.context.getPortalPlacement;
        if (!ref) return; // DO NOT scroll if position is fixed

        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
          maxHeight: maxMenuHeight,
          menuEl: ref,
          minHeight: minMenuHeight,
          placement: menuPlacement,
          shouldScroll: shouldScroll,
          isFixedPosition: isFixedPosition,
          theme: theme
        });
        if (getPortalPlacement) getPortalPlacement(state);

        _this.setState(state);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getUpdatedProps", function () {
        var menuPlacement = _this.props.menuPlacement;
        var placement = _this.state.placement || coercePlacement(menuPlacement);
        return _objectSpread({}, _this.props, {
          placement: placement,
          maxHeight: _this.state.maxHeight
        });
      });

      return _this;
    }

    _createClass$1(MenuPlacer, [{
      key: "render",
      value: function render() {
        var children = this.props.children;
        return children({
          ref: this.getPlacement,
          placerProps: this.getUpdatedProps()
        });
      }
    }]);

    return MenuPlacer;
  }(React.Component);

  _defineProperty$1(MenuPlacer, "contextTypes", {
    getPortalPlacement: PropTypes__default.func
  });

  var Menu = function Menu(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerRef = props.innerRef,
        innerProps = props.innerProps;
    var cn = cx(
    /*#__PURE__*/
    css(getStyles('menu', props)), {
      menu: true
    }, className);
    return React__default.createElement("div", _extends$1({
      className: cn
    }, innerProps, {
      ref: innerRef
    }), children);
  };
  // Menu List
  // ==============================

  var menuListCSS = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight,
        baseUnit = _ref4.theme.spacing.baseUnit;
    return {
      maxHeight: maxHeight,
      overflowY: 'auto',
      paddingBottom: baseUnit,
      paddingTop: baseUnit,
      position: 'relative',
      // required for offset[Height, Top] > keyboard scroll
      WebkitOverflowScrolling: 'touch'
    };
  };
  var MenuList = function MenuList(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isMulti = props.isMulti,
        innerRef = props.innerRef;
    return React__default.createElement("div", {
      className: cx(
      /*#__PURE__*/
      css(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    }, children);
  }; // ==============================
  // Menu Notices
  // ==============================

  var noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme,
        baseUnit = _ref5$theme.spacing.baseUnit,
        colors = _ref5$theme.colors;
    return {
      color: colors.neutral40,
      padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
      textAlign: 'center'
    };
  };

  var noOptionsMessageCSS = noticeCSS;
  var loadingMessageCSS = noticeCSS;
  var NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({
      className: cx(
      /*#__PURE__*/
      css(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps), children);
  };
  NoOptionsMessage.defaultProps = {
    children: 'No options'
  };
  var LoadingMessage = function LoadingMessage(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({
      className: cx(
      /*#__PURE__*/
      css(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps), children);
  };
  LoadingMessage.defaultProps = {
    children: 'Loading...'
  }; // ==============================
  // Menu Portal
  // ==============================

  var menuPortalCSS = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect,
        offset = _ref6.offset,
        position = _ref6.position;
    return {
      left: rect.left,
      position: position,
      top: offset,
      width: rect.width,
      zIndex: 1
    };
  };
  var MenuPortal =
  /*#__PURE__*/
  function (_Component2) {
    _inherits$1(MenuPortal, _Component2);

    function MenuPortal() {
      var _getPrototypeOf3;

      var _this2;

      _classCallCheck$1(this, MenuPortal);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _possibleConstructorReturn$1(this, (_getPrototypeOf3 = _getPrototypeOf$1(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this2)), "state", {
        placement: null
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this2)), "getPortalPlacement", function (_ref7) {
        var placement = _ref7.placement;
        var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

        if (placement !== initialPlacement) {
          _this2.setState({
            placement: placement
          });
        }
      });

      return _this2;
    }

    _createClass$1(MenuPortal, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          getPortalPlacement: this.getPortalPlacement
        };
      } // callback for occassions where the menu must "flip"

    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            appendTo = _this$props2.appendTo,
            children = _this$props2.children,
            controlElement = _this$props2.controlElement,
            menuPlacement = _this$props2.menuPlacement,
            position = _this$props2.menuPosition,
            getStyles = _this$props2.getStyles;
        var isFixed = position === 'fixed'; // bail early if required elements aren't present

        if (!appendTo && !isFixed || !controlElement) {
          return null;
        }

        var placement = this.state.placement || coercePlacement(menuPlacement);
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = isFixed ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        var state = {
          offset: offset,
          position: position,
          rect: rect
        }; // same wrapper element whether fixed or portalled

        var menuWrapper = React__default.createElement("div", {
          className:
          /*#__PURE__*/

          /*#__PURE__*/
          css(getStyles('menuPortal', state))
        }, children);
        return appendTo ? reactDom.createPortal(menuWrapper, appendTo) : menuWrapper;
      }
    }]);

    return MenuPortal;
  }(React.Component);

  _defineProperty$1(MenuPortal, "childContextTypes", {
    getPortalPlacement: PropTypes__default.func
  });

  var isArray = Array.isArray;
  var keyList = Object.keys;
  var hasProp = Object.prototype.hasOwnProperty;

  function equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;

    if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
      var arrA = isArray(a),
          arrB = isArray(b),
          i,
          length,
          key;

      if (arrA && arrB) {
        length = a.length;
        if (length != b.length) return false;

        for (i = length; i-- !== 0;) {
          if (!equal(a[i], b[i])) return false;
        }

        return true;
      }

      if (arrA != arrB) return false;
      var dateA = a instanceof Date,
          dateB = b instanceof Date;
      if (dateA != dateB) return false;
      if (dateA && dateB) return a.getTime() == b.getTime();
      var regexpA = a instanceof RegExp,
          regexpB = b instanceof RegExp;
      if (regexpA != regexpB) return false;
      if (regexpA && regexpB) return a.toString() == b.toString();
      var keys = keyList(a);
      length = keys.length;

      if (length !== keyList(b).length) {
        return false;
      }

      for (i = length; i-- !== 0;) {
        if (!hasProp.call(b, keys[i])) return false;
      } // end fast-deep-equal
      // Custom handling for React


      for (i = length; i-- !== 0;) {
        key = keys[i];

        if (key === '_owner' && a.$$typeof) {
          // React-specific: avoid traversing React elements' _owner.
          //  _owner contains circular references
          // and is not needed when comparing the actual elements (and not their owners)
          // .$$typeof and ._store on just reasonable markers of a react element
          continue;
        } else {
          // all other properties should be traversed as usual
          if (!equal(a[key], b[key])) return false;
        }
      } // fast-deep-equal index.js 2.0.1


      return true;
    }

    return a !== a && b !== b;
  } // end fast-deep-equal


  function exportedEqual(a, b) {
    try {
      return equal(a, b);
    } catch (error) {
      if (error.message && error.message.match(/stack|recursion/i)) {
        // warn on circular references, don't crash
        // browsers give this different errors name and messages:
        // chrome/safari: "RangeError", "Maximum call stack size exceeded"
        // firefox: "InternalError", too much recursion"
        // edge: "Error", "Out of stack space"
        console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
        return false;
      } // some other error. we should definitely know about these


      throw error;
    }
  }

  var diacritics = [{
    base: 'A',
    letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
  }, {
    base: 'AA',
    letters: /[\uA732]/g
  }, {
    base: 'AE',
    letters: /[\u00C6\u01FC\u01E2]/g
  }, {
    base: 'AO',
    letters: /[\uA734]/g
  }, {
    base: 'AU',
    letters: /[\uA736]/g
  }, {
    base: 'AV',
    letters: /[\uA738\uA73A]/g
  }, {
    base: 'AY',
    letters: /[\uA73C]/g
  }, {
    base: 'B',
    letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
  }, {
    base: 'C',
    letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
  }, {
    base: 'D',
    letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
  }, {
    base: 'DZ',
    letters: /[\u01F1\u01C4]/g
  }, {
    base: 'Dz',
    letters: /[\u01F2\u01C5]/g
  }, {
    base: 'E',
    letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
  }, {
    base: 'F',
    letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
  }, {
    base: 'G',
    letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
  }, {
    base: 'H',
    letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
  }, {
    base: 'I',
    letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
  }, {
    base: 'J',
    letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
  }, {
    base: 'K',
    letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
  }, {
    base: 'L',
    letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
  }, {
    base: 'LJ',
    letters: /[\u01C7]/g
  }, {
    base: 'Lj',
    letters: /[\u01C8]/g
  }, {
    base: 'M',
    letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
  }, {
    base: 'N',
    letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
  }, {
    base: 'NJ',
    letters: /[\u01CA]/g
  }, {
    base: 'Nj',
    letters: /[\u01CB]/g
  }, {
    base: 'O',
    letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
  }, {
    base: 'OI',
    letters: /[\u01A2]/g
  }, {
    base: 'OO',
    letters: /[\uA74E]/g
  }, {
    base: 'OU',
    letters: /[\u0222]/g
  }, {
    base: 'P',
    letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
  }, {
    base: 'Q',
    letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
  }, {
    base: 'R',
    letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
  }, {
    base: 'S',
    letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
  }, {
    base: 'T',
    letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
  }, {
    base: 'TZ',
    letters: /[\uA728]/g
  }, {
    base: 'U',
    letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
  }, {
    base: 'V',
    letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
  }, {
    base: 'VY',
    letters: /[\uA760]/g
  }, {
    base: 'W',
    letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
  }, {
    base: 'X',
    letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
  }, {
    base: 'Y',
    letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
  }, {
    base: 'Z',
    letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
  }, {
    base: 'a',
    letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
  }, {
    base: 'aa',
    letters: /[\uA733]/g
  }, {
    base: 'ae',
    letters: /[\u00E6\u01FD\u01E3]/g
  }, {
    base: 'ao',
    letters: /[\uA735]/g
  }, {
    base: 'au',
    letters: /[\uA737]/g
  }, {
    base: 'av',
    letters: /[\uA739\uA73B]/g
  }, {
    base: 'ay',
    letters: /[\uA73D]/g
  }, {
    base: 'b',
    letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
  }, {
    base: 'c',
    letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
  }, {
    base: 'd',
    letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
  }, {
    base: 'dz',
    letters: /[\u01F3\u01C6]/g
  }, {
    base: 'e',
    letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
  }, {
    base: 'f',
    letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
  }, {
    base: 'g',
    letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
  }, {
    base: 'h',
    letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
  }, {
    base: 'hv',
    letters: /[\u0195]/g
  }, {
    base: 'i',
    letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
  }, {
    base: 'j',
    letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
  }, {
    base: 'k',
    letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
  }, {
    base: 'l',
    letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
  }, {
    base: 'lj',
    letters: /[\u01C9]/g
  }, {
    base: 'm',
    letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
  }, {
    base: 'n',
    letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
  }, {
    base: 'nj',
    letters: /[\u01CC]/g
  }, {
    base: 'o',
    letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
  }, {
    base: 'oi',
    letters: /[\u01A3]/g
  }, {
    base: 'ou',
    letters: /[\u0223]/g
  }, {
    base: 'oo',
    letters: /[\uA74F]/g
  }, {
    base: 'p',
    letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
  }, {
    base: 'q',
    letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
  }, {
    base: 'r',
    letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
  }, {
    base: 's',
    letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
  }, {
    base: 't',
    letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
  }, {
    base: 'tz',
    letters: /[\uA729]/g
  }, {
    base: 'u',
    letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
  }, {
    base: 'v',
    letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
  }, {
    base: 'vy',
    letters: /[\uA761]/g
  }, {
    base: 'w',
    letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
  }, {
    base: 'x',
    letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
  }, {
    base: 'y',
    letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
  }, {
    base: 'z',
    letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
  }];
  var stripDiacritics = function stripDiacritics(str) {
    for (var i = 0; i < diacritics.length; i++) {
      str = str.replace(diacritics[i].letters, diacritics[i].base);
    }

    return str;
  };

  var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
  };

  var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
  };

  var createFilter = function createFilter(config) {
    return function (option, rawInput) {
      var _ignoreCase$ignoreAcc = _objectSpread({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
          ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
          ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
          stringify = _ignoreCase$ignoreAcc.stringify,
          trim = _ignoreCase$ignoreAcc.trim,
          matchFrom = _ignoreCase$ignoreAcc.matchFrom;

      var input = trim ? trimString(rawInput) : rawInput;
      var candidate = trim ? trimString(stringify(option)) : stringify(option);

      if (ignoreCase) {
        input = input.toLowerCase();
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        input = stripDiacritics(input);
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
  };

  var A11yText = function A11yText(props) {
    return React__default.createElement("span", _extends$1({
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        label: 'a11yText',
        zIndex: 9999,
        border: 0,
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: 1,
        width: 1,
        position: 'absolute',
        overflow: 'hidden',
        padding: 0,
        whiteSpace: 'nowrap',
        backgroundColor: 'red',
        color: 'blue'
      })
    }, props));
  };

  var DummyInput =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(DummyInput, _Component);

    function DummyInput() {
      _classCallCheck$1(this, DummyInput);

      return _possibleConstructorReturn$1(this, _getPrototypeOf$1(DummyInput).apply(this, arguments));
    }

    _createClass$1(DummyInput, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            inProp = _this$props.in,
            out = _this$props.out,
            onExited = _this$props.onExited,
            appear = _this$props.appear,
            enter = _this$props.enter,
            exit = _this$props.exit,
            innerRef = _this$props.innerRef,
            emotion = _this$props.emotion,
            props = _objectWithoutProperties$1(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

        return React__default.createElement("input", _extends$1({
          ref: innerRef
        }, props, {
          className:
          /*#__PURE__*/

          /*#__PURE__*/
          css({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: 'inherit',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(0)'
          })
        }));
      }
    }]);

    return DummyInput;
  }(React.Component);

  var NodeResolver =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(NodeResolver, _Component);

    function NodeResolver() {
      _classCallCheck$1(this, NodeResolver);

      return _possibleConstructorReturn$1(this, _getPrototypeOf$1(NodeResolver).apply(this, arguments));
    }

    _createClass$1(NodeResolver, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.innerRef(reactDom.findDOMNode(this));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.props.innerRef(null);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children;
      }
    }]);

    return NodeResolver;
  }(React.Component);

  var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
  var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
  };

  function preventTouchMove(e) {
    e.preventDefault();
  }
  function allowTouchMove(e) {
    e.stopPropagation();
  }
  function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;

    if (top === 0) {
      this.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      this.scrollTop = top - 1;
    }
  } // `ontouchstart` check works on most browsers
  // `maxTouchPoints` works on IE10/11 and Surface

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }

  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  var activeScrollLocks = 0;

  var ScrollLock =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(ScrollLock, _Component);

    function ScrollLock() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$1(this, ScrollLock);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "originalStyles", {});

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "listenerOptions", {
        capture: false,
        passive: false
      });

      return _this;
    }

    _createClass$1(ScrollLock, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (!canUseDOM) return;
        var _this$props = this.props,
            accountForScrollbars = _this$props.accountForScrollbars,
            touchScrollTarget = _this$props.touchScrollTarget;
        var target = document.body;
        var targetStyle = target && target.style;

        if (accountForScrollbars) {
          // store any styles already applied to the body
          STYLE_KEYS.forEach(function (key) {
            var val = targetStyle && targetStyle[key];
            _this2.originalStyles[key] = val;
          });
        } // apply the lock styles and padding if this is the first scroll lock


        if (accountForScrollbars && activeScrollLocks < 1) {
          var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
          var clientWidth = document.body ? document.body.clientWidth : 0;
          var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
          Object.keys(LOCK_STYLES).forEach(function (key) {
            var val = LOCK_STYLES[key];

            if (targetStyle) {
              targetStyle[key] = val;
            }
          });

          if (targetStyle) {
            targetStyle.paddingRight = "".concat(adjustedPadding, "px");
          }
        } // account for touch devices


        if (target && isTouchDevice()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
          }
        } // increment active scroll locks


        activeScrollLocks += 1;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;

        if (!canUseDOM) return;
        var _this$props2 = this.props,
            accountForScrollbars = _this$props2.accountForScrollbars,
            touchScrollTarget = _this$props2.touchScrollTarget;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks

        activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

        if (accountForScrollbars && activeScrollLocks < 1) {
          STYLE_KEYS.forEach(function (key) {
            var val = _this3.originalStyles[key];

            if (targetStyle) {
              targetStyle[key] = val;
            }
          });
        } // remove touch listeners


        if (target && isTouchDevice()) {
          target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return ScrollLock;
  }(React.Component);

  _defineProperty$1(ScrollLock, "defaultProps", {
    accountForScrollbars: true
  });

  // NOTE:
  // We shouldn't need this after updating to React v16.3.0, which introduces:
  // - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
  // - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
  var ScrollBlock =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits$1(ScrollBlock, _PureComponent);

    function ScrollBlock() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$1(this, ScrollBlock);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
        touchScrollTarget: null
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getScrollTarget", function (ref) {
        if (ref === _this.state.touchScrollTarget) return;

        _this.setState({
          touchScrollTarget: ref
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "blurSelectInput", function () {
        if (document.activeElement) {
          document.activeElement.blur();
        }
      });

      return _this;
    }

    _createClass$1(ScrollBlock, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            isEnabled = _this$props.isEnabled;
        var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

        if (!isEnabled) return children;
        /*
         * Div
         * ------------------------------
         * blocks scrolling on non-body elements behind the menu
          * NodeResolver
         * ------------------------------
         * we need a reference to the scrollable element to "unlock" scroll on
         * mobile devices
          * ScrollLock
         * ------------------------------
         * actually does the scroll locking
         */

        return React__default.createElement("div", null, React__default.createElement("div", {
          onClick: this.blurSelectInput,
          className:
          /*#__PURE__*/

          /*#__PURE__*/
          css({
            position: 'fixed',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0
          })
        }), React__default.createElement(NodeResolver, {
          innerRef: this.getScrollTarget
        }, children), touchScrollTarget ? React__default.createElement(ScrollLock, {
          touchScrollTarget: touchScrollTarget
        }) : null);
      }
    }]);

    return ScrollBlock;
  }(React.PureComponent);

  var ScrollCaptor =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(ScrollCaptor, _Component);

    function ScrollCaptor() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$1(this, ScrollCaptor);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "isBottom", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "isTop", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "scrollTarget", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "touchStart", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "cancelScroll", function (event) {
        event.preventDefault();
        event.stopPropagation();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleEventDelta", function (event, delta) {
        var _this$props = _this.props,
            onBottomArrive = _this$props.onBottomArrive,
            onBottomLeave = _this$props.onBottomLeave,
            onTopArrive = _this$props.onTopArrive,
            onTopLeave = _this$props.onTopLeave;
        var _this$scrollTarget = _this.scrollTarget,
            scrollTop = _this$scrollTarget.scrollTop,
            scrollHeight = _this$scrollTarget.scrollHeight,
            clientHeight = _this$scrollTarget.clientHeight;
        var target = _this.scrollTarget;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags

        if (availableScroll > delta && _this.isBottom) {
          if (onBottomLeave) onBottomLeave(event);
          _this.isBottom = false;
        }

        if (isDeltaPositive && _this.isTop) {
          if (onTopLeave) onTopLeave(event);
          _this.isTop = false;
        } // bottom limit


        if (isDeltaPositive && delta > availableScroll) {
          if (onBottomArrive && !_this.isBottom) {
            onBottomArrive(event);
          }

          target.scrollTop = scrollHeight;
          shouldCancelScroll = true;
          _this.isBottom = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
          if (onTopArrive && !_this.isTop) {
            onTopArrive(event);
          }

          target.scrollTop = 0;
          shouldCancelScroll = true;
          _this.isTop = true;
        } // cancel scroll


        if (shouldCancelScroll) {
          _this.cancelScroll(event);
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onWheel", function (event) {
        _this.handleEventDelta(event, event.deltaY);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onTouchStart", function (event) {
        // set touch start so we can calculate touchmove delta
        _this.touchStart = event.changedTouches[0].clientY;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onTouchMove", function (event) {
        var deltaY = _this.touchStart - event.changedTouches[0].clientY;

        _this.handleEventDelta(event, deltaY);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getScrollTarget", function (ref) {
        _this.scrollTarget = ref;
      });

      return _this;
    }

    _createClass$1(ScrollCaptor, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startListening(this.scrollTarget);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.stopListening(this.scrollTarget);
      }
    }, {
      key: "startListening",
      value: function startListening(el) {
        // bail early if no scroll available
        if (!el) return;
        if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

        if (typeof el.addEventListener === 'function') {
          el.addEventListener('wheel', this.onWheel, false);
        }

        if (typeof el.addEventListener === 'function') {
          el.addEventListener('touchstart', this.onTouchStart, false);
        }

        if (typeof el.addEventListener === 'function') {
          el.addEventListener('touchmove', this.onTouchMove, false);
        }
      }
    }, {
      key: "stopListening",
      value: function stopListening(el) {
        // bail early if no scroll available
        if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

        if (typeof el.removeEventListener === 'function') {
          el.removeEventListener('wheel', this.onWheel, false);
        }

        if (typeof el.removeEventListener === 'function') {
          el.removeEventListener('touchstart', this.onTouchStart, false);
        }

        if (typeof el.removeEventListener === 'function') {
          el.removeEventListener('touchmove', this.onTouchMove, false);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(NodeResolver, {
          innerRef: this.getScrollTarget
        }, this.props.children);
      }
    }]);

    return ScrollCaptor;
  }(React.Component);

  var ScrollCaptorSwitch =
  /*#__PURE__*/
  function (_Component2) {
    _inherits$1(ScrollCaptorSwitch, _Component2);

    function ScrollCaptorSwitch() {
      _classCallCheck$1(this, ScrollCaptorSwitch);

      return _possibleConstructorReturn$1(this, _getPrototypeOf$1(ScrollCaptorSwitch).apply(this, arguments));
    }

    _createClass$1(ScrollCaptorSwitch, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            isEnabled = _this$props2.isEnabled,
            props = _objectWithoutProperties$1(_this$props2, ["isEnabled"]);

        return isEnabled ? React__default.createElement(ScrollCaptor, props) : this.props.children;
      }
    }]);

    return ScrollCaptorSwitch;
  }(React.Component);

  _defineProperty$1(ScrollCaptorSwitch, "defaultProps", {
    isEnabled: true
  });

  var instructionsAriaMessage = function instructionsAriaMessage(event) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isSearchable = context.isSearchable,
        isMulti = context.isMulti,
        label = context.label,
        isDisabled = context.isDisabled;

    switch (event) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

      case 'input':
        return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
    }
  };
  var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
    var value = context.value,
        isDisabled = context.isDisabled;
    if (!value) return;

    switch (event) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(value, ", deselected.");

      case 'select-option':
        return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
    }
  };
  var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
    var focusedValue = _ref.focusedValue,
        getOptionLabel = _ref.getOptionLabel,
        selectValue = _ref.selectValue;
    return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
  };
  var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
    var focusedOption = _ref2.focusedOption,
        getOptionLabel = _ref2.getOptionLabel,
        options = _ref2.options;
    return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
  };
  var resultsAriaMessage = function resultsAriaMessage(_ref3) {
    var inputValue = _ref3.inputValue,
        screenReaderMessage = _ref3.screenReaderMessage;
    return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  };

  var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
  };
  var getOptionLabel = function getOptionLabel(option) {
    return option.label;
  };
  var getOptionValue = function getOptionValue(option) {
    return option.value;
  };
  var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
  };

  var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        isRtl = _ref.isRtl;
    return {
      label: 'container',
      direction: isRtl ? 'rtl' : null,
      pointerEvents: isDisabled ? 'none' : null,
      // cancel mouse events when disabled
      position: 'relative'
    };
  };
  var SelectContainer = function SelectContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isDisabled = props.isDisabled,
        isRtl = props.isRtl;
    return React__default.createElement("div", _extends$1({
      className: cx(
      /*#__PURE__*/
      css(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps), children);
  }; // ==============================
  // Value Container
  // ==============================

  var valueContainerCSS = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
      WebkitOverflowScrolling: 'touch',
      position: 'relative',
      overflow: 'hidden'
    };
  };
  var ValueContainer =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(ValueContainer, _Component);

    function ValueContainer() {
      _classCallCheck$1(this, ValueContainer);

      return _possibleConstructorReturn$1(this, _getPrototypeOf$1(ValueContainer).apply(this, arguments));
    }

    _createClass$1(ValueContainer, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            className = _this$props.className,
            cx = _this$props.cx,
            isMulti = _this$props.isMulti,
            getStyles = _this$props.getStyles,
            hasValue = _this$props.hasValue;
        return React__default.createElement("div", {
          className: cx(
          /*#__PURE__*/
          css(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        }, children);
      }
    }]);

    return ValueContainer;
  }(React.Component); // ==============================
  // Indicator Container
  // ==============================

  var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'flex',
      flexShrink: 0
    };
  };
  var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles;
    return React__default.createElement("div", {
      className: cx(
      /*#__PURE__*/
      css(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    }, children);
  };

  // ==============================
  // Dropdown & Clear Icons
  // ==============================
  var Svg = function Svg(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties$1(_ref, ["size"]);

    return React__default.createElement("svg", _extends$1({
      height: size,
      width: size,
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false",
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        display: 'inline-block',
        fill: 'currentColor',
        lineHeight: 1,
        stroke: 'currentColor',
        strokeWidth: 0
      })
    }, props));
  };

  var CrossIcon = function CrossIcon(props) {
    return React__default.createElement(Svg, _extends$1({
      size: 20
    }, props), React__default.createElement("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
  };
  var DownChevron = function DownChevron(props) {
    return React__default.createElement(Svg, _extends$1({
      size: 20
    }, props), React__default.createElement("path", {
      d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
  }; // ==============================
  // Dropdown & Clear Buttons
  // ==============================

  var baseCSS = function baseCSS(_ref2) {
    var isFocused = _ref2.isFocused,
        _ref2$theme = _ref2.theme,
        baseUnit = _ref2$theme.spacing.baseUnit,
        colors = _ref2$theme.colors;
    return {
      label: 'indicatorContainer',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      ':hover': {
        color: isFocused ? colors.neutral80 : colors.neutral40
      }
    };
  };

  var dropdownIndicatorCSS = baseCSS;
  var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({}, innerProps, {
      className: cx(
      /*#__PURE__*/
      css(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }), children || React__default.createElement(DownChevron, null));
  };
  var clearIndicatorCSS = baseCSS;
  var ClearIndicator = function ClearIndicator(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({}, innerProps, {
      className: cx(
      /*#__PURE__*/
      css(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }), children || React__default.createElement(CrossIcon, null));
  }; // ==============================
  // Separator
  // ==============================

  var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
    var isDisabled = _ref3.isDisabled,
        _ref3$theme = _ref3.theme,
        baseUnit = _ref3$theme.spacing.baseUnit,
        colors = _ref3$theme.colors;
    return {
      label: 'indicatorSeparator',
      alignSelf: 'stretch',
      backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
      marginBottom: baseUnit * 2,
      marginTop: baseUnit * 2,
      width: 1
    };
  };
  var IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return React__default.createElement("span", _extends$1({}, innerProps, {
      className: cx(
      /*#__PURE__*/
      css(getStyles('indicatorSeparator', props)), {
        'indicator-separator': true
      }, className)
    }));
  }; // ==============================
  // Loading
  // ==============================

  var keyframesName = 'react-select-loading-indicator';
  var keyframesInjected = false;
  var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
    var isFocused = _ref4.isFocused,
        size = _ref4.size,
        _ref4$theme = _ref4.theme,
        colors = _ref4$theme.colors,
        baseUnit = _ref4$theme.spacing.baseUnit;
    return {
      label: 'loadingIndicator',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      alignSelf: 'center',
      fontSize: size,
      lineHeight: 1,
      marginRight: size,
      textAlign: 'center',
      verticalAlign: 'middle'
    };
  };

  var LoadingDot = function LoadingDot(_ref5) {
    var color = _ref5.color,
        delay = _ref5.delay,
        offset = _ref5.offset;
    return React__default.createElement("span", {
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        animationDuration: '1s',
        animationDelay: "".concat(delay, "ms"),
        animationIterationCount: 'infinite',
        animationName: keyframesName,
        animationTimingFunction: 'ease-in-out',
        backgroundColor: color,
        borderRadius: '1em',
        display: 'inline-block',
        marginLeft: offset ? '1em' : null,
        height: '1em',
        verticalAlign: 'top',
        width: '1em'
      })
    });
  };

  var LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isFocused = props.isFocused,
        isRtl = props.isRtl,
        colors = props.theme.colors;
    var color = isFocused ? colors.neutral80 : colors.neutral20;

    if (!keyframesInjected) {
      // eslint-disable-next-line no-unused-expressions
      injectGlobal("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
      keyframesInjected = true;
    }

    return React__default.createElement("div", _extends$1({}, innerProps, {
      className: cx(
      /*#__PURE__*/
      css(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }), React__default.createElement(LoadingDot, {
      color: color,
      delay: 0,
      offset: isRtl
    }), React__default.createElement(LoadingDot, {
      color: color,
      delay: 160,
      offset: true
    }), React__default.createElement(LoadingDot, {
      color: color,
      delay: 320,
      offset: !isRtl
    }));
  };
  LoadingIndicator.defaultProps = {
    size: 4
  };

  var css$1 = function css$$1(_ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        _ref$theme = _ref.theme,
        colors = _ref$theme.colors,
        borderRadius = _ref$theme.borderRadius,
        spacing = _ref$theme.spacing;
    return {
      label: 'control',
      alignItems: 'center',
      backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
      borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
      borderRadius: borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: spacing.controlHeight,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      '&:hover': {
        borderColor: isFocused ? colors.primary : colors.neutral30
      }
    };
  };

  var Control = function Control(props) {
    var children = props.children,
        cx = props.cx,
        getStyles = props.getStyles,
        className = props.className,
        isDisabled = props.isDisabled,
        isFocused = props.isFocused,
        innerRef = props.innerRef,
        innerProps = props.innerProps,
        menuIsOpen = props.menuIsOpen;
    return React__default.createElement("div", _extends$1({
      ref: innerRef,
      className: cx(
      /*#__PURE__*/
      css(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
      }, className)
    }, innerProps), children);
  };

  var groupCSS = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
      paddingBottom: spacing.baseUnit * 2,
      paddingTop: spacing.baseUnit * 2
    };
  };

  var Group = function Group(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        Heading = props.Heading,
        headingProps = props.headingProps,
        label = props.label,
        theme = props.theme,
        selectProps = props.selectProps;
    return React__default.createElement("div", {
      className: cx(
      /*#__PURE__*/
      css(getStyles('group', props)), {
        'group': true
      }, className)
    }, React__default.createElement(Heading, _extends$1({}, headingProps, {
      selectProps: selectProps,
      theme: theme,
      getStyles: getStyles,
      cx: cx
    }), label), React__default.createElement("div", null, children));
  };

  var groupHeadingCSS = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      label: 'group',
      color: '#999',
      cursor: 'default',
      display: 'block',
      fontSize: '75%',
      fontWeight: '500',
      marginBottom: '0.25em',
      paddingLeft: spacing.baseUnit * 3,
      paddingRight: spacing.baseUnit * 3,
      textTransform: 'uppercase'
    };
  };
  var GroupHeading = function GroupHeading(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        theme = props.theme,
        selectProps = props.selectProps,
        cleanProps = _objectWithoutProperties$1(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

    return React__default.createElement("div", _extends$1({
      className: cx(
      /*#__PURE__*/
      css(getStyles('groupHeading', _objectSpread({
        theme: theme
      }, cleanProps))), {
        'group-heading': true
      }, className)
    }, cleanProps));
  };

  var inputCSS = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      margin: spacing.baseUnit / 2,
      paddingBottom: spacing.baseUnit / 2,
      paddingTop: spacing.baseUnit / 2,
      visibility: isDisabled ? 'hidden' : 'visible',
      color: colors.neutral80
    };
  };

  var inputStyle = function inputStyle(isHidden) {
    return {
      label: 'input',
      background: 0,
      border: 0,
      fontSize: 'inherit',
      opacity: isHidden ? 0 : 1,
      outline: 0,
      padding: 0,
      color: 'inherit'
    };
  };

  var Input = function Input(_ref2) {
    var className = _ref2.className,
        cx = _ref2.cx,
        getStyles = _ref2.getStyles,
        innerRef = _ref2.innerRef,
        isHidden = _ref2.isHidden,
        isDisabled = _ref2.isDisabled,
        theme = _ref2.theme,
        selectProps = _ref2.selectProps,
        props = _objectWithoutProperties$1(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

    return React__default.createElement("div", {
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      css(getStyles('input', _objectSpread({
        theme: theme
      }, props)))
    }, React__default.createElement(AutosizeInput, _extends$1({
      className: cx(null, {
        'input': true
      }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props)));
  };

  var multiValueCSS = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        borderRadius = _ref$theme.borderRadius,
        colors = _ref$theme.colors;
    return {
      label: 'multiValue',
      backgroundColor: colors.neutral10,
      borderRadius: borderRadius / 2,
      display: 'flex',
      margin: spacing.baseUnit / 2,
      minWidth: 0 // resolves flex/text-overflow bug

    };
  };
  var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme,
        borderRadius = _ref2$theme.borderRadius,
        colors = _ref2$theme.colors,
        cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
      borderRadius: borderRadius / 2,
      color: colors.neutral80,
      fontSize: '85%',
      overflow: 'hidden',
      padding: 3,
      paddingLeft: 6,
      textOverflow: cropWithEllipsis ? 'ellipsis' : null,
      whiteSpace: 'nowrap'
    };
  };
  var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme,
        spacing = _ref3$theme.spacing,
        borderRadius = _ref3$theme.borderRadius,
        colors = _ref3$theme.colors,
        isFocused = _ref3.isFocused;
    return {
      alignItems: 'center',
      borderRadius: borderRadius / 2,
      backgroundColor: isFocused && colors.dangerLight,
      display: 'flex',
      paddingLeft: spacing.baseUnit,
      paddingRight: spacing.baseUnit,
      ':hover': {
        backgroundColor: colors.dangerLight,
        color: colors.danger
      }
    };
  };
  var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children,
        innerProps = _ref4.innerProps;
    return React__default.createElement("div", innerProps, children);
  };
  var MultiValueContainer = MultiValueGeneric;
  var MultiValueLabel = MultiValueGeneric;
  var MultiValueRemove =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(MultiValueRemove, _Component);

    function MultiValueRemove() {
      _classCallCheck$1(this, MultiValueRemove);

      return _possibleConstructorReturn$1(this, _getPrototypeOf$1(MultiValueRemove).apply(this, arguments));
    }

    _createClass$1(MultiValueRemove, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            innerProps = _this$props.innerProps;
        return React__default.createElement("div", innerProps, children || React__default.createElement(CrossIcon, {
          size: 14
        }));
      }
    }]);

    return MultiValueRemove;
  }(React.Component);

  var MultiValue =
  /*#__PURE__*/
  function (_Component2) {
    _inherits$1(MultiValue, _Component2);

    function MultiValue() {
      _classCallCheck$1(this, MultiValue);

      return _possibleConstructorReturn$1(this, _getPrototypeOf$1(MultiValue).apply(this, arguments));
    }

    _createClass$1(MultiValue, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            children = _this$props2.children,
            className = _this$props2.className,
            components = _this$props2.components,
            cx = _this$props2.cx,
            data = _this$props2.data,
            getStyles = _this$props2.getStyles,
            innerProps = _this$props2.innerProps,
            isDisabled = _this$props2.isDisabled,
            removeProps = _this$props2.removeProps,
            selectProps = _this$props2.selectProps;
        var Container = components.Container,
            Label = components.Label,
            Remove = components.Remove;

        var containerInnerProps = _objectSpread({
          className: cx(
          /*#__PURE__*/
          css(getStyles('multiValue', this.props)), {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
          }, className)
        }, innerProps);

        var labelInnerProps = {
          className: cx(
          /*#__PURE__*/
          css(getStyles('multiValueLabel', this.props)), {
            'multi-value__label': true
          }, className)
        };

        var removeInnerProps = _objectSpread({
          className: cx(
          /*#__PURE__*/
          css(getStyles('multiValueRemove', this.props)), {
            'multi-value__remove': true
          }, className)
        }, removeProps);

        return React__default.createElement(Container, {
          data: data,
          innerProps: containerInnerProps,
          selectProps: selectProps
        }, React__default.createElement(Label, {
          data: data,
          innerProps: labelInnerProps,
          selectProps: selectProps
        }, children), React__default.createElement(Remove, {
          data: data,
          innerProps: removeInnerProps,
          selectProps: selectProps
        }));
      }
    }]);

    return MultiValue;
  }(React.Component);

  _defineProperty$1(MultiValue, "defaultProps", {
    cropWithEllipsis: true
  });

  var optionCSS = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'option',
      backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
      color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
      cursor: 'default',
      display: 'block',
      fontSize: 'inherit',
      padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
      width: '100%',
      userSelect: 'none',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      // provide some affordance on touch devices
      ':active': {
        backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
      }
    };
  };

  var Option = function Option(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isDisabled = props.isDisabled,
        isFocused = props.isFocused,
        isSelected = props.isSelected,
        innerRef = props.innerRef,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({
      ref: innerRef,
      className: cx(
      /*#__PURE__*/
      css(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, innerProps), children);
  };

  var placeholderCSS = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'placeholder',
      color: colors.neutral50,
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  };

  var Placeholder = function Placeholder(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({
      className: cx(
      /*#__PURE__*/
      css(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps), children);
  };

  var css$2 = function css$$1(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'singleValue',
      color: isDisabled ? colors.neutral40 : colors.neutral80,
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
      overflow: 'hidden',
      position: 'absolute',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  };

  var SingleValue = function SingleValue(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isDisabled = props.isDisabled,
        innerProps = props.innerProps;
    return React__default.createElement("div", _extends$1({
      className: cx(
      /*#__PURE__*/
      css(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps), children);
  };

  var components = {
    ClearIndicator: ClearIndicator,
    Control: Control,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option,
    Placeholder: Placeholder,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
  };
  var defaultComponents = function defaultComponents(props) {
    return _objectSpread({}, components, props.components);
  };

  var defaultStyles = {
    clearIndicator: clearIndicatorCSS,
    container: containerCSS,
    control: css$1,
    dropdownIndicator: dropdownIndicatorCSS,
    group: groupCSS,
    groupHeading: groupHeadingCSS,
    indicatorsContainer: indicatorsContainerCSS,
    indicatorSeparator: indicatorSeparatorCSS,
    input: inputCSS,
    loadingIndicator: loadingIndicatorCSS,
    loadingMessage: loadingMessageCSS,
    menu: menuCSS,
    menuList: menuListCSS,
    menuPortal: menuPortalCSS,
    multiValue: multiValueCSS,
    multiValueLabel: multiValueLabelCSS,
    multiValueRemove: multiValueRemoveCSS,
    noOptionsMessage: noOptionsMessageCSS,
    option: optionCSS,
    placeholder: placeholderCSS,
    singleValue: css$2,
    valueContainer: valueContainerCSS
  }; // Merge Utility

  var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
  };
  var borderRadius = 4;
  var baseUnit = 4;
  /* Used to calculate consistent margin/padding on elements */

  var controlHeight = 38;
  /* The minimum height of the control */

  var menuGutter = baseUnit * 2;
  /* The amount of space between the control and menu */

  var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
  };
  var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
  };

  var defaultProps = {
    backspaceRemovesValue: true,
    blurInputOnSelect: isTouchCapable(),
    captureMenuScroll: !isTouchCapable(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
      return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
      return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
      var count = _ref.count;
      return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
  };
  var instanceId = 1;

  var Select =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(Select, _Component);

    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
      var _this;

      _classCallCheck$1(this, Select);

      _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Select).call(this, _props));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
        ariaLiveSelection: '',
        ariaLiveContext: '',
        focusedOption: null,
        focusedValue: null,
        inputIsHidden: false,
        isFocused: false,
        menuOptions: {
          render: [],
          focusable: []
        },
        selectValue: []
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "blockOptionHover", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "isComposing", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "clearFocusValueOnUpdate", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "commonProps", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "components", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "hasGroups", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "initialTouchX", 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "initialTouchY", 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "inputIsHiddenAfterUpdate", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "instancePrefix", '');

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "openAfterFocus", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "scrollToFocusedOptionOnUpdate", false);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "userIsDragging", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "controlRef", null);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getControlRef", function (ref) {
        _this.controlRef = ref;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "focusedOptionRef", null);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getFocusedOptionRef", function (ref) {
        _this.focusedOptionRef = ref;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "menuListRef", null);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getMenuListRef", function (ref) {
        _this.menuListRef = ref;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "inputRef", null);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getInputRef", function (ref) {
        _this.inputRef = ref;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "cacheComponents", function (components$$1) {
        _this.components = defaultComponents({
          components: components$$1
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "focus", _this.focusInput);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "blur", _this.blurInput);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;
        onChange(newValue, _objectSpread({}, actionMeta, {
          name: name
        }));
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setValue", function (newValue) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
        var option = arguments.length > 2 ? arguments[2] : undefined;
        var _this$props2 = _this.props,
            closeMenuOnSelect = _this$props2.closeMenuOnSelect,
            isMulti = _this$props2.isMulti;

        _this.onInputChange('', {
          action: 'set-value'
        });

        if (closeMenuOnSelect) {
          _this.inputIsHiddenAfterUpdate = !isMulti;

          _this.onMenuClose();
        } // when the select value should change, we should reset focusedValue


        _this.clearFocusValueOnUpdate = true;

        _this.onChange(newValue, {
          action: action,
          option: option
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "selectOption", function (newValue) {
        var _this$props3 = _this.props,
            blurInputOnSelect = _this$props3.blurInputOnSelect,
            isMulti = _this$props3.isMulti;
        var selectValue = _this.state.selectValue;

        if (isMulti) {
          if (_this.isOptionSelected(newValue, selectValue)) {
            var candidate = _this.getOptionValue(newValue);

            _this.setValue(selectValue.filter(function (i) {
              return _this.getOptionValue(i) !== candidate;
            }), 'deselect-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'deselect-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            if (!_this.isOptionDisabled(newValue, selectValue)) {
              _this.setValue([].concat(_toConsumableArray$1(selectValue), [newValue]), 'select-option', newValue);

              _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                  value: _this.getOptionLabel(newValue)
                }
              });
            } else {
              // announce that option is disabled
              _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                  value: _this.getOptionLabel(newValue),
                  isDisabled: true
                }
              });
            }
          }
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue(newValue, 'select-option');

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }

        if (blurInputOnSelect) {
          _this.blurInput();
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "removeValue", function (removedValue) {
        var selectValue = _this.state.selectValue;

        var candidate = _this.getOptionValue(removedValue);

        _this.onChange(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        }), {
          action: 'remove-value',
          removedValue: removedValue
        });

        _this.announceAriaLiveSelection({
          event: 'remove-value',
          context: {
            value: removedValue ? _this.getOptionLabel(removedValue) : ''
          }
        });

        _this.focusInput();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "clearValue", function () {
        var isMulti = _this.props.isMulti;

        _this.onChange(isMulti ? [] : null, {
          action: 'clear'
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "popValue", function () {
        var selectValue = _this.state.selectValue;
        var lastSelectedValue = selectValue[selectValue.length - 1];

        _this.announceAriaLiveSelection({
          event: 'pop-value',
          context: {
            value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
          }
        });

        _this.onChange(selectValue.slice(0, selectValue.length - 1), {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getOptionLabel", function (data) {
        return _this.props.getOptionLabel(data);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getOptionValue", function (data) {
        return _this.props.getOptionValue(data);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getStyles", function (key, props) {
        var base = defaultStyles[key](props);
        base.boxSizing = 'border-box';
        var custom = _this.props.styles[key];
        return custom ? custom(base, props) : base;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getElementId", function (element) {
        return "".concat(_this.instancePrefix, "-").concat(element);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getActiveDescendentId", function () {
        var menuIsOpen = _this.props.menuIsOpen;
        var _this$state = _this.state,
            menuOptions = _this$state.menuOptions,
            focusedOption = _this$state.focusedOption;
        if (!focusedOption || !menuIsOpen) return undefined;
        var index = menuOptions.focusable.indexOf(focusedOption);
        var option = menuOptions.render[index];
        return option && option.key;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "announceAriaLiveSelection", function (_ref2) {
        var event = _ref2.event,
            context = _ref2.context;

        _this.setState({
          ariaLiveSelection: valueEventAriaMessage(event, context)
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "announceAriaLiveContext", function (_ref3) {
        var event = _ref3.event,
            context = _ref3.context;

        _this.setState({
          ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
            label: _this.props['aria-label']
          }))
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onMenuMouseDown", function (event) {
        if (event.button !== 0) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        _this.focusInput();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onMenuMouseMove", function (event) {
        _this.blockOptionHover = false;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onControlMouseDown", function (event) {
        var openMenuOnClick = _this.props.openMenuOnClick;

        if (!_this.state.isFocused) {
          if (openMenuOnClick) {
            _this.openAfterFocus = true;
          }

          _this.focusInput();
        } else if (!_this.props.menuIsOpen) {
          if (openMenuOnClick) {
            _this.openMenu('first');
          }
        } else {
          //$FlowFixMe
          if (event.target.tagName !== 'INPUT') {
            _this.onMenuClose();
          }
        } //$FlowFixMe


        if (event.target.tagName !== 'INPUT') {
          event.preventDefault();
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onDropdownIndicatorMouseDown", function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        if (_this.props.isDisabled) return;
        var _this$props4 = _this.props,
            isMulti = _this$props4.isMulti,
            menuIsOpen = _this$props4.menuIsOpen;

        _this.focusInput();

        if (menuIsOpen) {
          _this.inputIsHiddenAfterUpdate = !isMulti;

          _this.onMenuClose();
        } else {
          _this.openMenu('first');
        }

        event.preventDefault();
        event.stopPropagation();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onClearIndicatorMouseDown", function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        _this.clearValue();

        event.stopPropagation();
        _this.openAfterFocus = false;
        setTimeout(function () {
          return _this.focusInput();
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onScroll", function (event) {
        if (typeof _this.props.closeMenuOnScroll === 'boolean') {
          if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
            _this.props.onMenuClose();
          }
        } else if (typeof _this.props.closeMenuOnScroll === 'function') {
          if (_this.props.closeMenuOnScroll(event)) {
            _this.props.onMenuClose();
          }
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onCompositionStart", function () {
        _this.isComposing = true;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onCompositionEnd", function () {
        _this.isComposing = false;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onTouchStart", function (_ref4) {
        var touches = _ref4.touches;
        var touch = touches.item(0);

        if (!touch) {
          return;
        }

        _this.initialTouchX = touch.clientX;
        _this.initialTouchY = touch.clientY;
        _this.userIsDragging = false;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onTouchMove", function (_ref5) {
        var touches = _ref5.touches;
        var touch = touches.item(0);

        if (!touch) {
          return;
        }

        var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
        var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
        var moveThreshold = 5;
        _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onTouchEnd", function (event) {
        if (_this.userIsDragging) return; // close the menu if the user taps outside
        // we're checking on event.target here instead of event.currentTarget, because we want to assert information
        // on events on child elements, not the document (which we've attached this handler to).

        if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
          _this.blurInput();
        } // reset move vars


        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onControlTouchEnd", function (event) {
        if (_this.userIsDragging) return;

        _this.onControlMouseDown(event);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onClearIndicatorTouchEnd", function (event) {
        if (_this.userIsDragging) return;

        _this.onClearIndicatorMouseDown(event);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onDropdownIndicatorTouchEnd", function (event) {
        if (_this.userIsDragging) return;

        _this.onDropdownIndicatorMouseDown(event);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleInputChange", function (event) {
        var inputValue = event.currentTarget.value;
        _this.inputIsHiddenAfterUpdate = false;

        _this.onInputChange(inputValue, {
          action: 'input-change'
        });

        _this.onMenuOpen();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onInputFocus", function (event) {
        var _this$props5 = _this.props,
            isSearchable = _this$props5.isSearchable,
            isMulti = _this$props5.isMulti;

        if (_this.props.onFocus) {
          _this.props.onFocus(event);
        }

        _this.inputIsHiddenAfterUpdate = false;

        _this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });

        _this.setState({
          isFocused: true
        });

        if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
          _this.openMenu('first');
        }

        _this.openAfterFocus = false;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onInputBlur", function (event) {
        if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
          _this.inputRef.focus();

          return;
        }

        if (_this.props.onBlur) {
          _this.props.onBlur(event);
        }

        _this.onInputChange('', {
          action: 'input-blur'
        });

        _this.onMenuClose();

        _this.setState({
          focusedValue: null,
          isFocused: false
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onOptionHover", function (focusedOption) {
        if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
          return;
        }

        _this.setState({
          focusedOption: focusedOption
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "shouldHideSelectedOptions", function () {
        var _this$props6 = _this.props,
            hideSelectedOptions = _this$props6.hideSelectedOptions,
            isMulti = _this$props6.isMulti;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onKeyDown", function (event) {
        var _this$props7 = _this.props,
            isMulti = _this$props7.isMulti,
            backspaceRemovesValue = _this$props7.backspaceRemovesValue,
            escapeClearsValue = _this$props7.escapeClearsValue,
            inputValue = _this$props7.inputValue,
            isClearable = _this$props7.isClearable,
            isDisabled = _this$props7.isDisabled,
            menuIsOpen = _this$props7.menuIsOpen,
            onKeyDown = _this$props7.onKeyDown,
            tabSelectsValue = _this$props7.tabSelectsValue,
            openMenuOnFocus = _this$props7.openMenuOnFocus;
        var _this$state2 = _this.state,
            focusedOption = _this$state2.focusedOption,
            focusedValue = _this$state2.focusedValue,
            selectValue = _this$state2.selectValue;
        if (isDisabled) return;

        if (typeof onKeyDown === 'function') {
          onKeyDown(event);

          if (event.defaultPrevented) {
            return;
          }
        } // Block option hover events when the user has just pressed a key


        _this.blockOptionHover = true;

        switch (event.key) {
          case 'ArrowLeft':
            if (!isMulti || inputValue) return;

            _this.focusValue('previous');

            break;

          case 'ArrowRight':
            if (!isMulti || inputValue) return;

            _this.focusValue('next');

            break;

          case 'Delete':
          case 'Backspace':
            if (inputValue) return;

            if (focusedValue) {
              _this.removeValue(focusedValue);
            } else {
              if (!backspaceRemovesValue) return;

              if (isMulti) {
                _this.popValue();
              } else if (isClearable) {
                _this.clearValue();
              }
            }

            break;

          case 'Tab':
            if (_this.isComposing) return;

            if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
              return;
            }

            _this.selectOption(focusedOption);

            break;

          case 'Enter':
            if (event.keyCode === 229) {
              // ignore the keydown event from an Input Method Editor(IME)
              // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
              break;
            }

            if (menuIsOpen) {
              if (!focusedOption) return;
              if (_this.isComposing) return;

              _this.selectOption(focusedOption);

              break;
            }

            return;

          case 'Escape':
            if (menuIsOpen) {
              _this.inputIsHiddenAfterUpdate = false;

              _this.onInputChange('', {
                action: 'menu-close'
              });

              _this.onMenuClose();
            } else if (isClearable && escapeClearsValue) {
              _this.clearValue();
            }

            break;

          case ' ':
            // space
            if (inputValue) {
              return;
            }

            if (!menuIsOpen) {
              _this.openMenu('first');

              break;
            }

            if (!focusedOption) return;

            _this.selectOption(focusedOption);

            break;

          case 'ArrowUp':
            if (menuIsOpen) {
              _this.focusOption('up');
            } else {
              _this.openMenu('last');
            }

            break;

          case 'ArrowDown':
            if (menuIsOpen) {
              _this.focusOption('down');
            } else {
              _this.openMenu('first');
            }

            break;

          case 'PageUp':
            if (!menuIsOpen) return;

            _this.focusOption('pageup');

            break;

          case 'PageDown':
            if (!menuIsOpen) return;

            _this.focusOption('pagedown');

            break;

          case 'Home':
            if (!menuIsOpen) return;

            _this.focusOption('first');

            break;

          case 'End':
            if (!menuIsOpen) return;

            _this.focusOption('last');

            break;

          default:
            return;
        }

        event.preventDefault();
      });

      var value = _props.value;
      _this.cacheComponents = memoizeOne(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized$1(_assertThisInitialized$1(_this)));

      _this.cacheComponents(_props.components);

      _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

      var _selectValue = cleanValue(value);

      var _menuOptions = _this.buildMenuOptions(_props, _selectValue);

      _this.state.menuOptions = _menuOptions;
      _this.state.selectValue = _selectValue;
      return _this;
    }

    _createClass$1(Select, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();

        if (this.props.closeMenuOnScroll && document && document.addEventListener) {
          // Listen to all scroll events, and filter them out inside of 'onScroll'
          document.addEventListener('scroll', this.onScroll, true);
        }

        if (this.props.autoFocus) {
          this.focusInput();
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var _this$props8 = this.props,
            options = _this$props8.options,
            value = _this$props8.value,
            inputValue = _this$props8.inputValue; // re-cache custom components

        this.cacheComponents(nextProps.components); // rebuild the menu options

        if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
          var selectValue = cleanValue(nextProps.value);
          var menuOptions = this.buildMenuOptions(nextProps, selectValue);
          var focusedValue = this.getNextFocusedValue(selectValue);
          var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
          this.setState({
            menuOptions: menuOptions,
            selectValue: selectValue,
            focusedOption: focusedOption,
            focusedValue: focusedValue
          });
        } // some updates should toggle the state of the input visibility


        if (this.inputIsHiddenAfterUpdate != null) {
          this.setState({
            inputIsHidden: this.inputIsHiddenAfterUpdate
          });
          delete this.inputIsHiddenAfterUpdate;
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props9 = this.props,
            isDisabled = _this$props9.isDisabled,
            menuIsOpen = _this$props9.menuIsOpen;
        var isFocused = this.state.isFocused;

        if ( // ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) {
          this.focusInput();
        } // scroll the focused option into view if necessary


        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
          scrollIntoView(this.menuListRef, this.focusedOptionRef);
        }

        this.scrollToFocusedOptionOnUpdate = false;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        document.removeEventListener('scroll', this.onScroll, true);
      }
    }, {
      key: "onMenuOpen",
      // ==============================
      // Consumer Handlers
      // ==============================
      value: function onMenuOpen() {
        this.props.onMenuOpen();
      }
    }, {
      key: "onMenuClose",
      value: function onMenuClose() {
        var _this$props10 = this.props,
            isSearchable = _this$props10.isSearchable,
            isMulti = _this$props10.isMulti;
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
        this.onInputChange('', {
          action: 'menu-close'
        });
        this.props.onMenuClose();
      }
    }, {
      key: "onInputChange",
      value: function onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
      } // ==============================
      // Methods
      // ==============================

    }, {
      key: "focusInput",
      value: function focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
      }
    }, {
      key: "blurInput",
      value: function blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
      } // aliased for consumers

    }, {
      key: "openMenu",
      value: function openMenu(focusOption) {
        var _this$state3 = this.state,
            menuOptions = _this$state3.menuOptions,
            selectValue = _this$state3.selectValue,
            isFocused = _this$state3.isFocused;
        var isMulti = this.props.isMulti;
        var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

        if (!isMulti) {
          var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

          if (selectedIndex > -1) {
            openAtIndex = selectedIndex;
          }
        } // only scroll if the menu isn't already open


        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.inputIsHiddenAfterUpdate = false;
        this.onMenuOpen();
        this.setState({
          focusedValue: null,
          focusedOption: menuOptions.focusable[openAtIndex]
        });
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }
    }, {
      key: "focusValue",
      value: function focusValue(direction) {
        var _this$props11 = this.props,
            isMulti = _this$props11.isMulti,
            isSearchable = _this$props11.isSearchable;
        var _this$state4 = this.state,
            selectValue = _this$state4.selectValue,
            focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

        if (!isMulti) return;
        this.setState({
          focusedOption: null
        });
        var focusedIndex = selectValue.indexOf(focusedValue);

        if (!focusedValue) {
          focusedIndex = -1;
          this.announceAriaLiveContext({
            event: 'value'
          });
        }

        var lastIndex = selectValue.length - 1;
        var nextFocus = -1;
        if (!selectValue.length) return;

        switch (direction) {
          case 'previous':
            if (focusedIndex === 0) {
              // don't cycle from the start to the end
              nextFocus = 0;
            } else if (focusedIndex === -1) {
              // if nothing is focused, focus the last value first
              nextFocus = lastIndex;
            } else {
              nextFocus = focusedIndex - 1;
            }

            break;

          case 'next':
            if (focusedIndex > -1 && focusedIndex < lastIndex) {
              nextFocus = focusedIndex + 1;
            }

            break;
        }

        if (nextFocus === -1) {
          this.announceAriaLiveContext({
            event: 'input',
            context: {
              isSearchable: isSearchable,
              isMulti: isMulti
            }
          });
        }

        this.setState({
          inputIsHidden: nextFocus === -1 ? false : true,
          focusedValue: selectValue[nextFocus]
        });
      }
    }, {
      key: "focusOption",
      value: function focusOption() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
        var pageSize = this.props.pageSize;
        var _this$state5 = this.state,
            focusedOption = _this$state5.focusedOption,
            menuOptions = _this$state5.menuOptions;
        var options = menuOptions.focusable;
        if (!options.length) return;
        var nextFocus = 0; // handles 'first'

        var focusedIndex = options.indexOf(focusedOption);

        if (!focusedOption) {
          focusedIndex = -1;
          this.announceAriaLiveContext({
            event: 'menu'
          });
        }

        if (direction === 'up') {
          nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        } else if (direction === 'down') {
          nextFocus = (focusedIndex + 1) % options.length;
        } else if (direction === 'pageup') {
          nextFocus = focusedIndex - pageSize;
          if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
          nextFocus = focusedIndex + pageSize;
          if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') {
          nextFocus = options.length - 1;
        }

        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
          focusedOption: options[nextFocus],
          focusedValue: null
        });
        this.announceAriaLiveContext({
          event: 'menu',
          context: {
            isDisabled: isOptionDisabled(options[nextFocus])
          }
        });
      }
    }, {
      key: "getTheme",
      // ==============================
      // Getters
      // ==============================
      value: function getTheme() {
        // Use the default theme if there are no customizations.
        if (!this.props.theme) {
          return defaultTheme;
        } // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.


        if (typeof this.props.theme === 'function') {
          return this.props.theme(defaultTheme);
        } // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.


        return _objectSpread({}, defaultTheme, this.props.theme);
      }
    }, {
      key: "getCommonProps",
      value: function getCommonProps() {
        var clearValue = this.clearValue,
            getStyles = this.getStyles,
            setValue = this.setValue,
            selectOption = this.selectOption,
            props = this.props;
        var classNamePrefix = props.classNamePrefix,
            isMulti = props.isMulti,
            isRtl = props.isRtl,
            options = props.options;
        var selectValue = this.state.selectValue;
        var hasValue = this.hasValue();

        var getValue = function getValue() {
          return selectValue;
        };

        var cx = classNames.bind(null, classNamePrefix);
        return {
          cx: cx,
          clearValue: clearValue,
          getStyles: getStyles,
          getValue: getValue,
          hasValue: hasValue,
          isMulti: isMulti,
          isRtl: isRtl,
          options: options,
          selectOption: selectOption,
          setValue: setValue,
          selectProps: props,
          theme: this.getTheme()
        };
      }
    }, {
      key: "getNextFocusedValue",
      value: function getNextFocusedValue(nextSelectValue) {
        if (this.clearFocusValueOnUpdate) {
          this.clearFocusValueOnUpdate = false;
          return null;
        }

        var _this$state6 = this.state,
            focusedValue = _this$state6.focusedValue,
            lastSelectValue = _this$state6.selectValue;
        var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

        if (lastFocusedIndex > -1) {
          var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

          if (nextFocusedIndex > -1) {
            // the focused value is still in the selectValue, return it
            return focusedValue;
          } else if (lastFocusedIndex < nextSelectValue.length) {
            // the focusedValue is not present in the next selectValue array by
            // reference, so return the new value at the same index
            return nextSelectValue[lastFocusedIndex];
          }
        }

        return null;
      }
    }, {
      key: "getNextFocusedOption",
      value: function getNextFocusedOption(options) {
        var lastFocusedOption = this.state.focusedOption;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
      }
    }, {
      key: "hasValue",
      value: function hasValue() {
        var selectValue = this.state.selectValue;
        return selectValue.length > 0;
      }
    }, {
      key: "hasOptions",
      value: function hasOptions() {
        return !!this.state.menuOptions.render.length;
      }
    }, {
      key: "countOptions",
      value: function countOptions() {
        return this.state.menuOptions.focusable.length;
      }
    }, {
      key: "isClearable",
      value: function isClearable() {
        var _this$props12 = this.props,
            isClearable = _this$props12.isClearable,
            isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable

        if (isClearable === undefined) return isMulti;
        return isClearable;
      }
    }, {
      key: "isOptionDisabled",
      value: function isOptionDisabled$$1(option, selectValue) {
        return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
      }
    }, {
      key: "isOptionSelected",
      value: function isOptionSelected(option, selectValue) {
        var _this2 = this;

        if (selectValue.indexOf(option) > -1) return true;

        if (typeof this.props.isOptionSelected === 'function') {
          return this.props.isOptionSelected(option, selectValue);
        }

        var candidate = this.getOptionValue(option);
        return selectValue.some(function (i) {
          return _this2.getOptionValue(i) === candidate;
        });
      }
    }, {
      key: "filterOption",
      value: function filterOption(option, inputValue) {
        return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
      }
    }, {
      key: "formatOptionLabel",
      value: function formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
          var inputValue = this.props.inputValue;
          var selectValue = this.state.selectValue;
          return this.props.formatOptionLabel(data, {
            context: context,
            inputValue: inputValue,
            selectValue: selectValue
          });
        } else {
          return this.getOptionLabel(data);
        }
      }
    }, {
      key: "formatGroupLabel",
      value: function formatGroupLabel$$1(data) {
        return this.props.formatGroupLabel(data);
      } // ==============================
      // Mouse Handlers
      // ==============================

    }, {
      key: "startListeningComposition",
      // ==============================
      // Composition Handlers
      // ==============================
      value: function startListeningComposition() {
        if (document && document.addEventListener) {
          document.addEventListener('compositionstart', this.onCompositionStart, false);
          document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
      }
    }, {
      key: "stopListeningComposition",
      value: function stopListeningComposition() {
        if (document && document.removeEventListener) {
          document.removeEventListener('compositionstart', this.onCompositionStart);
          document.removeEventListener('compositionend', this.onCompositionEnd);
        }
      }
    }, {
      key: "startListeningToTouch",
      // ==============================
      // Touch Handlers
      // ==============================
      value: function startListeningToTouch() {
        if (document && document.addEventListener) {
          document.addEventListener('touchstart', this.onTouchStart, false);
          document.addEventListener('touchmove', this.onTouchMove, false);
          document.addEventListener('touchend', this.onTouchEnd, false);
        }
      }
    }, {
      key: "stopListeningToTouch",
      value: function stopListeningToTouch() {
        if (document && document.removeEventListener) {
          document.removeEventListener('touchstart', this.onTouchStart);
          document.removeEventListener('touchmove', this.onTouchMove);
          document.removeEventListener('touchend', this.onTouchEnd);
        }
      }
    }, {
      key: "buildMenuOptions",
      // ==============================
      // Menu Options
      // ==============================
      value: function buildMenuOptions(props, selectValue) {
        var _this3 = this;

        var _props$inputValue = props.inputValue,
            inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
            options = props.options;

        var toOption = function toOption(option, id) {
          var isDisabled = _this3.isOptionDisabled(option, selectValue);

          var isSelected = _this3.isOptionSelected(option, selectValue);

          var label = _this3.getOptionLabel(option);

          var value = _this3.getOptionValue(option);

          if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
            label: label,
            value: value,
            data: option
          }, inputValue)) {
            return;
          }

          var onHover = isDisabled ? undefined : function () {
            return _this3.onOptionHover(option);
          };
          var onSelect = isDisabled ? undefined : function () {
            return _this3.selectOption(option);
          };
          var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
          return {
            innerProps: {
              id: optionId,
              onClick: onSelect,
              onMouseMove: onHover,
              onMouseOver: onHover,
              tabIndex: -1
            },
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            key: optionId,
            label: label,
            type: 'option',
            value: value
          };
        };

        return options.reduce(function (acc, item, itemIndex) {
          if (item.options) {
            // TODO needs a tidier implementation
            if (!_this3.hasGroups) _this3.hasGroups = true;
            var items = item.options;
            var children = items.map(function (child, i) {
              var option = toOption(child, "".concat(itemIndex, "-").concat(i));
              if (option) acc.focusable.push(child);
              return option;
            }).filter(Boolean);

            if (children.length) {
              var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
              acc.render.push({
                type: 'group',
                key: groupId,
                data: item,
                options: children
              });
            }
          } else {
            var option = toOption(item, "".concat(itemIndex));

            if (option) {
              acc.render.push(option);
              acc.focusable.push(item);
            }
          }

          return acc;
        }, {
          render: [],
          focusable: []
        });
      } // ==============================
      // Renderers
      // ==============================

    }, {
      key: "constructAriaLiveMessage",
      value: function constructAriaLiveMessage() {
        var _this$state7 = this.state,
            ariaLiveContext = _this$state7.ariaLiveContext,
            selectValue = _this$state7.selectValue,
            focusedValue = _this$state7.focusedValue,
            focusedOption = _this$state7.focusedOption;
        var _this$props13 = this.props,
            options = _this$props13.options,
            menuIsOpen = _this$props13.menuIsOpen,
            inputValue = _this$props13.inputValue,
            screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

        var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
          focusedValue: focusedValue,
          getOptionLabel: this.getOptionLabel,
          selectValue: selectValue
        }) : ''; // An aria live message representing the currently focused option in the select.

        var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
          focusedOption: focusedOption,
          getOptionLabel: this.getOptionLabel,
          options: options
        }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

        var resultsMsg = resultsAriaMessage({
          inputValue: inputValue,
          screenReaderMessage: screenReaderStatus({
            count: this.countOptions()
          })
        });
        return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
      }
    }, {
      key: "renderInput",
      value: function renderInput() {
        var _this$props14 = this.props,
            isDisabled = _this$props14.isDisabled,
            isSearchable = _this$props14.isSearchable,
            inputId = _this$props14.inputId,
            inputValue = _this$props14.inputValue,
            tabIndex = _this$props14.tabIndex;
        var Input = this.components.Input;
        var inputIsHidden = this.state.inputIsHidden;
        var id = inputId || this.getElementId('input');

        if (!isSearchable) {
          // use a dummy input to maintain focus/blur functionality
          return React__default.createElement(DummyInput, {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop,
            onFocus: this.onInputFocus,
            readOnly: true,
            disabled: isDisabled,
            tabIndex: tabIndex,
            value: ""
          });
        } // aria attributes makes the JSX "noisy", separated for clarity


        var ariaAttributes = {
          'aria-autocomplete': 'list',
          'aria-label': this.props['aria-label'],
          'aria-labelledby': this.props['aria-labelledby']
        };
        var _this$commonProps = this.commonProps,
            cx = _this$commonProps.cx,
            theme = _this$commonProps.theme,
            selectProps = _this$commonProps.selectProps;
        return React__default.createElement(Input, _extends$1({
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          cx: cx,
          getStyles: this.getStyles,
          id: id,
          innerRef: this.getInputRef,
          isDisabled: isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          selectProps: selectProps,
          spellCheck: "false",
          tabIndex: tabIndex,
          theme: theme,
          type: "text",
          value: inputValue
        }, ariaAttributes));
      }
    }, {
      key: "renderPlaceholderOrValue",
      value: function renderPlaceholderOrValue() {
        var _this4 = this;

        var _this$components = this.components,
            MultiValue = _this$components.MultiValue,
            MultiValueContainer = _this$components.MultiValueContainer,
            MultiValueLabel = _this$components.MultiValueLabel,
            MultiValueRemove = _this$components.MultiValueRemove,
            SingleValue = _this$components.SingleValue,
            Placeholder = _this$components.Placeholder;
        var commonProps = this.commonProps;
        var _this$props15 = this.props,
            controlShouldRenderValue = _this$props15.controlShouldRenderValue,
            isDisabled = _this$props15.isDisabled,
            isMulti = _this$props15.isMulti,
            inputValue = _this$props15.inputValue,
            placeholder = _this$props15.placeholder;
        var _this$state8 = this.state,
            selectValue = _this$state8.selectValue,
            focusedValue = _this$state8.focusedValue,
            isFocused = _this$state8.isFocused;

        if (!this.hasValue() || !controlShouldRenderValue) {
          return inputValue ? null : React__default.createElement(Placeholder, _extends$1({}, commonProps, {
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused
          }), placeholder);
        }

        if (isMulti) {
          var selectValues = selectValue.map(function (opt) {
            var isOptionFocused = opt === focusedValue;
            return React__default.createElement(MultiValue, _extends$1({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isOptionFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }), _this4.formatOptionLabel(opt, 'value'));
          });
          return selectValues;
        }

        if (inputValue) {
          return null;
        }

        var singleValue = selectValue[0];
        return React__default.createElement(SingleValue, _extends$1({}, commonProps, {
          data: singleValue,
          isDisabled: isDisabled
        }), this.formatOptionLabel(singleValue, 'value'));
      }
    }, {
      key: "renderClearIndicator",
      value: function renderClearIndicator() {
        var ClearIndicator = this.components.ClearIndicator;
        var commonProps = this.commonProps;
        var _this$props16 = this.props,
            isDisabled = _this$props16.isDisabled,
            isLoading = _this$props16.isLoading;
        var isFocused = this.state.isFocused;

        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
          return null;
        }

        var innerProps = {
          onMouseDown: this.onClearIndicatorMouseDown,
          onTouchEnd: this.onClearIndicatorTouchEnd,
          'aria-hidden': 'true'
        };
        return React__default.createElement(ClearIndicator, _extends$1({}, commonProps, {
          innerProps: innerProps,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderLoadingIndicator",
      value: function renderLoadingIndicator() {
        var LoadingIndicator = this.components.LoadingIndicator;
        var commonProps = this.commonProps;
        var _this$props17 = this.props,
            isDisabled = _this$props17.isDisabled,
            isLoading = _this$props17.isLoading;
        var isFocused = this.state.isFocused;
        if (!LoadingIndicator || !isLoading) return null;
        var innerProps = {
          'aria-hidden': 'true'
        };
        return React__default.createElement(LoadingIndicator, _extends$1({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderIndicatorSeparator",
      value: function renderIndicatorSeparator() {
        var _this$components2 = this.components,
            DropdownIndicator = _this$components2.DropdownIndicator,
            IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

        if (!DropdownIndicator || !IndicatorSeparator) return null;
        var commonProps = this.commonProps;
        var isDisabled = this.props.isDisabled;
        var isFocused = this.state.isFocused;
        return React__default.createElement(IndicatorSeparator, _extends$1({}, commonProps, {
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderDropdownIndicator",
      value: function renderDropdownIndicator() {
        var DropdownIndicator = this.components.DropdownIndicator;
        if (!DropdownIndicator) return null;
        var commonProps = this.commonProps;
        var isDisabled = this.props.isDisabled;
        var isFocused = this.state.isFocused;
        var innerProps = {
          onMouseDown: this.onDropdownIndicatorMouseDown,
          onTouchEnd: this.onDropdownIndicatorTouchEnd,
          'aria-hidden': 'true'
        };
        return React__default.createElement(DropdownIndicator, _extends$1({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderMenu",
      value: function renderMenu() {
        var _this5 = this;

        var _this$components3 = this.components,
            Group = _this$components3.Group,
            GroupHeading = _this$components3.GroupHeading,
            Menu$$1 = _this$components3.Menu,
            MenuList$$1 = _this$components3.MenuList,
            MenuPortal$$1 = _this$components3.MenuPortal,
            LoadingMessage$$1 = _this$components3.LoadingMessage,
            NoOptionsMessage$$1 = _this$components3.NoOptionsMessage,
            Option = _this$components3.Option;
        var commonProps = this.commonProps;
        var _this$state9 = this.state,
            focusedOption = _this$state9.focusedOption,
            menuOptions = _this$state9.menuOptions;
        var _this$props18 = this.props,
            captureMenuScroll = _this$props18.captureMenuScroll,
            inputValue = _this$props18.inputValue,
            isLoading = _this$props18.isLoading,
            loadingMessage = _this$props18.loadingMessage,
            minMenuHeight = _this$props18.minMenuHeight,
            maxMenuHeight = _this$props18.maxMenuHeight,
            menuIsOpen = _this$props18.menuIsOpen,
            menuPlacement = _this$props18.menuPlacement,
            menuPosition = _this$props18.menuPosition,
            menuPortalTarget = _this$props18.menuPortalTarget,
            menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
            menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
            noOptionsMessage = _this$props18.noOptionsMessage,
            onMenuScrollToTop = _this$props18.onMenuScrollToTop,
            onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
        if (!menuIsOpen) return null; // TODO: Internal Option Type here

        var render = function render(props) {
          // for performance, the menu options in state aren't changed when the
          // focused option changes so we calculate additional props based on that
          var isFocused = focusedOption === props.data;
          props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
          return React__default.createElement(Option, _extends$1({}, commonProps, props, {
            isFocused: isFocused
          }), _this5.formatOptionLabel(props.data, 'menu'));
        };

        var menuUI;

        if (this.hasOptions()) {
          menuUI = menuOptions.render.map(function (item) {
            if (item.type === 'group') {
              var type = item.type,
                  group = _objectWithoutProperties$1(item, ["type"]);

              var headingId = "".concat(item.key, "-heading");
              return React__default.createElement(Group, _extends$1({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }), item.options.map(function (option) {
                return render(option);
              }));
            } else if (item.type === 'option') {
              return render(item);
            }
          });
        } else if (isLoading) {
          var message = loadingMessage({
            inputValue: inputValue
          });
          if (message === null) return null;
          menuUI = React__default.createElement(LoadingMessage$$1, commonProps, message);
        } else {
          var _message = noOptionsMessage({
            inputValue: inputValue
          });

          if (_message === null) return null;
          menuUI = React__default.createElement(NoOptionsMessage$$1, commonProps, _message);
        }

        var menuPlacementProps = {
          minMenuHeight: minMenuHeight,
          maxMenuHeight: maxMenuHeight,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition,
          menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        var menuElement = React__default.createElement(MenuPlacer, _extends$1({}, commonProps, menuPlacementProps), function (_ref6) {
          var ref = _ref6.ref,
              _ref6$placerProps = _ref6.placerProps,
              placement = _ref6$placerProps.placement,
              maxHeight = _ref6$placerProps.maxHeight;
          return React__default.createElement(Menu$$1, _extends$1({}, commonProps, menuPlacementProps, {
            innerRef: ref,
            innerProps: {
              onMouseDown: _this5.onMenuMouseDown,
              onMouseMove: _this5.onMenuMouseMove
            },
            isLoading: isLoading,
            placement: placement
          }), React__default.createElement(ScrollCaptorSwitch, {
            isEnabled: captureMenuScroll,
            onTopArrive: onMenuScrollToTop,
            onBottomArrive: onMenuScrollToBottom
          }, React__default.createElement(ScrollBlock, {
            isEnabled: menuShouldBlockScroll
          }, React__default.createElement(MenuList$$1, _extends$1({}, commonProps, {
            innerRef: _this5.getMenuListRef,
            isLoading: isLoading,
            maxHeight: maxHeight
          }), menuUI))));
        }); // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`

        return menuPortalTarget || menuPosition === 'fixed' ? React__default.createElement(MenuPortal$$1, _extends$1({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }), menuElement) : menuElement;
      }
    }, {
      key: "renderFormField",
      value: function renderFormField() {
        var _this6 = this;

        var _this$props19 = this.props,
            delimiter = _this$props19.delimiter,
            isDisabled = _this$props19.isDisabled,
            isMulti = _this$props19.isMulti,
            name = _this$props19.name;
        var selectValue = this.state.selectValue;
        if (!name || isDisabled) return;

        if (isMulti) {
          if (delimiter) {
            var value = selectValue.map(function (opt) {
              return _this6.getOptionValue(opt);
            }).join(delimiter);
            return React__default.createElement("input", {
              name: name,
              type: "hidden",
              value: value
            });
          } else {
            var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
              return React__default.createElement("input", {
                key: "i-".concat(i),
                name: name,
                type: "hidden",
                value: _this6.getOptionValue(opt)
              });
            }) : React__default.createElement("input", {
              name: name,
              type: "hidden"
            });
            return React__default.createElement("div", null, input);
          }
        } else {
          var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

          return React__default.createElement("input", {
            name: name,
            type: "hidden",
            value: _value
          });
        }
      }
    }, {
      key: "renderLiveRegion",
      value: function renderLiveRegion() {
        if (!this.state.isFocused) return null;
        return React__default.createElement(A11yText, {
          "aria-live": "assertive"
        }, React__default.createElement("p", {
          id: "aria-selection-event"
        }, "\xA0", this.state.ariaLiveSelection), React__default.createElement("p", {
          id: "aria-context"
        }, "\xA0", this.constructAriaLiveMessage()));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$components4 = this.components,
            Control = _this$components4.Control,
            IndicatorsContainer = _this$components4.IndicatorsContainer,
            SelectContainer = _this$components4.SelectContainer,
            ValueContainer = _this$components4.ValueContainer;
        var _this$props20 = this.props,
            className = _this$props20.className,
            id = _this$props20.id,
            isDisabled = _this$props20.isDisabled,
            menuIsOpen = _this$props20.menuIsOpen;
        var isFocused = this.state.isFocused;
        var commonProps = this.commonProps = this.getCommonProps();
        return React__default.createElement(SelectContainer, _extends$1({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }), this.renderLiveRegion(), React__default.createElement(Control, _extends$1({}, commonProps, {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: isDisabled,
          isFocused: isFocused,
          menuIsOpen: menuIsOpen
        }), React__default.createElement(ValueContainer, _extends$1({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderPlaceholderOrValue(), this.renderInput()), React__default.createElement(IndicatorsContainer, _extends$1({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
      }
    }]);

    return Select;
  }(React.Component);

  _defineProperty$1(Select, "defaultProps", defaultProps);

  var defaultProps$1 = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  };

  var manageState = function manageState(SelectComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits$1(StateManager, _Component);

      function StateManager() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck$1(this, StateManager);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "select", void 0);

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
          inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
          menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
          value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
        });

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onChange", function (value, actionMeta) {
          _this.callProp('onChange', value, actionMeta);

          _this.setState({
            value: value
          });
        });

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onInputChange", function (value, actionMeta) {
          // TODO: for backwards compatibility, we allow the prop to return a new
          // value, but now inputValue is a controllable prop we probably shouldn't
          var newValue = _this.callProp('onInputChange', value, actionMeta);

          _this.setState({
            inputValue: newValue !== undefined ? newValue : value
          });
        });

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onMenuOpen", function () {
          _this.callProp('onMenuOpen');

          _this.setState({
            menuIsOpen: true
          });
        });

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onMenuClose", function () {
          _this.callProp('onMenuClose');

          _this.setState({
            menuIsOpen: false
          });
        });

        return _this;
      }

      _createClass$1(StateManager, [{
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.select.blur();
        } // FIXME: untyped flow code, return any

      }, {
        key: "getProp",
        value: function getProp(key) {
          return this.props[key] !== undefined ? this.props[key] : this.state[key];
        } // FIXME: untyped flow code, return any

      }, {
        key: "callProp",
        value: function callProp(name) {
          if (typeof this.props[name] === 'function') {
            var _this$props;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            return (_this$props = this.props)[name].apply(_this$props, args);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props2 = this.props,
              defaultInputValue = _this$props2.defaultInputValue,
              defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
              defaultValue = _this$props2.defaultValue,
              props = _objectWithoutProperties$1(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

          return React__default.createElement(SelectComponent, _extends$1({}, props, {
            ref: function ref(_ref) {
              _this2.select = _ref;
            },
            inputValue: this.getProp('inputValue'),
            menuIsOpen: this.getProp('menuIsOpen'),
            onChange: this.onChange,
            onInputChange: this.onInputChange,
            onMenuClose: this.onMenuClose,
            onMenuOpen: this.onMenuOpen,
            value: this.getProp('value')
          }));
        }
      }]);

      return StateManager;
    }(React.Component), _defineProperty$1(_class, "defaultProps", defaultProps$1), _temp;
  };

  var defaultProps$2 = {
    cacheOptions: false,
    defaultOptions: false,
    filterOption: null
  };
  var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits$1(Async, _Component);

      function Async(props) {
        var _this;

        _classCallCheck$1(this, Async);

        _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Async).call(this));

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "select", void 0);

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "lastRequest", void 0);

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "mounted", false);

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "optionsCache", {});

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleInputChange", function (newValue, actionMeta) {
          var _this$props = _this.props,
              cacheOptions = _this$props.cacheOptions,
              onInputChange = _this$props.onInputChange; // TODO

          var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

          if (!inputValue) {
            delete _this.lastRequest;

            _this.setState({
              inputValue: '',
              loadedInputValue: '',
              loadedOptions: [],
              isLoading: false,
              passEmptyOptions: false
            });

            return;
          }

          if (cacheOptions && _this.optionsCache[inputValue]) {
            _this.setState({
              inputValue: inputValue,
              loadedInputValue: inputValue,
              loadedOptions: _this.optionsCache[inputValue],
              isLoading: false,
              passEmptyOptions: false
            });
          } else {
            var request = _this.lastRequest = {};

            _this.setState({
              inputValue: inputValue,
              isLoading: true,
              passEmptyOptions: !_this.state.loadedInputValue
            }, function () {
              _this.loadOptions(inputValue, function (options) {
                if (!_this.mounted) return;

                if (options) {
                  _this.optionsCache[inputValue] = options;
                }

                if (request !== _this.lastRequest) return;
                delete _this.lastRequest;

                _this.setState({
                  isLoading: false,
                  loadedInputValue: inputValue,
                  loadedOptions: options || [],
                  passEmptyOptions: false
                });
              });
            });
          }

          return inputValue;
        });

        _this.state = {
          defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
          inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
          isLoading: props.defaultOptions === true ? true : false,
          loadedOptions: [],
          passEmptyOptions: false
        };
        return _this;
      }

      _createClass$1(Async, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.mounted = true;
          var defaultOptions = this.props.defaultOptions;
          var inputValue = this.state.inputValue;

          if (defaultOptions === true) {
            this.loadOptions(inputValue, function (options) {
              if (!_this2.mounted) return;
              var isLoading = !!_this2.lastRequest;

              _this2.setState({
                defaultOptions: options || [],
                isLoading: isLoading
              });
            });
          }
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          // if the cacheOptions prop changes, clear the cache
          if (nextProps.cacheOptions !== this.props.cacheOptions) {
            this.optionsCache = {};
          }

          if (nextProps.defaultOptions !== this.props.defaultOptions) {
            this.setState({
              defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mounted = false;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.select.blur();
        }
      }, {
        key: "loadOptions",
        value: function loadOptions(inputValue, callback) {
          var loadOptions = this.props.loadOptions;
          if (!loadOptions) return callback();
          var loader = loadOptions(inputValue, callback);

          if (loader && typeof loader.then === 'function') {
            loader.then(callback, function () {
              return callback();
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;

          var _this$props2 = this.props,
              loadOptions = _this$props2.loadOptions,
              props = _objectWithoutProperties$1(_this$props2, ["loadOptions"]);

          var _this$state = this.state,
              defaultOptions = _this$state.defaultOptions,
              inputValue = _this$state.inputValue,
              isLoading = _this$state.isLoading,
              loadedInputValue = _this$state.loadedInputValue,
              loadedOptions = _this$state.loadedOptions,
              passEmptyOptions = _this$state.passEmptyOptions;
          var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
          return React__default.createElement(SelectComponent, _extends$1({}, props, {
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }));
        }
      }]);

      return Async;
    }(React.Component), _defineProperty$1(_class, "defaultProps", defaultProps$2), _temp;
  };
  var SelectState = manageState(Select);
  var Async = makeAsyncSelect(SelectState);

  var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(option.value).toLowerCase();
    var optionLabel = String(option.label).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
  };

  var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
      return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
      return !(!inputValue || selectValue.some(function (option) {
        return compareOption(inputValue, option);
      }) || selectOptions.some(function (option) {
        return compareOption(inputValue, option);
      }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
      return {
        label: optionLabel,
        value: inputValue,
        __isNew__: true
      };
    }
  };
  var defaultProps$3 = _objectSpread({
    allowCreateWhileLoading: false,
    createOptionPosition: 'last'
  }, builtins);
  var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits$1(Creatable, _Component);

      function Creatable(props) {
        var _this;

        _classCallCheck$1(this, Creatable);

        _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Creatable).call(this, props));

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "select", void 0);

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onChange", function (newValue, actionMeta) {
          var _this$props = _this.props,
              getNewOptionData = _this$props.getNewOptionData,
              inputValue = _this$props.inputValue,
              isMulti = _this$props.isMulti,
              onChange = _this$props.onChange,
              onCreateOption = _this$props.onCreateOption,
              value = _this$props.value;

          if (actionMeta.action !== 'select-option') {
            return onChange(newValue, actionMeta);
          }

          var newOption = _this.state.newOption;
          var valueArray = Array.isArray(newValue) ? newValue : [newValue];

          if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);else {
              var newOptionData = getNewOptionData(inputValue, inputValue);
              var newActionMeta = {
                action: 'create-option'
              };

              if (isMulti) {
                onChange([].concat(_toConsumableArray$1(cleanValue(value)), [newOptionData]), newActionMeta);
              } else {
                onChange(newOptionData, newActionMeta);
              }
            }
            return;
          }

          onChange(newValue, actionMeta);
        });

        var options = props.options || [];
        _this.state = {
          newOption: undefined,
          options: options
        };
        return _this;
      }

      _createClass$1(Creatable, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
              createOptionPosition = nextProps.createOptionPosition,
              formatCreateLabel = nextProps.formatCreateLabel,
              getNewOptionData = nextProps.getNewOptionData,
              inputValue = nextProps.inputValue,
              isLoading = nextProps.isLoading,
              isValidNewOption = nextProps.isValidNewOption,
              value = nextProps.value;
          var options = nextProps.options || [];
          var newOption = this.state.newOption;

          if (isValidNewOption(inputValue, cleanValue(value), options)) {
            newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
          } else {
            newOption = undefined;
          }

          this.setState({
            newOption: newOption,
            options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray$1(options)) : [].concat(_toConsumableArray$1(options), [newOption]) : options
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.select.blur();
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var props = _extends$1({}, this.props);

          var options = this.state.options;
          return React__default.createElement(SelectComponent, _extends$1({}, props, {
            ref: function ref(_ref) {
              _this2.select = _ref;
            },
            options: options,
            onChange: this.onChange
          }));
        }
      }]);

      return Creatable;
    }(React.Component), _defineProperty$1(_class, "defaultProps", defaultProps$3), _temp;
  }; // TODO: do this in package entrypoint

  var SelectCreatable = makeCreatableSelect(Select);
  var Creatable = manageState(SelectCreatable);

  var SelectCreatable$1 = makeCreatableSelect(Select);
  var SelectCreatableState = manageState(SelectCreatable$1);
  var AsyncCreatable = makeAsyncSelect(SelectCreatableState);

  // strip transition props off before spreading onto select component
  // note we need to be explicit about innerRef for flow
  var AnimatedInput = function AnimatedInput(WrappedComponent) {
    return function (_ref) {
      var inProp = _ref.in,
          onExited = _ref.onExited,
          appear = _ref.appear,
          enter = _ref.enter,
          exit = _ref.exit,
          props = _objectWithoutProperties$1(_ref, ["in", "onExited", "appear", "enter", "exit"]);

      return React__default.createElement(WrappedComponent, props);
    };
  };

  var Fade = function Fade(_ref) {
    var Tag = _ref.component,
        _ref$duration = _ref.duration,
        duration = _ref$duration === void 0 ? 1 : _ref$duration,
        inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties$1(_ref, ["component", "duration", "in", "onExited"]);

    var transition = {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 1,
        transition: "opacity ".concat(duration, "ms")
      },
      exiting: {
        opacity: 0
      },
      exited: {
        opacity: 0
      }
    };
    return React__default.createElement(reactTransitionGroup.Transition, {
      mountOnEnter: true,
      unmountOnExit: true,
      in: inProp,
      timeout: duration
    }, function (state) {
      var innerProps = {
        style: _objectSpread({}, transition[state])
      };
      return React__default.createElement(Tag, _extends$1({
        innerProps: innerProps
      }, props));
    });
  }; // ==============================
  // Collapse Transition
  // ==============================

  var collapseDuration = 260;
  // wrap each MultiValue with a collapse transition; decreases width until
  // finally removing from DOM
  var Collapse =
  /*#__PURE__*/
  function (_Component) {
    _inherits$1(Collapse, _Component);

    function Collapse() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$1(this, Collapse);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "duration", collapseDuration);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "rafID", void 0);

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
        width: 'auto'
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "transition", {
        exiting: {
          width: 0,
          transition: "width ".concat(_this.duration, "ms ease-out")
        },
        exited: {
          width: 0
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getWidth", function (ref) {
        if (ref && isNaN(_this.state.width)) {
          /*
            Here we're invoking requestAnimationFrame with a callback invoking our
            call to getBoundingClientRect and setState in order to resolve an edge case
            around portalling. Certain portalling solutions briefly remove children from the DOM
            before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
            while the Select component is in this state.
          */
          // cannot use `offsetWidth` because it is rounded
          _this.rafID = window.requestAnimationFrame(function () {
            var _ref$getBoundingClien = ref.getBoundingClientRect(),
                width = _ref$getBoundingClien.width;

            _this.setState({
              width: width
            });
          });
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getStyle", function (width) {
        return {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: width
        };
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getTransition", function (state) {
        return _this.transition[state];
      });

      return _this;
    }

    _createClass$1(Collapse, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.rafID) {
          window.cancelAnimationFrame(this.rafID);
        }
      } // width must be calculated; cannot transition from `undefined` to `number`

    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            children = _this$props.children,
            inProp = _this$props.in;
        var width = this.state.width;
        return React__default.createElement(reactTransitionGroup.Transition, {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          in: inProp,
          timeout: this.duration
        }, function (state) {
          var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));

          return React__default.createElement("div", {
            ref: _this2.getWidth,
            style: style
          }, children);
        });
      }
    }]);

    return Collapse;
  }(React.Component);

  var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
    return function (_ref) {
      var inProp = _ref.in,
          onExited = _ref.onExited,
          props = _objectWithoutProperties$1(_ref, ["in", "onExited"]);

      return React__default.createElement(Collapse, {
        in: inProp,
        onExited: onExited
      }, React__default.createElement(WrappedComponent, _extends$1({
        cropWithEllipsis: inProp
      }, props)));
    };
  };

  var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
    return function (props) {
      return React__default.createElement(Fade, _extends$1({
        component: WrappedComponent,
        duration: props.isMulti ? collapseDuration : 1
      }, props));
    };
  };

  var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
    return function (props) {
      return React__default.createElement(Fade, _extends$1({
        component: WrappedComponent
      }, props));
    };
  };

  // make ValueContainer a transition group
  var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
    return function (props) {
      return React__default.createElement(reactTransitionGroup.TransitionGroup, _extends$1({
        component: WrappedComponent
      }, props));
    };
  };

  var makeAnimated = function makeAnimated() {
    var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var components$$1 = defaultComponents({
      components: externalComponents
    });

    var Input = components$$1.Input,
        MultiValue = components$$1.MultiValue,
        Placeholder = components$$1.Placeholder,
        SingleValue = components$$1.SingleValue,
        ValueContainer = components$$1.ValueContainer,
        rest = _objectWithoutProperties$1(components$$1, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);

    return _objectSpread({
      Input: AnimatedInput(Input),
      MultiValue: AnimatedMultiValue(MultiValue),
      Placeholder: AnimatedPlaceholder(Placeholder),
      SingleValue: AnimatedSingleValue(SingleValue),
      ValueContainer: AnimatedValueContainer(ValueContainer)
    }, rest);
  };

  var AnimatedComponents = makeAnimated();
  var Input$1 = AnimatedComponents.Input;
  var MultiValue$1 = AnimatedComponents.MultiValue;
  var Placeholder$1 = AnimatedComponents.Placeholder;
  var SingleValue$1 = AnimatedComponents.SingleValue;
  var ValueContainer$1 = AnimatedComponents.ValueContainer;
  var index$2 = memoizeOne(makeAnimated, exportedEqual);

  var index$1$1 = manageState(Select);

  /**
   * A thin wrapper for 'react-select' with common defaults
   * @see https://react-select.com/props for full list of props
   * @param {Object} props - pass all props directly into the react-select component
   */
  var ReactSelectWrapper = function ReactSelectWrapper(props) {
    return /*#__PURE__*/React__default.createElement(index$1$1, props);
  };

  ReactSelectWrapper.defaultProps = {
    isMulti: false,
    isSearchable: false,
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    options: [],
    className: 'dropdown-select-container',
    classNamePrefix: 'dropdown-select',
    onChange: function onChange() {
      return null;
    },
    name: undefined,
    noOptionsMessage: function noOptionsMessage() {
      return 'No Options';
    }
  };

  var responseTransform = function responseTransform(countryData) {
    return countryData.map(function (item) {
      return {
        label: "".concat(item.code, " (+").concat(item.dial_code, ")"),
        value: item.code
      };
    });
  };

  var CountryCodeSelect = function CountryCodeSelect(_ref) {
    var countryData = _ref.countryData,
        className = _ref.className,
        classNamePrefix = _ref.classNamePrefix,
        defaultCountryCode = _ref.defaultCountryCode,
        onChange = _ref.onChange,
        isSearchable = _ref.isSearchable,
        name = _ref.name,
        renderNoData = _ref.renderNoData;
    return /*#__PURE__*/React__default.createElement(React.Fragment, null, countryData.length ? /*#__PURE__*/React__default.createElement(ReactSelectWrapper, {
      name: name,
      className: className,
      classNamePrefix: classNamePrefix,
      options: responseTransform(countryData),
      defaultValue: responseTransform(countryData.filter(function (item) {
        return item.code === defaultCountryCode;
      })),
      onChange: onChange,
      isSearchable: isSearchable
    }) : renderNoData());
  };

  CountryCodeSelect.defaultProps = {
    isSearchable: true,
    defaultCountryCode: 'ZA',
    onChange: function onChange() {
      return null;
    },
    className: undefined,
    classNamePrefix: undefined,
    name: 'country_code',
    countryData: [],
    renderNoData: function renderNoData() {
      return 'Loading...';
    }
  };

  var _templateObject$r;
  var SvgWrapper$1 = styled__default.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: 1px solid\n    ", ";\n  text-align: center;\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n  background-color: ", ";\n  color: ", ";\n\n  h1 {\n    color: ", ";\n  }\n\n  svg {\n    margin-left: auto;\n    margin-right: auto;\n    max-height: 80px;\n    width: auto;\n    /*condition*/\n\n    .fillColor {\n      fill: ", ";\n    }\n\n    .outlineColor {\n      fill: ", ";\n    }\n  }\n  @media (max-width: ", ") {\n    margin-bottom: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[4];
  }, function (props) {
    return props.hasBorder ? props.theme.colors.borderColor : props.theme.colors.ntrlMin;
  }, function (_ref) {
    var isChecked = _ref.isChecked,
        theme = _ref.theme;
    return isChecked ? theme.colors.primary : theme.colors.gray;
  }, function (_ref2) {
    var isChecked = _ref2.isChecked,
        theme = _ref2.theme;
    return isChecked ? 'white' : theme.colors.base;
  }, function (_ref3) {
    var isChecked = _ref3.isChecked,
        theme = _ref3.theme;
    return isChecked ? theme.colors.ntrlMin : theme.colors.primary;
  }, function (_ref4) {
    var isChecked = _ref4.isChecked,
        theme = _ref4.theme;
    return isChecked ? 'white' : theme.colors.base;
  }, function (_ref5) {
    var isChecked = _ref5.isChecked,
        theme = _ref5.theme;
    return isChecked ? theme.colors.primary : 'white';
  }, media.sm, function (props) {
    return props.theme.marginPaddings[2];
  });
  SvgWrapper$1.defaultProps = {
    isChecked: false
  };

  var _templateObject$s;
  var Body$2 = styled__default.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  .outlineColor {\n    fill: #ffffff;\n  }\n  display: flex;\n  flex-flow: row wrap;\n\n  button {\n    margin-top: 20px;\n    width: 150px;\n    cursor: pointer;\n    padding: 0;\n    &:not(:last-child) {\n      margin-right: ", ";\n    }\n  }\n  .outlineColor {\n    fill: white;\n  }\n\n  @media (max-width: ", ") {\n    display: block;\n    button {\n      width: 100%;\n      &:not(:last-child) {\n        margin-right: 0;\n      }\n    }\n  }\n"])), function (props) {
    return props.theme.marginPaddings[2];
  }, media.sm);

  var Shoes = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      version: "1.1",
      id: "svg-shoes",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 83.8 83.8",
      xmlSpace: "preserve"
    }, props), /*#__PURE__*/React__default.createElement("circle", {
      fill: "#fff",
      cx: "41.9",
      cy: "41.9",
      r: "41.9"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M61.12,56.33a1.22,1.22,0,1,1-1.22-1.21A1.22,1.22,0,0,1,61.12,56.33Z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M63.7,51.62a14.51,14.51,0,0,0-7.79-4,1.17,1.17,0,0,0-1,.3,7,7,0,0,1-4.3,1.43,6.5,6.5,0,0,1-5.48-3l-.07-.12L38.61,37A74.75,74.75,0,0,0,24.39,21.81a1.22,1.22,0,0,0-1.52,0,16.11,16.11,0,0,0-3.8,4.35,14.21,14.21,0,0,0-1.91,9.94v0a11.13,11.13,0,0,0,1.15,3.14,18.64,18.64,0,0,1,2.48,9V60.2A1.22,1.22,0,0,0,22,61.42h3.86a1.22,1.22,0,0,0,1.22-1.22V49.42a14.33,14.33,0,0,1,1.36-6.09A38.51,38.51,0,0,1,38.79,57.15a7.08,7.08,0,0,0,6.44,4.27h7.91A57.75,57.75,0,0,0,62.23,61c1.16-.2,4.69-.81,4.69-3.65C66.92,55.75,65.66,53.52,63.7,51.62Zm-39-2.2V59H23.22V48.27c0-.3,0-.62,0-1a21.72,21.72,0,0,0-2.72-9.19,38.86,38.86,0,0,1,6.05,3.67A16.07,16.07,0,0,0,24.66,49.42Zm37.16,9.13a56.25,56.25,0,0,1-8.68.43H45.23A4.65,4.65,0,0,1,41,56.17,40.59,40.59,0,0,0,19.44,35a12.14,12.14,0,0,1,1.72-7.6,13.43,13.43,0,0,1,2.48-3.05,72.42,72.42,0,0,1,13,14.1L43,47.58a9,9,0,0,0,7.59,4.17,9.89,9.89,0,0,0,5.45-1.67A12.39,12.39,0,0,1,62,53.36c1.61,1.57,2.48,3.2,2.48,3.94C64.49,57.8,63.49,58.27,61.82,58.55Z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M57.25,56.33A1.21,1.21,0,0,1,56,57.55H45.21a1.22,1.22,0,1,1,0-2.43H56A1.21,1.21,0,0,1,57.25,56.33Z"
    }));
  });

  var Clothing = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 85.2 85.2",
      xmlSpace: "preserve"
    }, props), /*#__PURE__*/React__default.createElement("circle", {
      className: "st0",
      cx: "42.6",
      cy: "42.6",
      r: "42.6"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M69.4,58.9C69,56.7,68,55,66.2,53.6l-4.4-3.3c-4.4-3.3-8.8-6.5-13.2-9.8c-0.6-0.4-1.3-0.8-2.3-1.2l-0.1,0 c-0.6-0.2-0.6-0.2-0.7-1c0-0.6,0.2-0.9,0.7-1.1c3-1.5,4.6-4.7,4.2-8c-0.5-3.6-3.4-6.4-7-6.7c-3.5-0.4-6.9,1.8-8.1,5.2 c-0.5,1.5,0.1,3.1,1.6,3.6c1.5,0.6,3.1-0.1,3.8-1.6l0.1-0.2c0-0.1,0.1-0.2,0.1-0.3c0.4-0.9,1.4-1.3,2.3-1.1c1,0.2,1.7,1,1.7,2 c0,1.1-0.6,1.8-1.6,2.2c-2.1,0.7-3.3,2.4-3.3,4.6v0.5c0,0.5,0,1.1,0,1.7v0.1c0,0,0,0-0.1,0c-1,0.2-2,0.7-2.9,1.4L19,53.7 c-1.7,1.3-2.7,2.9-3.1,4.8c-0.2,1-0.2,2-0.2,3c0,0.4,0.3,1,0.7,1.2c0.4,0.2,1,0,1.3-0.1c0.6-0.3,1.1-0.7,1.6-1.1 c0.2-0.2,0.5-0.3,0.9-0.3h5.2c12.5,0,25.4,0,38,0h0c1.8,0,2.9,0.4,3.9,1.2c0.2,0.2,0.6,0.5,1,0.5h0c0.4,0,0.8-0.3,1.1-0.7l0.1-0.1 v-2.9L69.4,58.9z M42.2,36.3c0.1-0.9,0.6-1.5,1.6-1.8c2-0.6,3.2-2.2,3.3-4.1c0.1-2.2-1.4-4.1-3.5-4.6c-2.2-0.5-4.3,0.6-5.2,2.7 l0,0.1c0,0,0,0.1,0,0.1c-0.1,0.3-0.4,0.4-0.7,0.3c-0.1-0.1-0.3-0.1-0.2-0.6c0.5-1.5,1.7-2.7,3.3-3.3c1.6-0.6,3.3-0.4,4.7,0.5 c1.6,1,2.5,2.8,2.5,4.7c0,1.9-1.1,3.6-2.8,4.6C45.1,35,45,35,44.9,35.1l-0.2,0.1c-1.1,0.6-1.7,1.5-1.7,2.7l0,1h-0.9 c0-0.2,0-0.4,0-0.6C42.1,37.6,42.1,37,42.2,36.3z M47.3,45.3c-1.5-1-3.1-1.6-4.7-1.6c-1.6,0-3.2,0.5-4.6,1.5c-1.9,1.3-3.8,2.7-5.7,4 l-0.7,0.5c-0.3,0.2-0.6,0.6-0.6,0.9c0,0.3,0,0.6,0.2,0.9c0.4,0.5,1.1,0.6,1.7,0.2c0,0,0.1-0.1,0.2-0.1l1.7-1.2 c1.5-1.1,3-2.1,4.5-3.2c0.6-0.4,1.2-0.7,1.8-0.9c1.7-0.5,3.4-0.2,5,0.9c2.9,2.1,5.8,4.1,8.7,6.2l3.1,2.2l4.2,3.1H23.3l3.4-2.5l2-1.5 l0,0l1.1-0.8c0.1,0,0.1-0.1,0.2-0.1c0.6-0.5,0.7-1.2,0.3-1.7c-0.4-0.5-1.1-0.6-1.7-0.2c-0.4,0.2-0.7,0.5-1,0.7l-9.4,6.7 c0.1-1,0.5-1.9,1.1-2.7c0.3-0.4,0.7-0.8,1.1-1.1c4-3,8-5.9,12-8.9l5.7-4.2c1.1-0.8,2.2-1.2,3.5-1.2h0.7c0.7,0,1.5,0,2.2,0.1 c0.8,0.1,1.6,0.4,2.5,1l17.8,13.1c1.3,0.9,2,2.2,2.2,3.7L47.3,45.3z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M42.6,42.6L42.6,42.6z"
    }));
  });

  var Bags = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      version: "1.1",
      id: "svg-bags",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 83.8 83.8",
      xmlSpace: "preserve"
    }, props), /*#__PURE__*/React__default.createElement("circle", {
      fill: "#fff",
      cx: "41.9",
      cy: "41.9",
      r: "41.9"
    }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
      fill: "#010101",
      d: "M65.4,33.4H52.3v-5.8c0-5.7-4.6-10.4-10.4-10.4s-10.4,4.6-10.4,10.4v5.8H18.4c-0.4,0-0.7,0-0.9,0.3 c-0.2,0.2-0.4,0.6-0.3,0.9l4.6,25c0.6,3.5,3.7,6,7.2,6.1h25.9c3.6-0.1,6.6-2.7,7.2-6.2l4.6-25c0.1-0.3-0.1-0.7-0.3-0.9 C66.1,33.5,65.8,33.3,65.4,33.4z M34,27.6c0-4.4,3.6-7.9,7.9-7.9s7.9,3.6,7.9,7.9v5.8H34V27.6z M59.6,59.3c-0.4,2.3-2.4,4-4.8,4H29 c-2.4,0-4.4-1.7-4.8-4l-4.3-23.5H64L59.6,59.3z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#010101",
      d: "M51.1,47.7c0.7,0,1.2-0.5,1.2-1.2v-3.7c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2v3.7 C49.9,47.2,50.4,47.7,51.1,47.7z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#010101",
      d: "M32.8,47.7c0.7,0,1.2-0.5,1.2-1.2v-3.7c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2v3.7 C31.5,47.2,32.1,47.7,32.8,47.7z"
    })));
  });

  var Accessories = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      version: "1.1",
      id: "svg-accessories",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 83.8 83.8",
      xmlSpace: "preserve",
      color: "#fff"
    }, props), /*#__PURE__*/React__default.createElement("circle", {
      fill: "#fff",
      cx: "41.9",
      cy: "41.9",
      r: "41.9"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M66.1,45.7v-8.5c0-3-2.6-5.8-7.5-7.7c-4.5-1.8-10.3-2.8-16.6-2.8s-12.2,1-16.7,2.8c-4.9,2-7.6,4.7-7.6,7.7v8.5 c0,1.8,1,4.5,5.6,6.9c3.1,1.6,7.5,2.8,12.3,3.3h0.1l0,0c0.8,1.1,2,1.7,3.4,1.7h5.8c1.2,0,2.3-0.5,3.1-1.4l0,0h2 c2.7,0,5.4,0.6,7.8,1.8c1.8,0.9,4,0.8,5.7-0.2c1.6-1,2.6-2.8,2.6-4.8c0-1.3-0.5-2.6-1.3-3.6l-0.1-0.1l0.1-0.1 C65.6,48.1,66.1,46.9,66.1,45.7z M35,47.4c0,0.2,0,0.3,0,0.4v5.4l-0.1,0c-4.1-0.6-7.6-1.6-10.2-2.9c-2.7-1.4-4.2-3-4.2-4.6V42 l0.2,0.2c4.2,3.4,11.4,4.7,14.3,5l0.1,0L35,47.4z M46.4,53.5c0,0.8-0.7,1.5-1.6,1.5h-5.8c-0.9,0-1.5-0.7-1.5-1.5v-1.5H42 c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3h-4.5v-1.5c0-0.9,0.7-1.5,1.5-1.5h5.8c0.9,0,1.6,0.7,1.6,1.5V53.5z M47.8,44.8 L47.8,44.8l-0.1,0c-0.8-0.7-1.8-1.1-2.8-1.1h-5.8c-1,0-2,0.4-2.8,1.1l0,0l-0.1,0c-3.7-0.4-7.2-1.2-9.9-2.3l0,0l0,0 c-0.1-0.2-0.2-0.4-0.2-0.5c0-0.5,0.9-1.6,4.2-2.6c3.2-1,7.3-1.5,11.8-1.5c4.4,0,8.6,0.5,11.7,1.5c2.8,0.9,4.1,2,4.1,2.6 c0,0.1,0,0.3-0.2,0.5l0,0l0,0C54.8,43.6,51.5,44.4,47.8,44.8z M62.1,55.6C61.6,55.9,61,56,60.4,56c-0.5,0-1-0.1-1.5-0.3 c-2.8-1.4-5.9-2.1-8.9-2.1h-1v-5.9h3c3.5,0,6.9,0.9,9.9,2.6c1,0.5,1.6,1.6,1.6,2.7C63.5,54.1,63,55,62.1,55.6z M63.5,45.7 c0,0.7-0.3,1.3-0.8,2l-0.1,0.1l-0.1,0c-1.7-0.9-3.5-1.6-5.4-2l-0.4-0.1l0.4-0.1c2.6-0.9,4.7-2,6.2-3.2l0.2-0.2V45.7z M60.4,41.1 l-0.1,0.1L60.2,41c-0.5-1.7-2.5-3.1-5.8-4.2c-3.4-1.1-7.8-1.7-12.5-1.7c-4.7,0-9.2,0.6-12.5,1.7c-3.4,1.1-5.3,2.5-5.9,4.2l-0.1,0.2 L23.4,41c-2-1.2-3.1-2.6-3.1-3.9c0-1.9,2.2-3.8,5.9-5.3c4.2-1.7,9.8-2.6,15.7-2.6c12.7,0,21.5,4.2,21.5,8 C63.5,38.5,62.4,39.8,60.4,41.1z"
    }));
  });

  var Watches = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      version: "1.1",
      id: "svg-watches",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 83.8 83.8",
      xmlSpace: "preserve"
    }, props), /*#__PURE__*/React__default.createElement("circle", {
      fill: "#fff",
      cx: "41.9",
      cy: "41.9",
      r: "41.9"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M55.7,40v-3.8c0-4.1-2.8-7.5-6.6-8.3v-7.4c0-1.6-1.3-2.8-2.8-2.8h-9.5c-1.6,0-2.8,1.3-2.8,2.8v7.4c-3.8,0.9-6.6,4.3-6.6,8.3 v11.4c0,4.1,2.8,7.5,6.6,8.3v7.4c0,1.6,1.3,2.8,2.8,2.8h9.5c1.6,0,2.8-1.3,2.8-2.8v-7.4c3.8-0.9,6.6-4.3,6.6-8.3v-3.8 c0.5,0,0.9-0.4,0.9-0.9V41C56.6,40.5,56.2,40,55.7,40L55.7,40z M47.1,63.4c0,0.5-0.4,0.9-0.9,0.9h-9.5c-0.5,0-0.9-0.4-0.9-0.9v-7.2 h11.4V63.4z M53.8,47.6c0,3.7-3,6.6-6.6,6.6H35.8c-3.7,0-6.6-3-6.6-6.6V36.2c0-3.7,3-6.6,6.6-6.6h1.4c0.5,0,0.9-0.4,0.9-0.9 c0-0.5-0.4-0.9-0.9-0.9h-1.4v-7.2c0-0.5,0.4-0.9,0.9-0.9h9.5c0.5,0,0.9,0.4,0.9,0.9v7.2h-1.4c-0.5,0-0.9,0.4-0.9,0.9 c0,0.5,0.4,0.9,0.9,0.9h1.4c3.7,0,6.6,3,6.6,6.6V47.6z M53.8,47.6"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M46.2,66.4h-9.5c-1.7,0-3.1-1.4-3.1-3.1v-7.2c-3.9-1-6.6-4.5-6.6-8.5V36.2c0-4,2.8-7.5,6.6-8.5v-7.2c0-1.7,1.4-3.1,3.1-3.1 h9.5c1.7,0,3.1,1.4,3.1,3.1v7.2c3.9,1,6.6,4.5,6.6,8.5v3.6c0.5,0.1,0.9,0.6,0.9,1.2v1.9c0,0.6-0.4,1.1-0.9,1.2v3.6 c0,4-2.8,7.5-6.6,8.5v7.2C49.3,65.1,47.9,66.4,46.2,66.4z M36.7,17.9c-1.4,0-2.6,1.2-2.6,2.6v7.6l-0.2,0c-3.7,0.9-6.4,4.2-6.4,8.1 v11.4c0,3.8,2.7,7.2,6.4,8.1l0.2,0v7.6c0,1.4,1.2,2.6,2.6,2.6h9.5c1.4,0,2.6-1.2,2.6-2.6v-7.6l0.2,0c3.7-0.9,6.4-4.2,6.4-8.1v-4h0.2 c0.4,0,0.7-0.3,0.7-0.7V41c0-0.4-0.3-0.7-0.7-0.7h-0.2v-4c0-3.8-2.7-7.2-6.4-8.1l-0.2,0v-7.6c0-1.4-1.2-2.6-2.6-2.6H36.7z M46.2,64.6h-9.5c-0.7,0-1.2-0.5-1.2-1.2v-7.5h11.9v7.5C47.4,64,46.9,64.6,46.2,64.6z M36,56.4v7c0,0.4,0.3,0.7,0.7,0.7h9.5 c0.4,0,0.7-0.3,0.7-0.7v-7H36z M47.1,54.5H35.8c-3.8,0-6.9-3.1-6.9-6.9V36.2c0-3.8,3.1-6.9,6.9-6.9h1.4c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7h-1.7v-7.5c0-0.7,0.5-1.2,1.2-1.2h9.5c0.7,0,1.2,0.5,1.2,1.2v7.5h-1.7c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7h1.4c3.8,0,6.9,3.1,6.9,6.9v11.4C54,51.4,50.9,54.5,47.1,54.5z M35.8,29.8c-3.5,0-6.4,2.9-6.4,6.4v11.4 c0,3.5,2.9,6.4,6.4,6.4h11.4c3.5,0,6.4-2.9,6.4-6.4V36.2c0-3.5-2.9-6.4-6.4-6.4h-1.4c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 h1.2v-7c0-0.4-0.3-0.7-0.7-0.7h-9.5c-0.4,0-0.7,0.3-0.7,0.7v7h1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2H35.8z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M45.2,41h-2.8v-4.7c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v5.7c0,0.5,0.4,0.9,0.9,0.9h3.8c0.5,0,0.9-0.4,0.9-0.9 C46.2,41.4,45.8,41,45.2,41L45.2,41z M45.2,41"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M45.2,43.1h-3.8c-0.7,0-1.2-0.5-1.2-1.2v-5.7c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2v4.5h2.6c0.7,0,1.2,0.5,1.2,1.2 S45.9,43.1,45.2,43.1z M41.4,35.5c-0.4,0-0.7,0.3-0.7,0.7v5.7c0,0.4,0.3,0.7,0.7,0.7h3.8c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7 h-3.1v-5C42.1,35.8,41.8,35.5,41.4,35.5z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M47.1,31.5H35.8c-2.6,0-4.7,2.1-4.7,4.7v11.4c0,2.6,2.1,4.7,4.7,4.7h11.4c2.6,0,4.7-2.1,4.7-4.7V36.2 C51.9,33.6,49.8,31.5,47.1,31.5L47.1,31.5z M47.1,50.5h-4.7v-0.8c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v0.8h-4.7 c-1.6,0-2.8-1.3-2.8-2.8v-4.7h0.8c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.8v-4.7c0-1.6,1.3-2.8,2.8-2.8h11.4 c1.6,0,2.8,1.3,2.8,2.8V41h-0.8c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9H50v4.7C50,49.2,48.7,50.5,47.1,50.5L47.1,50.5z M47.1,50.5"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M47.1,52.6H35.8c-2.8,0-5-2.2-5-5V36.2c0-2.8,2.2-5,5-5h11.4c2.8,0,5,2.2,5,5v11.4C52.1,50.4,49.9,52.6,47.1,52.6z M35.8,31.7c-2.5,0-4.5,2-4.5,4.5v11.4c0,2.5,2,4.5,4.5,4.5h11.4c2.5,0,4.5-2,4.5-4.5V36.2c0-2.5-2-4.5-4.5-4.5H35.8z M47.1,50.7h-5 v-1c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7v1h-5c-1.7,0-3.1-1.4-3.1-3.1v-5h1c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7h-1v-5 c0-1.7,1.4-3.1,3.1-3.1h11.4c1.7,0,3.1,1.4,3.1,3.1v5h-1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h1v5C50.2,49.3,48.8,50.7,47.1,50.7 z M42.6,50.2h4.5c1.4,0,2.6-1.2,2.6-2.6v-4.5h-0.5c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h0.5v-4.5c0-1.4-1.2-2.6-2.6-2.6H35.8 c-1.4,0-2.6,1.2-2.6,2.6v4.5h0.5c0.7,0,1.2,0.5,1.2,1.2s-0.5,1.2-1.2,1.2h-0.5v4.5c0,1.4,1.2,2.6,2.6,2.6h4.5v-0.5 c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2V50.2z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M41.4,29.6c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h0c-0.5,0-0.9,0.4-0.9,0.9C40.5,29.2,40.9,29.6,41.4,29.6L41.4,29.6 z M41.4,29.6"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M41.4,29.8c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C42.6,29.3,42.1,29.8,41.4,29.8z M41.4,27.9 c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7S41.8,27.9,41.4,27.9z"
    }));
  });

  var _templateObject$t;
  var ErrorMessage$1 = styled__default.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: ", ";\n"])), function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.marginPaddings[0];
  });

  var _templateObject$u, _templateObject2$3;
  var categories = catArray;

  var getSvg = function getSvg() {
    var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    switch (category) {
      case interestCategories.BAGS:
        return /*#__PURE__*/React__default.createElement(Bags, null);

      case interestCategories.SHOES:
        return /*#__PURE__*/React__default.createElement(Shoes, null);

      case interestCategories.APPAREL:
        return /*#__PURE__*/React__default.createElement(Clothing, null);

      case interestCategories.ACCESSORIES:
        return /*#__PURE__*/React__default.createElement(Accessories, null);

      case interestCategories.WATCHES:
        return /*#__PURE__*/React__default.createElement(Watches, null);

      default:
        return null;
    }
  };

  var Container$1 = styled__default.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[5];
  });
  var CategoryTitle = styled__default.h1(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  font-size: 14px;\n  text-transform: uppercase;\n"])));
  /**
   * InterestCatSelector is a specialized selector for select luxity specific interest categories
   */

  var InterestCatSelector = function InterestCatSelector(_ref) {
    var onCategoryChange = _ref.onCategoryChange,
        errorMessage = _ref.errorMessage,
        category = _ref.category;
    return /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(Body$2, null, categories.map(function (cat, index) {
      return /*#__PURE__*/React__default.createElement(WrapperButton, {
        key: "cat-".concat(index),
        id: "cat-".concat(index),
        type: "button",
        hasBorder: false,
        onClick: function onClick() {
          return onCategoryChange(cat.value);
        }
      }, /*#__PURE__*/React__default.createElement(SvgWrapper$1, {
        isChecked: category === cat.value
      }, getSvg(cat.value), /*#__PURE__*/React__default.createElement(CategoryTitle, null, cat.categoryTitle)));
    })), errorMessage && /*#__PURE__*/React__default.createElement(ErrorMessage$1, null, errorMessage));
  };

  InterestCatSelector.defaultProps = {
    errorMessage: '',
    category: null,
    onCategoryChange: function onCategoryChange() {
      return false;
    }
  };
  var CategoryInterestSelector = themed(InterestCatSelector);

  function _extends$2() {
    _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends$2.apply(this, arguments);
  }

  function _assertThisInitialized$2(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf$2(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf$2(subClass, superClass);
  }

  function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct$1()) {
      _construct = Reflect.construct.bind();
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf$2(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf$2(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf$2(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  // based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

  /**
   * Parse errors.md and turn it into a simple hash of code: message
   * @private
   */
  var ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found.\n\n",
    "75": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n"
  };
  /**
   * super basic version of sprintf
   * @private
   */

  function format() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var a = args[0];
    var b = [];
    var c;

    for (c = 1; c < args.length; c += 1) {
      b.push(args[c]);
    }

    b.forEach(function (d) {
      a = a.replace(/%[a-z]/, d);
    });
    return a;
  }
  /**
   * Create an error file out of errors.md for development and a simple web link to the full errors
   * in production mode.
   * @private
   */


  var PolishedError = /*#__PURE__*/function (_Error) {
    _inheritsLoose(PolishedError, _Error);

    function PolishedError(code) {
      var _this;

      if (process.env.NODE_ENV === 'production') {
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
      } else {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
      }

      return _assertThisInitialized$2(_this);
    }

    return PolishedError;
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  function colorToInt(color) {
    return Math.round(color * 255);
  }

  function convertToInt(red, green, blue) {
    return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
  }

  function hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) {
      convert = convertToInt;
    }

    if (saturation === 0) {
      // achromatic
      return convert(lightness, lightness, lightness);
    } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;

    if (huePrime >= 0 && huePrime < 1) {
      red = chroma;
      green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      red = secondComponent;
      green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      green = chroma;
      blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      green = secondComponent;
      blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      red = secondComponent;
      blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      red = chroma;
      blue = secondComponent;
    }

    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
  }

  var namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
  };
  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */

  function nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
  }

  var hexRegex = /^#[a-fA-F0-9]{6}$/;
  var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
  var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
  var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
  var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
  var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
  var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
  var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
  /**
   * Returns an RgbColor or RgbaColor object. This utility function is only useful
   * if want to extract a color component. With the color util `toColorString` you
   * can convert a RgbColor or RgbaColor object back to a string.
   *
   * @example
   * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
   * const color1 = parseToRgb('rgb(255, 0, 0)');
   * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
   * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
   */

  function parseToRgb(color) {
    if (typeof color !== 'string') {
      throw new PolishedError(3);
    }

    var normalizedColor = nameToHex(color);

    if (normalizedColor.match(hexRegex)) {
      return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
      };
    }

    if (normalizedColor.match(hexRgbaRegex)) {
      var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
      return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
        alpha: alpha
      };
    }

    if (normalizedColor.match(reducedHexRegex)) {
      return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
      };
    }

    if (normalizedColor.match(reducedRgbaHexRegex)) {
      var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

      return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
        alpha: _alpha
      };
    }

    var rgbMatched = rgbRegex.exec(normalizedColor);

    if (rgbMatched) {
      return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
      };
    }

    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

    if (rgbaMatched) {
      return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
      };
    }

    var hslMatched = hslRegex.exec(normalizedColor);

    if (hslMatched) {
      var hue = parseInt("" + hslMatched[1], 10);
      var saturation = parseInt("" + hslMatched[2], 10) / 100;
      var lightness = parseInt("" + hslMatched[3], 10) / 100;
      var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
      var hslRgbMatched = rgbRegex.exec(rgbColorString);

      if (!hslRgbMatched) {
        throw new PolishedError(4, normalizedColor, rgbColorString);
      }

      return {
        red: parseInt("" + hslRgbMatched[1], 10),
        green: parseInt("" + hslRgbMatched[2], 10),
        blue: parseInt("" + hslRgbMatched[3], 10)
      };
    }

    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

    if (hslaMatched) {
      var _hue = parseInt("" + hslaMatched[1], 10);

      var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

      var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

      var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

      var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

      if (!_hslRgbMatched) {
        throw new PolishedError(4, normalizedColor, _rgbColorString);
      }

      return {
        red: parseInt("" + _hslRgbMatched[1], 10),
        green: parseInt("" + _hslRgbMatched[2], 10),
        blue: parseInt("" + _hslRgbMatched[3], 10),
        alpha: parseFloat("" + hslaMatched[4])
      };
    }

    throw new PolishedError(5);
  }

  /**
   * Reduces hex values if possible e.g. #ff8866 to #f86
   * @private
   */
  var reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
      return "#" + value[1] + value[3] + value[5];
    }

    return value;
  };

  function numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  /**
   * Returns a string value for the color. The returned result is the smallest possible hex notation.
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   background: rgb(255, 205, 100),
   *   background: rgb({ red: 255, green: 205, blue: 100 }),
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *   background: ${rgb(255, 205, 100)};
   *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   background: "#ffcd64";
   *   background: "#ffcd64";
   * }
   */
  function rgb(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
      return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
    } else if (typeof value === 'object' && green === undefined && blue === undefined) {
      return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
    }

    throw new PolishedError(6);
  }

  /**
   * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
   *
   * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   background: rgba(255, 205, 100, 0.7),
   *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
   *   background: rgba(255, 205, 100, 1),
   *   background: rgba('#ffffff', 0.4),
   *   background: rgba('black', 0.7),
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *   background: ${rgba(255, 205, 100, 0.7)};
   *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
   *   background: ${rgba(255, 205, 100, 1)};
   *   background: ${rgba('#ffffff', 0.4)};
   *   background: ${rgba('black', 0.7)};
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   background: "rgba(255,205,100,0.7)";
   *   background: "rgba(255,205,100,0.7)";
   *   background: "#ffcd64";
   *   background: "rgba(255,255,255,0.4)";
   *   background: "rgba(0,0,0,0.7)";
   * }
   */
  function rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
      var rgbValue = parseToRgb(firstValue);
      return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
      return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
      return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    }

    throw new PolishedError(7);
  }

  // Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-redeclare
  function curried(f, length, acc) {
    return function fn() {
      // eslint-disable-next-line prefer-rest-params
      var combined = acc.concat(Array.prototype.slice.call(arguments));
      return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
    };
  } // eslint-disable-next-line no-redeclare


  function curry(f) {
    // eslint-disable-line no-redeclare
    return curried(f, f.length, []);
  }

  function guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
  }

  /**
   * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
   *
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   background: transparentize(0.1, '#fff');
   *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
   *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *   background: ${transparentize(0.1, '#fff')};
   *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
   *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   background: "rgba(255,255,255,0.9)";
   *   background: "rgba(255,255,255,0.8)";
   *   background: "rgba(255,0,0,0.3)";
   * }
   */

  function transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = parseToRgb(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

    var colorWithAlpha = _extends$2({}, parsedColor, {
      alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });

    return rgba(colorWithAlpha);
  } // prettier-ignore


  var curriedTransparentize = /*#__PURE__*/curry
  /* ::<number | string, string, string> */
  (transparentize);

  var _templateObject$v;
  var baseSliderStyles = styled.css(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  .rc-slider {\n    position: relative;\n    height: 14px;\n    padding: 5px 0;\n    width: 100%;\n    border-radius: 6px;\n    touch-action: none;\n    box-sizing: border-box;\n  }\n  .rc-slider * {\n    box-sizing: border-box;\n  }\n  .rc-slider-rail {\n    position: absolute;\n    width: 100%;\n    background-color: #e9e9e9;\n    height: 4px;\n    border-radius: 6px;\n  }\n  .rc-slider-track {\n    position: absolute;\n    left: 0;\n    height: 4px;\n    border-radius: 6px;\n    background-color: #abe2fb;\n  }\n  .rc-slider-handle {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n    margin-top: -5px;\n    border-radius: 50%;\n    border: solid 2px #96dbfa;\n    background-color: #fff;\n    -ms-touch-action: pan-x;\n    touch-action: pan-x;\n  }\n  .rc-slider-handle:focus {\n    border-color: #57c5f7;\n    box-shadow: 0 0 0 5px #96dbfa;\n    outline: none;\n  }\n  .rc-slider-handle-click-focused:focus {\n    border-color: #96dbfa;\n    box-shadow: unset;\n  }\n  .rc-slider-handle:hover {\n    border-color: #57c5f7;\n  }\n  .rc-slider-handle:active {\n    border-color: #57c5f7;\n    box-shadow: 0 0 5px #57c5f7;\n    cursor: grabbing;\n  }\n  .rc-slider-mark {\n    position: absolute;\n    top: 18px;\n    left: 0;\n    width: 100%;\n    font-size: 12px;\n  }\n  .rc-slider-mark-text {\n    position: absolute;\n    display: inline-block;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n    color: #999;\n  }\n  .rc-slider-mark-text-active {\n    color: #666;\n  }\n  .rc-slider-step {\n    position: absolute;\n    width: 100%;\n    height: 4px;\n    background: transparent;\n  }\n  .rc-slider-dot {\n    position: absolute;\n    bottom: -2px;\n    margin-left: -4px;\n    width: 8px;\n    height: 8px;\n    border: 2px solid #e9e9e9;\n    background-color: #fff;\n    cursor: pointer;\n    border-radius: 50%;\n    vertical-align: middle;\n  }\n  .rc-slider-dot-active {\n    border-color: #96dbfa;\n  }\n  .rc-slider-dot-reverse {\n    margin-left: 0;\n    margin-right: -4px;\n  }\n  .rc-slider-disabled {\n    background-color: #e9e9e9;\n  }\n  .rc-slider-disabled .rc-slider-track {\n    background-color: #ccc;\n  }\n  .rc-slider-disabled .rc-slider-handle,\n  .rc-slider-disabled .rc-slider-dot {\n    border-color: #ccc;\n    box-shadow: none;\n    background-color: #fff;\n    cursor: not-allowed;\n  }\n  .rc-slider-disabled .rc-slider-mark-text,\n  .rc-slider-disabled .rc-slider-dot {\n    cursor: not-allowed !important;\n  }\n  .rc-slider-vertical {\n    width: 14px;\n    height: 100%;\n    padding: 0 5px;\n  }\n  .rc-slider-vertical .rc-slider-rail {\n    height: 100%;\n    width: 4px;\n  }\n  .rc-slider-vertical .rc-slider-track {\n    left: 5px;\n    bottom: 0;\n    width: 4px;\n  }\n  .rc-slider-vertical .rc-slider-handle {\n    margin-left: -5px;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n  }\n  .rc-slider-vertical .rc-slider-mark {\n    top: 0;\n    left: 18px;\n    height: 100%;\n  }\n  .rc-slider-vertical .rc-slider-step {\n    height: 100%;\n    width: 4px;\n  }\n  .rc-slider-vertical .rc-slider-dot {\n    left: 2px;\n    margin-bottom: -4px;\n  }\n  .rc-slider-vertical .rc-slider-dot:first-child {\n    margin-bottom: -4px;\n  }\n  .rc-slider-vertical .rc-slider-dot:last-child {\n    margin-bottom: -4px;\n  }\n  .rc-slider-tooltip-zoom-down-enter,\n  .rc-slider-tooltip-zoom-down-appear {\n    animation-duration: 0.3s;\n    animation-fill-mode: both;\n    display: block !important;\n    animation-play-state: paused;\n  }\n  .rc-slider-tooltip-zoom-down-leave {\n    animation-duration: 0.3s;\n    animation-fill-mode: both;\n    display: block !important;\n    animation-play-state: paused;\n  }\n  .rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n  .rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n    animation-name: rcSliderTooltipZoomDownIn;\n    animation-play-state: running;\n  }\n  .rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n    animation-name: rcSliderTooltipZoomDownOut;\n    animation-play-state: running;\n  }\n  .rc-slider-tooltip-zoom-down-enter,\n  .rc-slider-tooltip-zoom-down-appear {\n    transform: scale(0, 0);\n    animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n  }\n  .rc-slider-tooltip-zoom-down-leave {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n  }\n  @keyframes rcSliderTooltipZoomDownIn {\n    0% {\n      opacity: 0;\n      transform-origin: 50% 100%;\n      transform: scale(0, 0);\n    }\n    100% {\n      transform-origin: 50% 100%;\n      transform: scale(1, 1);\n    }\n  }\n  @keyframes rcSliderTooltipZoomDownOut {\n    0% {\n      transform-origin: 50% 100%;\n      transform: scale(1, 1);\n    }\n    100% {\n      opacity: 0;\n      transform-origin: 50% 100%;\n      transform: scale(0, 0);\n    }\n  }\n  .rc-slider-tooltip {\n    position: absolute;\n    left: -9999px;\n    top: -9999px;\n    visibility: visible;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .rc-slider-tooltip * {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .rc-slider-tooltip-hidden {\n    display: none;\n  }\n  .rc-slider-tooltip-placement-top {\n    padding: 4px 0 8px 0;\n  }\n  .rc-slider-tooltip-inner {\n    padding: 6px 2px;\n    min-width: 24px;\n    height: 24px;\n    font-size: 12px;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    text-decoration: none;\n    background-color: #6c6c6c;\n    border-radius: 6px;\n    box-shadow: 0 0 4px #d9d9d9;\n  }\n  .rc-slider-tooltip-arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n  }\n  .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n    bottom: 4px;\n    left: 50%;\n    margin-left: -4px;\n    border-width: 4px 4px 0;\n    border-top-color: #6c6c6c;\n  }\n"])));

  var _templateObject$w, _templateObject2$4, _templateObject3$2, _templateObject4$2;
  var handleDimension = '14px';
  var SliderContainer = styled__default.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  ", ";\n  position: relative;\n  .rc-slider-handle {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  .rc-slider {\n    margin-bottom: ", ";\n    max-width: calc(100% - ", ");\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .rc-slider-track {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    height: ", ";\n    width: ", ";\n    transition: border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out;\n    &:hover,\n    &:focus {\n      border: ", ";\n      box-shadow: 0 0 0 5px\n        ", ";\n    }\n  }\n  ", "\n"])), baseSliderStyles, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.marginPaddings[6];
  }, handleDimension, function (props) {
    return props.theme.colors.primary;
  }, handleDimension, handleDimension, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return curriedTransparentize(0.8, props.theme.colors.primary);
  }, function (props) {
    return getSliderMarkStyle(props);
  });

  var getSliderMarkStyle = function getSliderMarkStyle(_ref) {
    var showMarks = _ref.showMarks,
        primary = _ref.theme.colors.primary;
    var visiblityStyle = showMarks ? styled.css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral([""]))) : styled.css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n        .rc-slider-mark-text,\n        .rc-slider-dot {\n          visibility: hidden;\n        }\n      "])));
    return styled.css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n    .rc-slider-mark-text {\n      color: ", ";\n    }\n\n    .rc-slider-dot {\n      border-color: ", ";\n      background-color: white;\n    }\n    ", "\n  "])), primary, primary, visiblityStyle);
  };

  var _templateObject$x;
  var ToolTipWrapper = styled__default.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  position: absolute;\n  right: auto;\n  top: 20px;\n  transform: translateX(-50%);\n  width: 100px;\n  text-align: center;\n"])));

  var _templateObject$y;
  var Footer = styled__default.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-end;\n"])));

  var _excluded$6 = ["dragging", "value", "offset", "index"],
      _excluded2 = ["renderTitleSection", "marks", "defaultMinValue", "defaultMaxValue", "min", "max", "toolTipComponent", "renderFooterSection", "onChange", "children", "identifier", "showMarks"];

  var _templateObject$z;
  var debounceBuilder = functions.debounced(100);
  var ChildrenWrapper = styled__default.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[3];
  });

  var renderCustomHandle = function renderCustomHandle() {
    var marks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var toolTipComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var handleProps = arguments.length > 2 ? arguments[2] : undefined;

    var dragging = handleProps.dragging,
        value = handleProps.value,
        offset = handleProps.offset,
        index = handleProps.index,
        restHandleProps = _objectWithoutProperties(handleProps, _excluded$6);

    var getToolTipProps = function getToolTipProps() {
      var newProps = {}; // Ensures that Tooltip component does not get ref prop

      Object.keys(handleProps).forEach(function (propName) {
        if (propName !== 'ref') {
          newProps[propName] = handleProps[propName];
        }
      });
      return newProps;
    };

    var Tooltip = toolTipComponent;
    return /*#__PURE__*/React__default.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(rcSlider.Handle, _extends({
      offset: offset,
      value: value
    }, restHandleProps, {
      dragging: dragging.toString()
    })), toolTipComponent && /*#__PURE__*/React__default.createElement(ToolTipWrapper, {
      style: {
        left: "".concat(offset, "%")
      }
    }, /*#__PURE__*/React__default.createElement(Tooltip, _extends({
      marks: marks
    }, getToolTipProps()))));
  };
  /** slider ui component for react */


  var RangeSlider = function RangeSlider(_ref) {
    var renderTitleSection = _ref.renderTitleSection,
        marks = _ref.marks,
        defaultMinValue = _ref.defaultMinValue,
        defaultMaxValue = _ref.defaultMaxValue,
        min = _ref.min,
        max = _ref.max,
        toolTipComponent = _ref.toolTipComponent,
        renderFooterSection = _ref.renderFooterSection,
        onChange = _ref.onChange,
        childRenderer = _ref.children,
        identifier = _ref.identifier,
        showMarks = _ref.showMarks,
        restProps = _objectWithoutProperties(_ref, _excluded2);

    var _useState = React.useState(defaultMinValue),
        _useState2 = _slicedToArray(_useState, 2),
        currMinVal = _useState2[0],
        setMinVal = _useState2[1];

    var _useState3 = React.useState(defaultMaxValue),
        _useState4 = _slicedToArray(_useState3, 2),
        currMaxVal = _useState4[0],
        setMaxVal = _useState4[1];
    /*
     *Description variable stores the time that the component renders
     * the state is used to enforce reenders for the component since the date now
     * is always changing
     * */


    var _useState5 = React.useState(0),
        _useState6 = _slicedToArray(_useState5, 2),
        seed = _useState6[0],
        setSeed = _useState6[1];

    var manuallyChangeMinValue = function manuallyChangeMinValue(val) {
      setMinVal(val);
      setSeed(Date.now());
    };

    var manuallyChangeMaxValue = function manuallyChangeMaxValue(val) {
      setMaxVal(val);
      setSeed(Date.now());
    };

    var prevMinVal = functions.usePrevious(currMinVal);
    var prevMaxVal = functions.usePrevious(currMaxVal);
    React.useEffect(function () {
      manuallyChangeMinValue(min);
      manuallyChangeMaxValue(max);
    }, [min, max]);
    React.useEffect(function () {
      if (prevMinVal !== currMinVal || prevMaxVal !== currMaxVal) {
        var value = {
          min: currMinVal,
          max: currMaxVal
        };
        debounceBuilder(function () {
          return onChange(value);
        });
      }
    }, [currMaxVal, currMinVal, onChange, prevMaxVal, prevMinVal]);
    var actionsObj = {
      manuallyChangeMinValue: manuallyChangeMinValue,
      manuallyChangeMaxValue: manuallyChangeMaxValue,
      currMinVal: currMinVal,
      currMaxVal: currMaxVal,
      defaultMinValue: defaultMinValue,
      defaultMaxValue: defaultMaxValue
    };
    return /*#__PURE__*/React__default.createElement(SliderContainer, {
      "data-qe-id": identifier,
      showMarks: showMarks
    }, renderTitleSection(actionsObj), childRenderer && /*#__PURE__*/React__default.createElement(ChildrenWrapper, null, typeof childRenderer === 'function' ? childRenderer(actionsObj) : childRenderer), /*#__PURE__*/React__default.createElement(rcSlider.Range, _extends({
      seed: seed,
      min: min,
      max: max,
      defaultValue: [defaultMinValue, defaultMaxValue],
      onChange: function onChange(_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            nextMin = _ref3[0],
            nextMax = _ref3[1];

        setMinVal(nextMin);
        setMaxVal(nextMax);
      },
      value: [currMinVal, currMaxVal],
      marks: marks,
      step: functions.isObjectEmpty(marks) ? 1 : null,
      handle: function handle(props) {
        return renderCustomHandle(marks, toolTipComponent, props);
      },
      allowCross: false
    }, restProps)), /*#__PURE__*/React__default.createElement(Footer, null, renderFooterSection(actionsObj)));
  };

  RangeSlider.defaultProps = {
    renderTitleSection: function renderTitleSection() {
      return false;
    },
    marks: {},
    toolTipComponent: null,
    renderFooterSection: function renderFooterSection() {
      return false;
    },
    onChange: function onChange() {
      return false;
    },
    children: null,
    showMarks: false
  };
  var RangeSlider$1 = themed(RangeSlider);

  var _templateObject$A, _templateObject2$5;
  var Title$2 = styled__default.h1(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: bold;\n  margin-bottom: 0;\n  text-transform: uppercase;\n"])), function (props) {
    return props.theme.fontSizes[2];
  });
  var InterestsSubheadingContainer = styled__default.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: ", ";\n  border-bottom: 1px solid ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n  width: 100%;\n  align-items: center;\n"])), function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.marginPaddings[3];
  }, function (props) {
    return props.theme.marginPaddings[3];
  });

  var InterestsSubheading = function InterestsSubheading(_ref) {
    var title = _ref.title,
        children = _ref.children,
        className = _ref.className;
    return /*#__PURE__*/React__default.createElement(InterestsSubheadingContainer, {
      className: className
    }, /*#__PURE__*/React__default.createElement(Title$2, null, title), /*#__PURE__*/React__default.createElement("div", null, children));
  };

  var _templateObject$B;
  var CurrencyInputWrapper = styled__default.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n\n  input[data-qe-id='masked-input-min'],\n  input[data-qe-id='masked-input-max'] {\n    flex-basis: 30%;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    border-bottom: 1px solid ", ";\n  }\n"])), function (props) {
    return props.theme.colors.primary;
  });

  var debounceBuilder$1 = functions.debounced(50);

  var getMaxPrice = function getMaxPrice() {
    var interestCategory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    switch (interestCategory) {
      case interestCategories.ACCESSORIES:
        return interestCategoryMaxPrices.ACCESSORIES;

      case interestCategories.BAGS:
        return interestCategoryMaxPrices.BAGS;

      case interestCategories.SHOES:
        return interestCategoryMaxPrices.SHOES;

      case interestCategories.WATCHES:
        return interestCategoryMaxPrices.WATCHES;

      case interestCategories.APPAREL:
        return interestCategoryMaxPrices.APPAREL;

      default:
        return 0;
    }
  };

  var getFooterButtons = function getFooterButtons(actionObj) {
    var giveFullRange = actionObj.giveFullRange;
    return /*#__PURE__*/React__default.createElement(SecondaryButton$1, {
      type: "button",
      onClick: giveFullRange
    }, "Full Price Range");
  };
  /** UI Slider with minimum and max input fields give the ability to
   * select a price range */


  var PriceRangeSelector = function PriceRangeSelector(_ref) {
    var onChange = _ref.onChange,
        category = _ref.category;
    var maxPrice = getMaxPrice(category);

    var handleSlideChange = function handleSlideChange(value) {
      var min_price = value.min,
          max_price = value.max;
      onChange({
        min_price: min_price,
        max_price: max_price
      });
    };

    var handleMinCurrencyChange = function handleMinCurrencyChange(targetValue, currMaxVal, manuallyChangeMinValue) {
      var value = parseInt(unMask(targetValue), 10);
      value = Number.isNaN(value) ? 0 : value;
      value = value > currMaxVal ? currMaxVal : value;
      debounceBuilder$1(function () {
        manuallyChangeMinValue(value);
        onChange({
          min_price: value,
          max_price: currMaxVal
        });
      });
    };

    var handleMaxCurrencyChange = function handleMaxCurrencyChange(targetValue, currMinVal, manuallyChangeMaxValue) {
      var value = parseInt(unMask(targetValue), 10);
      value = Number.isNaN(value) ? 0 : value;
      value = value < currMinVal ? currMinVal : value;
      debounceBuilder$1(function () {
        manuallyChangeMaxValue(value);
        onChange({
          max_price: value,
          min_price: currMinVal
        });
      });
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "price-ranges"
    }, /*#__PURE__*/React__default.createElement(RangeSlider$1, {
      renderTitleSection: function renderTitleSection() {
        return /*#__PURE__*/React__default.createElement(InterestsSubheading, {
          title: "Price Range"
        });
      },
      identifier: "price-range-slider",
      max: maxPrice,
      defaultMinValue: 0,
      min: 0,
      onChange: handleSlideChange,
      defaultMaxValue: maxPrice,
      renderFooterButtons: getFooterButtons,
      title: "Price Ranges"
    }, function (_ref2) {
      var manuallyChangeMinValue = _ref2.manuallyChangeMinValue,
          manuallyChangeMaxValue = _ref2.manuallyChangeMaxValue,
          currMinVal = _ref2.currMinVal,
          currMaxVal = _ref2.currMaxVal;
      return /*#__PURE__*/React__default.createElement(CurrencyInputWrapper, null, /*#__PURE__*/React__default.createElement(CurrencyInputFormatter, {
        "data-qe-id": "masked-input-min",
        value: currMinVal,
        onChange: function onChange(value) {
          handleMinCurrencyChange(value, currMaxVal, manuallyChangeMinValue);
        }
      }), /*#__PURE__*/React__default.createElement(CurrencyInputFormatter, {
        "data-qe-id": "masked-input-max",
        value: currMaxVal,
        onChange: function onChange(value) {
          handleMaxCurrencyChange(value, currMinVal, manuallyChangeMaxValue);
        }
      }));
    }));
  };

  PriceRangeSelector.defaultProps = {
    onChange: function onChange() {
      return false;
    },
    category: ''
  };

  var _templateObject$C;
  var ShoeSizeInputWrapper = styled__default.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n\n  input[data-qe-id='masked-input-min'],\n  input[data-qe-id='masked-input-max'] {\n    flex-basis: 49%;\n    border: 1px solid ", ";\n    border-radius: 6px;\n    background-color: ", ";\n    padding: 10px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n    input[data-qe-id='masked-input-min'] {\n      margin-bottom: 10px;\n    }\n    input[data-qe-id='masked-input-min'],\n    input[data-qe-id='masked-input-max'] {\n      flex-basis: 100%;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepColors.ntrl40;
  }, media.xs);

  var debounceBuilder$2 = functions.debounced(50);
  var shoeSizeType = {
    Uk: 'Uk',
    Eu: 'Eu',
    Us: 'Us'
  };

  var getMaxShoeSize = function getMaxShoeSize(euShoeSizes, ukShoeSizes, type) {
    var shoeSizes = ukShoeSizes;

    if (type === (shoeSizeType === null || shoeSizeType === void 0 ? void 0 : shoeSizeType.Eu)) {
      shoeSizes = euShoeSizes;
    }

    var sizes = shoeSizes.map(function (item) {
      return parseFloat(item.size);
    }); // Use the Math.max function to find the maximum size value

    var maxSize = sizes.reduce(function (max, current) {
      return Math.max(max, current);
    }, -50);
    return maxSize;
  };
  /** UI Slider with minimum and max input fields give the ability to
   * select a shoe size range */


  var ShoeSizeRangeSelector = function ShoeSizeRangeSelector(_ref) {
    var onChange = _ref.onChange,
        euShoeSizes = _ref.euShoeSizes,
        ukShoeSizes = _ref.ukShoeSizes,
        sizeType = _ref.sizeType;
    var maxShoeSize = getMaxShoeSize(euShoeSizes, ukShoeSizes, sizeType);

    var handleSlideChange = function handleSlideChange(value) {
      var min_shoe_size = value.min,
          max_shoe_size = value.max;
      onChange({
        min_shoe_size: min_shoe_size,
        max_shoe_size: max_shoe_size
      });
    };

    var handleMinShoeSizeChange = function handleMinShoeSizeChange(targetValue, currMaxVal, manuallyChangeMinValue) {
      var value = parseInt(targetValue, 10);
      value = Number.isNaN(value) ? 0 : value;
      value = value > currMaxVal ? currMaxVal : value;
      debounceBuilder$2(function () {
        manuallyChangeMinValue(value);
        onChange({
          min_shoe_size: value,
          max_shoe_size: currMaxVal
        });
      });
    };

    var handleMaxShoeSizeChange = function handleMaxShoeSizeChange(targetValue, currMinVal, manuallyChangeMaxValue) {
      var value = parseInt(targetValue, 10);
      value = Number.isNaN(value) ? 0 : value;
      value = value < currMinVal ? currMinVal : value;
      debounceBuilder$2(function () {
        manuallyChangeMaxValue(value);
        onChange({
          max_shoe_size: value,
          min_shoe_size: currMinVal
        });
      });
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "shoe-size-ranges"
    }, /*#__PURE__*/React__default.createElement(RangeSlider$1, {
      identifier: "shoe-size-range-slider",
      max: maxShoeSize,
      defaultMinValue: 1,
      min: 1,
      onChange: handleSlideChange,
      defaultMaxValue: maxShoeSize,
      title: "Shoe Size Ranges"
    }, function (_ref2) {
      var manuallyChangeMinValue = _ref2.manuallyChangeMinValue,
          manuallyChangeMaxValue = _ref2.manuallyChangeMaxValue,
          currMinVal = _ref2.currMinVal,
          currMaxVal = _ref2.currMaxVal;
      return /*#__PURE__*/React__default.createElement(ShoeSizeInputWrapper, null, /*#__PURE__*/React__default.createElement("input", {
        "data-qe-id": "masked-input-min",
        value: currMinVal,
        onChange: function onChange(value) {
          handleMinShoeSizeChange(value, currMaxVal, manuallyChangeMinValue);
        }
      }), /*#__PURE__*/React__default.createElement("input", {
        "data-qe-id": "masked-input-max",
        value: currMaxVal,
        onChange: function onChange(value) {
          handleMaxShoeSizeChange(value, currMinVal, manuallyChangeMaxValue);
        }
      }));
    }));
  };

  ShoeSizeRangeSelector.defaultProps = {
    onChange: function onChange() {
      return false;
    },
    euShoeSizes: [],
    ukShoeSizes: [],
    sizeType: 'Uk'
  };

  var getMaxSizeIndex = function getMaxSizeIndex() {
    var shoe_sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return shoe_sizes.length - 1;
  };

  var formatResultsForRangeSlider = function formatResultsForRangeSlider() {
    var shoe_sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var newDataShape = {};
    shoe_sizes.forEach(function (_ref, index) {
      var size = _ref.size;
      newDataShape[index] = size;
    });
    return newDataShape;
  };

  var ToolTipComponent = function ToolTipComponent(props) {
    var marks = props.marks,
        value = props.value;
    return /*#__PURE__*/React__default.createElement("div", null, marks[value]);
  };
  /** slider ui component for shoe size selection interests */


  var ShoeSizeSelector = function ShoeSizeSelector(_ref2) {
    var onChange = _ref2.onChange,
        shoeSizes = _ref2.shoeSizes;

    var handleShoeSizeChange = function handleShoeSizeChange(value) {
      var min_shoe_key = value.min,
          max_shoe_key = value.max;
      onChange({
        min_shoe_size_id: shoeSizes[min_shoe_key].id,
        max_shoe_size_id: shoeSizes[max_shoe_key].id
      });
    };

    var getFooterButtons = function getFooterButtons(actionObj) {
      var giveFullRange = actionObj.giveFullRange;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InvertedTextButton$1, {
        type: "button",
        className: "shoe-size-selector-full-btn",
        onClick: giveFullRange
      }, "Full Shoe Size Range"));
    };

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RangeSlider$1, {
      identifier: "shoe-size-range-slider",
      marks: formatResultsForRangeSlider(shoeSizes),
      min: 0,
      max: getMaxSizeIndex(shoeSizes),
      defaultMinValue: 0,
      defaultMaxValue: getMaxSizeIndex(shoeSizes),
      toolTipComponent: ToolTipComponent,
      renderFooterSection: getFooterButtons,
      onChange: handleShoeSizeChange
    }));
  };

  ShoeSizeSelector.defaultProps = {
    onChange: function onChange() {
      return false;
    },
    shoeSizes: []
  };

  var SimpleErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inherits(SimpleErrorBoundary, _React$Component);

    var _super = _createSuper(SimpleErrorBoundary);

    function SimpleErrorBoundary(props) {
      var _this;

      _classCallCheck(this, SimpleErrorBoundary);

      _this = _super.call(this, props);
      _this.state = {
        hasError: false
      };
      return _this;
    }

    _createClass(SimpleErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        if (this.props.errorLogger) this.props.errorLogger(error, errorInfo);
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.hasError) {
          // You can render any custom fallback UI
          return this.props.showMessageOnError ? /*#__PURE__*/React__default.createElement("h1", null, this.props.errorMessage) : null;
        }

        return this.props.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
          hasError: true
        };
      }
    }]);

    return SimpleErrorBoundary;
  }(React__default.Component);

  SimpleErrorBoundary.defaultProps = {
    errorMessage: 'Something went wrong',
    errorLogger: null,
    showMessageOnError: true
  };

  var _templateObject$D;
  var StyledHeader = styled__default.h5(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n\n  @media (max-width: ", ") {\n    display: block;\n  }\n\n  .icon-header__left {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n\n    @media (max-width: ", ") {\n      align-self: flex-start;\n    }\n\n    svg {\n      height: 1.5em;\n      width: 1.5em;\n      margin-right: ", ";\n    }\n  }\n\n  .icon-header__right {\n    display: flex;\n    flex-grow: 1;\n    justify-content: flex-end;\n  }\n"])), media.sm, media.sm, function (props) {
    return props.theme.marginPaddings[1];
  });

  /**
   * IconHeader can render the standard Luxity Page/Section Header nodes with SVG
   */
  var IconHeader = function IconHeader(_ref) {
    var title = _ref.title,
        SvgComponent = _ref.svgComponent,
        renderAppendage = _ref.renderAppendage;
    return /*#__PURE__*/React__default.createElement(StyledHeader, null, /*#__PURE__*/React__default.createElement("div", {
      className: "icon-header__left"
    }, /*#__PURE__*/React__default.createElement(SvgComponent, null), title), /*#__PURE__*/React__default.createElement("div", {
      className: "icon-header__right"
    }, renderAppendage && renderAppendage()));
  };

  IconHeader.defaultProps = {
    title: '',
    svgComponent: function svgComponent() {
      return false;
    },
    renderAppendage: function renderAppendage() {
      return false;
    }
  };
  var IconHeader$1 = themed(IconHeader);

  var Account = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      id: "svg-account",
      width: "25",
      height: "29",
      viewBox: "0 0 25 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default.createElement("path", {
      d: "M20.9496 10.2519V7.6666C20.9496 3.43926 17.1602 0 12.5016 0C7.84173 0 4.05044 3.43926 4.05044 7.6666V10.2519C2.26758 10.6808 1 12.2658 1 14.1175V24.021C1 26.2148 2.78986 28 4.9908 28H20.0092C22.2101 28 24 26.2148 24 24.021V14.115C24 12.2652 22.7324 10.6808 20.9496 10.2519ZM5.70052 10.136V7.6666C5.70052 4.34833 8.7516 1.64836 12.501 1.64836C16.249 1.64836 19.2988 4.34833 19.2988 7.6666V10.136H5.70052ZM20.0092 26.3548H4.9908C3.70162 26.3548 2.65261 25.3076 2.65261 24.021V14.115C2.65261 12.8296 3.70099 11.7843 4.9908 11.7843H20.0092C21.2996 11.7843 22.3499 12.8296 22.3499 14.115V24.021C22.3499 25.3076 21.2996 26.3548 20.0092 26.3548Z",
      fill: "currentColor"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M12.5012 14.1892C11.2038 14.1892 10.1484 15.2421 10.1484 16.5357V19.5739C10.1484 20.8675 11.2038 21.9204 12.5012 21.9204C13.7974 21.9204 14.8515 20.8675 14.8515 19.5739V16.5357C14.8515 15.2421 13.7974 14.1892 12.5012 14.1892ZM13.1982 16.5357V19.5739C13.1982 19.9591 12.8856 20.2721 12.5006 20.2721C12.1149 20.2721 11.8011 19.9591 11.8011 19.5739V16.5357C11.8011 16.1505 12.1149 15.8376 12.5012 15.8376C12.8856 15.8376 13.1982 16.1505 13.1982 16.5357Z",
      fill: "currentColor"
    }));
  });

  var _templateObject$E;
  var NotifyContainer = styled__default.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  .page-ready {\n    display: flex;\n    align-items: center;\n  }\n\n  .loader {\n    min-width: 150px;\n  }\n\n  .notification-dropdown-select-container {\n    min-width: 150px;\n\n    .notification-dropdown-select__control {\n      min-height: auto;\n      background-color: ", ";\n      border: none;\n      border-radius: 0;\n\n      &--is-focused {\n        border: none;\n        border-radius: 0;\n        box-shadow: none;\n      }\n\n      .notification-dropdown-select__value-container {\n        & > div {\n          padding: 0;\n          margin: 0;\n          color: ", ";\n        }\n        & .notification-dropdown-select__single-value,\n        & .notification-dropdown-select__placeholder {\n          overflow: visible;\n          font-weight: lighter;\n        }\n      }\n    }\n  }\n\n  .notification-dropdown-select__indicators {\n    padding: 0 !important;\n    .notification-dropdown-select__dropdown-indicator {\n      color: ", ";\n    }\n  }\n\n  .notification-dropdown-select__menu {\n    border-radius: 0;\n\n    & > .notification-dropdown-select__menu-list {\n      border-radius: 0;\n\n      & > .notification-dropdown-select__option {\n        font-weight: bold;\n        &:last-child {\n          border-bottom: none;\n        }\n\n        &.notification-dropdown-select__option--is-focused {\n          background-color: ", ";\n          border-style: hidden;\n        }\n        &.notification-dropdown-select__option--is-selected {\n          color: ", ";\n          background-color: ", ";\n          border-style: hidden;\n        }\n        &.notification-dropdown-select__option--is-selected.notification-dropdown-select__option--is-focused {\n          border-style: hidden;\n        }\n      }\n    }\n  }\n"])), function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.base;
  }, function (props) {
    return props.theme.colors.base;
  }, function (props) {
    return props.theme.colors.ntrlMinTen;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  });

  var defaultNotifyTime = 5000;
  var success = function success(message) {
    Notifications.notify.show(message, 'success', defaultNotifyTime);
  };
  var error = function error(message) {
    Notifications.notify.show(message, 'error', defaultNotifyTime);
  };
  /**
   * It represents the React Component that contains the notifications.
   * */

  var LuxityNotifications = function LuxityNotifications(props) {
    return /*#__PURE__*/React__default.createElement(Notifications__default, props);
  };

  var NotificationDropDown = /*#__PURE__*/function (_React$Component) {
    _inherits(NotificationDropDown, _React$Component);

    var _super = _createSuper(NotificationDropDown);

    function NotificationDropDown(props) {
      var _this;

      _classCallCheck(this, NotificationDropDown);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "postUpdate", function (selectedOption) {
        _this.setState({
          request: _objectSpread2(_objectSpread2({}, request), {}, {
            fetching: true
          })
        });

        _this.props.setSchedule(selectedOption.value).then(function () {
          _this.setState({
            selectedOption: selectedOption,
            request: _objectSpread2(_objectSpread2({}, request), {}, {
              success: true
            })
          });

          success('Notification Frequency Updated');
        }).catch(function () {
          _this.setState({
            request: _objectSpread2(_objectSpread2({}, request), {}, {
              failed: true
            })
          });

          error('Error Ocurred');
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getOptionsFromEnumResult", function (enumResult) {
        var enumValues = enumResult.data.__type.enumValues;
        return enumValues.map(function (enumItem) {
          return {
            label: enumItem.description,
            value: enumItem.name
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onData", function (_ref) {
        var data = _ref.data;

        var options = _this.getOptionsFromEnumResult(data);

        var currentValue = data.data.user.email_interest_send_schedule;

        _this.setState(function (prevState) {
          return {
            options: options,
            selectedOption: prevState.selectedOption || options.filter(function (item) {
              return item.value === currentValue;
            }).reduce(function (pv, cv) {
              return cv;
            }, null)
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "render", function () {
        var _this$state = _this.state,
            options = _this$state.options,
            selectedOption = _this$state.selectedOption,
            updating = _this$state.request.fetching;
        return /*#__PURE__*/React__default.createElement(NotifyContainer, null, /*#__PURE__*/React__default.createElement(LuxityNotifications, null), /*#__PURE__*/React__default.createElement(LuxityPageReady, {
          getRequestPromise: _this.props.getSchedule,
          onData: function onData(data) {
            return _this.onData(data);
          }
        }, /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: "notification-dropdown-label"
        }, "Notification:\xA0"), updating ? /*#__PURE__*/React__default.createElement(EllipsisLoader, null) : /*#__PURE__*/React__default.createElement(index$1$1, {
          isMulti: false,
          isSearchable: false,
          components: {
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          options: options,
          className: "notification-dropdown-select-container",
          classNamePrefix: "notification-dropdown-select",
          onChange: _this.postUpdate,
          value: selectedOption
        }))));
      });

      _this.state = {
        options: [],
        selectedOption: null,
        request: _objectSpread2({}, request)
      };
      return _this;
    }

    return _createClass(NotificationDropDown);
  }(React__default.Component);

  var NotificationDropDown$1 = themed(NotificationDropDown);

  var _templateObject$F, _templateObject2$6;
  var ALL_ITEM = {
    id: 'ALL',
    name: 'ALL'
  };
  var multiSelectorItemMaxHeight = '3rem';
  var multiSelectorItemAnimationDuration = '300ms';
  var multiselectorItemFadeIn = styled.keyframes(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  from {\n    margin: 0;\n    max-height: 0px;\n    opacity: 0;\n  }\n  to {\n    max-height: ", ";\n    opacity: 1;\n  }\n"])), multiSelectorItemMaxHeight);
  var StyledMultiselector = styled__default.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  .multiselector__selected-items,\n  .multiselector__selectable-items {\n    display: flex;\n    flex-flow: wrap;\n    margin-left: calc(-1 * ", ");\n    button {\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n      }\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n      padding: ", ";\n      text-transform: none;\n      box-sizing: border-box;\n      animation: ", " ease-in-out\n        ", " forwards;\n      flex-basis: calc(25% - ", ");\n      margin-bottom: ", ";\n      margin-left: ", ";\n      text-overflow: ellipsis;\n      overflow-x: hidden;\n      min-height: 40px;\n\n      @media (max-width: ", ") {\n        flex-basis: calc(50% - ", ");\n      }\n    }\n  }\n\n  .multiselector__footer {\n    display: flex;\n    justify-content: center;\n    button {\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n      }\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.marginPaddings[0];
  }, multiSelectorItemAnimationDuration, multiselectorItemFadeIn, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, media.sm, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  });
  /**
   * Multiselector with a GraphQL flavour (TODO: to be revised to make it remote api agnostic)
   */

  var GraphQLMultiSelector = /*#__PURE__*/function (_React$Component) {
    _inherits(GraphQLMultiSelector, _React$Component);

    var _super = _createSuper(GraphQLMultiSelector);

    function GraphQLMultiSelector(props) {
      var _this;

      _classCallCheck(this, GraphQLMultiSelector);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
        if (prevProps.graphQuery !== _this.props.graphQuery) {
          _this.makeRequest();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "makeRequest", function () {
        _this.pageReady.refreshPage();
      });

      _defineProperty(_assertThisInitialized(_this), "emptySelected", function () {
        return _this.setState({
          selected: [ALL_ITEM]
        });
      });

      _defineProperty(_assertThisInitialized(_this), "setNewResults", function (res) {
        var selectedIds = _this.state.selected.map(function (sel) {
          return sel.id;
        });

        var pagination = _this.props.resultProcessor(res);

        var allSelected = _this.state.selected.some(function (item) {
          return item.id === ALL_ITEM.id;
        });

        var newList = pagination.data.filter(function (newItem) {
          return !selectedIds.includes(newItem.id);
        });
        newList = allSelected ? newList : [ALL_ITEM].concat(_toConsumableArray(newList));

        _this.setState({
          list: newList,
          pagination: pagination
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onAddItem", function (addSelectedItem) {
        _this.setState(function (prevState) {
          var newSelectedList;
          var newList;

          if (addSelectedItem.id === ALL_ITEM.id) {
            // Clear Selected List
            // and move previous Selected items to list
            newSelectedList = [ALL_ITEM];
            newList = prevState.list.filter(function (item) {
              return item.id !== ALL_ITEM.id;
            }).concat(prevState.selected).sort(function (a, b) {
              return a.id - b.id;
            });
          } else {
            newSelectedList = _toConsumableArray(prevState.selected.filter(function (item) {
              return item.id !== ALL_ITEM.id;
            })).concat(addSelectedItem);
            newList = [ALL_ITEM].concat(_toConsumableArray(prevState.list.filter(function (item) {
              return item.id !== ALL_ITEM.id;
            }).filter(function (item) {
              return item.id !== addSelectedItem.id;
            })));
          }

          return {
            selected: newSelectedList,
            list: newList
          };
        }, function () {
          _this.props.onChange(_this.state.selected.filter(function (item) {
            return item.id !== ALL_ITEM.id;
          }));
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onRemoveItem", function (removeSelectedItem) {
        _this.setState(function (prevState) {
          // Cannot remove ALL from selection by unselecting it
          if ((removeSelectedItem === null || removeSelectedItem === void 0 ? void 0 : removeSelectedItem.id) === ALL_ITEM.id) {
            return {};
          }

          var newSelectedList = prevState.selected.filter(function (item) {
            return item.id !== removeSelectedItem.id;
          });

          var newList = _toConsumableArray(prevState.list).concat(removeSelectedItem).filter(function (item) {
            return item.id !== ALL_ITEM.id;
          }).sort(function (a, b) {
            return a.id - b.id;
          });

          return {
            list: newList,
            selected: newSelectedList.length ? newSelectedList : [ALL_ITEM]
          };
        }, function () {
          _this.props.onChange(_this.state.selected.filter(function (item) {
            return item.id !== ALL_ITEM.id;
          }));
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onIsLoading", function (flag) {
        _this.setState({
          isLoading: flag
        });
      });

      _defineProperty(_assertThisInitialized(_this), "render", function () {
        var _this$props = _this.props,
            baseClass = _this$props.baseClass,
            ItemRenderer = _this$props.itemRenderer,
            identifier = _this$props.identifier,
            triggerRequest = _this$props.triggerRequest,
            className = _this$props.className;
        var _this$state = _this.state,
            list = _this$state.list,
            selected = _this$state.selected,
            pagination = _this$state.pagination,
            isLoading = _this$state.isLoading;
        return /*#__PURE__*/React__default.createElement(StyledMultiselector, null, /*#__PURE__*/React__default.createElement("div", {
          "data-qe-id": identifier,
          className: "".concat(className, " ").concat(baseClass)
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(baseClass, "__selected-items")
        }, selected.map(function (item) {
          return /*#__PURE__*/React__default.createElement(ItemRenderer, {
            key: item.id,
            item: item,
            onSelect: _this.onRemoveItem,
            selected: true
          });
        })), /*#__PURE__*/React__default.createElement(LuxityPageReady, {
          ref: function ref(inst) {
            _this.pageReady = inst;
          },
          onData: _this.setNewResults,
          onIsLoading: _this.onIsLoading,
          getRequestPromise: function getRequestPromise() {
            return triggerRequest();
          }
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(baseClass, "__selectable-items")
        }, list.map(function (item) {
          return /*#__PURE__*/React__default.createElement(ItemRenderer, {
            key: item.id,
            item: item,
            onSelect: _this.onAddItem,
            selected: false
          });
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(baseClass, "__footer")
        }, /*#__PURE__*/React__default.createElement(InvertedTextButton$1, {
          disabled: isLoading || !pagination.has_more_pages,
          onClick: _this.props.increaseLimit,
          type: "button"
        }, "SHOW MORE"))));
      });

      _this.state = {
        selected: [ALL_ITEM],
        list: [],
        pagination: {},
        isLoading: false
      };
      return _this;
    }

    return _createClass(GraphQLMultiSelector);
  }(React__default.Component);

  GraphQLMultiSelector.defaultProps = {
    baseClass: 'multiselector'
  };
  var GraphQLMultiSelector$1 = themed(GraphQLMultiSelector);

  var Search = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      overflow: "visible",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default.createElement("path", {
      d: "M14.82 13.93L11.21 10.32C12.1 9.23 12.64 7.83 12.64 6.31C12.64 2.83 9.81 0 6.32 0C2.83 0 0 2.83 0 6.32C0 9.81 2.83 12.64 6.32 12.64C7.84 12.64 9.23 12.1 10.32 11.21L13.93 14.81C14.17 15.06 14.57 15.06 14.81 14.81C15.06 14.57 15.06 14.18 14.82 13.93ZM6.32 11.38C3.53 11.38 1.25 9.11 1.25 6.32C1.25 3.53 3.52 1.25 6.32 1.25C9.11 1.25 11.39 3.52 11.39 6.32C11.39 9.12 9.11 11.38 6.32 11.38Z",
      fill: "currentColor"
    }));
  });

  var _templateObject$G;

  var Title$3 = function Title(_ref) {
    var baseClass = _ref.baseClass,
        className = _ref.className,
        title = _ref.title,
        searchPlaceHolder = _ref.searchPlaceHolder,
        onSearchChanged = _ref.onSearchChanged;
    return /*#__PURE__*/React__default.createElement(InterestsSubheading, {
      className: "".concat(className, " ").concat(baseClass, "__title"),
      title: title
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title__search"
    }, /*#__PURE__*/React__default.createElement(Search, null), /*#__PURE__*/React__default.createElement("input", {
      placeholder: searchPlaceHolder,
      type: "text",
      name: "search",
      onChange: onSearchChanged
    })));
  };

  var StyledTitle = styled__default(Title$3)(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n\n  .title__search,\n  .title__search {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 30px;\n    margin-bottom: ", ";\n\n    svg {\n      margin-left: ", ";\n      fill: ", ";\n      stroke: ", ";\n    }\n\n    input {\n      width: 140px;\n      border: none;\n      font-size: ", ";\n      transition: 0.2s border-color ease-in-out;\n      margin-left: ", ";\n      padding: 0;\n\n      :focus {\n        border-color: ", ";\n        border-bottom: none;\n      }\n    }\n  }\n"])), function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.fontSizes[2];
  }, function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.marginPaddings[3];
  }, function (props) {
    return props.theme.colors.primary || '';
  }, function (props) {
    return props.theme.colors.primary || '';
  }, function (props) {
    return props.theme.fontSizes[2];
  }, function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.colors.primary;
  });
  var Title$4 = themed(StyledTitle);

  var debounceBuilder$3 = functions.debounced(200);

  /**
   * Luxity flavoured GraphQLMultiselector with text Search, category and limit controls
   */
  var LuxityGraphQLMultiselector = /*#__PURE__*/function (_React$Component) {
    _inherits(LuxityGraphQLMultiselector, _React$Component);

    var _super = _createSuper(LuxityGraphQLMultiselector);

    function LuxityGraphQLMultiselector(props) {
      var _this;

      _classCallCheck(this, LuxityGraphQLMultiselector);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "multiSelectorRef", /*#__PURE__*/React__default.createRef());

      _defineProperty(_assertThisInitialized(_this), "increaseLimit", function () {
        _this.setState(function (prevState) {
          return {
            limit: prevState.limit + _this.props.queryLimitIncrement
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onChange", function (selection) {
        _this.props.onChange(selection);
      });

      _defineProperty(_assertThisInitialized(_this), "onSearchChanged", function (event) {
        event.preventDefault();
        var searchText = event.target.value;
        debounceBuilder$3(function () {
          _this.setState({
            nameFilter: searchText
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "render", function () {
        var _this$state = _this.state,
            limit = _this$state.limit,
            category = _this$state.category,
            nameFilter = _this$state.nameFilter;
        var _this$props = _this.props,
            title = _this$props.title,
            baseClass = _this$props.baseClass,
            getGraphQuery = _this$props.getGraphQuery,
            resultProcessor = _this$props.resultProcessor,
            itemRenderer = _this$props.itemRenderer,
            searchPlaceHolder = _this$props.searchPlaceHolder,
            graphApi = _this$props.graphApi,
            identifier = _this$props.identifier,
            requestInstance = _this$props.requestInstance;
        return /*#__PURE__*/React__default.createElement("div", {
          className: baseClass
        }, /*#__PURE__*/React__default.createElement(Title$4, {
          title: title,
          baseClass: baseClass,
          searchPlaceHolder: searchPlaceHolder,
          onSearchChanged: _this.onSearchChanged
        }), /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(GraphQLMultiSelector$1, {
          triggerRequest: function triggerRequest() {
            return requestInstance.post(graphApi, {
              query: getGraphQuery(limit, 1, 'id|desc', category, nameFilter)
            });
          },
          graphQuery: getGraphQuery(limit, 1, 'id|desc', category, nameFilter),
          identifier: identifier,
          ref: _this.multiSelectorRef,
          onChange: _this.onChange,
          resultProcessor: resultProcessor,
          increaseLimit: _this.increaseLimit,
          itemRenderer: itemRenderer
        })));
      });

      _this.state = {
        limit: props.baseQueryLimit,
        category: props.category,
        nameFilter: ''
      };
      return _this;
    }

    _createClass(LuxityGraphQLMultiselector, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$multiSelectorRe;

        if (prevProps.category !== this.props.category && (_this$multiSelectorRe = this.multiSelectorRef) !== null && _this$multiSelectorRe !== void 0 && _this$multiSelectorRe.current) {
          this.multiSelectorRef.current.emptySelected();
        }
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, prevState) {
        if (prevState.category !== props.category) {
          return {
            category: props.category
          };
        }

        return null;
      }
    }]);

    return LuxityGraphQLMultiselector;
  }(React__default.Component);

  LuxityGraphQLMultiselector.defaultProps = {
    baseClass: '',
    searchPlaceHolder: '',
    queryLimitIncrement: 12,
    baseQueryLimit: 12
  };

  var _templateObject$H;
  var BaseButton = styled__default.button(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (props) {
    return props.theme.colors.base;
  }, function (props) {
    return props.theme.colors.borderColor;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  });
  var UnselectedButton = themed(BaseButton);

  var ItemRenderer = function ItemRenderer(_ref) {
    var item = _ref.item,
        onSelect = _ref.onSelect,
        selected = _ref.selected;
    var props = {
      onClick: function onClick(e) {
        e.preventDefault();
        onSelect(item);
      }
    };
    return selected ? /*#__PURE__*/React__default.createElement(PrimaryButton$1, props, item.name) : /*#__PURE__*/React__default.createElement(UnselectedButton, props, item.name);
  };

  var BrandSelector = function BrandSelector(_ref) {
    var onChange = _ref.onChange,
        category = _ref.category,
        graphApi = _ref.graphApi,
        itemRenderer = _ref.itemRenderer,
        getGraphQuery = _ref.getGraphQuery,
        resultProcessor = _ref.resultProcessor,
        requestInstance = _ref.requestInstance;
    return /*#__PURE__*/React__default.createElement(LuxityGraphQLMultiselector, {
      baseQueryLimit: 16,
      title: "Brands",
      queryId: "getBrands",
      baseClass: "brand-selector",
      identifier: "brand-selector",
      searchPlaceHolder: "Search brands",
      category: category,
      onChange: onChange,
      graphApi: graphApi,
      itemRenderer: itemRenderer,
      getGraphQuery: getGraphQuery,
      resultProcessor: resultProcessor,
      requestInstance: requestInstance
    });
  };

  BrandSelector.defaultProps = {
    itemRenderer: ItemRenderer,
    resultProcessor: function resultProcessor(result) {
      return result.data.data.luxity_brands;
    }
  };

  var StyleSelector = function StyleSelector(_ref) {
    var onChange = _ref.onChange,
        category = _ref.category,
        graphApi = _ref.graphApi,
        itemRenderer = _ref.itemRenderer,
        getGraphQuery = _ref.getGraphQuery,
        resultProcessor = _ref.resultProcessor,
        requestInstance = _ref.requestInstance;
    return /*#__PURE__*/React__default.createElement(LuxityGraphQLMultiselector, {
      title: "Styles",
      queryId: "getStyles",
      baseQueryLimit: 16,
      baseClass: "style-selector",
      identifier: "style-selector",
      searchPlaceHolder: "Search Styles",
      category: category,
      onChange: onChange,
      graphApi: graphApi,
      itemRenderer: itemRenderer,
      getGraphQuery: getGraphQuery,
      resultProcessor: resultProcessor,
      requestInstance: requestInstance
    });
  };

  StyleSelector.defaultProps = {
    itemRenderer: ItemRenderer,
    resultProcessor: function resultProcessor(result) {
      return result.data.data.luxity_styles;
    }
  };

  var shoeSizeTypes = {
    uk: {
      label: 'UK',
      value: 'uk'
    },
    eu: {
      label: 'EU',
      value: 'eu'
    }
  };

  var _templateObject$I, _templateObject2$7;
  var TitleWrapper = styled__default.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: nowrap row;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  label {\n    margin-bottom: 0;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[4];
  });
  var onShoeSizeTypeChangeTimeout = 300;
  var ShoeSizeFadeContainer = styled__default.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  transition: opacity ease-in-out ", "ms;\n  opacity: ", ";\n  .rc-slider-handle,\n  .rc-slider-handle-2,\n  .shoe-size-tooltip {\n    transition: opacity ease-in-out ", "ms;\n    opacity: ", ";\n  }\n"])), onShoeSizeTypeChangeTimeout, function (props) {
    return props.childVisible ? 1 : 0;
  }, onShoeSizeTypeChangeTimeout, function (props) {
    return props.childVisible ? 1 : 0;
  });
  ShoeSizeFadeContainer.defaultProps = {
    childVisible: false
  };

  var OpacityTransitionRender = function OpacityTransitionRender(_ref) {
    var shoeSizeType = _ref.shoeSizeType,
        children = _ref.children;
    var prevShoeSizeType = functions.usePrevious(shoeSizeType);

    var _React$useState = React__default.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        childVisible = _React$useState2[0],
        setChildVisible = _React$useState2[1];

    React__default.useEffect(function () {
      if (prevShoeSizeType !== shoeSizeType) {
        setChildVisible(false);
        setTimeout(function () {
          setChildVisible(true);
        }, onShoeSizeTypeChangeTimeout);
      }
    }, [prevShoeSizeType, shoeSizeType]);
    return /*#__PURE__*/React__default.createElement(ShoeSizeFadeContainer, {
      childVisible: childVisible
    }, children);
  };

  var WrappedShoeSizeSelector = function WrappedShoeSizeSelector(_ref2) {
    var onChange = _ref2.onChange,
        requestInstance = _ref2.requestInstance,
        graphApi = _ref2.graphApi,
        defaultShoeSizeType = _ref2.defaultShoeSizeType,
        getGraphQuery = _ref2.getGraphQuery;

    var _useState = React.useState(defaultShoeSizeType),
        _useState2 = _slicedToArray(_useState, 2),
        shoeSizeType = _useState2[0],
        setShoeSizeType = _useState2[1];

    var _useState3 = React.useState(defaultShoeSizeType),
        _useState4 = _slicedToArray(_useState3, 2),
        transitionedTo = _useState4[0],
        setTransitionedTo = _useState4[1];

    var triggerRequest = function triggerRequest() {
      return requestInstance.post(graphApi, {
        query: getGraphQuery()
      });
    };

    var shoeSizeTypeProps = {
      name: 'shoe_size_type',
      noWrap: true,
      options: [{
        innerText: shoeSizeTypes.uk.label,
        actionCallback: function actionCallback() {
          setTransitionedTo(shoeSizeTypes.uk.value);
          setTimeout(function () {
            return setShoeSizeType(shoeSizeTypes.uk.value);
          }, onShoeSizeTypeChangeTimeout);
        },
        checked: shoeSizeType === shoeSizeTypes.uk.value
      }, {
        innerText: shoeSizeTypes.eu.label,
        actionCallback: function actionCallback() {
          setTransitionedTo(shoeSizeTypes.eu.value);
          setTimeout(function () {
            return setShoeSizeType(shoeSizeTypes.eu.value);
          }, onShoeSizeTypeChangeTimeout);
        },
        checked: shoeSizeType === shoeSizeTypes.eu.value
      }]
    };

    var handlePropOnChange = function handlePropOnChange(value) {
      var payload = _objectSpread2(_objectSpread2({}, value), {}, {
        shoe_size_type: shoeSizeType
      });

      onChange(payload);
    };

    var renderShoeSizeSelector = function renderShoeSizeSelector() {
      var passedShoeSizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return /*#__PURE__*/React__default.createElement(ShoeSizeSelector, {
        shoeSizes: passedShoeSizes,
        onChange: function onChange(value) {
          return handlePropOnChange(value);
        }
      });
    };

    var getShoeSizeSelector = function getShoeSizeSelector() {
      var euShoeSizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var ukShoeShoes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (shoeSizeType === shoeSizeTypes.eu.value) {
        return renderShoeSizeSelector(euShoeSizes);
      }

      if (shoeSizeType === shoeSizeTypes.uk.value) {
        return renderShoeSizeSelector(ukShoeShoes);
      }

      return null;
    };

    return /*#__PURE__*/React__default.createElement(LuxityPageReady, {
      getRequestPromise: triggerRequest
    }, /*#__PURE__*/React__default.createElement(TitleWrapper, null, /*#__PURE__*/React__default.createElement(InterestsSubheading, {
      title: "Shoe Size Range"
    }, /*#__PURE__*/React__default.createElement(RadioButtons$1, shoeSizeTypeProps))), /*#__PURE__*/React__default.createElement(LuxityPageReadyContext.Consumer, null, function (_ref3) {
      var _ref3$data$data = _ref3.data.data,
          _ref3$data$data$luxit = _ref3$data$data.luxity_eu_shoe_sizes,
          luxity_eu_shoe_sizes = _ref3$data$data$luxit === void 0 ? [] : _ref3$data$data$luxit,
          _ref3$data$data$luxit2 = _ref3$data$data.luxity_uk_shoe_sizes,
          luxity_uk_shoe_sizes = _ref3$data$data$luxit2 === void 0 ? [] : _ref3$data$data$luxit2;
      return /*#__PURE__*/React__default.createElement(OpacityTransitionRender, {
        shoeSizeType: transitionedTo
      }, getShoeSizeSelector(luxity_eu_shoe_sizes, luxity_uk_shoe_sizes));
    }));
  };

  WrappedShoeSizeSelector.defaultProps = {
    onChange: function onChange() {
      return false;
    }
  };

  var _templateObject$J;
  var SelectionWrapper = styled__default.div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: calc(-1 * ", ");\n  label {\n    margin-bottom: ", ";\n    flex-basis: calc(33.33% - ", ");\n    margin-bottom: ", ";\n    margin-left: ", ";\n  }\n  @media (max-width: ", ") {\n    label {\n      flex-basis: calc(50% - ", ");\n    }\n  }\n"])), function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, media.sm, function (props) {
    return props.theme.marginPaddings[2];
  });

  var _excluded$7 = ["title", "checked", "renderIcon", "onChange", "checkedValue", "unCheckedValue"];

  var _templateObject$K, _templateObject2$8, _templateObject3$3;
  var Content = styled__default.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: 1px solid ", ";\n  transition: 200ms ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n  cursor: pointer;\n"])), function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.marginPaddings[0];
  });
  var InputText = styled__default.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  transition: 200ms ease-in;\n  margin-left: auto;\n  margin-right: auto;\n"])));
  var StyledLabel = styled__default.label(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  line-height: initial;\n  display: block;\n  box-sizing: border-box;\n  transition: 200ms ease-in-out;\n  text-align: center;\n\n  &:hover ", " {\n    color: ", ";\n  }\n\n  input {\n    display: none;\n    &:checked ~ ", " {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &:checked ~ ", " ", " {\n      color: ", ";\n    }\n\n    &:disabled ~ ", " {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n"])), InputText, function (props) {
    return props.theme.colors.primary;
  }, Content, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.ntrlMin;
  }, Content, InputText, function (props) {
    return props.theme.colors.ntrlMin;
  }, Content);
  /**
   * CheckButton: Styled checkbox that resembles a button
   * */

  var CheckButton = function CheckButton(props) {
    var title = props.title,
        checked = props.checked,
        renderIcon = props.renderIcon,
        onChange = props.onChange,
        checkedValue = props.checkedValue,
        unCheckedValue = props.unCheckedValue,
        restProps = _objectWithoutProperties(props, _excluded$7);

    var _React$useState = React__default.useState(checked),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        checkedState = _React$useState2[0],
        setCheck = _React$useState2[1];

    var prevCheckState = functions.usePrevious(checkedState);
    React__default.useEffect(function () {
      if (prevCheckState !== checkedState) {
        onChange(checkedState);
      }
    }, [checkedState, onChange, prevCheckState]);

    var handleInputChange = function handleInputChange(e) {
      var targetChecked = e.target.checked;
      setCheck(targetChecked);
    };

    return /*#__PURE__*/React__default.createElement(StyledLabel, null, /*#__PURE__*/React__default.createElement("input", _extends({
      defaultChecked: checked
    }, restProps, {
      type: "checkbox",
      onChange: handleInputChange
    })), /*#__PURE__*/React__default.createElement(Content, null, /*#__PURE__*/React__default.createElement(InputText, null, title), renderIcon(checkedState)));
  };

  CheckButton.defaultProps = {
    title: '',
    checked: false,
    renderIcon: function renderIcon() {
      return false;
    },
    onChange: function onChange() {
      return false;
    }
  };
  var CheckButton$1 = themed(CheckButton);

  var MALE$1 = genders.MALE,
      FEMALE$1 = genders.FEMALE;

  /**
   * Stylized CheckboxButton for selecting gender
   * */
  var GenderCheckbox = function GenderCheckbox(_ref) {
    var gender = _ref.gender,
        checked = _ref.checked,
        onInputChange = _ref.onInputChange;

    var getTitle = function getTitle() {
      switch (gender) {
        case MALE$1:
          return 'Male';

        case FEMALE$1:
          return 'Female';

        default:
          return '';
      }
    };

    return /*#__PURE__*/React__default.createElement(CheckButton$1, {
      onChange: onInputChange,
      checked: checked,
      name: getTitle().toLowerCase(),
      title: getTitle()
    });
  };

  GenderCheckbox.defaultProps = {
    name: ''
  };

  var MALE$2 = genders.MALE,
      FEMALE$2 = genders.FEMALE;

  /**
   *  GenderSelector: specialized selector to pick genders for the Interest Component
   * */
  var GenderSelector = function GenderSelector(_ref) {
    var gender = _ref.gender,
        onChange = _ref.onChange,
        maleInputRef = _ref.maleInputRef,
        femaleInputRef = _ref.femaleInputRef;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "gender-selector"
    }, /*#__PURE__*/React__default.createElement(InterestsSubheading, {
      title: "Department"
    }), /*#__PURE__*/React__default.createElement(SelectionWrapper, {
      className: "gender-selector__selection-wrapper"
    }, /*#__PURE__*/React__default.createElement(GenderCheckbox, {
      className: "gender-selector__selection-wrapper__input-container",
      gender: MALE$2,
      checked: MALE$2 === gender,
      onInputChange: function onInputChange(isChecked) {
        return onChange(isChecked, MALE$2);
      },
      checkBoxButtonRef: maleInputRef
    }), /*#__PURE__*/React__default.createElement(GenderCheckbox, {
      className: "gender-selector__selection-wrapper__input-container",
      gender: FEMALE$2,
      checked: FEMALE$2 === gender,
      onInputChange: function onInputChange(isChecked) {
        return onChange(isChecked, FEMALE$2);
      },
      checkBoxButtonRef: femaleInputRef
    })));
  };

  GenderSelector.defaultProps = {
    gender: null,
    onChange: function onChange() {
      return false;
    }
  };
  var GenderSelector$1 = themed(GenderSelector);

  var Add = (function (props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default.createElement("path", {
      d: "M0 11.5H23",
      stroke: "#000000",
      strokeWidth: "1.8"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M11.5 0L11.5 23",
      stroke: "#000000",
      strokeWidth: "1.8"
    }));
  });

  var _templateObject$L, _templateObject2$9, _templateObject3$4, _templateObject4$3, _templateObject5$1;
  var UNISEX$1 = genders.UNISEX;
  var AddInterestContainer = styled__default.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  border: 1px solid ", ";\n  padding: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[6];
  }, function (props) {
    return props.theme.colors.borderColor;
  }, function (props) {
    return props.theme.marginPaddings[6];
  });
  var SaveAndCancelButtonContainer = styled__default.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n\n  @media (max-width: ", ") {\n    .fl-right__item {\n      flex-direction: column;\n      margin-right: 0;\n      margin-left: ", ";\n    }\n\n    button {\n      margin-bottom: ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.marginPaddings[6];
  }, media.xs, function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.marginPaddings[1];
  });
  var CatSelectorParagraph = styled__default.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n  margin-bottom: ", ";\n"])), function (props) {
    return props.theme.colors.darkerGray;
  }, function (props) {
    return props.theme.marginPaddings[2];
  });
  var AddInterestButton = styled__default.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n  border: 1px solid ", ";\n  padding-top: ", ";\n  margin-bottom: ", ";\n  padding-left: 1.5rem;\n  width: 95%;\n  font-size: 17px;\n"])), function (props) {
    return props.theme.colors.darkerGray;
  }, function (props) {
    return props.theme.colors.borderColor;
  }, function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.marginPaddings[2];
  });
  var AddInterestButtonContainer = styled__default.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  display: flex;\n\n  #add-icon {\n    margin-bottom: 1.5rem;\n\n    svg {\n      width: 15px;\n    }\n  }\n"])));

  var AddIcon = function AddIcon(_ref) {
    var onClick = _ref.onClick,
        id = _ref.id;
    return /*#__PURE__*/React__default.createElement(IconWrapper, {
      id: id,
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(SvgWrapper, null, /*#__PURE__*/React__default.createElement(Add, null)));
  };

  var defaultState = {
    category_type: null,
    brands: [],
    min_shoe_size_id: null,
    max_shoe_size_id: null,
    min_price: null,
    max_price: null,
    styles: [],
    gender: [],
    request: _objectSpread2({}, request),
    isCategoriesShown: false
  };
  /**
   * Generates Interest UI and submits graph payloads as a highly specialised component
   */

  var AddInterest = /*#__PURE__*/function (_React$Component) {
    _inherits(AddInterest, _React$Component);

    var _super = _createSuper(AddInterest);

    function AddInterest(props) {
      var _this;

      _classCallCheck(this, AddInterest);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "maleCheckBoxRef", /*#__PURE__*/React__default.createRef());

      _defineProperty(_assertThisInitialized(_this), "femaleCheckBoxRef", /*#__PURE__*/React__default.createRef());

      _defineProperty(_assertThisInitialized(_this), "onCategoryChanged", function (categoryType) {
        _this.setState({
          category_type: categoryType,
          brands: [],
          styles: []
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onGenderChanged", function (isChecked, gender) {
        return _this.setState(function (prevState) {
          // current array of options
          var gendersSelected = _toConsumableArray(prevState.gender);

          var index; // check if the check box is checked or unchecked

          if (isChecked) {
            gendersSelected.push(gender);
          } else {
            // or remove the value from the unchecked checkbox from the array
            index = gendersSelected.indexOf(gender);
            gendersSelected.splice(index, 1);
          }

          return {
            gender: gendersSelected
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onBrandsChanged", function (brandsArray) {
        _this.setState({
          brands: brandsArray.map(function (brand) {
            return brand.id;
          })
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onShoeSizesChanged", function (shoeSizes) {
        _this.setState(_objectSpread2({}, shoeSizes));
      });

      _defineProperty(_assertThisInitialized(_this), "onPriceRangesChanged", function (priceRange) {
        _this.setState(_objectSpread2({}, priceRange));
      });

      _defineProperty(_assertThisInitialized(_this), "onStylesChanged", function (stylesArray) {
        _this.setState({
          styles: stylesArray.map(function (style) {
            return style.id;
          })
        });
      });

      _defineProperty(_assertThisInitialized(_this), "payloadIsValid", function () {
        // price/shoe-size always have initial values as soon as category is set
        var category_type = _this.state.category_type;
        return category_type !== null;
      });

      _defineProperty(_assertThisInitialized(_this), "submitInterest", function () {
        _this.setState({
          request: _objectSpread2(_objectSpread2({}, request), {}, {
            fetching: true
          })
        });

        var _this$state = _this.state,
            brands = _this$state.brands,
            min_shoe_size_id = _this$state.min_shoe_size_id,
            max_shoe_size_id = _this$state.max_shoe_size_id,
            shoe_size_type = _this$state.shoe_size_type,
            min_price = _this$state.min_price,
            max_price = _this$state.max_price,
            styles = _this$state.styles,
            category_type = _this$state.category_type,
            requestState = _this$state.request,
            gender = _this$state.gender;
        var payloadGender = gender[0];

        if (gender.length > 1 || !gender.length) {
          payloadGender = UNISEX$1;
        }

        var basePayload = {
          category_type: category_type,
          brands: brands,
          min_price: min_price,
          max_price: max_price,
          styles: styles,
          gender: payloadGender,
          request: requestState
        };
        var shoeSizesPayload = category_type === interestCategories.SHOES ? {
          min_shoe_size_id: min_shoe_size_id,
          max_shoe_size_id: max_shoe_size_id,
          shoe_size_type: shoe_size_type
        } : {};

        var payload = _objectSpread2(_objectSpread2({}, basePayload), shoeSizesPayload);

        simpleRequest(_this.props.requestInstance, _this.props.addInterestApi, method.POST, payload, function () {
          _this.setState({
            request: _objectSpread2(_objectSpread2({}, request), {}, {
              success: true
            })
          });

          _this.props.onSubmitSuccess(_objectSpread2({}, payload));
        }, _this.handleRequestError);
      });

      _defineProperty(_assertThisInitialized(_this), "handleRequestError", function (_ref2) {
        var data = _ref2.data;

        _this.setState({
          request: _objectSpread2({}, request)
        });

        var errorMessages = Object.keys(data).map(function (key) {
          return data[key];
        }).flat();
        error(errorMessages.map(function (message, key) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: "error-".concat(key)
          }, message);
        }));
      });

      _defineProperty(_assertThisInitialized(_this), "resetState", function () {
        _this.setState(_objectSpread2({}, defaultState));
      });

      _defineProperty(_assertThisInitialized(_this), "handleGenderChange", function (isChecked, gender) {
        return _this.onGenderChanged(isChecked, gender);
      });

      _defineProperty(_assertThisInitialized(_this), "onAddInterestClick", function () {
        _this.setState(function (prevState) {
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            isCategoriesShown: true
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "render", function () {
        var _this$state2 = _this.state,
            category_type = _this$state2.category_type,
            fetching = _this$state2.request.fetching;
        var _this$props = _this.props,
            requestInstance = _this$props.requestInstance,
            baseGraphApi = _this$props.baseGraphApi,
            getBrandsGraphQuery = _this$props.getBrandsGraphQuery,
            getStylesGraphQuery = _this$props.getStylesGraphQuery,
            getShoesGraphQuery = _this$props.getShoesGraphQuery,
            defaultShoeSizeType = _this$props.defaultShoeSizeType;
        return /*#__PURE__*/React__default.createElement(React.Fragment, null, !_this.state.isCategoriesShown && /*#__PURE__*/React__default.createElement(AddInterestButtonContainer, {
          onClick: _this.onAddInterestClick
        }, /*#__PURE__*/React__default.createElement(AddInterestButton, null, "Add Interest"), /*#__PURE__*/React__default.createElement(AddIcon, {
          id: "add-icon"
        })), _this.state.isCategoriesShown && /*#__PURE__*/React__default.createElement(AddInterestContainer, null, /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(CatSelectorParagraph, null, "Select the catergory that interests you"), /*#__PURE__*/React__default.createElement(CategoryInterestSelector, {
          category: category_type,
          onCategoryChange: _this.onCategoryChanged
        }), category_type ? /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(GenderSelector$1, {
          onChange: _this.handleGenderChange
        }), /*#__PURE__*/React__default.createElement(BrandSelector, {
          category: category_type,
          onChange: _this.onBrandsChanged,
          requestInstance: requestInstance,
          graphApi: "".concat(baseGraphApi, "?id=getBrands"),
          getGraphQuery: getBrandsGraphQuery
        }), category_type === interestCategories.SHOES && /*#__PURE__*/React__default.createElement(WrappedShoeSizeSelector, {
          defaultShoeSizeType: defaultShoeSizeType,
          getGraphQuery: getShoesGraphQuery,
          graphApi: "".concat(baseGraphApi, "?id=shoeSizeQuery"),
          requestInstance: requestInstance,
          onChange: _this.onShoeSizesChanged
        }), /*#__PURE__*/React__default.createElement(PriceRangeSelector, {
          category: category_type,
          onChange: _this.onPriceRangesChanged
        }), /*#__PURE__*/React__default.createElement(StyleSelector, {
          category: category_type,
          onChange: _this.onStylesChanged,
          requestInstance: requestInstance,
          graphApi: "".concat(baseGraphApi, "?id=getStyles"),
          getGraphQuery: getStylesGraphQuery
        })) : null, /*#__PURE__*/React__default.createElement(SaveAndCancelButtonContainer, null, /*#__PURE__*/React__default.createElement("div", {
          className: "fl-right"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "fl-right__item"
        }, /*#__PURE__*/React__default.createElement(SecondaryButton$1, {
          type: "button",
          onClick: function onClick() {
            return _this.resetState();
          }
        }, "CANCEL")), /*#__PURE__*/React__default.createElement("div", {
          className: "fl-right__item"
        }, /*#__PURE__*/React__default.createElement(PrimaryButton$1, {
          "data-qe-id": "add-interest-btn",
          disabled: fetching || !_this.payloadIsValid(),
          type: "button",
          onClick: function onClick() {
            _this.submitInterest();

            _this.resetState();
          }
        }, fetching ? 'SAVING' : 'SAVE')))))));
      });

      _this.state = _objectSpread2({}, defaultState);
      return _this;
    }

    return _createClass(AddInterest);
  }(React__default.Component);

  var AddInterest$1 = themed(AddInterest);

  var _templateObject$M;
  var MyInterestTitleHeadingContainer = styled__default.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n\n  .heading-title-section {\n    display: flex;\n    justify-content: space-between;\n    width: 95%;\n    padding: ", ";\n  }\n\n  .heading-title {\n    color: ", ";\n    font-weight: bold;\n    flex-basis: calc(100% / 6);\n    margin-left: ", ";\n    padding-bottom: 0;\n  }\n\n  .heading-title-empty {\n    flex-basis: 5%;\n    margin-left: 1rem;\n  }\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, media.xs);

  var MyInterestTitleHeading = function MyInterestTitleHeading() {
    return /*#__PURE__*/React__default.createElement(MyInterestTitleHeadingContainer, null, /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title-section"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title"
    }, "Category"), /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title"
    }, "Brands"), /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title"
    }, "Department"), /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title"
    }, "Price Range"), /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title"
    }, "Style"), /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title"
    }, "Shoe Size")), /*#__PURE__*/React__default.createElement("div", {
      className: "heading-title-empty"
    }));
  };

  var MyInterestTitleHeading$1 = themed(MyInterestTitleHeading);

  var _templateObject$N;
  var SvgWrapper$2 = styled__default.span(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.colors.primary;
  });
  var AccountIcon = themed(function () {
    return /*#__PURE__*/React__default.createElement(SvgWrapper$2, null, /*#__PURE__*/React__default.createElement(Account, null));
  });

  /**
   * Page/View that controls the viewing and Adding of Luxity Interests
   */
  var Interests = /*#__PURE__*/function (_React$Component) {
    _inherits(Interests, _React$Component);

    var _super = _createSuper(Interests);

    function Interests(props) {
      var _this;

      _classCallCheck(this, Interests);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "setInterests", function (data) {
        var interests = data.data.data.interests.data;

        _this.setState({
          interests: interests
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onInterestSubmitSuccess", function (interestItem) {
        // due to the fact that we dont get the Interest payload back - we have to re-request the list
        _this.triggerInterestRequest().then(function (res) {
          return _this.setInterests(res);
        }); // UNCOMMENT WHEN Interest Items is returned as expected Object Shape
        // this.setState(prevState => {
        //   const newInterests = [interestItem].concat(prevState.interests);
        //   return { ...prevState, interests: newInterests };
        // });

      });

      _defineProperty(_assertThisInitialized(_this), "onDeleteInterest", function (deletedItem) {
        _this.setState(function (prevState) {
          var newInterests = prevState.interests.filter(function (item) {
            return item.id !== deletedItem.id;
          });
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            interests: newInterests
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "triggerInterestRequest", function () {
        var _this$props = _this.props,
            requestInstance = _this$props.requestInstance,
            baseGraphApi = _this$props.baseGraphApi,
            interestQuery = _this$props.interestQuery;
        return requestInstance.post("".concat(baseGraphApi, "?id=getInterests"), {
          query: interestQuery
        });
      });

      _this.state = {
        interests: []
      };
      return _this;
    }

    _createClass(Interests, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var interests = this.state.interests;
        var _this$props2 = this.props,
            addInterestApi = _this$props2.addInterestApi,
            requestInstance = _this$props2.requestInstance,
            baseGraphApi = _this$props2.baseGraphApi,
            getBrandsGraphQuery = _this$props2.getBrandsGraphQuery,
            getStylesGraphQuery = _this$props2.getStylesGraphQuery,
            getShoesGraphQuery = _this$props2.getShoesGraphQuery,
            deleteInterestApi = _this$props2.deleteInterestApi,
            setSchedule = _this$props2.setSchedule,
            getSchedule = _this$props2.getSchedule,
            interestsTitle = _this$props2.interestsTitle,
            defaultShoeSizeType = _this$props2.defaultShoeSizeType;
        return /*#__PURE__*/React__default.createElement("div", {
          className: "interests"
        }, /*#__PURE__*/React__default.createElement(Notifications__default, {
          options: {
            zIndex: 9999999
          }
        }), /*#__PURE__*/React__default.createElement(IconHeader$1, {
          svgComponent: function svgComponent() {
            return /*#__PURE__*/React__default.createElement(AccountIcon, null);
          },
          title: interestsTitle,
          svgName: "account",
          renderAppendage: function renderAppendage() {
            return /*#__PURE__*/React__default.createElement(NotificationDropDown$1, {
              getSchedule: getSchedule,
              setSchedule: setSchedule
            });
          }
        }), /*#__PURE__*/React__default.createElement(AddInterest$1, {
          addInterestApi: addInterestApi,
          onSubmitSuccess: function onSubmitSuccess(interest) {
            return _this2.onInterestSubmitSuccess(interest);
          },
          requestInstance: requestInstance,
          baseGraphApi: baseGraphApi,
          getBrandsGraphQuery: getBrandsGraphQuery,
          getStylesGraphQuery: getStylesGraphQuery,
          getShoesGraphQuery: getShoesGraphQuery,
          defaultShoeSizeType: defaultShoeSizeType
        }), interests.length > 0 ? /*#__PURE__*/React__default.createElement(MyInterestTitleHeading$1, null) : '', /*#__PURE__*/React__default.createElement(LuxityPageReady, {
          getRequestPromise: function getRequestPromise() {
            return _this2.triggerInterestRequest();
          },
          ref: function ref(inst) {
            _this2.pageReady = inst;
          },
          onData: this.setInterests
        }, /*#__PURE__*/React__default.createElement(React.Fragment, null, interests.map(function (item) {
          return /*#__PURE__*/React__default.createElement(SimpleErrorBoundary, {
            showMessageOnError: false,
            key: "interest-item-error-".concat(item.id)
          }, /*#__PURE__*/React__default.createElement(InterestItem$1, {
            deleteInterestApi: deleteInterestApi,
            requestInstance: requestInstance,
            onDeleted: _this2.onDeleteInterest,
            data: item
          }));
        }))));
      }
    }]);

    return Interests;
  }(React__default.Component);

  Interests.defaultProps = {
    interestsTitle: 'Interests',
    defaultShoeSizeType: shoeSizeTypes.eu.value
  };

  var _templateObject$O, _templateObject2$a, _templateObject3$5, _templateObject4$4, _templateObject5$2, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30;
  var HeaderWrapper = styled__default.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n   {\n    display: inline-block;\n    background-color: ", ";\n    position: relative;\n    width: 100%;\n\n    .header__search-container,\n    .header__search-input {\n      background-color: ", ";\n    }\n\n    .header__search-container {\n      max-width: ", ";\n      margin: 0 auto;\n      padding: ", " 5%;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepPageSizes.container;
  }, function (props) {
    return props.theme.marginPaddings[1];
  });
  var PageContainer = styled__default.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n   {\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    padding: 0 5%;\n    display: flex;\n    justify-content: space-between;\n  }\n"])), function (props) {
    return props.theme.rareStepPageSizes.container;
  });
  var HeaderContainer = styled__default.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    justify-content: space-between;\n    padding: ", " 5%;\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.rareStepPageSizes.container;
  });
  var LogoFigure = styled__default.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"])));
  var LogoImage = styled__default.img(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n   {\n    width: 160px;\n    cursor: pointer;\n  }\n"])));
  var CurrencyFlagIcon = styled__default.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n   {\n    width: 25px;\n    height: 15px;\n    margin-top: 9px;\n    margin-right: 10px;\n  }\n"])));
  var SellToUsLink = styled__default.a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n   {\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    cursor: pointer;\n    text-decoration: none;\n    font-style: italic;\n\n    &:hover,\n    &:active {\n      color: ", ";\n      text-decoration: none;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.secondary;
  }, function (props) {
    return props.theme.rareStepFontWeights.bold;
  }, function (props) {
    return props.theme.rareStepFontSize.h5;
  }, function (props) {
    return props.theme.rareStepColors.secondary;
  });
  var HeaderIconsContainer = styled__default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    align-items: center;\n\n    .account-icon {\n      &__wrapper {\n        position: relative;\n      }\n\n      &__dropdown {\n        position: absolute;\n        width: 100%;\n        top: 25px;\n        left: 0;\n      }\n    }\n  }\n"])));
  var HeaderIcon = styled__default.img(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n   {\n    width: 25px;\n    height: 22px;\n    margin-left: ", ";\n    cursor: pointer;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[3];
  });
  var NavigationContainer = styled__default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    justify-content: space-between;\n    background-color: ", ";\n    padding-top: ", ";\n  }\n"])), function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.marginPaddings[1];
  });
  var NavigationLink = styled__default.a(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    flex-wrap: no-wrap;\n    align-items: center;\n    color: ", ";\n    font-size: ", ";\n    margin-right: ", ";\n    padding-top: 2px;\n    padding-bottom: ", ";\n    cursor: pointer;\n    border-bottom: 2px solid ", ";\n    text-decoration: none;\n    white-space: nowrap;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &:hover,\n    &:active {\n      color: ", ";\n      text-decoration: none;\n      border-bottom: 2px solid ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepFontSize.h5;
  }, function (props) {
    return props.theme.marginPaddings[5];
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepColors.secondary;
  });
  var NavigationLinks = styled__default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n  }\n"])));
  var Dropdown = styled__default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    background-color: ", ";\n    padding: ", " 0;\n    border-top: 1px solid ", ";\n    font-size: ", ";\n    position: absolute;\n    width: 100%;\n  }\n"])), function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.marginPaddings[4];
  }, function (props) {
    return props.theme.rareStepColors.ntrl40;
  }, function (props) {
    return props.theme.rareStepFontSize.h5;
  });
  var DropdownBrands = styled__default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    flex-direction: column;\n    width: 20%;\n  }\n"])));
  var DropdownLinks = styled__default.ul(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n   {\n    padding: 0 ", ";\n    border-right: 1px solid ", ";\n    width: 50%;\n    column-count: 3;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[3];
  }, function (props) {
    return props.theme.rareStepColors.ntrl40;
  });
  var DropdownLinksList = styled__default.li(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n   {\n    list-style: none;\n  }\n"])));
  var DropdownFigure = styled__default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    width: 30%;\n    padding-left: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[5];
  });
  var DropdownImage = styled__default.img(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n   {\n    width: 90%;\n    height: 300px;\n    object-fit: cover;\n    margin-left: auto;\n    max-height: 100%;\n  }\n"])));
  var DropdownLink = styled__default.a(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n   {\n    color: ", ";\n    padding-bottom: ", ";\n    cursor: pointer;\n    text-decoration: none;\n\n    &:hover,\n    &:active {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var DropdownBrandLinkContainer = styled__default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n\n    &:hover {\n      cursor: pointer;\n\n      hr {\n        display: block;\n      }\n\n      a {\n        font-weight: ", ";\n      }\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepFontWeights.bold;
  });
  var DropdownBrandLinkHR = styled__default.hr(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n   {\n    display: none;\n    width: 20px;\n    margin: 10px 10px 0 0;\n    color: ", ";\n    height: 1px;\n    border: 1px solid ", ";\n  }\n"])), function (props) {
    return props.theme.rareStepColors.secondary;
  }, function (props) {
    return props.theme.rareStepColors.secondary;
  });
  var DropdownBrandLink = styled__default.a(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n   {\n    color: ", ";\n    padding-bottom: 0.5rem;\n    text-decoration: none;\n\n    &:hover,\n    &:active {\n      color: ", ";\n      text-decoration: none;\n      font-weight: ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepFontWeights.bold;
  });
  var DropdownNavigatorIcon = styled__default.img(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n   {\n    width: 15px;\n    height: 12px;\n    margin-left: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[0];
  });
  var SellToUsHR = styled__default.hr(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n   {\n    width: 80px;\n    margin-top: 10px;\n    color: ", ";\n    border: 1px solid ", ";\n    margin-right: 10px;\n  }\n"])), function (props) {
    return props.theme.rareStepColors.secondary;
  }, function (props) {
    return props.theme.rareStepColors.secondary;
  });
  var SearchContainer = styled__default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    padding: ", " 0;\n    align-items: center;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[1];
  });
  var SearchInput = styled__default.input(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n   {\n    width: 100%;\n    font-size: ", ";\n    padding-bottom: ", ";\n    color: ", ";\n    border: none;\n    margin-left: ", ";\n\n    &:active,\n    &:focus,\n    &:focus-visible {\n      outline: none;\n      border: none;\n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepFontSize.footerTitle;
  }, function (props) {
    return props.theme.marginPaddings[0];
  }, function (props) {
    return props.theme.rareStepColors.ntrl40;
  }, function (props) {
    return props.theme.marginPaddings[3];
  }, function (props) {
    return props.theme.rareStepColors.ntrl40;
  });
  var SearchIcon = styled__default.img(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n   {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    margin-bottom: 7px;\n  }\n"])));
  var CloseIcon = styled__default.img(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n   {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n  }\n"])));
  var CurrencyContainer = styled__default.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n  }\n"])));
  var DropdownSearchContainer = styled__default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n   {\n    background-color: ", ";\n    border-top: 1px solid ", ";\n  }\n"])), function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepColors.ntrl40;
  });

  var Search$1 = function Search(_ref) {
    var closeIconUrl = _ref.closeIconUrl,
        navigationSearchIconUrl = _ref.navigationSearchIconUrl,
        wordpressSiteUrl = _ref.wordpressSiteUrl,
        toggleSearch = _ref.toggleSearch;
    var searchInputRef = React.useRef(null);

    var handleOnSearch = function handleOnSearch() {
      window.location.replace("".concat(wordpressSiteUrl, "/?post_type=product&s=").concat(searchInputRef.current.value));
    };

    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === 'Enter') {
        handleOnSearch();
      }
    };

    React.useEffect(function () {
      searchInputRef.current.focus();
    }, []);
    return /*#__PURE__*/React__default.createElement(SearchContainer, {
      className: "header__search-container"
    }, /*#__PURE__*/React__default.createElement(SearchIcon, {
      className: "header__icon",
      src: navigationSearchIconUrl,
      onClick: handleOnSearch
    }), /*#__PURE__*/React__default.createElement(SearchInput, {
      className: "header__search-input",
      ref: searchInputRef,
      placeholder: "Search...",
      onKeyDown: handleKeyDown
    }), /*#__PURE__*/React__default.createElement(CloseIcon, {
      className: "header__icon",
      src: closeIconUrl,
      onClick: toggleSearch
    }));
  };

  function capitalizeWords(str) {
    return str.toLowerCase().replace(/\b\w/g, function (match) {
      return match.toUpperCase();
    });
  }

  var HeaderDropdown = function HeaderDropdown(_ref) {
    var currentSelectedItem = _ref.currentSelectedItem,
        handleShowDropdown = _ref.handleShowDropdown,
        handleHideDropdown = _ref.handleHideDropdown;
    return /*#__PURE__*/React__default.createElement(Dropdown, {
      onMouseOver: handleShowDropdown,
      onMouseOut: handleHideDropdown
    }, /*#__PURE__*/React__default.createElement(PageContainer, null, /*#__PURE__*/React__default.createElement(DropdownLinks, null, ((currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.items) || []).map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(DropdownLinksList, {
        key: index
      }, /*#__PURE__*/React__default.createElement(DropdownLink, {
        href: item.itemLink
      }, capitalizeWords(item.itemName)));
    })), /*#__PURE__*/React__default.createElement(DropdownFigure, null, (currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.brandImageUrl) && /*#__PURE__*/React__default.createElement(DropdownImage, {
      src: currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.brandImageUrl
    }))));
  };

  function Navigation(_ref) {
    var dropdownClosedIconUrl = _ref.dropdownClosedIconUrl,
        dropdownOpenIconUrl = _ref.dropdownOpenIconUrl,
        handleShowDropdown = _ref.handleShowDropdown,
        handleHideDropdown = _ref.handleHideDropdown,
        currentSelectedItem = _ref.currentSelectedItem,
        desktopHeaderLinks = _ref.desktopHeaderLinks;
    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(NavigationContainer, null, /*#__PURE__*/React__default.createElement(PageContainer, null, /*#__PURE__*/React__default.createElement(NavigationLinks, null, desktopHeaderLinks.left.map(function (link, index) {
      return link !== null && link !== void 0 && link.isDropdown ? /*#__PURE__*/React__default.createElement(NavigationLink, {
        key: index,
        onMouseOver: function onMouseOver() {
          return handleShowDropdown(link);
        },
        onMouseOut: handleHideDropdown
      }, capitalizeWords(link.name), currentSelectedItem.name === link.name ? /*#__PURE__*/React__default.createElement(DropdownNavigatorIcon, {
        src: dropdownClosedIconUrl
      }) : /*#__PURE__*/React__default.createElement(DropdownNavigatorIcon, {
        src: dropdownOpenIconUrl
      })) : /*#__PURE__*/React__default.createElement(NavigationLink, {
        href: link.url,
        key: index
      }, capitalizeWords(link.name));
    })), /*#__PURE__*/React__default.createElement(NavigationLinks, null, desktopHeaderLinks.right.map(function (link, index) {
      return /*#__PURE__*/React__default.createElement(NavigationLink, {
        href: link.url,
        key: index
      }, link.name);
    })))));
  }

  var RareStepDesktopHeader = function RareStepDesktopHeader(_ref) {
    var headerLogoImgUrl = _ref.headerLogoImgUrl,
        searchIconUrl = _ref.searchIconUrl,
        cartIconUrl = _ref.cartIconUrl,
        userIconUrl = _ref.userIconUrl,
        interestIconUrl = _ref.interestIconUrl,
        dropdownClosedIconUrl = _ref.dropdownClosedIconUrl,
        dropdownOpenIconUrl = _ref.dropdownOpenIconUrl,
        currencyFlagIconUrl = _ref.currencyFlagIconUrl,
        closeIconUrl = _ref.closeIconUrl,
        navigationSearchIconUrl = _ref.navigationSearchIconUrl,
        wordpressSiteUrl = _ref.wordpressSiteUrl,
        desktopHeaderLinks = _ref.desktopHeaderLinks,
        handleOnAccountClick = _ref.handleOnAccountClick,
        handleOnCartClick = _ref.handleOnCartClick,
        userIconDropdownContent = _ref.userIconDropdownContent;
    var timeoutIdRef = React.useRef(null);

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        showSearch = _useState2[0],
        setShowSearch = _useState2[1];

    var _useState3 = React.useState({}),
        _useState4 = _slicedToArray(_useState3, 2),
        currentSelectedItem = _useState4[0],
        setCurrentSelectedItem = _useState4[1];

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isUserIconDropdownContent = _useState6[0],
        setIsUserIconDropdownContent = _useState6[1];

    var userDropdownTimeoutIdRef = React.useRef(null);

    var toggleSearch = function toggleSearch() {
      setShowSearch(!showSearch);
    };

    var _handleShowDropdown = function handleShowDropdown(currentItem) {
      clearTimeout(timeoutIdRef.current);

      if (currentItem) {
        setCurrentSelectedItem(currentItem);
      }
    };

    var handleHideDropdown = function handleHideDropdown() {
      timeoutIdRef.current = setTimeout(function () {
        setCurrentSelectedItem({});
      }, 500);
    };

    var handleShowUserDropdown = function handleShowUserDropdown() {
      clearTimeout(userDropdownTimeoutIdRef.current);
      setIsUserIconDropdownContent(true);
    };

    var handleHideUserDropdown = function handleHideUserDropdown() {
      userDropdownTimeoutIdRef.current = setTimeout(function () {
        setIsUserIconDropdownContent(false);
      }, 500);
    };

    return /*#__PURE__*/React__default.createElement(HeaderWrapper, null, /*#__PURE__*/React__default.createElement(HeaderContainer, null, /*#__PURE__*/React__default.createElement(LogoFigure, null, /*#__PURE__*/React__default.createElement(LogoImage, {
      className: "header__logo",
      src: headerLogoImgUrl,
      onClick: function onClick() {
        window.location.href = wordpressSiteUrl;
      }
    })), /*#__PURE__*/React__default.createElement(HeaderIconsContainer, null, /*#__PURE__*/React__default.createElement(SellToUsHR, null), /*#__PURE__*/React__default.createElement(SellToUsLink, {
      href: desktopHeaderLinks.button.url
    }, desktopHeaderLinks.button.name), /*#__PURE__*/React__default.createElement("div", {
      className: "account-icon__wrapper"
    }, /*#__PURE__*/React__default.createElement(HeaderIcon, {
      src: searchIconUrl,
      onClick: toggleSearch
    }), interestIconUrl && /*#__PURE__*/React__default.createElement(HeaderIcon, {
      src: interestIconUrl
    }), userIconUrl && /*#__PURE__*/React__default.createElement(HeaderIcon, {
      onMouseOver: handleShowUserDropdown,
      onMouseOut: handleHideUserDropdown,
      className: "account-icon",
      src: userIconUrl,
      onClick: handleOnAccountClick
    }), /*#__PURE__*/React__default.createElement(HeaderIcon, {
      src: cartIconUrl,
      onClick: handleOnCartClick
    }), isUserIconDropdownContent && userIconDropdownContent && /*#__PURE__*/React__default.createElement("div", {
      onFocus: handleShowUserDropdown,
      onBlur: handleHideUserDropdown,
      onMouseOver: handleShowUserDropdown,
      onMouseOut: handleHideUserDropdown,
      className: "account-icon__dropdown"
    }, userIconDropdownContent)))), /*#__PURE__*/React__default.createElement(Navigation, {
      dropdownClosedIconUrl: dropdownClosedIconUrl,
      dropdownOpenIconUrl: dropdownOpenIconUrl,
      currencyFlagIconUrl: currencyFlagIconUrl,
      handleShowDropdown: _handleShowDropdown,
      currentSelectedItem: currentSelectedItem,
      handleHideDropdown: handleHideDropdown,
      desktopHeaderLinks: desktopHeaderLinks
    }), showSearch && /*#__PURE__*/React__default.createElement(DropdownSearchContainer, null, /*#__PURE__*/React__default.createElement(Search$1, {
      closeIconUrl: closeIconUrl,
      navigationSearchIconUrl: navigationSearchIconUrl,
      wordpressSiteUrl: wordpressSiteUrl,
      toggleSearch: toggleSearch
    })), Object.keys(currentSelectedItem).length !== 0 && /*#__PURE__*/React__default.createElement(HeaderDropdown, {
      currentSelectedItem: currentSelectedItem,
      handleShowDropdown: function handleShowDropdown() {
        return _handleShowDropdown();
      },
      handleHideDropdown: handleHideDropdown
    }));
  };

  var RareStepDesktopHeader$1 = themed(RareStepDesktopHeader);

  var _templateObject$P, _templateObject2$b, _templateObject3$6, _templateObject4$5, _templateObject5$3, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1, _templateObject18$1, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23$1;
  var HeaderWrapper$1 = styled__default.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    background-color: ", ";\n    position: relative;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    padding: ", " 5%;\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.marginPaddings[3];
  });
  var Icon = styled__default.img(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n   {\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n  }\n"])));
  var Logo = styled__default.img(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n   {\n    width: 140px;\n    height: auto;\n    margin-left: 30px;\n    cursor: pointer;\n  }\n"])));
  var IconWrapper$1 = styled__default.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    width: auto;\n    height: 25px;\n\n    .search-icon,\n    .cart-icon {\n      width: 100%;\n      height: 100%;\n    }\n\n    .cart-icon {\n      margin-left: 10px;\n    }\n  }\n"])));
  var NavigationWrapper = styled__default.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (props) {
    return props.theme.marginPaddings[1];
  });
  var NavigationWrapperTitle = styled__default.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  font-size: 16px;\n"])));
  var NavigationWrapperItem = styled__default.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  padding: 10px 0px 0px 20px;\n  font-size: 14px;\n  cursor: pointer;\n"])));
  var SideNavWrapper = styled__default.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n   {\n    position: relative;\n    overflow: hidden;\n\n    .side-nav-link--bottom {\n      font-size: ", ";\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepFontSize.h6;
  });
  var SideNav = styled__default.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n   {\n    position: fixed;\n    top: 0;\n    left: -100%;\n    width: 80%;\n    height: 100%;\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n    z-index: 9;\n  }\n"])), function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.marginPaddings[1];
  });
  var Overlay = styled__default.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n   {\n    position: fixed;\n    top: 0;\n    right: 200%;\n    width: 20%;\n    height: 100%;\n    background-color: ", ";\n    opacity: 0.5;\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrl40;
  });
  var CloseIcon$1 = styled__default.img(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n   {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n  }\n"])));
  var SideNavLink = styled__default.a(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n   {\n    padding: ", ";\n    color: ", ";\n    text-decoration: none;\n    text-align: left;\n    display: block;\n    width: 100%;\n    cursor: pointer;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var CloseIconWrapper = styled__default.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n   {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n  }\n"])));
  var SellToUsLink$1 = styled__default.a(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n   {\n    color: ", ";\n    border: 1px solid ", ";\n    background-color: transparent;\n    text-transform: uppercase;\n    font-weight: ", ";\n    display: block;\n    width: calc(100% - ", ");\n    padding: ", ";\n    margin: ", ";\n    text-align: center;\n    text-decoration: none;\n    border-radius: 5px;\n    letter-spacing: 1px;\n    font-style: italic;\n    font-size: ", ";\n  }\n"])), function (props) {
    return props.theme.rareStepColors.secondary;
  }, function (props) {
    return props.theme.rareStepColors.secondary;
  }, function (props) {
    return props.theme.rareStepFontWeights.bold;
  }, function (props) {
    return props.theme.marginPaddings[2];
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.rareStepFontSize.h5;
  });
  var SubMenuLinkContainer = styled__default.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n"])));
  var SubMenuRightIcon = styled__default.img(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n   {\n    width: 20px;\n    height: 20px;\n  }\n"])));
  var Hr = styled__default.hr(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral(["\n   {\n    width: 100%;\n    color: ", ";\n    margin: 0;\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMax;
  });
  var MobileSearchContainer = styled__default.div(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteral(["\n   {\n    background-color: ", ";\n\n    .header {\n      &__icon {\n        width: 20px;\n        height: 20px;\n      }\n\n      &__search-container {\n        border-top: 1px solid ", ";\n        padding-left: 5%;\n        padding-right: 5%;\n      }\n\n      &__search-input {\n        width: 100%;\n        color: ", ";\n        background-color: ", ";\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepColors.ntrl50;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepColors.primary;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var BackButton = styled__default.button(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteral(["\n   {\n    background-color: transparent;\n    border: none;\n    color: ", ";\n    margin: 30px 0;\n    position: relative;\n\n    &:hover {\n      cursor: pointer;\n      background-color: transparent;\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var BackIcon = styled__default.img(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteral(["\n   {\n    width: 20px;\n    height: 20px;\n    margin-right: 10px;\n    position: absolute;\n    top: 0;\n    left: 10px;\n  }\n"])));
  var BackButtonContent = styled__default.div(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteral(["\n   {\n    font-size: ", ";\n    text-transform: uppercase;\n    color: ", ";\n    margin-left: 35px;\n    display: inline-block;\n  }\n"])), function (props) {
    return props.theme.rareStepFontSize.h5;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var SideNavLinksContainer = styled__default.div(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteral(["\n   {\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 90%;\n    padding-bottom: 50px;\n    overscroll-behavior: contain;\n  }\n"])));
  var MenuSideNavWrapper = styled__default.div(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteral(["\n   {\n    .side-nav {\n      transition: left 1s ease-in-out;\n\n      &--open {\n        left: 0;\n      }\n\n      &--close {\n        left: -100%;\n      }\n\n      &__currency {\n        margin: ", " 0 0\n          ", ";\n      }\n    }\n\n    .overlay {\n      transition: right 1s ease-in-out;\n\n      &--open {\n        right: 0;\n      }\n\n      &--close {\n        right: 200%;\n      }\n    }\n  }\n"])), function (props) {
    return props.theme.marginPaddings[4];
  }, function (props) {
    return props.theme.marginPaddings[1];
  });

  var enableBodyScroll = function enableBodyScroll() {
    var _document = document,
        body = _document.body;
    body.style.overflow = '';
  };
  var disableBodyScroll = function disableBodyScroll() {
    var _document2 = document,
        body = _document2.body;
    body.style.overflow = 'hidden';
  };

  function MenuSideNav(_ref) {
    var closeIconUrl = _ref.closeIconUrl,
        children = _ref.children,
        setShowSideNav = _ref.setShowSideNav,
        isSubMenu = _ref.isSubMenu,
        backIconUrl = _ref.backIconUrl,
        sideNavClassName = _ref.sideNavClassName,
        overlayClassName = _ref.overlayClassName;

    var handleSideNavClose = function handleSideNavClose() {
      setShowSideNav(false);
      enableBodyScroll();
    };

    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(SideNavWrapper, null, /*#__PURE__*/React__default.createElement(SideNav, {
      className: sideNavClassName
    }, isSubMenu ? /*#__PURE__*/React__default.createElement(BackButton, {
      onClick: function onClick() {
        return setShowSideNav(false);
      }
    }, /*#__PURE__*/React__default.createElement(BackIcon, {
      src: backIconUrl
    }), /*#__PURE__*/React__default.createElement(BackButtonContent, null, "Back to menu")) : /*#__PURE__*/React__default.createElement(CloseIconWrapper, null, /*#__PURE__*/React__default.createElement(CloseIcon$1, {
      onClick: handleSideNavClose,
      src: closeIconUrl
    })), /*#__PURE__*/React__default.createElement(SideNavLinksContainer, null, children)), /*#__PURE__*/React__default.createElement(Overlay, {
      onClick: handleSideNavClose,
      className: overlayClassName
    })));
  }

  function SideNavLinks(_ref) {
    var rightArrowIconUrl = _ref.rightArrowIconUrl,
        links = _ref.links,
        setShowSideNavSubMenu = _ref.setShowSideNavSubMenu,
        closeSubMenu = _ref.closeSubMenu,
        setShowSideNav = _ref.setShowSideNav;

    var handleOnLinkClick = function handleOnLinkClick(link) {
      link.onClick();
      closeSubMenu();
    };

    var handleToRedirectOnItem = function handleToRedirectOnItem(item) {
      item.onClickItem();
      setShowSideNav();
    };

    return /*#__PURE__*/React__default.createElement(React.Fragment, null, ((links === null || links === void 0 ? void 0 : links.navigationMenus) || []).map(function (item) {
      return /*#__PURE__*/React__default.createElement(NavigationWrapper, null, item.isButton ? /*#__PURE__*/React__default.createElement(SellToUsLink$1, {
        onClick: function onClick() {
          return handleToRedirectOnItem(item);
        }
      }, item.title) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NavigationWrapperTitle, {
        style: {
          cursor: item.isLink && 'pointer'
        },
        onClick: function onClick() {
          return item.isLink && handleToRedirectOnItem(item);
        }
      }, item.title), item.items.map(function (subItems) {
        return subItems.isMobile && /*#__PURE__*/React__default.createElement(NavigationWrapperItem, {
          onClick: function onClick() {
            return handleToRedirectOnItem(subItems);
          }
        }, subItems.name);
      })));
    }), links.top.map(function (link, index) {
      return link !== null && link !== void 0 && link.isSubMenu ? /*#__PURE__*/React__default.createElement(SubMenuLinkContainer, {
        onClick: function onClick() {
          return setShowSideNavSubMenu(true);
        },
        key: index
      }, /*#__PURE__*/React__default.createElement(SideNavLink, null, capitalizeWords(link.name)), /*#__PURE__*/React__default.createElement(SubMenuRightIcon, {
        src: rightArrowIconUrl
      })) : /*#__PURE__*/React__default.createElement(SideNavLink, {
        key: index,
        href: link.url
      }, capitalizeWords(link.name));
    }), links.button && /*#__PURE__*/React__default.createElement(SellToUsLink$1, {
      href: links.button.url
    }, links.button.name), links.bottom.map(function (link, index) {
      return /*#__PURE__*/React__default.createElement(SideNavLink, {
        key: index,
        href: link.url,
        className: "side-nav-link--bottom",
        onClick: link !== null && link !== void 0 && link.isButton ? function () {
          return handleOnLinkClick(link);
        } : null
      }, capitalizeWords(link.name));
    }));
  }

  function SideNavSubMenuLinks(_ref) {
    var links = _ref.links;
    return /*#__PURE__*/React__default.createElement(React.Fragment, null, links.subMenuLinks.map(function (link, index) {
      return /*#__PURE__*/React__default.createElement(SideNavLink, {
        key: index,
        href: link.url
      }, capitalizeWords(link.name));
    }));
  }

  function RareStepMobileHeader(_ref) {
    var headerLogoImgUrl = _ref.headerLogoImgUrl,
        searchIconUrl = _ref.searchIconUrl,
        menuIconUrl = _ref.menuIconUrl,
        cartIconUrl = _ref.cartIconUrl,
        closeIconUrl = _ref.closeIconUrl,
        mobileHeaderLinks = _ref.mobileHeaderLinks,
        rightArrowIconUrl = _ref.rightArrowIconUrl,
        navigationSearchIconUrl = _ref.navigationSearchIconUrl,
        wordpressSiteUrl = _ref.wordpressSiteUrl,
        backIconUrl = _ref.backIconUrl,
        currencyFlagIconUrl = _ref.currencyFlagIconUrl,
        handleOnCartClick = _ref.handleOnCartClick;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        showSideNav = _useState2[0],
        setShowSideNav = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showSideNavSubMenu = _useState4[0],
        setShowSideNavSubMenu = _useState4[1];

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showSearch = _useState6[0],
        setShowSearch = _useState6[1];

    var toggleSearch = function toggleSearch() {
      setShowSearch(!showSearch);
    };

    var closeSubMenu = function closeSubMenu() {
      setShowSideNav(false);
      enableBodyScroll();
    };

    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(HeaderWrapper$1, null, /*#__PURE__*/React__default.createElement(Icon, {
      onClick: function onClick() {
        disableBodyScroll();
        setShowSideNav(true);
      },
      src: menuIconUrl
    }), /*#__PURE__*/React__default.createElement(Logo, {
      src: headerLogoImgUrl,
      onClick: function onClick() {
        window.location.href = wordpressSiteUrl;
      }
    }), /*#__PURE__*/React__default.createElement(IconWrapper$1, null, /*#__PURE__*/React__default.createElement(Icon, {
      className: "search-icon",
      src: searchIconUrl,
      onClick: toggleSearch
    }), /*#__PURE__*/React__default.createElement(Icon, {
      className: "cart-icon",
      src: cartIconUrl,
      onClick: handleOnCartClick
    }))), showSearch && /*#__PURE__*/React__default.createElement(MobileSearchContainer, null, /*#__PURE__*/React__default.createElement(Search$1, {
      closeIconUrl: closeIconUrl,
      navigationSearchIconUrl: navigationSearchIconUrl,
      wordpressSiteUrl: wordpressSiteUrl,
      toggleSearch: toggleSearch
    })), /*#__PURE__*/React__default.createElement(Hr, null), /*#__PURE__*/React__default.createElement(MenuSideNavWrapper, null, /*#__PURE__*/React__default.createElement(MenuSideNav, {
      sideNavClassName: "side-nav side-nav--".concat(showSideNav ? 'open' : 'close'),
      overlayClassName: "overlay overlay--".concat(showSideNav ? 'open' : 'close'),
      closeIconUrl: closeIconUrl,
      backIconUrl: backIconUrl,
      isSubMenu: false,
      setShowSideNav: setShowSideNav
    }, /*#__PURE__*/React__default.createElement(SideNavLinks, {
      rightArrowIconUrl: rightArrowIconUrl,
      links: mobileHeaderLinks,
      setShowSideNavSubMenu: setShowSideNavSubMenu,
      currencyFlagIconUrl: currencyFlagIconUrl,
      closeSubMenu: closeSubMenu,
      setShowSideNav: setShowSideNav
    }))), /*#__PURE__*/React__default.createElement(MenuSideNavWrapper, null, /*#__PURE__*/React__default.createElement(MenuSideNav, {
      sideNavClassName: "side-nav side-nav--".concat(showSideNavSubMenu ? 'open' : 'close'),
      overlayClassName: "overlay overlay--".concat(showSideNavSubMenu ? 'open' : 'close'),
      closeIconUrl: closeIconUrl,
      backIconUrl: backIconUrl,
      isSubMenu: true,
      setShowSideNav: setShowSideNavSubMenu
    }, /*#__PURE__*/React__default.createElement(SideNavSubMenuLinks, {
      links: mobileHeaderLinks
    }))));
  }

  /** RareStep header component */

  var RareStepHeader = function RareStepHeader(_ref) {
    var headerLogoImgUrl = _ref.headerLogoImgUrl,
        searchIconUrl = _ref.searchIconUrl,
        cartIconUrl = _ref.cartIconUrl,
        userIconUrl = _ref.userIconUrl,
        interestIconUrl = _ref.interestIconUrl,
        dropdownClosedIconUrl = _ref.dropdownClosedIconUrl,
        dropdownOpenIconUrl = _ref.dropdownOpenIconUrl,
        currencyFlagIconUrl = _ref.currencyFlagIconUrl,
        closeIconUrl = _ref.closeIconUrl,
        navigationSearchIconUrl = _ref.navigationSearchIconUrl,
        wordpressSiteUrl = _ref.wordpressSiteUrl,
        desktopHeaderWrapperClass = _ref.desktopHeaderWrapperClass,
        menuIconUrl = _ref.menuIconUrl,
        mobileHeaderWrapperClass = _ref.mobileHeaderWrapperClass,
        rightArrowIconUrl = _ref.rightArrowIconUrl,
        desktopHeaderLinks = _ref.desktopHeaderLinks,
        mobileHeaderLinks = _ref.mobileHeaderLinks,
        mobileCloseIconUrl = _ref.mobileCloseIconUrl,
        handleOnAccountClick = _ref.handleOnAccountClick,
        backIconUrl = _ref.backIconUrl,
        handleOnCartClick = _ref.handleOnCartClick,
        userIconDropdownContent = _ref.userIconDropdownContent;
    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: desktopHeaderWrapperClass
    }, /*#__PURE__*/React__default.createElement(RareStepDesktopHeader$1, {
      headerLogoImgUrl: headerLogoImgUrl,
      searchIconUrl: searchIconUrl,
      cartIconUrl: cartIconUrl,
      userIconUrl: userIconUrl,
      interestIconUrl: interestIconUrl,
      dropdownClosedIconUrl: dropdownClosedIconUrl,
      dropdownOpenIconUrl: dropdownOpenIconUrl,
      currencyFlagIconUrl: currencyFlagIconUrl,
      closeIconUrl: closeIconUrl,
      navigationSearchIconUrl: navigationSearchIconUrl,
      wordpressSiteUrl: wordpressSiteUrl,
      desktopHeaderLinks: desktopHeaderLinks,
      handleOnAccountClick: handleOnAccountClick,
      handleOnCartClick: handleOnCartClick,
      userIconDropdownContent: userIconDropdownContent
    })), /*#__PURE__*/React__default.createElement("div", {
      className: mobileHeaderWrapperClass
    }, /*#__PURE__*/React__default.createElement(RareStepMobileHeader, {
      menuIconUrl: menuIconUrl,
      headerLogoImgUrl: headerLogoImgUrl,
      searchIconUrl: searchIconUrl,
      cartIconUrl: cartIconUrl,
      closeIconUrl: closeIconUrl,
      rightArrowIconUrl: rightArrowIconUrl,
      mobileHeaderLinks: mobileHeaderLinks,
      navigationSearchIconUrl: navigationSearchIconUrl,
      mobileCloseIconUrl: mobileCloseIconUrl,
      wordpressSiteUrl: wordpressSiteUrl,
      backIconUrl: backIconUrl,
      currencyFlagIconUrl: currencyFlagIconUrl,
      handleOnCartClick: handleOnCartClick
    })));
  };

  RareStepHeader.defaultProps = {
    userIconDropdownContent: null
  };
  var index$3 = themed(RareStepHeader);

  var _templateObject$Q, _templateObject2$c, _templateObject3$7, _templateObject4$6, _templateObject5$4, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$2;
  var FooterWrapper = styled__default.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n   {\n    background-color: ", ";\n    font-weight: ", ";\n    padding-top: ", ";\n    font-size: ", ";\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMax;
  }, function (props) {
    return props.theme.rareStepFontWeights.bold;
  }, function (props) {
    return props.theme.marginPaddings[4];
  }, function (props) {
    return props.theme.rareStepFontSize.h5;
  });
  var PageContainer$1 = styled__default.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n   {\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    padding: 0 5%;\n    display: flex;\n    justify-content: space-between;\n  }\n"])), function (props) {
    return props.theme.rareStepPageSizes.container;
  });
  var FooterLinksWrapper = styled__default.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    flex-basis: 70%;\n    padding-bottom: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[4];
  });
  var FooterLinksContainer = styled__default.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    padding-right: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[4];
  });
  var FooterTitleLink = styled__default.a(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n   {\n    text-transform: uppercase;\n    color: ", ";\n    margin-bottom: ", ";\n    cursor: pointer;\n    font-weight: ", ";\n    font-size: ", ";\n    text-decoration: none;\n\n    &:hover,\n    &:active {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.rareStepFontWeights.bold;
  }, function (props) {
    return props.theme.rareStepFontSize.footerTitle;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var FooterLink = styled__default.a(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n   {\n    color: ", ";\n    cursor: pointer;\n    margin-bottom: ", ";\n    font-weight: ", ";\n    text-decoration: none;\n    font-size: ", ";\n\n    &:hover,\n    &:active {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.space[2];
  }, function (props) {
    return props.theme.rareStepFontWeights.normal;
  }, function (props) {
    return props.theme.rareStepFontSize.h6;
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var FooterImage = styled__default.img(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n   {\n    width: 100%;\n    height: 100%;\n    max-height: 300px;\n    object-fit: cover;\n  }\n"])));
  var FooterImageWrapper = styled__default.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n   {\n    flex-basis: 30%;\n    padding-bottom: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[4];
  });
  var FooterLogo = styled__default.img(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n   {\n    width: 120px;\n    margin-top: ", ";\n    cursor: pointer;\n  }\n"])), function (props) {
    return props.theme.marginPaddings[5];
  });
  var SocialIconWrapper = styled__default.div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n  }\n"])));
  var SocialIcon = styled__default.img(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n   {\n    width: 30px;\n    height: 30px;\n    margin-right: ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[0];
  });
  var FooterCopyrightContainer = styled__default.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    padding: ", " 0;\n    border-top: 1px solid ", ";\n  }\n"])), function (props) {
    return props.theme.marginPaddings[1];
  }, function (props) {
    return props.theme.rareStepColors.ntrlMin;
  });
  var FooterCopyrightText = styled__default.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n   {\n    color: ", ";\n    font-weight: ", ";\n  }\n"])), function (props) {
    return props.theme.rareStepColors.ntrlMin;
  }, function (props) {
    return props.theme.rareStepFontWeights.normal;
  });
  var FooterPayments = styled__default.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n"])));
  var FooterPaymentImage = styled__default.img(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n   {\n    width: 100px;\n    height: 30px;\n  }\n"])));
  var FooterConnectContainer = styled__default.div(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral(["\n   {\n    display: flex;\n    flex-direction: column;\n  }\n"])));

  var FooterCopyright = function FooterCopyright(_ref) {
    var paymentImage = _ref.paymentImage;
    return /*#__PURE__*/React__default.createElement(FooterCopyrightContainer, null, /*#__PURE__*/React__default.createElement(PageContainer$1, {
      className: "footer__copyright-container"
    }, /*#__PURE__*/React__default.createElement(FooterCopyrightText, {
      className: "footer__desktop-copyrights"
    }, "\xA9".concat(new Date().getFullYear(), " \u2022 Rare Step \u2022 Website Developed by B Online")), /*#__PURE__*/React__default.createElement(FooterCopyrightText, {
      className: "footer__mobile-copyrights"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__copyright-text"
    }, "\xA9".concat(new Date().getFullYear(), " Rare Step")), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__copyright-text"
    }, "Website Developed by B Online")), /*#__PURE__*/React__default.createElement(FooterPayments, {
      className: "footer__payment-options"
    }, /*#__PURE__*/React__default.createElement(FooterPaymentImage, {
      className: "footer__payment-image",
      src: paymentImage
    }))));
  };

  function FooterConnect(_ref) {
    var footerLogoImageUrl = _ref.footerLogoImageUrl,
        facebookUrl = _ref.facebookUrl,
        facebookIconUrl = _ref.facebookIconUrl,
        instagramUrl = _ref.instagramUrl,
        instagramImageUrl = _ref.instagramImageUrl,
        className = _ref.className,
        wordpressSiteUrl = _ref.wordpressSiteUrl,
        tiktokUrl = _ref.tiktokUrl,
        tiktokImageUrl = _ref.tiktokImageUrl;
    return /*#__PURE__*/React__default.createElement(FooterConnectContainer, {
      className: className
    }, /*#__PURE__*/React__default.createElement(FooterLogo, {
      className: "footer__logo",
      src: footerLogoImageUrl,
      onClick: function onClick() {
        window.location.href = wordpressSiteUrl;
      }
    }), /*#__PURE__*/React__default.createElement(FooterTitleLink, {
      className: "footer__link"
    }, "Connect"), /*#__PURE__*/React__default.createElement(SocialIconWrapper, null, /*#__PURE__*/React__default.createElement(FooterLink, {
      target: "_blank",
      href: facebookUrl
    }, /*#__PURE__*/React__default.createElement(SocialIcon, {
      src: facebookIconUrl
    })), /*#__PURE__*/React__default.createElement(FooterLink, {
      target: "_blank",
      href: instagramUrl
    }, /*#__PURE__*/React__default.createElement(SocialIcon, {
      src: instagramImageUrl
    })), /*#__PURE__*/React__default.createElement(FooterLink, {
      target: "_blank",
      href: tiktokUrl
    }, /*#__PURE__*/React__default.createElement(SocialIcon, {
      src: tiktokImageUrl
    }))));
  }

  /** RareStep footer component */

  var RareStepFooter = function RareStepFooter(_ref) {
    var footerImageUrl = _ref.footerImageUrl,
        footerLogoImageUrl = _ref.footerLogoImageUrl,
        facebookUrl = _ref.facebookUrl,
        facebookIconUrl = _ref.facebookIconUrl,
        instagramUrl = _ref.instagramUrl,
        instagramImageUrl = _ref.instagramImageUrl,
        paymentImage = _ref.paymentImage,
        footerLinks = _ref.footerLinks,
        wordpressSiteUrl = _ref.wordpressSiteUrl,
        tiktokUrl = _ref.tiktokUrl,
        tiktokImageUrl = _ref.tiktokImageUrl;
    return /*#__PURE__*/React__default.createElement(FooterWrapper, null, /*#__PURE__*/React__default.createElement(PageContainer$1, {
      className: "footer__page-container"
    }, /*#__PURE__*/React__default.createElement(FooterLinksWrapper, {
      className: "footer__links-wrapper"
    }, footerLinks.map(function (footerLink, index) {
      return /*#__PURE__*/React__default.createElement(FooterLinksContainer, {
        className: "footer__links",
        key: index
      }, /*#__PURE__*/React__default.createElement(FooterTitleLink, {
        target: footerLink !== null && footerLink !== void 0 && footerLink.openInNewTab ? '_blank' : '_self',
        className: "footer__link",
        href: footerLink.url
      }, footerLink.title), footerLink.links.map(function (link, linkIndex) {
        return /*#__PURE__*/React__default.createElement(FooterLink, {
          target: footerLink !== null && footerLink !== void 0 && footerLink.openInNewTab ? '_blank' : '_self',
          className: "footer__link",
          href: link.url,
          key: linkIndex
        }, link.name);
      }), index === 0 && /*#__PURE__*/React__default.createElement(FooterConnect, {
        className: "footer__connect-desktop",
        footerLogoImageUrl: footerLogoImageUrl,
        facebookUrl: facebookUrl,
        facebookIconUrl: facebookIconUrl,
        instagramUrl: instagramUrl,
        instagramImageUrl: instagramImageUrl,
        wordpressSiteUrl: wordpressSiteUrl,
        tiktokUrl: tiktokUrl,
        tiktokImageUrl: tiktokImageUrl
      }));
    })), /*#__PURE__*/React__default.createElement(FooterConnect, {
      className: "footer__connect-mobile",
      footerLogoImageUrl: footerLogoImageUrl,
      facebookUrl: facebookUrl,
      facebookIconUrl: facebookIconUrl,
      instagramUrl: instagramUrl,
      instagramImageUrl: instagramImageUrl,
      wordpressSiteUrl: wordpressSiteUrl,
      tiktokUrl: tiktokUrl,
      tiktokImageUrl: tiktokImageUrl
    }), /*#__PURE__*/React__default.createElement(FooterImageWrapper, {
      className: "footer__figure"
    }, /*#__PURE__*/React__default.createElement(FooterImage, {
      src: footerImageUrl
    }))), /*#__PURE__*/React__default.createElement(FooterCopyright, {
      paymentImage: paymentImage
    }));
  };

  var index$4 = themed(RareStepFooter);

  var isCheckBoxInput = (element) => element.type === 'checkbox';

  var isDateObject = (value) => value instanceof Date;

  var isNullOrUndefined = (value) => value == null;

  const isObjectType = (value) => typeof value === 'object';
  var isObject = (value) => !isNullOrUndefined(value) &&
      !Array.isArray(value) &&
      isObjectType(value) &&
      !isDateObject(value);

  var getEventValue = (event) => isObject(event) && event.target
      ? isCheckBoxInput(event.target)
          ? event.target.checked
          : event.target.value
      : event;

  var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

  var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

  var isPlainObject = (tempObject) => {
      const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
      return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
  };

  var isWeb = typeof window !== 'undefined' &&
      typeof window.HTMLElement !== 'undefined' &&
      typeof document !== 'undefined';

  function cloneObject(data) {
      let copy;
      const isArray = Array.isArray(data);
      if (data instanceof Date) {
          copy = new Date(data);
      }
      else if (data instanceof Set) {
          copy = new Set(data);
      }
      else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
          (isArray || isObject(data))) {
          copy = isArray ? [] : {};
          if (!isArray && !isPlainObject(data)) {
              copy = data;
          }
          else {
              for (const key in data) {
                  if (data.hasOwnProperty(key)) {
                      copy[key] = cloneObject(data[key]);
                  }
              }
          }
      }
      else {
          return data;
      }
      return copy;
  }

  var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

  var isUndefined = (val) => val === undefined;

  var get = (obj, path, defaultValue) => {
      if (!path || !isObject(obj)) {
          return defaultValue;
      }
      const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
      return isUndefined(result) || result === obj
          ? isUndefined(obj[path])
              ? defaultValue
              : obj[path]
          : result;
  };

  const EVENTS = {
      BLUR: 'blur',
      FOCUS_OUT: 'focusout',
      CHANGE: 'change',
  };
  const VALIDATION_MODE = {
      onBlur: 'onBlur',
      onChange: 'onChange',
      onSubmit: 'onSubmit',
      onTouched: 'onTouched',
      all: 'all',
  };
  const INPUT_VALIDATION_RULES = {
      max: 'max',
      min: 'min',
      maxLength: 'maxLength',
      minLength: 'minLength',
      pattern: 'pattern',
      required: 'required',
      validate: 'validate',
  };

  const HookFormContext = React__default.createContext(null);
  /**
   * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
   *
   * @remarks
   * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
   *
   * @returns return all useForm methods
   *
   * @example
   * ```tsx
   * function App() {
   *   const methods = useForm();
   *   const onSubmit = data => console.log(data);
   *
   *   return (
   *     <FormProvider {...methods} >
   *       <form onSubmit={methods.handleSubmit(onSubmit)}>
   *         <NestedInput />
   *         <input type="submit" />
   *       </form>
   *     </FormProvider>
   *   );
   * }
   *
   *  function NestedInput() {
   *   const { register } = useFormContext(); // retrieve all hook methods
   *   return <input {...register("test")} />;
   * }
   * ```
   */
  const useFormContext = () => React__default.useContext(HookFormContext);

  var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
      const result = {
          defaultValues: control._defaultValues,
      };
      for (const key in formState) {
          Object.defineProperty(result, key, {
              get: () => {
                  const _key = key;
                  if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                      control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                  }
                  localProxyFormState && (localProxyFormState[_key] = true);
                  return formState[_key];
              },
          });
      }
      return result;
  };

  var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

  var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
      updateFormState(formStateData);
      const { name, ...formState } = formStateData;
      return (isEmptyObject(formState) ||
          Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
          Object.keys(formState).find((key) => _proxyFormState[key] ===
              (!isRoot || VALIDATION_MODE.all)));
  };

  var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

  var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
      ? name === signalName ||
          (Array.isArray(name) &&
              name.some((currentName) => currentName && exact && currentName === signalName))
      : !name ||
          !signalName ||
          name === signalName ||
          convertToArrayPayload(name).some((currentName) => currentName &&
              (currentName.startsWith(signalName) ||
                  signalName.startsWith(currentName)));

  function useSubscribe(props) {
      const _props = React__default.useRef(props);
      _props.current = props;
      React__default.useEffect(() => {
          const subscription = !props.disabled &&
              _props.current.subject &&
              _props.current.subject.subscribe({
                  next: _props.current.next,
              });
          return () => {
              subscription && subscription.unsubscribe();
          };
      }, [props.disabled]);
  }

  /**
   * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
   *
   * @remarks
   * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
   *
   * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
   *
   * @example
   * ```tsx
   * function App() {
   *   const { register, handleSubmit, control } = useForm({
   *     defaultValues: {
   *     firstName: "firstName"
   *   }});
   *   const { dirtyFields } = useFormState({
   *     control
   *   });
   *   const onSubmit = (data) => console.log(data);
   *
   *   return (
   *     <form onSubmit={handleSubmit(onSubmit)}>
   *       <input {...register("firstName")} placeholder="First Name" />
   *       {dirtyFields.firstName && <p>Field is dirty.</p>}
   *       <input type="submit" />
   *     </form>
   *   );
   * }
   * ```
   */
  function useFormState(props) {
      const methods = useFormContext();
      const { control = methods.control, disabled, name, exact } = props || {};
      const [formState, updateFormState] = React__default.useState(control._formState);
      const _mounted = React__default.useRef(true);
      const _localProxyFormState = React__default.useRef({
          isDirty: false,
          isLoading: false,
          dirtyFields: false,
          touchedFields: false,
          isValidating: false,
          isValid: false,
          errors: false,
      });
      const _name = React__default.useRef(name);
      _name.current = name;
      useSubscribe({
          disabled,
          next: (value) => _mounted.current &&
              shouldSubscribeByName(_name.current, value.name, exact) &&
              shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
              updateFormState({
                  ...control._formState,
                  ...value,
              }),
          subject: control._subjects.state,
      });
      React__default.useEffect(() => {
          _mounted.current = true;
          _localProxyFormState.current.isValid && control._updateValid(true);
          return () => {
              _mounted.current = false;
          };
      }, [control]);
      return getProxyFormState(formState, control, _localProxyFormState.current, false);
  }

  var isString = (value) => typeof value === 'string';

  var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
      if (isString(names)) {
          isGlobal && _names.watch.add(names);
          return get(formValues, names, defaultValue);
      }
      if (Array.isArray(names)) {
          return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
      }
      isGlobal && (_names.watchAll = true);
      return formValues;
  };

  /**
   * Custom hook to subscribe to field change and isolate re-rendering at the component level.
   *
   * @remarks
   *
   * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
   *
   * @example
   * ```tsx
   * const { watch } = useForm();
   * const values = useWatch({
   *   name: "fieldName"
   *   control,
   * })
   * ```
   */
  function useWatch(props) {
      const methods = useFormContext();
      const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
      const _name = React__default.useRef(name);
      _name.current = name;
      useSubscribe({
          disabled,
          subject: control._subjects.values,
          next: (formState) => {
              if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                  updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
              }
          },
      });
      const [value, updateValue] = React__default.useState(control._getWatch(name, defaultValue));
      React__default.useEffect(() => control._removeUnmounted());
      return value;
  }

  var isKey = (value) => /^\w*$/.test(value);

  var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

  function set(object, path, value) {
      let index = -1;
      const tempPath = isKey(path) ? [path] : stringToPath(path);
      const length = tempPath.length;
      const lastIndex = length - 1;
      while (++index < length) {
          const key = tempPath[index];
          let newValue = value;
          if (index !== lastIndex) {
              const objValue = object[key];
              newValue =
                  isObject(objValue) || Array.isArray(objValue)
                      ? objValue
                      : !isNaN(+tempPath[index + 1])
                          ? []
                          : {};
          }
          object[key] = newValue;
          object = object[key];
      }
      return object;
  }

  /**
   * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
   *
   * @remarks
   * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
   *
   * @param props - the path name to the form field value, and validation rules.
   *
   * @returns field properties, field and form state. {@link UseControllerReturn}
   *
   * @example
   * ```tsx
   * function Input(props) {
   *   const { field, fieldState, formState } = useController(props);
   *   return (
   *     <div>
   *       <input {...field} placeholder={props.name} />
   *       <p>{fieldState.isTouched && "Touched"}</p>
   *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
   *     </div>
   *   );
   * }
   * ```
   */
  function useController(props) {
      const methods = useFormContext();
      const { name, disabled, control = methods.control, shouldUnregister } = props;
      const isArrayField = isNameInFieldArray(control._names.array, name);
      const value = useWatch({
          control,
          name,
          defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
          exact: true,
      });
      const formState = useFormState({
          control,
          name,
      });
      const _registerProps = React__default.useRef(control.register(name, {
          ...props.rules,
          value,
      }));
      _registerProps.current = control.register(name, props.rules);
      React__default.useEffect(() => {
          const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
          const updateMounted = (name, value) => {
              const field = get(control._fields, name);
              if (field) {
                  field._f.mount = value;
              }
          };
          updateMounted(name, true);
          if (_shouldUnregisterField) {
              const value = cloneObject(get(control._options.defaultValues, name));
              set(control._defaultValues, name, value);
              if (isUndefined(get(control._formValues, name))) {
                  set(control._formValues, name, value);
              }
          }
          return () => {
              (isArrayField
                  ? _shouldUnregisterField && !control._state.action
                  : _shouldUnregisterField)
                  ? control.unregister(name)
                  : updateMounted(name, false);
          };
      }, [name, control, isArrayField, shouldUnregister]);
      React__default.useEffect(() => {
          control._updateDisabledField({
              disabled,
              fields: control._fields,
              name,
          });
      }, [disabled, name, control]);
      return {
          field: {
              name,
              value,
              disabled,
              onChange: React__default.useCallback((event) => _registerProps.current.onChange({
                  target: {
                      value: getEventValue(event),
                      name: name,
                  },
                  type: EVENTS.CHANGE,
              }), [name]),
              onBlur: React__default.useCallback(() => _registerProps.current.onBlur({
                  target: {
                      value: get(control._formValues, name),
                      name: name,
                  },
                  type: EVENTS.BLUR,
              }), [name, control]),
              ref: (elm) => {
                  const field = get(control._fields, name);
                  if (field && elm) {
                      field._f.ref = {
                          focus: () => elm.focus(),
                          select: () => elm.select(),
                          setCustomValidity: (message) => elm.setCustomValidity(message),
                          reportValidity: () => elm.reportValidity(),
                      };
                  }
              },
          },
          formState,
          fieldState: Object.defineProperties({}, {
              invalid: {
                  enumerable: true,
                  get: () => !!get(formState.errors, name),
              },
              isDirty: {
                  enumerable: true,
                  get: () => !!get(formState.dirtyFields, name),
              },
              isTouched: {
                  enumerable: true,
                  get: () => !!get(formState.touchedFields, name),
              },
              error: {
                  enumerable: true,
                  get: () => get(formState.errors, name),
              },
          }),
      };
  }

  var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
      ? {
          ...errors[name],
          types: {
              ...(errors[name] && errors[name].types ? errors[name].types : {}),
              [type]: message || true,
          },
      }
      : {};

  const focusFieldBy = (fields, callback, fieldsNames) => {
      for (const key of fieldsNames || Object.keys(fields)) {
          const field = get(fields, key);
          if (field) {
              const { _f, ...currentField } = field;
              if (_f && callback(_f.name)) {
                  if (_f.ref.focus) {
                      _f.ref.focus();
                      break;
                  }
                  else if (_f.refs && _f.refs[0].focus) {
                      _f.refs[0].focus();
                      break;
                  }
              }
              else if (isObject(currentField)) {
                  focusFieldBy(currentField, callback);
              }
          }
      }
  };

  var getValidationModes = (mode) => ({
      isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
      isOnBlur: mode === VALIDATION_MODE.onBlur,
      isOnChange: mode === VALIDATION_MODE.onChange,
      isOnAll: mode === VALIDATION_MODE.all,
      isOnTouch: mode === VALIDATION_MODE.onTouched,
  });

  var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
      (_names.watchAll ||
          _names.watch.has(name) ||
          [..._names.watch].some((watchName) => name.startsWith(watchName) &&
              /^\.\w+/.test(name.slice(watchName.length))));

  var updateFieldArrayRootError = (errors, error, name) => {
      const fieldArrayErrors = compact(get(errors, name));
      set(fieldArrayErrors, 'root', error[name]);
      set(errors, name, fieldArrayErrors);
      return errors;
  };

  var isBoolean = (value) => typeof value === 'boolean';

  var isFileInput = (element) => element.type === 'file';

  var isFunction = (value) => typeof value === 'function';

  var isHTMLElement = (value) => {
      if (!isWeb) {
          return false;
      }
      const owner = value ? value.ownerDocument : 0;
      return (value instanceof
          (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
  };

  var isMessage = (value) => isString(value);

  var isRadioInput = (element) => element.type === 'radio';

  var isRegex = (value) => value instanceof RegExp;

  const defaultResult = {
      value: false,
      isValid: false,
  };
  const validResult = { value: true, isValid: true };
  var getCheckboxValue = (options) => {
      if (Array.isArray(options)) {
          if (options.length > 1) {
              const values = options
                  .filter((option) => option && option.checked && !option.disabled)
                  .map((option) => option.value);
              return { value: values, isValid: !!values.length };
          }
          return options[0].checked && !options[0].disabled
              ? // @ts-expect-error expected to work in the browser
                  options[0].attributes && !isUndefined(options[0].attributes.value)
                      ? isUndefined(options[0].value) || options[0].value === ''
                          ? validResult
                          : { value: options[0].value, isValid: true }
                      : validResult
              : defaultResult;
      }
      return defaultResult;
  };

  const defaultReturn = {
      isValid: false,
      value: null,
  };
  var getRadioValue = (options) => Array.isArray(options)
      ? options.reduce((previous, option) => option && option.checked && !option.disabled
          ? {
              isValid: true,
              value: option.value,
          }
          : previous, defaultReturn)
      : defaultReturn;

  function getValidateError(result, ref, type = 'validate') {
      if (isMessage(result) ||
          (Array.isArray(result) && result.every(isMessage)) ||
          (isBoolean(result) && !result)) {
          return {
              type,
              message: isMessage(result) ? result : '',
              ref,
          };
      }
  }

  var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
      ? validationData
      : {
          value: validationData,
          message: '',
      };

  var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
      const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
      const inputValue = get(formValues, name);
      if (!mount || disabled) {
          return {};
      }
      const inputRef = refs ? refs[0] : ref;
      const setCustomValidity = (message) => {
          if (shouldUseNativeValidation && inputRef.reportValidity) {
              inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
              inputRef.reportValidity();
          }
      };
      const error = {};
      const isRadio = isRadioInput(ref);
      const isCheckBox = isCheckBoxInput(ref);
      const isRadioOrCheckbox = isRadio || isCheckBox;
      const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
          isUndefined(ref.value) &&
          isUndefined(inputValue)) ||
          (isHTMLElement(ref) && ref.value === '') ||
          inputValue === '' ||
          (Array.isArray(inputValue) && !inputValue.length);
      const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
      const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
          const message = exceedMax ? maxLengthMessage : minLengthMessage;
          error[name] = {
              type: exceedMax ? maxType : minType,
              message,
              ref,
              ...appendErrorsCurry(exceedMax ? maxType : minType, message),
          };
      };
      if (isFieldArray
          ? !Array.isArray(inputValue) || !inputValue.length
          : required &&
              ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                  (isBoolean(inputValue) && !inputValue) ||
                  (isCheckBox && !getCheckboxValue(refs).isValid) ||
                  (isRadio && !getRadioValue(refs).isValid))) {
          const { value, message } = isMessage(required)
              ? { value: !!required, message: required }
              : getValueAndMessage(required);
          if (value) {
              error[name] = {
                  type: INPUT_VALIDATION_RULES.required,
                  message,
                  ref: inputRef,
                  ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
              };
              if (!validateAllFieldCriteria) {
                  setCustomValidity(message);
                  return error;
              }
          }
      }
      if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
          let exceedMax;
          let exceedMin;
          const maxOutput = getValueAndMessage(max);
          const minOutput = getValueAndMessage(min);
          if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
              const valueNumber = ref.valueAsNumber ||
                  (inputValue ? +inputValue : inputValue);
              if (!isNullOrUndefined(maxOutput.value)) {
                  exceedMax = valueNumber > maxOutput.value;
              }
              if (!isNullOrUndefined(minOutput.value)) {
                  exceedMin = valueNumber < minOutput.value;
              }
          }
          else {
              const valueDate = ref.valueAsDate || new Date(inputValue);
              const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
              const isTime = ref.type == 'time';
              const isWeek = ref.type == 'week';
              if (isString(maxOutput.value) && inputValue) {
                  exceedMax = isTime
                      ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                      : isWeek
                          ? inputValue > maxOutput.value
                          : valueDate > new Date(maxOutput.value);
              }
              if (isString(minOutput.value) && inputValue) {
                  exceedMin = isTime
                      ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                      : isWeek
                          ? inputValue < minOutput.value
                          : valueDate < new Date(minOutput.value);
              }
          }
          if (exceedMax || exceedMin) {
              getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
              if (!validateAllFieldCriteria) {
                  setCustomValidity(error[name].message);
                  return error;
              }
          }
      }
      if ((maxLength || minLength) &&
          !isEmpty &&
          (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
          const maxLengthOutput = getValueAndMessage(maxLength);
          const minLengthOutput = getValueAndMessage(minLength);
          const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
              inputValue.length > +maxLengthOutput.value;
          const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
              inputValue.length < +minLengthOutput.value;
          if (exceedMax || exceedMin) {
              getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
              if (!validateAllFieldCriteria) {
                  setCustomValidity(error[name].message);
                  return error;
              }
          }
      }
      if (pattern && !isEmpty && isString(inputValue)) {
          const { value: patternValue, message } = getValueAndMessage(pattern);
          if (isRegex(patternValue) && !inputValue.match(patternValue)) {
              error[name] = {
                  type: INPUT_VALIDATION_RULES.pattern,
                  message,
                  ref,
                  ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
              };
              if (!validateAllFieldCriteria) {
                  setCustomValidity(message);
                  return error;
              }
          }
      }
      if (validate) {
          if (isFunction(validate)) {
              const result = await validate(inputValue, formValues);
              const validateError = getValidateError(result, inputRef);
              if (validateError) {
                  error[name] = {
                      ...validateError,
                      ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                  };
                  if (!validateAllFieldCriteria) {
                      setCustomValidity(validateError.message);
                      return error;
                  }
              }
          }
          else if (isObject(validate)) {
              let validationResult = {};
              for (const key in validate) {
                  if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                      break;
                  }
                  const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                  if (validateError) {
                      validationResult = {
                          ...validateError,
                          ...appendErrorsCurry(key, validateError.message),
                      };
                      setCustomValidity(validateError.message);
                      if (validateAllFieldCriteria) {
                          error[name] = validationResult;
                      }
                  }
              }
              if (!isEmptyObject(validationResult)) {
                  error[name] = {
                      ref: inputRef,
                      ...validationResult,
                  };
                  if (!validateAllFieldCriteria) {
                      return error;
                  }
              }
          }
      }
      setCustomValidity(true);
      return error;
  };

  function baseGet(object, updatePath) {
      const length = updatePath.slice(0, -1).length;
      let index = 0;
      while (index < length) {
          object = isUndefined(object) ? index++ : object[updatePath[index++]];
      }
      return object;
  }
  function isEmptyArray(obj) {
      for (const key in obj) {
          if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
              return false;
          }
      }
      return true;
  }
  function unset(object, path) {
      const paths = Array.isArray(path)
          ? path
          : isKey(path)
              ? [path]
              : stringToPath(path);
      const childObject = paths.length === 1 ? object : baseGet(object, paths);
      const index = paths.length - 1;
      const key = paths[index];
      if (childObject) {
          delete childObject[key];
      }
      if (index !== 0 &&
          ((isObject(childObject) && isEmptyObject(childObject)) ||
              (Array.isArray(childObject) && isEmptyArray(childObject)))) {
          unset(object, paths.slice(0, -1));
      }
      return object;
  }

  function createSubject() {
      let _observers = [];
      const next = (value) => {
          for (const observer of _observers) {
              observer.next && observer.next(value);
          }
      };
      const subscribe = (observer) => {
          _observers.push(observer);
          return {
              unsubscribe: () => {
                  _observers = _observers.filter((o) => o !== observer);
              },
          };
      };
      const unsubscribe = () => {
          _observers = [];
      };
      return {
          get observers() {
              return _observers;
          },
          next,
          subscribe,
          unsubscribe,
      };
  }

  var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

  function deepEqual(object1, object2) {
      if (isPrimitive(object1) || isPrimitive(object2)) {
          return object1 === object2;
      }
      if (isDateObject(object1) && isDateObject(object2)) {
          return object1.getTime() === object2.getTime();
      }
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);
      if (keys1.length !== keys2.length) {
          return false;
      }
      for (const key of keys1) {
          const val1 = object1[key];
          if (!keys2.includes(key)) {
              return false;
          }
          if (key !== 'ref') {
              const val2 = object2[key];
              if ((isDateObject(val1) && isDateObject(val2)) ||
                  (isObject(val1) && isObject(val2)) ||
                  (Array.isArray(val1) && Array.isArray(val2))
                  ? !deepEqual(val1, val2)
                  : val1 !== val2) {
                  return false;
              }
          }
      }
      return true;
  }

  var isMultipleSelect = (element) => element.type === `select-multiple`;

  var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

  var live = (ref) => isHTMLElement(ref) && ref.isConnected;

  var objectHasFunction = (data) => {
      for (const key in data) {
          if (isFunction(data[key])) {
              return true;
          }
      }
      return false;
  };

  function markFieldsDirty(data, fields = {}) {
      const isParentNodeArray = Array.isArray(data);
      if (isObject(data) || isParentNodeArray) {
          for (const key in data) {
              if (Array.isArray(data[key]) ||
                  (isObject(data[key]) && !objectHasFunction(data[key]))) {
                  fields[key] = Array.isArray(data[key]) ? [] : {};
                  markFieldsDirty(data[key], fields[key]);
              }
              else if (!isNullOrUndefined(data[key])) {
                  fields[key] = true;
              }
          }
      }
      return fields;
  }
  function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
      const isParentNodeArray = Array.isArray(data);
      if (isObject(data) || isParentNodeArray) {
          for (const key in data) {
              if (Array.isArray(data[key]) ||
                  (isObject(data[key]) && !objectHasFunction(data[key]))) {
                  if (isUndefined(formValues) ||
                      isPrimitive(dirtyFieldsFromValues[key])) {
                      dirtyFieldsFromValues[key] = Array.isArray(data[key])
                          ? markFieldsDirty(data[key], [])
                          : { ...markFieldsDirty(data[key]) };
                  }
                  else {
                      getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                  }
              }
              else {
                  dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
              }
          }
      }
      return dirtyFieldsFromValues;
  }
  var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

  var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
      ? value
      : valueAsNumber
          ? value === ''
              ? NaN
              : value
                  ? +value
                  : value
          : valueAsDate && isString(value)
              ? new Date(value)
              : setValueAs
                  ? setValueAs(value)
                  : value;

  function getFieldValue(_f) {
      const ref = _f.ref;
      if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
          return;
      }
      if (isFileInput(ref)) {
          return ref.files;
      }
      if (isRadioInput(ref)) {
          return getRadioValue(_f.refs).value;
      }
      if (isMultipleSelect(ref)) {
          return [...ref.selectedOptions].map(({ value }) => value);
      }
      if (isCheckBoxInput(ref)) {
          return getCheckboxValue(_f.refs).value;
      }
      return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
  }

  var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
      const fields = {};
      for (const name of fieldsNames) {
          const field = get(_fields, name);
          field && set(fields, name, field._f);
      }
      return {
          criteriaMode,
          names: [...fieldsNames],
          fields,
          shouldUseNativeValidation,
      };
  };

  var getRuleValue = (rule) => isUndefined(rule)
      ? rule
      : isRegex(rule)
          ? rule.source
          : isObject(rule)
              ? isRegex(rule.value)
                  ? rule.value.source
                  : rule.value
              : rule;

  var hasValidation = (options) => options.mount &&
      (options.required ||
          options.min ||
          options.max ||
          options.maxLength ||
          options.minLength ||
          options.pattern ||
          options.validate);

  function schemaErrorLookup(errors, _fields, name) {
      const error = get(errors, name);
      if (error || isKey(name)) {
          return {
              error,
              name,
          };
      }
      const names = name.split('.');
      while (names.length) {
          const fieldName = names.join('.');
          const field = get(_fields, fieldName);
          const foundError = get(errors, fieldName);
          if (field && !Array.isArray(field) && name !== fieldName) {
              return { name };
          }
          if (foundError && foundError.type) {
              return {
                  name: fieldName,
                  error: foundError,
              };
          }
          names.pop();
      }
      return {
          name,
      };
  }

  var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
      if (mode.isOnAll) {
          return false;
      }
      else if (!isSubmitted && mode.isOnTouch) {
          return !(isTouched || isBlurEvent);
      }
      else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
          return !isBlurEvent;
      }
      else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
          return isBlurEvent;
      }
      return true;
  };

  var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

  const defaultOptions = {
      mode: VALIDATION_MODE.onSubmit,
      reValidateMode: VALIDATION_MODE.onChange,
      shouldFocusError: true,
  };
  function createFormControl(props = {}, flushRootRender) {
      let _options = {
          ...defaultOptions,
          ...props,
      };
      let _formState = {
          submitCount: 0,
          isDirty: false,
          isLoading: isFunction(_options.defaultValues),
          isValidating: false,
          isSubmitted: false,
          isSubmitting: false,
          isSubmitSuccessful: false,
          isValid: false,
          touchedFields: {},
          dirtyFields: {},
          errors: {},
      };
      let _fields = {};
      let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values)
          ? cloneObject(_options.defaultValues || _options.values) || {}
          : {};
      let _formValues = _options.shouldUnregister
          ? {}
          : cloneObject(_defaultValues);
      let _state = {
          action: false,
          mount: false,
          watch: false,
      };
      let _names = {
          mount: new Set(),
          unMount: new Set(),
          array: new Set(),
          watch: new Set(),
      };
      let delayErrorCallback;
      let timer = 0;
      const _proxyFormState = {
          isDirty: false,
          dirtyFields: false,
          touchedFields: false,
          isValidating: false,
          isValid: false,
          errors: false,
      };
      const _subjects = {
          values: createSubject(),
          array: createSubject(),
          state: createSubject(),
      };
      const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
      const validationModeBeforeSubmit = getValidationModes(_options.mode);
      const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
      const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
      const debounce = (callback) => (wait) => {
          clearTimeout(timer);
          timer = setTimeout(callback, wait);
      };
      const _updateValid = async (shouldUpdateValid) => {
          if (_proxyFormState.isValid || shouldUpdateValid) {
              const isValid = _options.resolver
                  ? isEmptyObject((await _executeSchema()).errors)
                  : await executeBuiltInValidation(_fields, true);
              if (isValid !== _formState.isValid) {
                  _subjects.state.next({
                      isValid,
                  });
              }
          }
      };
      const _updateIsValidating = (value) => _proxyFormState.isValidating &&
          _subjects.state.next({
              isValidating: value,
          });
      const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
          if (args && method) {
              _state.action = true;
              if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                  const fieldValues = method(get(_fields, name), args.argA, args.argB);
                  shouldSetValues && set(_fields, name, fieldValues);
              }
              if (shouldUpdateFieldsAndState &&
                  Array.isArray(get(_formState.errors, name))) {
                  const errors = method(get(_formState.errors, name), args.argA, args.argB);
                  shouldSetValues && set(_formState.errors, name, errors);
                  unsetEmptyArray(_formState.errors, name);
              }
              if (_proxyFormState.touchedFields &&
                  shouldUpdateFieldsAndState &&
                  Array.isArray(get(_formState.touchedFields, name))) {
                  const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                  shouldSetValues && set(_formState.touchedFields, name, touchedFields);
              }
              if (_proxyFormState.dirtyFields) {
                  _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
              }
              _subjects.state.next({
                  name,
                  isDirty: _getDirty(name, values),
                  dirtyFields: _formState.dirtyFields,
                  errors: _formState.errors,
                  isValid: _formState.isValid,
              });
          }
          else {
              set(_formValues, name, values);
          }
      };
      const updateErrors = (name, error) => {
          set(_formState.errors, name, error);
          _subjects.state.next({
              errors: _formState.errors,
          });
      };
      const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
          const field = get(_fields, name);
          if (field) {
              const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
              isUndefined(defaultValue) ||
                  (ref && ref.defaultChecked) ||
                  shouldSkipSetValueAs
                  ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                  : setFieldValue(name, defaultValue);
              _state.mount && _updateValid();
          }
      };
      const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
          let shouldUpdateField = false;
          let isPreviousDirty = false;
          const output = {
              name,
          };
          if (!isBlurEvent || shouldDirty) {
              if (_proxyFormState.isDirty) {
                  isPreviousDirty = _formState.isDirty;
                  _formState.isDirty = output.isDirty = _getDirty();
                  shouldUpdateField = isPreviousDirty !== output.isDirty;
              }
              const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
              isPreviousDirty = get(_formState.dirtyFields, name);
              isCurrentFieldPristine
                  ? unset(_formState.dirtyFields, name)
                  : set(_formState.dirtyFields, name, true);
              output.dirtyFields = _formState.dirtyFields;
              shouldUpdateField =
                  shouldUpdateField ||
                      (_proxyFormState.dirtyFields &&
                          isPreviousDirty !== !isCurrentFieldPristine);
          }
          if (isBlurEvent) {
              const isPreviousFieldTouched = get(_formState.touchedFields, name);
              if (!isPreviousFieldTouched) {
                  set(_formState.touchedFields, name, isBlurEvent);
                  output.touchedFields = _formState.touchedFields;
                  shouldUpdateField =
                      shouldUpdateField ||
                          (_proxyFormState.touchedFields &&
                              isPreviousFieldTouched !== isBlurEvent);
              }
          }
          shouldUpdateField && shouldRender && _subjects.state.next(output);
          return shouldUpdateField ? output : {};
      };
      const shouldRenderByError = (name, isValid, error, fieldState) => {
          const previousFieldError = get(_formState.errors, name);
          const shouldUpdateValid = _proxyFormState.isValid &&
              isBoolean(isValid) &&
              _formState.isValid !== isValid;
          if (props.delayError && error) {
              delayErrorCallback = debounce(() => updateErrors(name, error));
              delayErrorCallback(props.delayError);
          }
          else {
              clearTimeout(timer);
              delayErrorCallback = null;
              error
                  ? set(_formState.errors, name, error)
                  : unset(_formState.errors, name);
          }
          if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
              !isEmptyObject(fieldState) ||
              shouldUpdateValid) {
              const updatedFormState = {
                  ...fieldState,
                  ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                  errors: _formState.errors,
                  name,
              };
              _formState = {
                  ..._formState,
                  ...updatedFormState,
              };
              _subjects.state.next(updatedFormState);
          }
          _updateIsValidating(false);
      };
      const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
      const executeSchemaAndUpdateState = async (names) => {
          const { errors } = await _executeSchema(names);
          if (names) {
              for (const name of names) {
                  const error = get(errors, name);
                  error
                      ? set(_formState.errors, name, error)
                      : unset(_formState.errors, name);
              }
          }
          else {
              _formState.errors = errors;
          }
          return errors;
      };
      const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
          valid: true,
      }) => {
          for (const name in fields) {
              const field = fields[name];
              if (field) {
                  const { _f, ...fieldValue } = field;
                  if (_f) {
                      const isFieldArrayRoot = _names.array.has(_f.name);
                      const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                      if (fieldError[_f.name]) {
                          context.valid = false;
                          if (shouldOnlyCheckValid) {
                              break;
                          }
                      }
                      !shouldOnlyCheckValid &&
                          (get(fieldError, _f.name)
                              ? isFieldArrayRoot
                                  ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                  : set(_formState.errors, _f.name, fieldError[_f.name])
                              : unset(_formState.errors, _f.name));
                  }
                  fieldValue &&
                      (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
              }
          }
          return context.valid;
      };
      const _removeUnmounted = () => {
          for (const name of _names.unMount) {
              const field = get(_fields, name);
              field &&
                  (field._f.refs
                      ? field._f.refs.every((ref) => !live(ref))
                      : !live(field._f.ref)) &&
                  unregister(name);
          }
          _names.unMount = new Set();
      };
      const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
          !deepEqual(getValues(), _defaultValues));
      const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
          ...(_state.mount
              ? _formValues
              : isUndefined(defaultValue)
                  ? _defaultValues
                  : isString(names)
                      ? { [names]: defaultValue }
                      : defaultValue),
      }, isGlobal, defaultValue);
      const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
      const setFieldValue = (name, value, options = {}) => {
          const field = get(_fields, name);
          let fieldValue = value;
          if (field) {
              const fieldReference = field._f;
              if (fieldReference) {
                  !fieldReference.disabled &&
                      set(_formValues, name, getFieldValueAs(value, fieldReference));
                  fieldValue =
                      isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                          ? ''
                          : value;
                  if (isMultipleSelect(fieldReference.ref)) {
                      [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                  }
                  else if (fieldReference.refs) {
                      if (isCheckBoxInput(fieldReference.ref)) {
                          fieldReference.refs.length > 1
                              ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                  (checkboxRef.checked = Array.isArray(fieldValue)
                                      ? !!fieldValue.find((data) => data === checkboxRef.value)
                                      : fieldValue === checkboxRef.value))
                              : fieldReference.refs[0] &&
                                  (fieldReference.refs[0].checked = !!fieldValue);
                      }
                      else {
                          fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                      }
                  }
                  else if (isFileInput(fieldReference.ref)) {
                      fieldReference.ref.value = '';
                  }
                  else {
                      fieldReference.ref.value = fieldValue;
                      if (!fieldReference.ref.type) {
                          _subjects.values.next({
                              name,
                              values: { ..._formValues },
                          });
                      }
                  }
              }
          }
          (options.shouldDirty || options.shouldTouch) &&
              updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
          options.shouldValidate && trigger(name);
      };
      const setValues = (name, value, options) => {
          for (const fieldKey in value) {
              const fieldValue = value[fieldKey];
              const fieldName = `${name}.${fieldKey}`;
              const field = get(_fields, fieldName);
              (_names.array.has(name) ||
                  !isPrimitive(fieldValue) ||
                  (field && !field._f)) &&
                  !isDateObject(fieldValue)
                  ? setValues(fieldName, fieldValue, options)
                  : setFieldValue(fieldName, fieldValue, options);
          }
      };
      const setValue = (name, value, options = {}) => {
          const field = get(_fields, name);
          const isFieldArray = _names.array.has(name);
          const cloneValue = cloneObject(value);
          set(_formValues, name, cloneValue);
          if (isFieldArray) {
              _subjects.array.next({
                  name,
                  values: { ..._formValues },
              });
              if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                  options.shouldDirty) {
                  _subjects.state.next({
                      name,
                      dirtyFields: getDirtyFields(_defaultValues, _formValues),
                      isDirty: _getDirty(name, cloneValue),
                  });
              }
          }
          else {
              field && !field._f && !isNullOrUndefined(cloneValue)
                  ? setValues(name, cloneValue, options)
                  : setFieldValue(name, cloneValue, options);
          }
          isWatched(name, _names) && _subjects.state.next({ ..._formState });
          _subjects.values.next({
              name,
              values: { ..._formValues },
          });
          !_state.mount && flushRootRender();
      };
      const onChange = async (event) => {
          const target = event.target;
          let name = target.name;
          let isFieldValueUpdated = true;
          const field = get(_fields, name);
          const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
          if (field) {
              let error;
              let isValid;
              const fieldValue = getCurrentFieldValue();
              const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
              const shouldSkipValidation = (!hasValidation(field._f) &&
                  !_options.resolver &&
                  !get(_formState.errors, name) &&
                  !field._f.deps) ||
                  skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
              const watched = isWatched(name, _names, isBlurEvent);
              set(_formValues, name, fieldValue);
              if (isBlurEvent) {
                  field._f.onBlur && field._f.onBlur(event);
                  delayErrorCallback && delayErrorCallback(0);
              }
              else if (field._f.onChange) {
                  field._f.onChange(event);
              }
              const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
              const shouldRender = !isEmptyObject(fieldState) || watched;
              !isBlurEvent &&
                  _subjects.values.next({
                      name,
                      type: event.type,
                      values: { ..._formValues },
                  });
              if (shouldSkipValidation) {
                  _proxyFormState.isValid && _updateValid();
                  return (shouldRender &&
                      _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
              }
              !isBlurEvent && watched && _subjects.state.next({ ..._formState });
              _updateIsValidating(true);
              if (_options.resolver) {
                  const { errors } = await _executeSchema([name]);
                  const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                  const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                  error = errorLookupResult.error;
                  name = errorLookupResult.name;
                  isValid = isEmptyObject(errors);
              }
              else {
                  error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                  isFieldValueUpdated =
                      isNaN(fieldValue) ||
                          fieldValue === get(_formValues, name, fieldValue);
                  if (isFieldValueUpdated) {
                      if (error) {
                          isValid = false;
                      }
                      else if (_proxyFormState.isValid) {
                          isValid = await executeBuiltInValidation(_fields, true);
                      }
                  }
              }
              if (isFieldValueUpdated) {
                  field._f.deps &&
                      trigger(field._f.deps);
                  shouldRenderByError(name, isValid, error, fieldState);
              }
          }
      };
      const trigger = async (name, options = {}) => {
          let isValid;
          let validationResult;
          const fieldNames = convertToArrayPayload(name);
          _updateIsValidating(true);
          if (_options.resolver) {
              const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
              isValid = isEmptyObject(errors);
              validationResult = name
                  ? !fieldNames.some((name) => get(errors, name))
                  : isValid;
          }
          else if (name) {
              validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                  const field = get(_fields, fieldName);
                  return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
              }))).every(Boolean);
              !(!validationResult && !_formState.isValid) && _updateValid();
          }
          else {
              validationResult = isValid = await executeBuiltInValidation(_fields);
          }
          _subjects.state.next({
              ...(!isString(name) ||
                  (_proxyFormState.isValid && isValid !== _formState.isValid)
                  ? {}
                  : { name }),
              ...(_options.resolver || !name ? { isValid } : {}),
              errors: _formState.errors,
              isValidating: false,
          });
          options.shouldFocus &&
              !validationResult &&
              focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
          return validationResult;
      };
      const getValues = (fieldNames) => {
          const values = {
              ..._defaultValues,
              ...(_state.mount ? _formValues : {}),
          };
          return isUndefined(fieldNames)
              ? values
              : isString(fieldNames)
                  ? get(values, fieldNames)
                  : fieldNames.map((name) => get(values, name));
      };
      const getFieldState = (name, formState) => ({
          invalid: !!get((formState || _formState).errors, name),
          isDirty: !!get((formState || _formState).dirtyFields, name),
          isTouched: !!get((formState || _formState).touchedFields, name),
          error: get((formState || _formState).errors, name),
      });
      const clearErrors = (name) => {
          name &&
              convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
          _subjects.state.next({
              errors: name ? _formState.errors : {},
          });
      };
      const setError = (name, error, options) => {
          const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
          set(_formState.errors, name, {
              ...error,
              ref,
          });
          _subjects.state.next({
              name,
              errors: _formState.errors,
              isValid: false,
          });
          options && options.shouldFocus && ref && ref.focus && ref.focus();
      };
      const watch = (name, defaultValue) => isFunction(name)
          ? _subjects.values.subscribe({
              next: (payload) => name(_getWatch(undefined, defaultValue), payload),
          })
          : _getWatch(name, defaultValue, true);
      const unregister = (name, options = {}) => {
          for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
              _names.mount.delete(fieldName);
              _names.array.delete(fieldName);
              if (!options.keepValue) {
                  unset(_fields, fieldName);
                  unset(_formValues, fieldName);
              }
              !options.keepError && unset(_formState.errors, fieldName);
              !options.keepDirty && unset(_formState.dirtyFields, fieldName);
              !options.keepTouched && unset(_formState.touchedFields, fieldName);
              !_options.shouldUnregister &&
                  !options.keepDefaultValue &&
                  unset(_defaultValues, fieldName);
          }
          _subjects.values.next({
              values: { ..._formValues },
          });
          _subjects.state.next({
              ..._formState,
              ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
          });
          !options.keepIsValid && _updateValid();
      };
      const _updateDisabledField = ({ disabled, name, field, fields, }) => {
          if (isBoolean(disabled)) {
              const value = disabled
                  ? undefined
                  : get(_formValues, name, getFieldValue(field ? field._f : get(fields, name)._f));
              set(_formValues, name, value);
              updateTouchAndDirty(name, value, false, false, true);
          }
      };
      const register = (name, options = {}) => {
          let field = get(_fields, name);
          const disabledIsDefined = isBoolean(options.disabled);
          set(_fields, name, {
              ...(field || {}),
              _f: {
                  ...(field && field._f ? field._f : { ref: { name } }),
                  name,
                  mount: true,
                  ...options,
              },
          });
          _names.mount.add(name);
          if (field) {
              _updateDisabledField({
                  field,
                  disabled: options.disabled,
                  name,
              });
          }
          else {
              updateValidAndValue(name, true, options.value);
          }
          return {
              ...(disabledIsDefined ? { disabled: options.disabled } : {}),
              ...(_options.progressive
                  ? {
                      required: !!options.required,
                      min: getRuleValue(options.min),
                      max: getRuleValue(options.max),
                      minLength: getRuleValue(options.minLength),
                      maxLength: getRuleValue(options.maxLength),
                      pattern: getRuleValue(options.pattern),
                  }
                  : {}),
              name,
              onChange,
              onBlur: onChange,
              ref: (ref) => {
                  if (ref) {
                      register(name, options);
                      field = get(_fields, name);
                      const fieldRef = isUndefined(ref.value)
                          ? ref.querySelectorAll
                              ? ref.querySelectorAll('input,select,textarea')[0] || ref
                              : ref
                          : ref;
                      const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                      const refs = field._f.refs || [];
                      if (radioOrCheckbox
                          ? refs.find((option) => option === fieldRef)
                          : fieldRef === field._f.ref) {
                          return;
                      }
                      set(_fields, name, {
                          _f: {
                              ...field._f,
                              ...(radioOrCheckbox
                                  ? {
                                      refs: [
                                          ...refs.filter(live),
                                          fieldRef,
                                          ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                      ],
                                      ref: { type: fieldRef.type, name },
                                  }
                                  : { ref: fieldRef }),
                          },
                      });
                      updateValidAndValue(name, false, undefined, fieldRef);
                  }
                  else {
                      field = get(_fields, name, {});
                      if (field._f) {
                          field._f.mount = false;
                      }
                      (_options.shouldUnregister || options.shouldUnregister) &&
                          !(isNameInFieldArray(_names.array, name) && _state.action) &&
                          _names.unMount.add(name);
                  }
              },
          };
      };
      const _focusError = () => _options.shouldFocusError &&
          focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
      const handleSubmit = (onValid, onInvalid) => async (e) => {
          if (e) {
              e.preventDefault && e.preventDefault();
              e.persist && e.persist();
          }
          let fieldValues = cloneObject(_formValues);
          _subjects.state.next({
              isSubmitting: true,
          });
          if (_options.resolver) {
              const { errors, values } = await _executeSchema();
              _formState.errors = errors;
              fieldValues = values;
          }
          else {
              await executeBuiltInValidation(_fields);
          }
          unset(_formState.errors, 'root');
          if (isEmptyObject(_formState.errors)) {
              _subjects.state.next({
                  errors: {},
              });
              await onValid(fieldValues, e);
          }
          else {
              if (onInvalid) {
                  await onInvalid({ ..._formState.errors }, e);
              }
              _focusError();
              setTimeout(_focusError);
          }
          _subjects.state.next({
              isSubmitted: true,
              isSubmitting: false,
              isSubmitSuccessful: isEmptyObject(_formState.errors),
              submitCount: _formState.submitCount + 1,
              errors: _formState.errors,
          });
      };
      const resetField = (name, options = {}) => {
          if (get(_fields, name)) {
              if (isUndefined(options.defaultValue)) {
                  setValue(name, get(_defaultValues, name));
              }
              else {
                  setValue(name, options.defaultValue);
                  set(_defaultValues, name, options.defaultValue);
              }
              if (!options.keepTouched) {
                  unset(_formState.touchedFields, name);
              }
              if (!options.keepDirty) {
                  unset(_formState.dirtyFields, name);
                  _formState.isDirty = options.defaultValue
                      ? _getDirty(name, get(_defaultValues, name))
                      : _getDirty();
              }
              if (!options.keepError) {
                  unset(_formState.errors, name);
                  _proxyFormState.isValid && _updateValid();
              }
              _subjects.state.next({ ..._formState });
          }
      };
      const _reset = (formValues, keepStateOptions = {}) => {
          const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
          const cloneUpdatedValues = cloneObject(updatedValues);
          const values = formValues && !isEmptyObject(formValues)
              ? cloneUpdatedValues
              : _defaultValues;
          if (!keepStateOptions.keepDefaultValues) {
              _defaultValues = updatedValues;
          }
          if (!keepStateOptions.keepValues) {
              if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
                  for (const fieldName of _names.mount) {
                      get(_formState.dirtyFields, fieldName)
                          ? set(values, fieldName, get(_formValues, fieldName))
                          : setValue(fieldName, get(values, fieldName));
                  }
              }
              else {
                  if (isWeb && isUndefined(formValues)) {
                      for (const name of _names.mount) {
                          const field = get(_fields, name);
                          if (field && field._f) {
                              const fieldReference = Array.isArray(field._f.refs)
                                  ? field._f.refs[0]
                                  : field._f.ref;
                              if (isHTMLElement(fieldReference)) {
                                  const form = fieldReference.closest('form');
                                  if (form) {
                                      form.reset();
                                      break;
                                  }
                              }
                          }
                      }
                  }
                  _fields = {};
              }
              _formValues = props.shouldUnregister
                  ? keepStateOptions.keepDefaultValues
                      ? cloneObject(_defaultValues)
                      : {}
                  : cloneObject(values);
              _subjects.array.next({
                  values: { ...values },
              });
              _subjects.values.next({
                  values: { ...values },
              });
          }
          _names = {
              mount: new Set(),
              unMount: new Set(),
              array: new Set(),
              watch: new Set(),
              watchAll: false,
              focus: '',
          };
          !_state.mount && flushRootRender();
          _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
          _state.watch = !!props.shouldUnregister;
          _subjects.state.next({
              submitCount: keepStateOptions.keepSubmitCount
                  ? _formState.submitCount
                  : 0,
              isDirty: keepStateOptions.keepDirty
                  ? _formState.isDirty
                  : !!(keepStateOptions.keepDefaultValues &&
                      !deepEqual(formValues, _defaultValues)),
              isSubmitted: keepStateOptions.keepIsSubmitted
                  ? _formState.isSubmitted
                  : false,
              dirtyFields: keepStateOptions.keepDirtyValues
                  ? _formState.dirtyFields
                  : keepStateOptions.keepDefaultValues && formValues
                      ? getDirtyFields(_defaultValues, formValues)
                      : {},
              touchedFields: keepStateOptions.keepTouched
                  ? _formState.touchedFields
                  : {},
              errors: keepStateOptions.keepErrors ? _formState.errors : {},
              isSubmitting: false,
              isSubmitSuccessful: false,
          });
      };
      const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
          ? formValues(_formValues)
          : formValues, keepStateOptions);
      const setFocus = (name, options = {}) => {
          const field = get(_fields, name);
          const fieldReference = field && field._f;
          if (fieldReference) {
              const fieldRef = fieldReference.refs
                  ? fieldReference.refs[0]
                  : fieldReference.ref;
              if (fieldRef.focus) {
                  fieldRef.focus();
                  options.shouldSelect && fieldRef.select();
              }
          }
      };
      const _updateFormState = (updatedFormState) => {
          _formState = {
              ..._formState,
              ...updatedFormState,
          };
      };
      const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
          _options.defaultValues().then((values) => {
              reset(values, _options.resetOptions);
              _subjects.state.next({
                  isLoading: false,
              });
          });
      return {
          control: {
              register,
              unregister,
              getFieldState,
              handleSubmit,
              setError,
              _executeSchema,
              _getWatch,
              _getDirty,
              _updateValid,
              _removeUnmounted,
              _updateFieldArray,
              _updateDisabledField,
              _getFieldArray,
              _reset,
              _resetDefaultValues,
              _updateFormState,
              _subjects,
              _proxyFormState,
              get _fields() {
                  return _fields;
              },
              get _formValues() {
                  return _formValues;
              },
              get _state() {
                  return _state;
              },
              set _state(value) {
                  _state = value;
              },
              get _defaultValues() {
                  return _defaultValues;
              },
              get _names() {
                  return _names;
              },
              set _names(value) {
                  _names = value;
              },
              get _formState() {
                  return _formState;
              },
              set _formState(value) {
                  _formState = value;
              },
              get _options() {
                  return _options;
              },
              set _options(value) {
                  _options = {
                      ..._options,
                      ...value,
                  };
              },
          },
          trigger,
          register,
          handleSubmit,
          watch,
          setValue,
          getValues,
          reset,
          resetField,
          clearErrors,
          unregister,
          setError,
          setFocus,
          getFieldState,
      };
  }

  /**
   * Custom hook to manage the entire form.
   *
   * @remarks
   * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
   *
   * @param props - form configuration and validation parameters.
   *
   * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
   *
   * @example
   * ```tsx
   * function App() {
   *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
   *   const onSubmit = data => console.log(data);
   *
   *   console.log(watch("example"));
   *
   *   return (
   *     <form onSubmit={handleSubmit(onSubmit)}>
   *       <input defaultValue="test" {...register("example")} />
   *       <input {...register("exampleRequired", { required: true })} />
   *       {errors.exampleRequired && <span>This field is required</span>}
   *       <button>Submit</button>
   *     </form>
   *   );
   * }
   * ```
   */
  function useForm(props = {}) {
      const _formControl = React__default.useRef();
      const _values = React__default.useRef();
      const [formState, updateFormState] = React__default.useState({
          isDirty: false,
          isValidating: false,
          isLoading: isFunction(props.defaultValues),
          isSubmitted: false,
          isSubmitting: false,
          isSubmitSuccessful: false,
          isValid: false,
          submitCount: 0,
          dirtyFields: {},
          touchedFields: {},
          errors: {},
          defaultValues: isFunction(props.defaultValues)
              ? undefined
              : props.defaultValues,
      });
      if (!_formControl.current) {
          _formControl.current = {
              ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
              formState,
          };
      }
      const control = _formControl.current.control;
      control._options = props;
      useSubscribe({
          subject: control._subjects.state,
          next: (value) => {
              if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                  updateFormState({ ...control._formState });
              }
          },
      });
      React__default.useEffect(() => {
          if (props.values && !deepEqual(props.values, _values.current)) {
              control._reset(props.values, control._options.resetOptions);
              _values.current = props.values;
          }
          else {
              control._resetDefaultValues();
          }
      }, [props.values, control]);
      React__default.useEffect(() => {
          if (!control._state.mount) {
              control._updateValid();
              control._state.mount = true;
          }
          if (control._state.watch) {
              control._state.watch = false;
              control._subjects.state.next({ ...control._formState });
          }
          control._removeUnmounted();
      });
      _formControl.current.formState = getProxyFormState(formState, control);
      return _formControl.current;
  }

  var _excluded$8 = ["ref"];

  var _templateObject$R, _templateObject2$d;
  var OptionsRow = styled__default.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n"])));
  var Options = styled__default.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  flex-basis: 60%;\n"])));

  var CommunicationPreferenceOptionsRenderer = function CommunicationPreferenceOptionsRenderer(_ref) {
    var control = _ref.control,
        name = _ref.name,
        isDisabled = _ref.isDisabled,
        options = _ref.options,
        defaultValue = _ref.defaultValue,
        setValue = _ref.setValue;

    var _useController = useController({
      name: name,
      control: control,
      defaultValue: defaultValue
    }),
        _useController$field = _useController.field,
        ref = _useController$field.ref,
        inputProps = _objectWithoutProperties(_useController$field, _excluded$8),
        _useController$fieldS = _useController.fieldState,
        invalid = _useController$fieldS.invalid,
        error = _useController$fieldS.error;

    React.useEffect(function () {
      if (defaultValue) {
        setValue(name, defaultValue);
      }
    }, [defaultValue, name, setValue]);
    return /*#__PURE__*/React__default.createElement(OptionsRow, null, /*#__PURE__*/React__default.createElement(Options, null, options.map(function (option) {
      return /*#__PURE__*/React__default.createElement(RadioButtonLabel, {
        key: option.value,
        htmlFor: option.value
      }, /*#__PURE__*/React__default.createElement(RadioButtonInput, _extends({
        id: option.value,
        ref: ref,
        type: "radio",
        name: name,
        defaultChecked: inputProps.value === option.value.toString()
      }, inputProps, {
        disabled: isDisabled,
        value: option.value
      })), /*#__PURE__*/React__default.createElement(RadioButtonCircle, null, /*#__PURE__*/React__default.createElement(RadioButtonCircleInner, null)), /*#__PURE__*/React__default.createElement(RadioButtonText, null, option.label));
    })), invalid && /*#__PURE__*/React__default.createElement("span", {
      className: "form__error"
    }, error === null || error === void 0 ? void 0 : error.message));
  };

  var _templateObject$S, _templateObject2$e;
  var SectionContainer = styled__default.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  border-top: flex 1px solid ", ";\n  border-top-width: calc(100% - 50px);\n  padding: 5px 10px;\n"])), function (props) {
    return props.theme.colors.primary;
  });
  var SectionHeading = styled__default.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  padding: 5px 10px;\n"])));

  var CommunicationPreferenceSection = function CommunicationPreferenceSection(_ref) {
    var section_heading = _ref.section_heading,
        description = _ref.description,
        control = _ref.control,
        name = _ref.name,
        isDisabled = _ref.isDisabled,
        options = _ref.options,
        defaultValue = _ref.defaultValue,
        setValue = _ref.setValue;
    return /*#__PURE__*/React__default.createElement(SectionContainer, null, /*#__PURE__*/React__default.createElement(SectionHeading, null, section_heading), /*#__PURE__*/React__default.createElement(CommunicationPreferenceOptionsRenderer, {
      description: description,
      control: control,
      name: name,
      isDisabled: isDisabled,
      options: options,
      defaultValue: defaultValue,
      setValue: setValue
    }));
  };

  var CommunicationPreferenceSection$1 = themed(CommunicationPreferenceSection);

  var _templateObject$T, _templateObject2$f, _templateObject3$8;
  var CommunicationPreferenceContainer = styled__default.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  border: solid 1px #d1d5dbff;\n  margin-bottom: 40px;\n"])));
  var EditButtonRow = styled__default.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: end;\n  padding: 10px 5px;\n  margin-right: 16px;\n"])));
  var SubmitButton = styled__default.input(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  flex-basis: 15%;\n  margin-right: 5px;\n"])));
  var BaseRequest = {
    loading: false,
    success: false,
    failed: false
  };

  var CommunicationPreferences = function CommunicationPreferences(_ref) {
    var header = _ref.header,
        requestInstance = _ref.requestInstance,
        updateNotificationsApi = _ref.updateNotificationsApi,
        preferenceData = _ref.preferenceData,
        btnClassName = _ref.btnClassName;

    var _useForm = useForm(),
        handleSubmit = _useForm.handleSubmit,
        control = _useForm.control,
        setValue = _useForm.setValue;

    var _useState = React.useState(_objectSpread2({}, BaseRequest)),
        _useState2 = _slicedToArray(_useState, 2),
        requestState = _useState2[0],
        setRequestState = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isEditing = _useState4[0],
        setIsEditing = _useState4[1]; //


    var communicationOptions = [{
      label: 'WhatsApp',
      value: 'WHATSAPP'
    }, {
      label: 'Email',
      value: 'EMAIL'
    }];

    var updateRequestState = function updateRequestState(obj) {
      setRequestState(_objectSpread2(_objectSpread2({}, BaseRequest), obj));
    };

    var onSubmit = function onSubmit(form_data) {
      updateRequestState({
        loading: true
      });
      simpleRequest(requestInstance, updateNotificationsApi, method.POST, form_data, function () {
        updateRequestState({
          success: true,
          loading: false
        });
        success('Communication Preferences Updated.');
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      }, function (data) {
        updateRequestState({
          failed: true,
          loading: false
        });
        var errorMessages = Object.keys(data).map(function (key) {
          return data[key];
        }).flat();
        error(errorMessages.map(function (message, key) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: "error-".concat(key)
          }, message);
        }));
      });
    };

    return /*#__PURE__*/React__default.createElement(React.Fragment, null, requestState.loading && /*#__PURE__*/React__default.createElement(EllipsisLoader, null), header, /*#__PURE__*/React__default.createElement(CommunicationPreferenceContainer, null, /*#__PURE__*/React__default.createElement("form", {
      onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/React__default.createElement(CommunicationPreferenceSection$1, {
      control: control,
      name: "default_communication",
      options: communicationOptions,
      isDisabled: !isEditing,
      defaultValue: preferenceData.default_communication,
      setValue: setValue
    }), isEditing ? /*#__PURE__*/React__default.createElement(EditButtonRow, null, /*#__PURE__*/React__default.createElement(SubmitButton, {
      type: "submit",
      value: "Save",
      className: "".concat(btnClassName !== null && btnClassName !== void 0 ? btnClassName : 'btn--luxity')
    }), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "".concat(btnClassName !== null && btnClassName !== void 0 ? btnClassName : 'btn--luxity'),
      onClick: function onClick() {
        setIsEditing(!isEditing);
      }
    }, "Cancel")) : /*#__PURE__*/React__default.createElement(EditButtonRow, null, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "".concat(btnClassName !== null && btnClassName !== void 0 ? btnClassName : 'btn--luxity'),
      onClick: function onClick() {
        setIsEditing(!isEditing);
      }
    }, "Edit")))));
  };

  var index$5 = themed(CommunicationPreferences);

  var _templateObject$U;
  var FooterWrapper$1 = styled__default.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n   {\n    background-color: ", ";\n  }\n"])), function (props) {
    return props.theme.colors.gray;
  });

  var Event = function Event(instance, track) {
    var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var action = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var label = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var value = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

    if (track) {
      instance.event({
        category: category,
        action: action,
        label: label,
        value: value
      });
    }
  };

  var GALink = function GALink(props) {
    var gaOnClick = function gaOnClick(event) {
      Event(props.instance, props.track, 'Link', "Click on ".concat(props.href), props.label);

      if (typeof props.onClick === 'function') {
        props.onClick(event);
      }
    };

    return /*#__PURE__*/React__default.createElement("a", _extends({
      href: "/"
    }, props, {
      onClick: gaOnClick
    }), props.children);
  };

  var LuxityFooter = function LuxityFooter(_ref) {
    var _ref$showNewsletter = _ref.showNewsletter,
        showNewsletter = _ref$showNewsletter === void 0 ? true : _ref$showNewsletter,
        _ref$buyLinks = _ref.buyLinks,
        buyLinks = _ref$buyLinks === void 0 ? [] : _ref$buyLinks,
        _ref$sellLinks = _ref.sellLinks,
        sellLinks = _ref$sellLinks === void 0 ? [] : _ref$sellLinks,
        _ref$helpLinks = _ref.helpLinks,
        helpLinks = _ref$helpLinks === void 0 ? [] : _ref$helpLinks,
        _ref$companyLinks = _ref.companyLinks,
        companyLinks = _ref$companyLinks === void 0 ? [] : _ref$companyLinks,
        _ref$socialLinks = _ref.socialLinks,
        socialLinks = _ref$socialLinks === void 0 ? [] : _ref$socialLinks,
        _ref$contactLinks = _ref.contactLinks,
        contactLinks = _ref$contactLinks === void 0 ? [] : _ref$contactLinks,
        _ref$quickiesLinks = _ref.quickiesLinks,
        quickiesLinks = _ref$quickiesLinks === void 0 ? [] : _ref$quickiesLinks,
        visaImgSrc = _ref.visaImgSrc,
        masterCardSrc = _ref.masterCardSrc,
        logoSrc = _ref.logoSrc,
        formIconSrc = _ref.formIconSrc,
        onSubmit = _ref.onSubmit;
    var currentYear = new Date().getFullYear();

    var _useForm = useForm(),
        handleSubmit = _useForm.handleSubmit,
        register = _useForm.register,
        errors = _useForm.formState.errors,
        reset = _useForm.reset,
        setError = _useForm.setError;

    var renderLinks = function renderLinks(links, title) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "footer__link-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "footer__link-title"
      }, title), /*#__PURE__*/React__default.createElement("div", {
        className: "footer__links"
      }, !!links.length && links.map(function (link) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "footer__link-wrapper",
          key: link.label
        }, link.icon && /*#__PURE__*/React__default.createElement("img", {
          className: "footer__link-icon",
          src: link.icon,
          alt: link.label
        }), /*#__PURE__*/React__default.createElement(GALink, {
          instance: link.instance,
          href: link.href,
          label: link.label,
          className: "footer__link",
          rel: "noopener noreferrer",
          track: link === null || link === void 0 ? void 0 : link.track,
          target: link.target
        }, link.iconClassName && /*#__PURE__*/React__default.createElement("i", {
          className: link.iconClassName
        }), link.label));
      })));
    };

    var submitForm = function submitForm(data) {
      onSubmit(data).then(function (res) {
        if (res.success) {
          reset();
        } else {
          setError('email', {
            type: 'custom',
            message: res.errorMessage
          });
        }
      });
    };

    return /*#__PURE__*/React__default.createElement(FooterWrapper$1, null, showNewsletter && /*#__PURE__*/React__default.createElement("div", {
      className: "footer__newsletter-section"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__newsletter-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__title-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__newsletter-title"
    }, "Sign up to our news letter"), /*#__PURE__*/React__default.createElement("p", {
      className: "footer__newsletter-text"
    }, "By signing up you agree to our terms & conditions and privacy policy. You can unsubscribe anytime.")), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__newsletter-form"
    }, /*#__PURE__*/React__default.createElement("form", {
      onSubmit: handleSubmit(submitForm)
    }, /*#__PURE__*/React__default.createElement("input", _extends({}, register('email', {
      required: 'The email field is required.',
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        message: 'Invalid email address'
      }
    }), {
      placeholder: "Your Sexy Email",
      className: "footer__form-input"
    })), errors.email && /*#__PURE__*/React__default.createElement("span", {
      className: "footer__form-errors"
    }, errors.email.message), /*#__PURE__*/React__default.createElement("button", {
      type: "submit"
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "footer__newsletter-icon",
      src: formIconSrc,
      alt: "submit"
    })))))), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__wrapper footer__wrapper--desktop"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__main-section"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__logo-wrapper"
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "footer__logo",
      src: logoSrc,
      alt: "luxity-logo"
    })), renderLinks(buyLinks, 'Buy'), /*#__PURE__*/React__default.createElement("div", null, renderLinks(sellLinks, 'Sell'), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__link-child"
    }, renderLinks(companyLinks, 'Company'))), renderLinks(helpLinks, 'Help'), renderLinks(socialLinks, 'Follow us'), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__link-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__link-title"
    }, "Contact"), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__links"
    }, !!contactLinks.map && contactLinks.map(function (link) {
      return !link.isContact ? /*#__PURE__*/React__default.createElement(GALink, {
        key: link.label,
        instance: link.instance,
        href: link.href,
        label: link.label,
        className: "footer__link",
        rel: "noopener noreferrer",
        track: link === null || link === void 0 ? void 0 : link.track,
        target: link.target
      }, link.label) : /*#__PURE__*/React__default.createElement("div", {
        className: "footer__text"
      }, link.label);
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__store-hours"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__text"
    }, "Monday - Friday"), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__text"
    }, "8:30am - 5pm")))), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__copyrights-section"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__payment-icons"
    }, /*#__PURE__*/React__default.createElement("img", {
      alt: "visa",
      src: masterCardSrc
    }), /*#__PURE__*/React__default.createElement("img", {
      src: visaImgSrc,
      alt: "button"
    })), /*#__PURE__*/React__default.createElement("p", {
      className: "footer__copyright"
    }, "Copyright ", currentYear, " | Luxity (Pty) LTD | All Rights Reserved | Website Developed by B Online"))), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__wrapper footer__wrapper--mobile"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__section-row"
    }, renderLinks(quickiesLinks, 'Quickies'), renderLinks(socialLinks, 'Follow us')), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__section-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__link-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__link-title"
    }, "We love..."), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__links"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer__text"
    }, "Visa"), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__text"
    }, "Mastercard"), /*#__PURE__*/React__default.createElement("div", {
      className: "footer__text"
    }, "EFT"))), renderLinks(helpLinks, 'Legal Stuff')), /*#__PURE__*/React__default.createElement("p", {
      className: "footer__copyright footer__copyright--mobile"
    }, "Copyright ", currentYear, " | Luxity (Pty) LTD | All Rights Reserved | Website Developed by B Online")));
  };

  var index$6 = themed(LuxityFooter);

  var getBrands = function getBrands() {
    return {
      query: "{\n        latest_arrivals: luxity_brands(has_products: true, limit: 1000, page: 1, sort_by: \"name|asc\") {data {id name slug}}\n        bags: luxity_brands(has_products: true, limit: 1000, page: 1, category_type: BAGS, sort_by: \"name|asc\") {data {id name slug}}\n        shoes: luxity_brands(has_products: true, limit: 1000, page: 1, category_type: SHOES, sort_by: \"name|asc\") {data {id name slug}}\n        apparel: luxity_brands(has_products: true, limit: 1000, page: 1, category_type: APPAREL, sort_by: \"name|asc\") {data {id name slug}}\n        accessories: luxity_brands(has_products: true, limit: 1000, page: 1, category_type: ACCESSORIES, sort_by: \"name|asc\") {data {id name slug}}\n        watches: luxity_brands(has_products: true, limit: 1000, page: 1, category_type: WATCHES, sort_by: \"name|asc\") {data {id name slug}}\n        accessories_categories: luxity_accessories_categories_list { id name slug }\n        apparel_styles: luxity_apparel_styles_list { name slug }\n      }  "
    };
  };
  var searchProducts = function searchProducts(search, limit) {
    return {
      query: "\n      query SearchProducts($search: String!, $limit: Int!) {\n        luxity_products_serach_results(search: $search, limit: $limit) {\n          brands {\n            name\n            link\n          }\n          products {\n            name\n            link\n          }\n          luxity_product_ids\n        }\n      }\n    ",
      variables: {
        search: search,
        limit: limit
      }
    };
  };

  var Dropdown$1 = function Dropdown(_ref) {
    var title = _ref.title,
        imageSrc = _ref.imageSrc,
        _ref$categoryElements = _ref.categoryElements,
        categoryElements = _ref$categoryElements === void 0 ? [] : _ref$categoryElements,
        _ref$brandElements = _ref.brandElements,
        brandElements = _ref$brandElements === void 0 ? [] : _ref$brandElements,
        productsUrl = _ref.productsUrl,
        categorySlug = _ref.categorySlug,
        categoryTitle = _ref.categoryTitle,
        isLoading = _ref.isLoading,
        hasError = _ref.hasError;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hasError ? /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__errors"
    }, "Failed to load data.") : /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown"
    }, isLoading ? /*#__PURE__*/React__default.createElement("div", {
      className: "cover-spinner"
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__column"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__title"
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__elements dropdown__elements--column"
    }, !!categoryElements.length && categoryElements.map(function (categoryElement) {
      return categoryElement.category ? /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(productsUrl, "/").concat(categoryElement.category, "/").concat(categoryElement === null || categoryElement === void 0 ? void 0 : categoryElement.slug),
        className: "dropdown__element",
        key: categoryElement.name
      }, categoryElement === null || categoryElement === void 0 ? void 0 : categoryElement.name.toLowerCase()) : /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(productsUrl, "/").concat(categoryElement === null || categoryElement === void 0 ? void 0 : categoryElement.slug),
        className: "dropdown__element",
        key: categoryElement.name
      }, categoryElement === null || categoryElement === void 0 ? void 0 : categoryElement.name.toLowerCase());
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__column"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__title"
    }, "Brands"), /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__elements"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/").concat(categorySlug),
      className: "dropdown__element"
    }, "All ", categoryTitle), !!brandElements.length && brandElements.map(function (brand) {
      return /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(productsUrl, "/").concat(categorySlug, "/").concat(brand === null || brand === void 0 ? void 0 : brand.slug),
        className: "dropdown__element",
        key: brand.name
      }, brand === null || brand === void 0 ? void 0 : brand.name);
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "dropdown__column"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: imageSrc,
      alt: "".concat(title)
    })))));
  };

  var StoresDropdown = function StoresDropdown(_ref) {
    var _ref$stores = _ref.stores,
        stores = _ref$stores === void 0 ? [] : _ref$stores,
        contactNumber = _ref.contactNumber;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "stores-dropdown"
    }, !!stores.length && stores.map(function (store) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__store-details",
        key: store.name
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__store-image"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "stores-dropdown__image",
        src: store.image,
        alt: store.name
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__store-info"
      }, /*#__PURE__*/React__default.createElement("h4", {
        className: "stores-dropdown__title"
      }, store.title, " ", /*#__PURE__*/React__default.createElement("br", null), " ", store.location), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-days"
      }, store.regularOpenDays), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-hours"
      }, store.regularOpenHours), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-days"
      }, store.holidayOpenDays), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-hours"
      }, store.holidayOpenHours), (store === null || store === void 0 ? void 0 : store.weekendOpenDays) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-days"
      }, store.weekendOpenDays), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-hours"
      }, store.weekendOpenHours))));
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "stores-dropdown__queries"
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "stores-dropdown__queries-title"
    }, "Customer Queries: "), /*#__PURE__*/React__default.createElement("a", {
      className: "stores-dropdown__contact-details",
      href: "tel:".concat(contactNumber)
    }, contactNumber)));
  };

  var categories$1 = {
    shoes: {
      name: 'Shoes',
      slug: 'shoes'
    },
    bags: {
      name: 'Bags',
      slug: 'bags'
    },
    clothing: {
      name: 'Clothing',
      slug: 'apparel'
    },
    watches: {
      name: 'Watches',
      slug: 'watches'
    },
    accessories: {
      name: 'Accessories',
      slug: 'accessories'
    }
  };

  var removeCategoryByName = function removeCategoryByName(categories, name) {
    var _categories$filter;

    return (_categories$filter = categories === null || categories === void 0 ? void 0 : categories.filter(function (category) {
      return category.name !== name;
    })) !== null && _categories$filter !== void 0 ? _categories$filter : [];
  };

  var SearchResults = function SearchResults(_ref) {
    var searchValue = _ref.searchValue,
        searchLoading = _ref.searchLoading,
        searchResults = _ref.searchResults,
        onViewAll = _ref.onViewAll,
        searchResultsRef = _ref.searchResultsRef,
        onSearchSubmit = _ref.onSearchSubmit,
        setSearchValue = _ref.setSearchValue;

    if (searchValue.trim() !== '') {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "z-50 absolute md:top-14 font-body bg-white w-full lg:w-1/2 flex flex-col md:flex-row md:divide-x divide-black lg:mt-1 shadow-md",
        ref: searchResultsRef
      }, searchLoading ? /*#__PURE__*/React__default.createElement("div", {
        className: "w-full py-20 flex items-center justify-center"
      }, "Searching ...") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, searchResults.brands.length === 0 && searchResults.products.length === 0 ? /*#__PURE__*/React__default.createElement("div", {
        className: "w-full py-20 flex items-center justify-center"
      }, "No products found") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "w-full lg:w-1/3"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "font-bold p-2 px-4"
      }, "Brands"), searchResults.brands.map(function (brand) {
        return /*#__PURE__*/React__default.createElement("a", {
          key: brand.link,
          href: brand.link,
          className: ""
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "p-2 px-4 hover:bg-gray-100"
        }, brand.name));
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "w-full lg:w-2/3"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "font-bold p-2 px-4"
      }, "Products"), searchResults.products.map(function (product) {
        return /*#__PURE__*/React__default.createElement("a", {
          key: product.link,
          href: product.link
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "p-2 px-4 hover:bg-gray-100"
        }, product.name));
      }), /*#__PURE__*/React__default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          onViewAll();
          onSearchSubmit(searchValue);
          setSearchValue('');
        },
        className: "bottom-0 mt-5 py-3 w-full font-body text-center text-white uppercase bg-black hover:bg-gray-950 border border-black transition-all ease-in-out duration-300 cursor-pointer"
      }, "View all")))));
    }

    return null;
  };

  var LuxityDesktopHeader = function LuxityDesktopHeader(_ref) {
    var accountIcon = _ref.accountIcon,
        cartIcon = _ref.cartIcon,
        interestIcon = _ref.interestIcon,
        cartCount = _ref.cartCount,
        logoSrc = _ref.logoSrc,
        categoryElements = _ref.categoryElements,
        newBrandsImage = _ref.newBrandsImage,
        bagsImage = _ref.bagsImage,
        shoesImage = _ref.shoesImage,
        clothingImage = _ref.clothingImage,
        accessoriesImage = _ref.accessoriesImage,
        watchesImage = _ref.watchesImage,
        stores = _ref.stores,
        contactNumber = _ref.contactNumber,
        productsUrl = _ref.productsUrl,
        onInterestClick = _ref.onInterestClick,
        onCartClick = _ref.onCartClick,
        onAccountClick = _ref.onAccountClick,
        inputSearchIcon = _ref.inputSearchIcon,
        onSearch = _ref.onSearch,
        onSellToUsClick = _ref.onSellToUsClick,
        blogLink = _ref.blogLink,
        contactUsLink = _ref.contactUsLink,
        ourStoryLink = _ref.ourStoryLink,
        onLogoClick = _ref.onLogoClick,
        endpoint = _ref.endpoint,
        onSearchSubmit = _ref.onSearchSubmit,
        onProductIdsReceived = _ref.onProductIdsReceived,
        shop = _ref.shop,
        app = _ref.app;

    var _useState = React.useState(''),
        _useState2 = _slicedToArray(_useState, 2),
        searchValue = _useState2[0],
        setSearchValue = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        loading = _useState4[0],
        setLoading = _useState4[1];

    var _useState5 = React.useState({
      latestArrivals: [],
      bags: [],
      shoes: [],
      clothing: [],
      accessories: [],
      watches: [],
      accessoriesCategories: [],
      apparelStyles: []
    }),
        _useState6 = _slicedToArray(_useState5, 2),
        dropdownData = _useState6[0],
        setDropdownData = _useState6[1];

    var _useState7 = React.useState(false),
        _useState8 = _slicedToArray(_useState7, 2),
        hasError = _useState8[0],
        setHasError = _useState8[1];

    var _useState9 = React.useState(true),
        _useState10 = _slicedToArray(_useState9, 2),
        searchLoading = _useState10[0],
        setSearchLoading = _useState10[1];

    var _useState11 = React.useState({
      brands: [],
      products: []
    }),
        _useState12 = _slicedToArray(_useState11, 2),
        searchResults = _useState12[0],
        setSearchResults = _useState12[1];

    var searchResultsRef = React.useRef(null);
    React.useEffect(function () {
      var handleClickOutside = function handleClickOutside(event) {
        if (searchResultsRef.current && !searchResultsRef.current.contains(event.target)) {
          setSearchValue('');
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return function () {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Enter') {
        onSearchSubmit(searchValue);
        setSearchValue('');
      } else if (event.key === 'Escape') {
        setSearchValue('');
      }
    };

    function addCategoryToElements(elements, categoryName) {
      return elements.map(function (element) {
        return _objectSpread2(_objectSpread2({}, element), {}, {
          category: categoryName
        });
      });
    }

    React.useMemo(function () {
      setLoading(true);
      axios.post("".concat(endpoint), getBrands()).then(function (_ref2) {
        var data = _ref2.data;
        setLoading(false);
        setDropdownData(function (prev) {
          return _objectSpread2(_objectSpread2({}, prev), {}, {
            latestArrivals: data.data.latest_arrivals.data,
            bags: data.data.bags.data,
            shoes: data.data.shoes.data,
            apparel: data.data.apparel.data,
            accessories: data.data.accessories.data,
            watches: data.data.watches.data,
            accessoriesCategories: data.data.accessories_categories,
            apparelStyles: data.data.apparel_styles
          });
        });
      }).catch(function () {
        return setHasError(true);
      });
    }, [endpoint]);

    var handleChange = function handleChange(event) {
      var value = event.target.value;
      setSearchValue(value);
      onSearch(value);

      if (value.trim() !== '') {
        setSearchLoading(true);
        axios.post(endpoint, searchProducts(value, 6)).then(function (response) {
          setSearchResults(response.data.data.luxity_products_serach_results);
          var ids = response.data.data.luxity_products_serach_results.luxity_product_ids;
          onProductIdsReceived(ids);
          setSearchLoading(false);
        }).catch(function () {
          setSearchLoading(false);
        });
      } else {
        setSearchResults({
          brands: [],
          products: []
        });
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "navbar"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__logo-wrapper"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: onLogoClick,
      className: "navbar__logo"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: logoSrc,
      alt: "luxity-logo"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__section"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__body"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__product-search"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: inputSearchIcon,
      alt: "search-icon",
      className: "navbar__input-search-icon"
    }), /*#__PURE__*/React__default.createElement("input", {
      className: "navbar__form-input",
      type: "text",
      placeholder: "Search for items and designs",
      value: searchValue,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onClick: onSearch
    })), /*#__PURE__*/React__default.createElement(SearchResults, {
      searchValue: searchValue,
      searchLoading: searchLoading,
      searchResults: searchResults,
      onViewAll: function onViewAll() {
        onSearchSubmit(searchValue);
        setSearchValue('');
      },
      searchResultsRef: searchResultsRef,
      onSearchSubmit: onSearchSubmit,
      setSearchValue: setSearchValue
    }), /*#__PURE__*/React__default.createElement("nav", {
      className: "navbar__nav-links navbar__nav-links--wrap"
    }, /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/brands"),
      className: "navbar__link-item navbar__link-item--desktop"
    }, "New"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
      title: "Department",
      imageSrc: newBrandsImage,
      categoryElements: categoryElements,
      brandElements: dropdownData.latestArrivals,
      productsUrl: productsUrl,
      categorySlug: "brands",
      categoryTitle: "Brands",
      isLoading: loading,
      hasError: hasError
    }))), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/bags"),
      className: "navbar__link-item navbar__link-item--desktop"
    }, "Bags"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
      title: "Department",
      imageSrc: bagsImage,
      categoryElements: addCategoryToElements(categoryElements, categories$1.bags.slug),
      brandElements: dropdownData.bags,
      productsUrl: productsUrl,
      categorySlug: categories$1.bags.slug,
      categoryTitle: categories$1.bags.name,
      isLoading: loading,
      hasError: hasError
    }))), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/shoes"),
      className: "navbar__link-item navbar__link-item--desktop"
    }, "Shoes"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
      title: "Department",
      imageSrc: shoesImage,
      categoryElements: addCategoryToElements(categoryElements, categories$1.shoes.slug),
      brandElements: dropdownData.shoes,
      productsUrl: productsUrl,
      categorySlug: categories$1.shoes.slug,
      categoryTitle: categories$1.shoes.name,
      isLoading: loading,
      hasError: hasError
    }))), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/apparel"),
      className: "navbar__link-item navbar__link-item--desktop"
    }, "Clothing"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
      title: "Department",
      imageSrc: clothingImage,
      categoryElements: dropdownData.apparelStyles,
      brandElements: dropdownData.apparel,
      productsUrl: productsUrl,
      categorySlug: categories$1.clothing.slug,
      categoryTitle: categories$1.clothing.name,
      isLoading: loading,
      hasError: hasError
    }))), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/accessories"),
      className: "navbar__link-item navbar__link-item--desktop"
    }, "Accessories"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
      title: "Categories",
      imageSrc: accessoriesImage,
      categoryElements: removeCategoryByName(dropdownData.accessoriesCategories, 'ACCESSORIES'),
      brandElements: dropdownData.accessories,
      productsUrl: productsUrl,
      categorySlug: categories$1.accessories.slug,
      categoryTitle: categories$1.accessories.name,
      isLoading: loading,
      hasError: hasError
    }))), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productsUrl, "/watches"),
      className: "navbar__link-item navbar__link-item--desktop"
    }, "Watches"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
      title: "Department",
      imageSrc: watchesImage,
      categoryElements: addCategoryToElements(categoryElements, categories$1.watches.slug),
      brandElements: dropdownData.watches,
      productsUrl: productsUrl,
      categorySlug: categories$1.watches.slug,
      categoryTitle: categories$1.watches.name,
      isLoading: loading,
      hasError: hasError
    }))), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "/contact-us",
      className: "navbar__link-item navbar__link-item--desktop"
    }, "Stores"), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__dropdown"
    }, /*#__PURE__*/React__default.createElement(StoresDropdown, {
      stores: stores,
      contactNumber: contactNumber
    }))))), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__icons-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__icons"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "".concat(app ? 'navbar__icon--app' : 'navbar__icon'),
      onClick: onInterestClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: interestIcon,
      alt: "interest-icon"
    })), shop && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "navbar__icon",
      onClick: onAccountClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: accountIcon,
      alt: "account-icon"
    })), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "navbar__cart-icon ".concat(app ? 'navbar__icon--app' : 'navbar__icon'),
      onClick: onCartClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: cartIcon,
      alt: "cart-icon"
    }), shop && /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__cart-count"
    }, cartCount))), /*#__PURE__*/React__default.createElement("nav", {
      className: "navbar__nav-links"
    }, /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__company-link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: ourStoryLink,
      className: "navbar__link-item"
    }, "Our Story")), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__company-link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: blogLink,
      className: "navbar__link-item"
    }, "Blog")), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__company-link"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: contactUsLink,
      className: "navbar__link-item"
    }, "Contact Us")), /*#__PURE__*/React__default.createElement("li", {
      className: "navbar__company-link"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "navbar__company-block",
      onClick: onSellToUsClick
    }, "Sell to us")))))));
  };

  var StoresDropdown$1 = function StoresDropdown(_ref) {
    var backIcon = _ref.backIcon,
        onBackClick = _ref.onBackClick,
        stores = _ref.stores,
        contactUsLink = _ref.contactUsLink;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__sub-menu"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__back-button-wrapper",
      onClick: onBackClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: backIcon,
      alt: "back-icon",
      className: "side-nav__back-icon"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__back-button"
    }, "Back To Menu")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__store-details"
    }, !!stores.length && stores.map(function (store) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__main-title"
      }, store.title, ", ", store.location), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-days"
      }, store.regularOpenDays), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-hours"
      }, store.regularOpenHours), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-days"
      }, store.holidayOpenDays), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-hours"
      }, store.holidayOpenHours), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-days"
      }, store.weekendOpenDays), /*#__PURE__*/React__default.createElement("div", {
        className: "stores-dropdown__open-hours"
      }, store.weekendOpenHours), /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(contactUsLink, "/#").concat(store.slug),
        className: "stores-dropdown__view-more"
      }, ' ', "View More"));
    })));
  };

  var BrandsDropDown = function BrandsDropDown(_ref) {
    var subMenuOpen = _ref.subMenuOpen,
        onBackClick = _ref.onBackClick,
        backIcon = _ref.backIcon,
        subMenuCategoryTitle = _ref.subMenuCategoryTitle,
        productUrl = _ref.productUrl,
        categoryElements = _ref.categoryElements,
        subMenuBrandsTitle = _ref.subMenuBrandsTitle,
        _ref$brandsList = _ref.brandsList,
        brandsList = _ref$brandsList === void 0 ? [] : _ref$brandsList,
        categorySlug = _ref.categorySlug,
        isLoading = _ref.isLoading,
        hasError = _ref.hasError;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__content ".concat(subMenuOpen ? '' : 'side-nav__content--hidden')
    }, hasError ? /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__errors"
    }, "Failed to load data.") : /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__sub-menu-wrapper"
    }, isLoading ? /*#__PURE__*/React__default.createElement("div", {
      className: "cover-spinner"
    }) : /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__sub-menu"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__back-button-wrapper",
      onClick: onBackClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: backIcon,
      alt: "back-icon",
      className: "side-nav__back-icon"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__back-button"
    }, "Back To Menu")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__sub-menu-title"
    }, subMenuCategoryTitle), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__elements"
    }, categoryElements.map(function (category) {
      return /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(productUrl, "/").concat(category.slug),
        className: "side-nav__element"
      }, category.name.toLowerCase());
    })), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__elements"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__sub-menu-title"
    }, subMenuBrandsTitle), /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(productUrl, "/brands"),
      className: "side-nav__element"
    }, "All Brands"), !!brandsList.length && brandsList.map(function (brand) {
      return /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(productUrl, "/").concat(categorySlug, "/").concat(brand.slug),
        className: "side-nav__element"
      }, brand.name);
    })))));
  };

  var LuxitySideNav = function LuxitySideNav(_ref) {
    var accordionIcon = _ref.accordionIcon,
        closeIcon = _ref.closeIcon,
        backIcon = _ref.backIcon,
        productUrl = _ref.productUrl,
        onAccountClick = _ref.onAccountClick,
        onCartClick = _ref.onCartClick,
        contactUsLink = _ref.contactUsLink,
        ourStoryLink = _ref.ourStoryLink,
        blogLink = _ref.blogLink,
        onSellToUsClick = _ref.onSellToUsClick,
        stores = _ref.stores,
        categoryElements = _ref.categoryElements,
        showSideNav = _ref.showSideNav,
        onMenuClick = _ref.onMenuClick,
        endpoint = _ref.endpoint;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        subMenuOpen = _useState2[0],
        setSubMenuOpen = _useState2[1];

    var _useState3 = React.useState(''),
        _useState4 = _slicedToArray(_useState3, 2),
        displayedSubMenu = _useState4[0],
        setDisplayedSubMenu = _useState4[1];

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        loading = _useState6[0],
        setLoading = _useState6[1];

    var _useState7 = React.useState({
      latestArrivals: [],
      bags: [],
      shoes: [],
      clothing: [],
      accessories: [],
      watches: [],
      accessoriesCategories: [],
      apparelStyles: []
    }),
        _useState8 = _slicedToArray(_useState7, 2),
        dropdownData = _useState8[0],
        setDropdownData = _useState8[1];

    var _useState9 = React.useState(false),
        _useState10 = _slicedToArray(_useState9, 2),
        hasError = _useState10[0],
        setHasError = _useState10[1];

    var onSubMenuClick = function onSubMenuClick(subMenu) {
      setSubMenuOpen(function (prev) {
        return !prev;
      });
      setDisplayedSubMenu(subMenu);
    };

    var onStoresClick = function onStoresClick() {
      setSubMenuOpen(false);
      setDisplayedSubMenu('stores');
    };

    var onBackClick = function onBackClick() {
      setSubMenuOpen(false);
      setDisplayedSubMenu('');
    };

    var onCloseSideNav = function onCloseSideNav(e) {
      onMenuClick();

      if (e.key === 'Enter') {
        e.preventDefault();
      }
    };

    React.useMemo(function () {
      setLoading(true);
      axios.post("".concat(endpoint), getBrands()).then(function (_ref2) {
        var data = _ref2.data;
        setLoading(false);
        setDropdownData(function (prev) {
          return _objectSpread2(_objectSpread2({}, prev), {}, {
            latestArrivals: data.data.latest_arrivals.data,
            bags: data.data.bags.data,
            shoes: data.data.shoes.data,
            apparel: data.data.apparel.data,
            accessories: data.data.accessories.data,
            watches: data.data.watches.data,
            accessoriesCategories: data.data.accessories_categories,
            apparelStyles: data.data.apparel_styles
          });
        });
      }).catch(function () {
        return setHasError(true);
      });
    }, [endpoint]);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav"
    }, /*#__PURE__*/React__default.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: "side-nav__overlay ".concat(showSideNav ? 'side-nav__overlay--visible' : 'side-nav__overlay--hidden', " "),
      onClick: onCloseSideNav,
      onKeyDown: onCloseSideNav
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__content ".concat(subMenuOpen ? 'side-nav__content--hidden' : '', " ").concat(showSideNav ? 'side-nav__content--open' : 'side-nav__content--closed')
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: onMenuClick,
      className: "side-nav__icon-container"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: closeIcon,
      alt: "close-icon",
      className: "side-nav__close-icon"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-items-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: function onClick() {
        return onSubMenuClick('new');
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "New"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: function onClick() {
        return onSubMenuClick('bags');
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Bags"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: function onClick() {
        return onSubMenuClick('shoes');
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Shoes"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: function onClick() {
        return onSubMenuClick('clothing');
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Clothing"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: function onClick() {
        return onSubMenuClick('accessories');
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Accessories"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: function onClick() {
        return onSubMenuClick('watches');
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Watches"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onStoresClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Our Stores"), /*#__PURE__*/React__default.createElement("img", {
      src: accordionIcon,
      alt: "accordion-icon",
      className: "side-nav__accordion-icon"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__block-button",
      onClick: onSellToUsClick
    }, "Sell To Us")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: ourStoryLink,
      className: "side-nav__sub-link"
    }, "Our Story")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: blogLink,
      className: "side-nav__sub-link"
    }, "Blog")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: contactUsLink,
      className: "side-nav__sub-link"
    }, "Contact Us")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__sub-link",
      onClick: onAccountClick
    }, "My Account")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__sub-link",
      onClick: onCartClick
    }, "My Cart")))), /*#__PURE__*/React__default.createElement(BrandsDropDown, {
      subMenuOpen: subMenuOpen && displayedSubMenu === 'new',
      onBackClick: onBackClick,
      backIcon: backIcon,
      subMenuCategoryTitle: "Department",
      productUrl: productUrl,
      categoryElements: categoryElements,
      subMenuBrandsTitle: "Brands",
      brandsList: dropdownData.latestArrivals,
      categorySlug: displayedSubMenu,
      isLoading: loading,
      hasError: hasError
    }), /*#__PURE__*/React__default.createElement(BrandsDropDown, {
      subMenuOpen: subMenuOpen && displayedSubMenu === 'bags',
      onBackClick: onBackClick,
      backIcon: backIcon,
      subMenuCategoryTitle: "Department",
      productUrl: productUrl,
      categoryElements: categoryElements,
      subMenuBrandsTitle: "Bag Brands",
      brandsList: dropdownData.bags,
      categorySlug: displayedSubMenu,
      isLoading: loading,
      hasError: hasError
    }), /*#__PURE__*/React__default.createElement(BrandsDropDown, {
      subMenuOpen: subMenuOpen && displayedSubMenu === 'shoes',
      onBackClick: onBackClick,
      backIcon: backIcon,
      subMenuCategoryTitle: "Department",
      productUrl: productUrl,
      categoryElements: categoryElements,
      subMenuBrandsTitle: "Shoe Brands",
      brandsList: dropdownData.shoes,
      categorySlug: displayedSubMenu,
      isLoading: loading,
      hasError: hasError
    }), /*#__PURE__*/React__default.createElement(BrandsDropDown, {
      subMenuOpen: subMenuOpen && displayedSubMenu === 'clothing',
      onBackClick: onBackClick,
      backIcon: backIcon,
      subMenuCategoryTitle: "Department",
      productUrl: productUrl,
      categoryElements: dropdownData.apparelStyles,
      subMenuBrandsTitle: "Clothing Brands",
      brandsList: dropdownData.clothing,
      categorySlug: displayedSubMenu,
      isLoading: loading,
      hasError: hasError
    }), /*#__PURE__*/React__default.createElement(BrandsDropDown, {
      subMenuOpen: subMenuOpen && displayedSubMenu === 'accessories',
      onBackClick: onBackClick,
      backIcon: backIcon,
      subMenuCategoryTitle: "Categories",
      productUrl: productUrl,
      categoryElements: removeCategoryByName(dropdownData.accessoriesCategories, 'ACCESSORIES'),
      subMenuBrandsTitle: "Accessory Brands",
      brandsList: dropdownData.accessories,
      categorySlug: displayedSubMenu,
      isLoading: loading,
      hasError: hasError
    }), /*#__PURE__*/React__default.createElement(BrandsDropDown, {
      subMenuOpen: subMenuOpen && displayedSubMenu === 'watches',
      onBackClick: onBackClick,
      backIcon: backIcon,
      subMenuCategoryTitle: "Department",
      productUrl: productUrl,
      categoryElements: categoryElements,
      subMenuBrandsTitle: "Watches Brands",
      brandsList: dropdownData.watches,
      categorySlug: displayedSubMenu,
      isLoading: loading,
      hasError: hasError
    }), displayedSubMenu === 'stores' && /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__content"
    }, /*#__PURE__*/React__default.createElement(StoresDropdown$1, {
      backIcon: backIcon,
      onBackClick: onBackClick,
      stores: stores,
      contactUsLink: contactUsLink
    })));
  };

  var LuxityAppSideNav = function LuxityAppSideNav(_ref) {
    var closeIcon = _ref.closeIcon,
        accountIcon = _ref.accountIcon,
        orderIcon = _ref.orderIcon,
        saleIcon = _ref.saleIcon,
        onDashboardClick = _ref.onDashboardClick,
        onLogoutClick = _ref.onLogoutClick,
        bugReportLink = _ref.bugReportLink,
        onLuxityShopClick = _ref.onLuxityShopClick,
        onInterestClick = _ref.onInterestClick,
        onAddressClick = _ref.onAddressClick,
        onCouponsClick = _ref.onCouponsClick,
        onEditProfileClick = _ref.onEditProfileClick,
        onCurrentOrdersClick = _ref.onCurrentOrdersClick,
        onPastOrdersClick = _ref.onPastOrdersClick,
        onPastSalesClick = _ref.onPastSalesClick,
        onPaidOutClick = _ref.onPaidOutClick,
        showSideNav = _ref.showSideNav,
        onMenuClick = _ref.onMenuClick;

    var onCloseSideNav = function onCloseSideNav(e) {
      onMenuClick();

      if (e.key === 'Enter') {
        e.preventDefault();
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav"
    }, /*#__PURE__*/React__default.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: "side-nav__overlay ".concat(showSideNav ? 'side-nav__overlay--visible' : 'side-nav__overlay--hidden', " "),
      onClick: onCloseSideNav,
      onKeyDown: onCloseSideNav
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__content ".concat(showSideNav ? 'side-nav__content--open' : 'side-nav__content--closed')
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: onMenuClick,
      className: "side-nav__icon-container"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: closeIcon,
      alt: "close-icon",
      className: "side-nav__close-icon"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-items-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: accountIcon,
      alt: "close-icon",
      className: "side-nav__menu-icon"
    }), "My Account"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onInterestClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Interests"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onAddressClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Addresses"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onCouponsClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Coupons"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onEditProfileClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Edit Profile"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-divider"
    }, " "), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: orderIcon,
      alt: "close-icon",
      className: "side-nav__menu-icon"
    }), "My Orders"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onCurrentOrdersClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Current Orders"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onPastOrdersClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Past Orders"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-divider"
    }, " "), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: saleIcon,
      alt: "close-icon",
      className: "side-nav__menu-icon"
    }), "My Sales"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onPastSalesClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Sales & Consignments"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__menu-title-wrapper",
      onClick: onPaidOutClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "side-nav__menu-title"
    }, "Paid Out"))), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__block-button",
      onClick: onLuxityShopClick
    }, "LUXITY SHOP")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__sub-link",
      onClick: onDashboardClick
    }, "Dashboard")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: bugReportLink,
      className: "side-nav__sub-link"
    }, "Help")), /*#__PURE__*/React__default.createElement("div", {
      className: "side-nav__menu-item"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "side-nav__sub-link",
      onClick: onLogoutClick
    }, "Logout")))));
  };

  var LuxityMobileHeader = function LuxityMobileHeader(_ref) {
    var logoSrc = _ref.logoSrc,
        menuIcon = _ref.menuIcon,
        inputSearchIcon = _ref.inputSearchIcon,
        onSearch = _ref.onSearch,
        onCartClick = _ref.onCartClick,
        cartIcon = _ref.cartIcon,
        cartCount = _ref.cartCount,
        closeIcon = _ref.closeIcon,
        accountIcon = _ref.accountIcon,
        saleIcon = _ref.saleIcon,
        orderIcon = _ref.orderIcon,
        accordionIcon = _ref.accordionIcon,
        backIcon = _ref.backIcon,
        productsUrl = _ref.productsUrl,
        stores = _ref.stores,
        categoryElements = _ref.categoryElements,
        onAccountClick = _ref.onAccountClick,
        onDashboardClick = _ref.onDashboardClick,
        contactUsLink = _ref.contactUsLink,
        ourStoryLink = _ref.ourStoryLink,
        blogLink = _ref.blogLink,
        bugReportLink = _ref.bugReportLink,
        onSellToUsClick = _ref.onSellToUsClick,
        onLogoClick = _ref.onLogoClick,
        onLuxityShopClick = _ref.onLuxityShopClick,
        endpoint = _ref.endpoint,
        onSearchSubmit = _ref.onSearchSubmit,
        onProductIdsReceived = _ref.onProductIdsReceived,
        onLogoutClick = _ref.onLogoutClick,
        onInterestClick = _ref.onInterestClick,
        onAddressClick = _ref.onAddressClick,
        onCouponsClick = _ref.onCouponsClick,
        onEditProfileClick = _ref.onEditProfileClick,
        onCurrentOrdersClick = _ref.onCurrentOrdersClick,
        onPastOrdersClick = _ref.onPastOrdersClick,
        onPastSalesClick = _ref.onPastSalesClick,
        onPaidOutClick = _ref.onPaidOutClick,
        shop = _ref.shop,
        app = _ref.app;

    var _useState = React.useState(''),
        _useState2 = _slicedToArray(_useState, 2),
        searchValue = _useState2[0],
        setSearchValue = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showSearchBar = _useState4[0],
        setShowSearchbar = _useState4[1];

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showSideNav = _useState6[0],
        setShowSideNav = _useState6[1];

    var _useState7 = React.useState(true),
        _useState8 = _slicedToArray(_useState7, 2),
        searchLoading = _useState8[0],
        setSearchLoading = _useState8[1];

    var _useState9 = React.useState({
      brands: [],
      products: []
    }),
        _useState10 = _slicedToArray(_useState9, 2),
        searchResults = _useState10[0],
        setSearchResults = _useState10[1];

    var handleChange = function handleChange(event) {
      var value = event.target.value;
      setSearchValue(value);
      onSearch(value);

      if (value.trim() !== '') {
        setSearchLoading(true);
        axios.post(endpoint, searchProducts(value, 6)).then(function (response) {
          setSearchResults(response.data.data.luxity_products_serach_results);
          var ids = response.data.data.luxity_products_serach_results.luxity_product_ids;
          onProductIdsReceived(ids);
          setSearchLoading(false);
        }).catch(function () {
          setSearchLoading(false);
        });
      } else {
        setSearchResults({
          brands: [],
          products: []
        });
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Enter') {
        onSearchSubmit(searchValue);
        setSearchValue('');
      } else if (event.key === 'Escape') {
        setSearchValue('');
      }
    };

    var onSearchClick = function onSearchClick() {
      setShowSearchbar(function (prev) {
        return !prev;
      });
      setSearchValue('');
    };

    var onMenuClick = function onMenuClick() {
      setShowSideNav(function (prev) {
        return !prev;
      });
    };

    var handleSellToUsClick = function handleSellToUsClick() {
      onSellToUsClick();
      setShowSideNav(false);
    };

    var handleCartClick = function handleCartClick() {
      onCartClick();
      setShowSideNav(false);
    };

    var handleLuxityShopClick = function handleLuxityShopClick() {
      onLuxityShopClick();
      setShowSideNav(false);
    };

    var handleLogoutClick = function handleLogoutClick() {
      onLogoutClick();
      setShowSideNav(false);
    };

    var handleInterestClick = function handleInterestClick() {
      onInterestClick();
      setShowSideNav(false);
    };

    var handleAddressClick = function handleAddressClick() {
      onAddressClick();
      setShowSideNav(false);
    };

    var handleCouponsClick = function handleCouponsClick() {
      onCouponsClick();
      setShowSideNav(false);
    };

    var handleEditProfileClick = function handleEditProfileClick() {
      onEditProfileClick();
      setShowSideNav(false);
    };

    var handleCurrentOrdersClick = function handleCurrentOrdersClick() {
      onCurrentOrdersClick();
      setShowSideNav(false);
    };

    var handlePastOrdersClick = function handlePastOrdersClick() {
      onPastOrdersClick();
      setShowSideNav(false);
    };

    var handlePastSalesClick = function handlePastSalesClick() {
      onPastSalesClick();
      setShowSideNav(false);
    };

    var handlePaidOutClick = function handlePaidOutClick() {
      onPaidOutClick();
      setShowSideNav(false);
    };

    return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar navbar__mobile-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__wrapper"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "navbar__menu-icon-wrapper",
      onClick: onMenuClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: menuIcon,
      alt: "menu-icon",
      className: "navbar__menu-icon"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__search-wrapper"
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: onLogoClick,
      className: "navbar__logo"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: logoSrc,
      alt: "luxity-logo"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__icons-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__icons"
    }, shop && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "navbar__icon",
      onClick: onSearchClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: inputSearchIcon,
      className: "navbar__icon",
      alt: "interest-icon"
    })), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "navbar__cart-icon navbar__icon",
      onClick: onCartClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: cartIcon,
      alt: "cart-icon"
    }), shop && /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__cart-count"
    }, cartCount))))), showSearchBar && /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__product-search-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "navbar__product-search"
    }, /*#__PURE__*/React__default.createElement("input", {
      className: "navbar__form-input",
      type: "text",
      placeholder: "Search for items and designs",
      value: searchValue,
      onChange: handleChange,
      onKeyDown: handleKeyDown
    })), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: onSearchClick
    }, /*#__PURE__*/React__default.createElement("img", {
      src: closeIcon,
      alt: "close-icon",
      className: "navbar__input-close-icon"
    })))), /*#__PURE__*/React__default.createElement(SearchResults, {
      searchValue: searchValue,
      searchLoading: searchLoading,
      searchResults: searchResults,
      onViewAll: function onViewAll() {
        onSearchSubmit(searchValue);
        setSearchValue('');
      },
      onSearchSubmit: onSearchSubmit,
      setSearchValue: setSearchValue
    }), shop && /*#__PURE__*/React__default.createElement(LuxitySideNav, {
      accordionIcon: accordionIcon,
      logoSrc: logoSrc,
      closeIcon: closeIcon,
      backIcon: backIcon,
      productUrl: productsUrl,
      onAccountClick: onAccountClick,
      onCartClick: handleCartClick,
      contactUsLink: contactUsLink,
      ourStoryLink: ourStoryLink,
      blogLink: blogLink,
      onSellToUsClick: handleSellToUsClick,
      stores: stores,
      categoryElements: categoryElements,
      showSideNav: showSideNav,
      onMenuClick: onMenuClick,
      endpoint: endpoint
    }), app && /*#__PURE__*/React__default.createElement(LuxityAppSideNav, {
      accordionIcon: accordionIcon,
      closeIcon: closeIcon,
      accountIcon: accountIcon,
      orderIcon: orderIcon,
      saleIcon: saleIcon,
      onDashboardClick: onDashboardClick,
      onLogoutClick: handleLogoutClick,
      bugReportLink: bugReportLink,
      ourStoryLink: ourStoryLink,
      blogLink: blogLink,
      onLuxityShopClick: handleLuxityShopClick,
      showSideNav: showSideNav,
      onMenuClick: onMenuClick,
      onInterestClick: handleInterestClick,
      onAddressClick: handleAddressClick,
      onCouponsClick: handleCouponsClick,
      onEditProfileClick: handleEditProfileClick,
      onCurrentOrdersClick: handleCurrentOrdersClick,
      onPastOrdersClick: handlePastOrdersClick,
      onPastSalesClick: handlePastSalesClick,
      onPaidOutClick: handlePaidOutClick
    }));
  };

  exports.Accordion = index;
  exports.Checkbox = LuxityCheckbox;
  exports.CheckboxFormWrapper = FormWrapper;
  exports.CommunicationPreferences = index$5;
  exports.CountryCodeSelect = CountryCodeSelect;
  exports.CurrencyInputFormatter = CurrencyInputFormatter;
  exports.InterestCatSelector = CategoryInterestSelector;
  exports.InterestItem = InterestItem$1;
  exports.Interests = Interests;
  exports.InvertedTextButton = InvertedTextButton$1;
  exports.LuxityAppSideNav = LuxityAppSideNav;
  exports.LuxityDesktopHeader = LuxityDesktopHeader;
  exports.LuxityFooter = index$6;
  exports.LuxityMobileHeader = LuxityMobileHeader;
  exports.LuxityPageReady = LuxityPageReady;
  exports.LuxitySideNav = LuxitySideNav;
  exports.Notify = LuxityNotifications;
  exports.NotifyError = error;
  exports.NotifySuccess = success;
  exports.PriceRangeSelector = PriceRangeSelector;
  exports.PrimaryButton = PrimaryButton$1;
  exports.RadioButtons = RadioButtons$1;
  exports.RadioButtonsFormWrapper = FormWrapper$1;
  exports.RareStepFooter = index$4;
  exports.RareStepHeader = index$3;
  exports.ReactSelectWrapper = ReactSelectWrapper;
  exports.SecondaryButton = SecondaryButton$1;
  exports.ShoeSizeRangeSelector = ShoeSizeRangeSelector;
  exports.ShoeSizeSelector = ShoeSizeSelector;
  exports.TextButton = TextButton$1;
  exports.Tooltip = index$1;
  exports.WrapperButton = WrapperButton;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
